/**
 * door-conf2-measurements.js — Measurement tabs, dimensions, porch/panel unit UI.
 * Loaded by door-config2-snippet.liquid before door-conf2.js.
 */
(function () {
    var deps = {};
    // --- Dp start 17-07 ---
    var _prevSidelightActive = null;
    var _prevTransomActive = null;
    var _prevPrehungStyle = null;
    var _hasInitializedPrevValues = false;
    // --- Dp end 17-07 ---

    function all(selector, root) {
        return Array.from((root || document).querySelectorAll(selector));
    }

    function doorConfigSchemaRef() {
        return typeof deps.getDoorConfigSchema === 'function' ? deps.getDoorConfigSchema() : null;
    }

    function normalizeOptionIdKey(id) {
        if (typeof deps.normalizeOptionIdKey === 'function') return deps.normalizeOptionIdKey(id);
        return String(id || '').toLowerCase().replace(/-/g, '_');
    }

    function sanitizeForDomId(s) {
        if (typeof deps.sanitizeForDomId === 'function') return deps.sanitizeForDomId(s);
        return String(s == null ? '' : s).toLowerCase().trim().replace(/[^a-z0-9_-]+/g, '_').replace(/^_+|_+$/g, '');
    }

    function buildOptionDomId(selectId, valueOrLabel, index) {
        if (typeof deps.buildOptionDomId === 'function') return deps.buildOptionDomId(selectId, valueOrLabel, index);
        return sanitizeForDomId(selectId) + '__' + (index != null ? index : 0);
    }

    function ensureSelectHasId(selectEl, prefix) {
        if (typeof deps.ensureSelectHasId === 'function') return deps.ensureSelectHasId(selectEl, prefix);
        if (selectEl && selectEl.id) return selectEl.id;
        return '';
    }

    function applyHideWhen(schema, container) {
        if (typeof deps.applyHideWhen === 'function') deps.applyHideWhen(schema, container);
    }

    function applyChoiceVisibility(schema, container) {
        if (typeof deps.applyChoiceVisibility === 'function') deps.applyChoiceVisibility(schema, container);
    }

    function enhanceDoorSelectWithDivDropdown(selectEl) {
        if (typeof deps.enhanceDoorSelectWithDivDropdown === 'function') {
            return deps.enhanceDoorSelectWithDivDropdown(selectEl);
        }
        return null;
    }

    function updateEstimatedPrice() {
        try { if (typeof deps.updateEstimatedPrice === 'function') deps.updateEstimatedPrice(); } catch (eMeasPrice) { }
    }

    function updateDoorPreview() {
        try { if (typeof deps.updateDoorPreview === 'function') deps.updateDoorPreview(); } catch (eMeasPrev) { }
    }

    function formatMoney(amount) {
        if (typeof deps.formatMoney === 'function') return deps.formatMoney(amount);
        return String(amount == null ? '' : amount);
    }

    function parseShowWhenProductTagsRaw(raw) {
        if (typeof deps.parseShowWhenProductTagsRaw === 'function') return deps.parseShowWhenProductTagsRaw(raw);
        return raw;
    }

    function normProductTagSlug(s) {
        if (typeof deps.normProductTagSlug === 'function') return deps.normProductTagSlug(s);
        return String(s || '').toLowerCase().trim();
    }

    function getConfiguratorProductTagContext(schema) {
        if (typeof deps.getConfiguratorProductTagContext === 'function') return deps.getConfiguratorProductTagContext(schema);
        return { productTags: [], urlCollectionHandle: '', globalTagMap: null };
    }

    function choiceHasShowWhenProductTagsField(choice) {
        if (typeof deps.choiceHasShowWhenProductTagsField === 'function') return deps.choiceHasShowWhenProductTagsField(choice);
        return false;
    }

    function normalizeTagSetsForChoice(showWhenProductTags, choiceValue, opts) {
        if (typeof deps.normalizeTagSetsForChoice === 'function') {
            return deps.normalizeTagSetsForChoice(showWhenProductTags, choiceValue, opts);
        }
        return [];
    }

    function tagSetsMatchProductTags(tagSets, productTags) {
        if (typeof deps.tagSetsMatchProductTags === 'function') return deps.tagSetsMatchProductTags(tagSets, productTags);
        return true;
    }
    function inferStaticMeasurementPanelKey(el) {
        if (!el || !el.closest) return '';
        // --- Dp start 17-07  ---
        if (el.closest('.door-rough-panel-default')) return 'rough';
        // --- Dp end 17-07  ---
        var p = el.closest('.door-measurement-static-panel');
        if (!p || !p.classList) return '';
        if (p.classList.contains('door-measurement-static-panel--exact')) return 'exact';
        if (p.classList.contains('door-measurement-static-panel--finished')) return 'finished';
        if (p.classList.contains('door-measurement-static-panel--rough')) return 'rough';
        if (p.classList.contains('door-measurement-static-panel--jamb')) return 'jamb';
        if (p.classList.contains('door-measurement-static-panel--sidelight')) return 'sidelight';
        if (p.classList.contains('door-measurement-static-panel--transom')) return 'transom';
        return '';
    }

    function staticMeasurementPanelShortKey(panelKey) {
        // User preference: avoid 1-letter codes; keep readable words.
        var k = String(panelKey || '').toLowerCase();
        if (k === 'exact' || k === 'finished' || k === 'rough' || k === 'jamb' || k === 'sidelight' || k === 'transom') return k;
        return 'panel';
    }

    /** Extra measurement tabs + panel values for sidelight / transom sizing. */
    var MEASURE_TAB_EXACT_DOOR = 'exact_door_size';
    var MEASURE_TAB_EXACT_GATE = 'exact_gate_size';
    var MEASURE_TAB_EXACT_SIDELIGHT = 'exact_sidelight_size';
    var MEASURE_TAB_EXACT_TRANSOM = 'exact_transom_size';
    var MEASURE_TAB_FINISHED_OPENING = 'finished_opening_size';
    var COLLECTION_GARDEN_GATES = 'garden-gates';
    var COLLECTION_PET_GATES = 'pet-gates';
    var COLLECTIONS_SIDELIGHT_TRANSOM = [
        'exterior-sidelights',
        'screen-storm-sidelights',
        'interior-sidelights',
        'exterior-transoms',
        'screen-storm-transoms',
        'interior-transoms'
    ];
    var GATE_SWING_DIRECTION_ALLOW = {
        in_left: true,
        out_left: true,
        in_right: true,
        out_right: true
    };

    function normalizeSwingDirectionValue(v) {
        return String(v == null ? '' : v).trim().toLowerCase().replace(/[\s-]+/g, '_');
    }

    function isAllowedGateSwingDirectionValue(v) {
        return !!GATE_SWING_DIRECTION_ALLOW[normalizeSwingDirectionValue(v)];
    }

    function isGateCollectionHandle(handle) {
        var h = normProductTagSlug(handle);
        return h === COLLECTION_GARDEN_GATES || h === COLLECTION_PET_GATES;
    }

    function getActiveGateCollectionHandle() {
        try {
            var main = document.getElementById('door-configurator');
            var ctx = getConfiguratorProductTagContext(doorConfigSchemaRef());
            var urlCol = ctx && ctx.urlCollectionHandle ? normProductTagSlug(ctx.urlCollectionHandle) : '';
            if (isGateCollectionHandle(urlCol)) return urlCol;
            if (main) {
                var route = normProductTagSlug(main.getAttribute('data-route-collection') || '');
                if (isGateCollectionHandle(route)) return route;
                var raw = main.getAttribute('data-product-collection-handles') || '[]';
                var handles = JSON.parse(raw);
                if (Array.isArray(handles)) {
                    for (var hi = 0; hi < handles.length; hi++) {
                        var h = normProductTagSlug(handles[hi]);
                        if (isGateCollectionHandle(h)) return h;
                    }
                }
            }
        } catch (eGateCol) { }
        return '';
    }

    function isGateCollection() {
        return !!getActiveGateCollectionHandle();
    }

    /** Classify a collection handle as sidelight | transom | ''. */
    function classifySidelightTransomHandle(handle) {
        var h = normProductTagSlug(handle);
        if (!h) return '';
        if (h.indexOf('transom') !== -1) return 'transom';
        if (h.indexOf('sidelight') !== -1) return 'sidelight';
        if (COLLECTIONS_SIDELIGHT_TRANSOM.indexOf(h) !== -1) {
            return h.indexOf('transom') !== -1 ? 'transom' : 'sidelight';
        }
        return '';
    }

    /**
     * Active collection only (URL path → data-route-collection).
     * Do not scan every product.collections handle — that hides Exact Door Size
     * on door pages that also belong to a sidelight/transom collection.
     */
    /* MERGE: seo_pdp_url — start (also read ?config= / PDP_ROUTE_COLLECTION) */
    function collectSidelightTransomCandidateHandles() {
        var handles = [];
        function push(h) {
            h = normProductTagSlug(h);
            if (!h) return;
            if (handles.indexOf(h) === -1) handles.push(h);
        }
        try {
            var pathMatch = String((window.location && window.location.pathname) || '')
                .match(/\/collections\/([^\/\?#]+)/i);
            if (pathMatch) push(decodeURIComponent(pathMatch[1]));
        } catch (eUrlPath) { }
        try {
            var params = new URLSearchParams((window.location && window.location.search) || '');
            var fromQuery = params.get('config') || params.get('collection') || params.get('col');
            /* MERGE: pdp_config_id — skip numeric ?config= */
            if (fromQuery && !/^\d+$/.test(String(fromQuery))) push(fromQuery);
        } catch (eUrlQuery) { }
        try {
            if (window.PDP_ROUTE_COLLECTION) push(window.PDP_ROUTE_COLLECTION);
        } catch (ePdpRoute) { }
        var main = document.getElementById('door-configurator');
        if (main) {
            push(main.getAttribute('data-route-collection') || '');
        }
        return handles;
    }
    /* MERGE: seo_pdp_url — end */

    function isEntranceUnitsProduct() {
        try {
            var ctx = getConfiguratorProductTagContext(doorConfigSchemaRef());
            var urlCol = ctx && ctx.urlCollectionHandle ? normProductTagSlug(ctx.urlCollectionHandle) : '';
            if (urlCol && (urlCol.indexOf('entrance-unit') !== -1 || urlCol.indexOf('entrance-units') !== -1)) return true;
            var main = document.getElementById('door-configurator') || document.getElementById('landing-product-configurator');
            if (main) {
                var routeCol = normProductTagSlug(main.getAttribute('data-route-collection') || '');
                if (routeCol && (routeCol.indexOf('entrance-unit') !== -1 || routeCol.indexOf('entrance-units') !== -1)) return true;
                var rawHandles = main.getAttribute('data-product-collection-handles') || '[]';
                try {
                    var handles = JSON.parse(rawHandles);
                    if (Array.isArray(handles)) {
                        for (var hi = 0; hi < handles.length; hi++) {
                            var ch = normProductTagSlug(handles[hi]);
                            if (ch && (ch.indexOf('entrance-unit') !== -1 || ch.indexOf('entrance-units') !== -1)) return true;
                        }
                    }
                } catch (eH) { }
                var tagsAttr = (main.getAttribute('data-product-tags') || '').toLowerCase();
                if (tagsAttr.indexOf('entrance-unit') !== -1 || tagsAttr.indexOf('entrance-units') !== -1) return true;
                var prodName = (main.getAttribute('data-product-name') || '').toLowerCase();
                if (prodName.indexOf('entrance-unit') !== -1 || prodName.indexOf('entrance-units') !== -1) return true;
            }
        } catch (eEnt) { }
        return false;
    }

    function getSidelightTransomCollectionType() {
        if (isEntranceUnitsProduct()) return '';
        try {
            var handles = collectSidelightTransomCandidateHandles();
            for (var hi = 0; hi < handles.length; hi++) {
                var typed = classifySidelightTransomHandle(handles[hi]);
                if (typed) return typed;
            }
        } catch (eSideTransCol) { }
        return '';
    }

    function isSidelightOrTransomCollectionActive() {
        return !!getSidelightTransomCollectionType();
    }

    function isMeasureDebugOn() {
        try {
            if (window.__doorMeasureDebug === true) return true;
            if (window.localStorage && window.localStorage.getItem('door_measure_debug') === '1') return true;
        } catch (eDbgRead) { }
        return false;
    }
    function logMeasureDebug() {
        if (!isMeasureDebugOn()) return;
        try {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('[measurements]');
            console.log.apply(console, args);
        } catch (eDbgLog) { }
    }

    function isDoorThicknessMeasureTitleKey(key) {
        return key === 'door_thickness'
            || key === 'exact_door_thickness'
            || key === 'sidelight_thickness'
            || key === 'transom_thickness'
            || key === 'gate_thickness'
            || key === 'exact_gate_thickness';
    }

    function stripDescriptionMediaUrls(text) {
        var s = text == null ? '' : String(text);
        if (!s) return '';
        s = s.replace(/https?:\/\/[^\s<>"']+\.(?:png|jpe?g|gif|webp|svg|bmp|ico)(?:\?[^\s<>"']*)?/gi, '');
        s = s.replace(/https?:\/\/cdn\.shopify\.com\/s\/files\/[^\s<>"']+/gi, '');
        s = s.replace(/(?:^|\s)https?:\/\/[^\s<>"']+/gi, ' ');
        s = s.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').replace(/[ \t]{2,}/g, ' ').trim();
        return s;
    }

    function extractDescriptionMediaUrl(text) {
        var s = text == null ? '' : String(text);
        if (!s) return '';
        var m = s.match(/https?:\/\/[^\s<>"']+\.(?:png|jpe?g|gif|webp|svg|bmp|ico)(?:\?[^\s<>"']*)?/i);
        if (m && m[0]) return m[0];
        m = s.match(/https?:\/\/cdn\.shopify\.com\/s\/files\/[^\s<>"']+/i);
        return (m && m[0]) ? m[0] : '';
    }

    function mapCollectionDoorWording(text) {
        var raw = stripDescriptionMediaUrls(text);
        if (!raw) return raw;
        var type = getSidelightTransomCollectionType();
        var singular = '';
        var plural = '';
        if (type === 'transom') {
            singular = 'transom';
            plural = 'transoms';
        } else if (type === 'sidelight') {
            singular = 'sidelight';
            plural = 'sidelights';
        } else if (isGateCollection()) {
            singular = 'gate';
            plural = 'gates';
        } else {
            return raw;
        }
        return raw.replace(/\b(doors?)\b/gi, function (match) {
            var isPlural = /s$/i.test(match);
            var repl = isPlural ? plural : singular;
            if (match === match.toUpperCase()) return repl.toUpperCase();
            if (match.charAt(0) === match.charAt(0).toUpperCase()) {
                return repl.charAt(0).toUpperCase() + repl.slice(1);
            }
            return repl;
        });
    }

    function applySidelightTransomDoorWordingCopy(rootEl) {
        rootEl = rootEl || document.getElementById('door-configurator-options') || document;
        if (!rootEl || !getSidelightTransomCollectionType()) return;
        try {
            rootEl.querySelectorAll('.door-measure-dimension-hint, .door-option-desc, .common-check-option-desc').forEach(function (el) {
                if (!el) return;
                if (el.classList && el.classList.contains('door-sdl-profile-desc')) return;
                if (el.getAttribute && el.getAttribute('data-skip-door-wording') === '1') return;
                var attr = el.classList && el.classList.contains('door-measure-dimension-hint')
                    ? 'data-door-original-hint'
                    : 'data-door-original-desc';
                var live = String(el.textContent || '');
                var mediaUrl = el.getAttribute('data-door-desc-media-url')
                    || extractDescriptionMediaUrl(live)
                    || extractDescriptionMediaUrl(el.getAttribute(attr) || '');
                if (mediaUrl) el.setAttribute('data-door-desc-media-url', mediaUrl);
                if (!el.getAttribute(attr)) el.setAttribute(attr, stripDescriptionMediaUrls(live));
                var original = stripDescriptionMediaUrls(el.getAttribute(attr) || live);
                if (el.getAttribute(attr) !== original) el.setAttribute(attr, original);
                var next = mapCollectionDoorWording(original);
                if (live !== next) el.textContent = next;
            });
        } catch (eDoorWordMeas) { }
    }

    function applySidelightTransomMeasurementDimensionCopy(rootEl) {
        rootEl = rootEl || document.getElementById('door-configurator-options') || document;
        var type = getSidelightTransomCollectionType();
        if (!rootEl) return;
        try {
            var renamed = 0;
            rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
                var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                if (!titleEl) return;
                var liveTitle = String(titleEl.textContent || '').trim();
                if (!titleEl.getAttribute('data-door-original-title')) {
                    // Prefer door/exact door wording as the stable original.
                    var seed = liveTitle;
                    var liveKey = normalizeOptionIdKey(seed);
                    if (liveKey === 'sidelight_thickness' || liveKey === 'transom_thickness') {
                        seed = 'Door Thickness';
                    }
                    titleEl.setAttribute('data-door-original-title', seed);
                }
                var origTitle = String(titleEl.getAttribute('data-door-original-title') || '').trim();
                var key = normalizeOptionIdKey(origTitle);
                var curKey = normalizeOptionIdKey(liveTitle);
                if (!isDoorThicknessMeasureTitleKey(key) && !isDoorThicknessMeasureTitleKey(curKey)) return;
                if (key !== 'door_thickness' && key !== 'exact_door_thickness') {
                    // Repair bad originals captured after an earlier rename.
                    titleEl.setAttribute(
                        'data-door-original-title',
                        curKey.indexOf('exact') !== -1 ? 'Exact Door Thickness' : 'Door Thickness'
                    );
                    origTitle = titleEl.getAttribute('data-door-original-title');
                }
                var nextTitle = origTitle;
                if (type === 'sidelight') nextTitle = 'Sidelight Thickness';
                else if (type === 'transom') nextTitle = 'Transom Thickness';
                if (String(titleEl.textContent || '').trim() !== nextTitle) renamed++;
                titleEl.textContent = nextTitle;

                // Dp strat 29-07
                try {
                    var imgEl = row.querySelector('img.door-measure-svg, img');
                    if (imgEl) {
                        if (type === 'sidelight') {
                            imgEl.src = 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Sidelight_Thickness.svg?v=1785226038';
                        } else if (type === 'transom') {
                            imgEl.src = 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Transom_Thickness.svg?v=1785226034';
                        }
                    }
                } catch (eImg) { }
                // Dp end 29-07
            });
            applySidelightTransomDoorWordingCopy(rootEl);
            logMeasureDebug('applySidelightTransomMeasurementDimensionCopy', {
                type: type || 'none',
                renamed: renamed
            });
        } catch (eSideTransTitle) { }
    }

    function isGardenGatesCollection() {
        return getActiveGateCollectionHandle() === COLLECTION_GARDEN_GATES;
    }

    function isPetGatesCollection() {
        return getActiveGateCollectionHandle() === COLLECTION_PET_GATES;
    }

    var PET_GATES_EXACT_MEASURE_TITLE_COPY = {
        'exact door width': 'Exact Gate Width',
        'exact door height': 'Exact Gate Height',
        'exact door thickness': 'Gate Thickness',
        'door thickness': 'Gate Thickness'
    };

    var PET_GATES_GATE_TITLE_TO_DOOR = {
        'exact gate width': 'Exact Door Width',
        'exact gate height': 'Exact Door Height',
        'exact gate thickness': 'Exact Door Thickness',
        'gate thickness': 'Exact Door Thickness'
    };

    var PET_GATES_EXACT_MEASURE_HINT_COPY = {
        'enter the largest measurement for the width of your door.': 'Enter the largest measurement for the width of your gate.',
        'enter the tallest measurement for the height of your door.': 'Enter the tallest measurement for the height of your gate.',
        'enter the measurement for the thickness of your door.': 'Enter the measurement for the thickness of your gate.'
    };

    var PET_GATES_GATE_HINT_TO_DOOR = {
        'enter the largest measurement for the width of your gate.': 'Enter the largest measurement for the width of your door.',
        'enter the tallest measurement for the height of your gate.': 'Enter the tallest measurement for the height of your door.',
        'enter the measurement for the thickness of your gate.': 'Enter the measurement for the thickness of your door.',
        'enter the measurement for the thickness of your gates': 'Enter the measurement for the thickness of your door.'
    };

    // Hint override keyed by ORIGINAL TITLE (takes priority over the hint-text map).
    // Lets the Finished Opening "Door Thickness" row use a different hint than the
    // Exact "Exact Door Thickness" row even though their original hint text matches.
    var PET_GATES_MEASURE_HINT_BY_TITLE = {
        'door thickness': 'Enter the measurement for the thickness of your gates',
        'exact door thickness': 'Enter the measurement for the thickness of your gate.'
    };

    function normalizeGateMeasureOriginalTitle(title) {
        var key = String(title || '').trim().toLowerCase();
        return PET_GATES_GATE_TITLE_TO_DOOR[key] || title;
    }

    function normalizeGateMeasureOriginalHint(hint) {
        var key = String(hint || '').trim().toLowerCase();
        return PET_GATES_GATE_HINT_TO_DOOR[key] || hint;
    }

    function applyPetGatesMeasurementDimensionCopy(rootEl) {
        rootEl = rootEl || document.getElementById('door-configurator-options') || document;
        var isGate = isGateCollection();
        var sideTransType = getSidelightTransomCollectionType();
        try {
            rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
                var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                var hintEl = row.querySelector('.door-measure-dimension-hint');
                if (!titleEl) return;

                var liveTitle = String(titleEl.textContent || '').trim();
                if (!titleEl.getAttribute('data-door-original-title')) {
                    titleEl.setAttribute(
                        'data-door-original-title',
                        normalizeGateMeasureOriginalTitle(liveTitle)
                    );
                } else {
                    // Repair originals that were accidentally captured after a Gate rename.
                    var storedTitle = titleEl.getAttribute('data-door-original-title') || '';
                    var repairedTitle = normalizeGateMeasureOriginalTitle(storedTitle);
                    if (repairedTitle && repairedTitle !== storedTitle) {
                        titleEl.setAttribute('data-door-original-title', repairedTitle);
                    }
                }
                if (hintEl && !hintEl.getAttribute('data-door-original-hint')) {
                    hintEl.setAttribute(
                        'data-door-original-hint',
                        normalizeGateMeasureOriginalHint(String(hintEl.textContent || '').trim())
                    );
                } else if (hintEl) {
                    var storedHint = hintEl.getAttribute('data-door-original-hint') || '';
                    var repairedHint = normalizeGateMeasureOriginalHint(storedHint);
                    if (repairedHint && repairedHint !== storedHint) {
                        hintEl.setAttribute('data-door-original-hint', repairedHint);
                    }
                }

                var origTitle = titleEl.getAttribute('data-door-original-title') || '';
                var titleKey = origTitle.toLowerCase();
                var titleCopy = PET_GATES_EXACT_MEASURE_TITLE_COPY[titleKey];
                var origKey = normalizeOptionIdKey(origTitle);

                if (isGate && titleCopy) {
                    titleEl.textContent = titleCopy;
                    if (hintEl) {
                        var origHint = hintEl.getAttribute('data-door-original-hint') || '';
                        var hintCopy = PET_GATES_MEASURE_HINT_BY_TITLE[titleKey]
                            || PET_GATES_EXACT_MEASURE_HINT_COPY[origHint.toLowerCase()]
                            || mapCollectionDoorWording(origHint);
                        if (hintCopy) hintEl.textContent = hintCopy;
                    }
                } else if (isGate) {
                    // Gate collection but no mapped title — still rewrite door→gate in hints.
                    if (hintEl) {
                        var gateHintSrc = hintEl.getAttribute('data-door-original-hint') || hintEl.textContent || '';
                        hintEl.textContent = mapCollectionDoorWording(gateHintSrc);
                    }
                } else if (
                    sideTransType
                    && (origKey === 'door_thickness' || origKey === 'exact_door_thickness')
                ) {
                    // Keep sidelight/transom rename; do NOT restore "Door Thickness".
                    titleEl.textContent = sideTransType === 'transom'
                        ? 'Transom Thickness'
                        : 'Sidelight Thickness';
                    if (hintEl) {
                        var sideHint = String(hintEl.getAttribute('data-door-original-hint') || hintEl.textContent || '');
                        hintEl.textContent = mapCollectionDoorWording(sideHint);
                    }
                } else if (sideTransType && hintEl) {
                    var anyHint = String(hintEl.getAttribute('data-door-original-hint') || hintEl.textContent || '');
                    hintEl.textContent = mapCollectionDoorWording(anyHint);
                } else if (!isGate) {
                    // Unwind gate wording only when leaving garden/pet gate collections.
                    var curTitle = String(titleEl.textContent || '').trim().toLowerCase();
                    if (curTitle.indexOf('gate') !== -1 && origTitle) {
                        titleEl.textContent = origTitle;
                        if (hintEl) {
                            hintEl.textContent = hintEl.getAttribute('data-door-original-hint') || hintEl.textContent;
                        }
                    }
                }

                // Dp start VDN-390 23-10
                var livePreHung = String(titleEl.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
                var origPreHung = String(titleEl.getAttribute('data-door-original-title') || '').trim().toLowerCase().replace(/\s+/g, ' ');
                if (
                    livePreHung === 'pre-hung unit depth'
                    || livePreHung === 'pre hung unit depth'
                    || origPreHung === 'pre-hung unit depth'
                    || origPreHung === 'pre hung unit depth'
                    || livePreHung === 'pre-hung jamb width'
                    || livePreHung === 'pre hung jamb width'
                    || origPreHung === 'pre-hung jamb width'
                    || origPreHung === 'pre hung jamb width'
                    || livePreHung === 'pre-hung jamb depth'
                    || livePreHung === 'pre hung jamb depth'
                    || origPreHung === 'pre-hung jamb depth'
                    || origPreHung === 'pre hung jamb depth'
                ) {
                    titleEl.setAttribute('data-door-original-title', 'Pre-hung Jamb Depth');
                    if (!isGate) titleEl.textContent = 'Pre-hung Jamb Depth';
                }
                if (hintEl && !isGate) {
                    var liveHintPh = String(hintEl.textContent || '').trim();
                    var origHintPh = String(hintEl.getAttribute('data-door-original-hint') || liveHintPh).trim();
                    if (/^(?:depth|width) should include finished wall thickness\.?$/i.test(liveHintPh)
                        || /^(?:depth|width) should include finished wall thickness\.?$/i.test(origHintPh)) {
                        hintEl.setAttribute('data-door-original-hint', 'Width should include finished wall thickness.');
                        hintEl.textContent = 'Width should include finished wall thickness.';
                    }
                }
                // Dp end VDN-390 23-10
            });
            if (sideTransType) applySidelightTransomDoorWordingCopy(rootEl);
        } catch (ePetCopy) { }
    }

    function petGatesExactMeasureTitleCopy(title) {
        if (!isGateCollection()) return title;
        var key = String(title || '').trim().toLowerCase();
        return PET_GATES_EXACT_MEASURE_TITLE_COPY[key] || title;
    }

    function petGatesExactMeasureHintCopy(hint) {
        if (!isGateCollection()) return hint;
        var key = String(hint || '').trim().toLowerCase();
        return PET_GATES_EXACT_MEASURE_HINT_COPY[key] || hint;
    }

    function petGatesExistingMeasureIntroCopy(text) {
        if (!isGateCollection()) return text;
        var s = String(text || '');
        if (s === 'Add your measurements for your Existing Door') return 'Add your measurements for your Existing Gate';
        if (s.indexOf('Existing Door') !== -1) return s.replace(/Existing Door/g, 'Existing Gate');
        return s;
    }

    function parsePetGatesMeasureFraction(val) {
        if (val == null || val === '') return 0;
        var s = String(val).trim();
        if (!s) return 0;
        var n = parseFloat(s);
        if (!isNaN(n)) return n;
        if (s === '½') return 0.5;
        if (s === '¼') return 0.25;
        if (s === '¾') return 0.75;
        if (s.indexOf('/') !== -1) {
            var parts = s.split('/');
            if (parts.length >= 2) {
                var a = parseFloat(parts[0]);
                var b = parseFloat(parts[1]);
                if (!isNaN(a) && !isNaN(b) && b) return a / b;
            }
        }
        return 0;
    }

    function petGatesPricingDebugEnabled() {
        try { return window.DOOR_PET_GATES_PRICE_DEBUG === true; } catch (eDbg) { return false; }
    }

    function logPetGatesPricing(label, data) {
        if (!petGatesPricingDebugEnabled()) return;
        try {
            if (data !== undefined) console.log('[pet-gates-pricing]', label, data);
            else console.log('[pet-gates-pricing]', label);
        } catch (eLog) { }
    }

    function logPetGatesChangeSimple(widthIn, heightIn, info) {
        try {
            info = info || { price: 0, multiplier: 1, handle: '' };
            var price = parseFloat(info.price) || 0;
            var line = '[pet-gates-pricing] ' + String(widthIn) + '" x ' + String(heightIn) + '" → addon $' + price;
            if (price > 0) {
                if (info.multiplier && info.multiplier !== 1) {
                    line += '  (oversized height: ' + info.handle + ' base x' + info.multiplier + ')';
                } else if (info.handle) {
                    line += '  (' + info.handle + ')';
                }
                console.log(line);
                return;
            }
            var catalog = readPetGatesPricingCatalog();
            if (!catalog.length) {
                console.log(line + '  (catalog EMPTY — check #door-pet-gates-pricing-json / gates metaobjects)');
                return;
            }
            var handles = catalog.map(function (r) { return (r && (r.handle || r.key)) || '?'; });
            console.log(line + '  (no matching row; ' + catalog.length + ' handles: ' + handles.join(', ') + ')');
        } catch (eLog) { }
    }

    /** Panel visible — native <select> may be display:none (div dropdown). */
    function isPetGatesMeasureSelectInActivePanel(el) {
        if (!el || String(el.tagName || '').toUpperCase() !== 'SELECT') return false;
        var panel = el.closest ? el.closest('.door-measurement-static-panel') : null;
        if (panel && panel.classList && panel.classList.contains('door-hidden')) return false;
        var wrap = el.closest ? el.closest('.door-measurement-static-rows, .door-measurement-embedded-dimensions') : null;
        if (wrap && wrap.classList && wrap.classList.contains('door-hidden')) return false;
        return true;
    }

    function isExactGateOrDoorWidthTitle(title) {
        var t = String(title || '').toLowerCase();
        return t.indexOf('width') !== -1 && (t.indexOf('door') !== -1 || t.indexOf('gate') !== -1);
    }

    function isExactGateOrDoorHeightTitle(title) {
        var t = String(title || '').toLowerCase();
        return t.indexOf('height') !== -1 && (t.indexOf('door') !== -1 || t.indexOf('gate') !== -1);
    }

    function firstActivePetGatesMeasureSelect(selector) {
        try {
            var nodes = document.querySelectorAll(selector);
            for (var i = 0; i < nodes.length; i++) {
                var el = nodes[i];
                if (!isPetGatesMeasureSelectInActivePanel(el)) continue;
                return el;
            }
        } catch (eVis) { }
        return null;
    }

    function findPetGatesExactMeasureSelect(unit) {
        unit = String(unit || '');
        var wantWidth = unit.indexOf('width') !== -1;
        var wantHeight = unit.indexOf('height') !== -1;
        var wantFrac = unit.indexOf('frac') !== -1;
        var idSelector = '';
        if (wantWidth && !wantFrac) {
            idSelector = 'select#exact-door-width-int, select[id^="exact-door-width-int"], select[id^="exact-gate-width-int"]';
        } else if (wantWidth && wantFrac) {
            idSelector = 'select#exact-door-width-frac, select[id^="exact-door-width-frac"], select[id^="exact-gate-width-frac"]';
        } else if (wantHeight && !wantFrac) {
            idSelector = 'select#door_height, select[id^="door_height"]:not([id*="fraction"]):not([id*="frac"])';
        } else if (wantHeight && wantFrac) {
            idSelector = 'select#door_height_fraction, select[id^="door_height_fraction"], select[id^="door_height_frac"]';
        }
        if (idSelector) {
            var byId = firstActivePetGatesMeasureSelect(idSelector);
            if (byId) return byId;
        }
        try {
            var panels = document.querySelectorAll('.door-measurement-static-panel--exact');
            for (var pi = 0; pi < panels.length; pi++) {
                var panel = panels[pi];
                if (!panel || (panel.classList && panel.classList.contains('door-hidden'))) continue;
                var rows = panel.querySelectorAll('.door-measure-dimension-row');
                for (var ri = 0; ri < rows.length; ri++) {
                    var row = rows[ri];
                    if (!row) continue;
                    var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                    var title = String((titleEl && titleEl.textContent) || '');
                    var match = (wantWidth && isExactGateOrDoorWidthTitle(title)) || (wantHeight && isExactGateOrDoorHeightTitle(title));
                    if (!match) continue;
                    var sel = wantFrac
                        ? row.querySelector('select.door-dimension-frac-select')
                        : row.querySelector('select.door-dimension-int-select');
                    if (isPetGatesMeasureSelectInActivePanel(sel)) return sel;
                }
            }
        } catch (eRow) { }
        return null;
    }

    function isPetGatesExactMeasureSelectEl(el) {
        if (!el || String(el.tagName || '').toUpperCase() !== 'SELECT') return false;
        var id = String(el.id || '');
        if (id === 'exact-door-width-int' || id.indexOf('exact-door-width-int') === 0) return true;
        if (id === 'exact-door-width-frac' || id.indexOf('exact-door-width-frac') === 0) return true;
        if (id.indexOf('exact-gate-width-int') === 0 || id.indexOf('exact-gate-width-frac') === 0) return true;
        if (id === 'door_height' || (id.indexOf('door_height') === 0 && id.indexOf('fraction') === -1 && id.indexOf('frac') === -1)) return true;
        if (id === 'door_height_fraction' || id.indexOf('door_height_fraction') === 0 || id.indexOf('door_height_frac') === 0) return true;
        var row = el.closest ? el.closest('.door-measure-dimension-row') : null;
        if (!row) return false;
        var panel = row.closest ? row.closest('.door-measurement-static-panel--exact') : null;
        if (!panel || !isPetGatesMeasureSelectInActivePanel(el)) return false;
        var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
        var title = String((titleEl && titleEl.textContent) || '');
        if (!isExactGateOrDoorWidthTitle(title) && !isExactGateOrDoorHeightTitle(title)) return false;
        return el.classList && (el.classList.contains('door-dimension-int-select') || el.classList.contains('door-dimension-frac-select'));
    }

    function firstVisiblePetGatesHeightIntSelect() {
        return findPetGatesExactMeasureSelect('height-int');
    }

    function readPetGatesExactMeasureInchesFromDom() {
        var wIntEl = findPetGatesExactMeasureSelect('width-int');
        var wFracEl = findPetGatesExactMeasureSelect('width-frac');
        var hIntEl = findPetGatesExactMeasureSelect('height-int');
        var hFracEl = findPetGatesExactMeasureSelect('height-frac');
        var width = parseFloat(wIntEl && wIntEl.value != null ? wIntEl.value : 0) || 0;
        width += parsePetGatesMeasureFraction(wFracEl && wFracEl.value);
        var height = parseFloat(hIntEl && hIntEl.value != null ? hIntEl.value : 0) || 0;
        height += parsePetGatesMeasureFraction(hFracEl && hFracEl.value);
        return {
            width: width,
            height: height,
            elements: {
                widthInt: wIntEl ? wIntEl.id || '(no-id)' : null,
                widthFrac: wFracEl ? wFracEl.id || '(no-id)' : null,
                heightInt: hIntEl ? hIntEl.id || '(no-id)' : null,
                heightFrac: hFracEl ? hFracEl.id || '(no-id)' : null
            }
        };
    }

    function parsePetGatesCatalogHandleBounds(handle) {
        var s = String(handle || '').trim();
        var m = /^gates[-_](\d+(?:\.\d+)?)[-_](\d+(?:\.\d+)?)[-_](\d+(?:\.\d+)?)[-_](\d+(?:\.\d+)?)$/i.exec(s);
        if (m) {
            return {
                width_min: parseFloat(m[1]),
                width_max: parseFloat(m[2]),
                height_min: parseFloat(m[3]),
                height_max: parseFloat(m[4])
            };
        }
        // Tolerate handles with a single height value, e.g. gates-37-39-32 → height 32-32.
        var m3 = /^gates[-_](\d+(?:\.\d+)?)[-_](\d+(?:\.\d+)?)[-_](\d+(?:\.\d+)?)$/i.exec(s);
        if (m3) {
            return {
                width_min: parseFloat(m3[1]),
                width_max: parseFloat(m3[2]),
                height_min: parseFloat(m3[3]),
                height_max: parseFloat(m3[3])
            };
        }
        return null;
    }

    function readPetGatesPricingCatalog() {
        try {
            if (Array.isArray(window.__doorPetGatesPricingCatalog)) return window.__doorPetGatesPricingCatalog;
            var el = document.getElementById('door-pet-gates-pricing-json');
            if (!el) return [];
            var raw = String(el.textContent || '').trim();
            if (!raw) return [];
            var data = JSON.parse(raw);
            window.__doorPetGatesPricingCatalog = Array.isArray(data) ? data : [];
            return window.__doorPetGatesPricingCatalog;
        } catch (eCat) {
            return [];
        }
    }

    function parsePetGatesCatalogRowPrice(row) {
        var p = row.price != null ? row.price : (row.price_value != null ? row.price_value : row.amount);
        if (p && typeof p === 'object') {
            p = p.value != null ? p.value : (p.amount != null ? p.amount : p.price);
        }
        var parsed = parseFloat(p);
        return isNaN(parsed) ? 0 : parsed;
    }

    function getPetGatesCatalogRowBounds(row) {
        if (!row) return null;
        if (row.width_min != null && row.width_max != null && row.height_min != null && row.height_max != null) {
            return {
                width_min: parseFloat(row.width_min),
                width_max: parseFloat(row.width_max),
                height_min: parseFloat(row.height_min),
                height_max: parseFloat(row.height_max)
            };
        }
        return parsePetGatesCatalogHandleBounds(row.handle || row.key || '');
    }

    /**
     * Returns { price, multiplier, handle } for the given dimensions.
     * Normal: exact width+height band match (multiplier 1).
     * Oversized height: when height is above every band for the width, use the
     * highest height band's price and double it (multiplier 2).
     */
    function findPetGatesCatalogPriceInfo(widthIn, heightIn) {
        widthIn = parseFloat(widthIn);
        heightIn = parseFloat(heightIn);
        var none = { price: 0, multiplier: 1, handle: '' };
        if (isNaN(widthIn) || isNaN(heightIn) || widthIn <= 0 || heightIn <= 0) return none;
        var catalog = readPetGatesPricingCatalog();
        if (!catalog.length) return none;
        var topBand = null;
        for (var i = 0; i < catalog.length; i++) {
            var row = catalog[i] || {};
            var bounds = getPetGatesCatalogRowBounds(row);
            if (!bounds) continue;
            if (widthIn + 0.0001 < bounds.width_min || widthIn - 0.0001 > bounds.width_max) continue;
            if (heightIn + 0.0001 >= bounds.height_min && heightIn - 0.0001 <= bounds.height_max) {
                return {
                    price: parsePetGatesCatalogRowPrice(row),
                    multiplier: 1,
                    handle: row.handle || row.key || ''
                };
            }
            if (!topBand || bounds.height_max > topBand.bounds.height_max) {
                topBand = { row: row, bounds: bounds };
            }
        }
        if (topBand && heightIn - 0.0001 > topBand.bounds.height_max) {
            return {
                price: parsePetGatesCatalogRowPrice(topBand.row) * 2,
                multiplier: 2,
                handle: topBand.row.handle || topBand.row.key || ''
            };
        }
        return none;
    }

    function findPetGatesCatalogPrice(widthIn, heightIn) {
        return findPetGatesCatalogPriceInfo(widthIn, heightIn).price;
    }

    function clearPetGatesSupersededMeasurementAddons() {
        try {
            window['__doorAddon_intExtOversizedApi'] = 0;
            window['__doorAddon_intExtThicknessBand'] = 0;
            window.__doorIntExtAddonPrice = 0;
            window['__doorAddon_sidelightTransomOversized'] = 0;
            window['__doorAddon_sidelightTransomOversizedPair1'] = 0;
            window['__doorAddon_sidelightTransomOversizedPair2'] = 0;
        } catch (eClr) { }
        try {
            if (window.DoorIntExtPricingRule && typeof window.DoorIntExtPricingRule.clearIntExtGeneralOversizedAddonKeys === 'function') {
                window.DoorIntExtPricingRule.clearIntExtGeneralOversizedAddonKeys();
            }
        } catch (eClr2) { }
    }

    function syncPetGatesMeasurementPrice(changedEl, opts) {
        opts = opts || {};
        if (!isPetGatesCollection()) {
            window.__doorAddon_pet_gates_measurements = 0;
            return { price: 0, multiplier: 1, handle: '' };
        }
        var dims = readPetGatesExactMeasureInchesFromDom();
        var info = findPetGatesCatalogPriceInfo(dims.width, dims.height);
        var next = info.price > 0 ? info.price : 0;
        var prev = parseFloat(window.__doorAddon_pet_gates_measurements) || 0;
        clearPetGatesSupersededMeasurementAddons();
        window.__doorAddon_pet_gates_measurements = next;
        if (opts.uiSyncOnly) return info;
        var shouldSyncDisplay = !!changedEl || !!opts.force || Math.abs(prev - next) >= 0.01;
        if (!shouldSyncDisplay) return info;
        try {
            if (window.DoorIntExtPricingRule && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function') {
                window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                    source: 'petGatesMeasure',
                    silent: !changedEl,
                    userAction: !!changedEl
                });
            }
        } catch (ePrice) { }
        return info;
    }

    function isPetGatesMeasurementTypeRadioEl(el) {
        if (!el || String(el.tagName || '').toUpperCase() !== 'INPUT') return false;
        if (String(el.type || '').toLowerCase() !== 'radio') return false;
        var optId = el.getAttribute && el.getAttribute('data-option-id');
        return isMeasurementTypeOptionId(optId);
    }

    function resetPetGatesMeasurementPrice(changedEl) {
        if (!isPetGatesCollection()) return;
        clearPetGatesSupersededMeasurementAddons();
        window.__doorAddon_pet_gates_measurements = 0;
        try {
            if (window.DoorIntExtPricingRule && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function') {
                window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                    source: 'petGatesMeasureTabReset',
                    silent: !changedEl,
                    userAction: !!changedEl
                });
            }
        } catch (ePrice) { }
    }

    // Reset the width/height selections (both tab panels) back to their defaults so a
    // tab switch starts clean. Garden/pet gates; programmatic so no change events fire.
    function resetPetGatesMeasurementSelections() {
        if (!isGateCollection()) return;
        var container = document.getElementById('door-configurator-options');
        if (!container) return;
        var section = container.querySelector('.door-measurement-type-section') || container;
        // Ensure gate width/height selects carry Gate Width/Height ranges
        // before we reset the values. The tab-change path does not run the gate rules
        // sync, so the default height may not yet exist as an option in the
        // freshly shown panel; without this the height reset silently no-ops while
        // width (default '36') still matches a standard option.
        try { applyPetGatesDimensionSelectRanges(container); } catch (ePetDimRange) { }
        section.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
            if (!row) return;
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase();
            var intSel = row.querySelector('select.door-dimension-int-select');
            var fracSel = row.querySelector('select.door-dimension-frac-select');
            if (intSel && intSel.removeAttribute) intSel.removeAttribute('data-door-user-changed');
            if (fracSel && fracSel.removeAttribute) fracSel.removeAttribute('data-door-user-changed');
            if (title.indexOf('width') !== -1) {
                if (intSel) setMeasurementSelectValue(intSel, PET_GATES_DOOR_WIDTH_DEFAULT, { dispatchChange: false });
                if (fracSel) setMeasurementSelectValue(fracSel, DEFAULT_EXACT_DOOR_WIDTH_FRAC, { dispatchChange: false });
            } else if (title.indexOf('height') !== -1) {
                if (intSel) setMeasurementSelectValue(intSel, getDefaultExactDoorHeightInt(), { dispatchChange: false });
                if (fracSel) setMeasurementSelectValue(fracSel, DEFAULT_EXACT_DOOR_HEIGHT_FRAC, { dispatchChange: false });
            }
        });
    }

    // Gate collection tab switch (Exact Gate Size <-> Finished Opening Size): reset
    // width/height to defaults. Pet-gates also zeros the measurement addon price.
    function resetPetGatesMeasurementOnTabChange(changedEl) {
        if (!isGateCollection()) return;
        setTimeout(function () {
            if (!isGateCollection()) return;
            resetPetGatesMeasurementSelections();
            if (isPetGatesCollection()) {
                resetPetGatesMeasurementPrice(changedEl || true);
                var dims = readPetGatesExactMeasureInchesFromDom();
                logPetGatesChangeSimple(dims.width, dims.height, { price: 0, multiplier: 1, handle: '' });
            }
        }, 0);
    }

    function onPetGatesMeasurementFieldChange(e) {
        if (!isPetGatesCollection()) return;
        var t = e && e.target;
        if (!t) return;
        if (isPetGatesMeasurementTypeRadioEl(t)) {
            resetPetGatesMeasurementOnTabChange(t);
            return;
        }
        if (!isPetGatesExactMeasureSelectEl(t)) return;
        var info = syncPetGatesMeasurementPrice(t);
        var dims = readPetGatesExactMeasureInchesFromDom();
        logPetGatesChangeSimple(dims.width, dims.height, info);
    }

    var _petGatesMeasurePricingBound = false;
    function bindPetGatesMeasurementPricing() {
        if (_petGatesMeasurePricingBound) return;
        _petGatesMeasurePricingBound = true;
        document.addEventListener('change', onPetGatesMeasurementFieldChange, true);
    }

    function isFinishedOpeningMeasureTab(valueKey) {
        var v = normalizeOptionIdKey(valueKey);
        return v === MEASURE_TAB_FINISHED_OPENING || v === 'finished_opening';
    }

    function isRoughOpeningMeasureTab(valueKey) {
        var v = normalizeOptionIdKey(valueKey);
        return v === 'rough_opening_size' || v === 'rough_opening';
    }

    /**
     * Finished Opening Size tab must submit finished_opening / finished_opening_size —
     * never rough_opening_size (custom app / cart map the token literally).
     */
    function resolveFinishedOpeningTabValue(choice) {
        var raw = choice && choice.value != null && choice.value !== '' ? String(choice.value) : '';
        var n = normalizeOptionIdKey(raw);
        if (n === MEASURE_TAB_FINISHED_OPENING) return MEASURE_TAB_FINISHED_OPENING;
        if (n === 'finished_opening') return 'finished_opening';
        if (isRoughOpeningMeasureTab(n) || n.indexOf('rough') !== -1) {
            return 'finished_opening';
        }
        if (n && (n.indexOf('finished') !== -1 || (n.indexOf('opening') !== -1 && n.indexOf('rough') === -1))) {
            return raw;
        }
        return 'finished_opening';
    }

    /** True when label/value text is Finished Opening (not Rough Opening). */
    function isFinishedOpeningChoiceText(o) {
        var t = String((o && (o.label || o.title || o.value)) || '').toLowerCase();
        if (!t) return false;
        if (t.indexOf('rough') !== -1) return false;
        if (t.indexOf('jamb') !== -1) return false;
        if (t.indexOf('exact') !== -1) return false;
        return t.indexOf('finished') !== -1
            || (t.indexOf('opening') !== -1 && t.indexOf('rough') === -1);
    }

    /**
     * Normalize measurement tab list so Finished Opening Size never carries rough_opening_size.
     * Rough Opening Size keeps rough_opening_size only.
     */
    function normalizeFinishedVsRoughMeasurementTabValues(list) {
        if (!Array.isArray(list)) return list;
        return list.map(function (o) {
            if (!o) return o;
            var labelText = String((o.label || o.title || '') || '').toLowerCase();
            var valNorm = normalizeOptionIdKey(o.value);
            var vis = String(o.measureVis || '').toLowerCase();
            var looksFinished = isFinishedOpeningChoiceText(o)
                || vis === 'slab'
                || labelText.indexOf('finished') !== -1;
            var looksRough = isRoughOpeningMeasureTab(valNorm)
                || labelText.indexOf('rough') !== -1
                || valNorm.indexOf('rough') !== -1;
            if (looksFinished && !labelText.match(/\brough\b/) && (looksRough || !isFinishedOpeningMeasureTab(valNorm))) {
                var next = {};
                for (var k in o) {
                    if (Object.prototype.hasOwnProperty.call(o, k)) next[k] = o[k];
                }
                next.value = resolveFinishedOpeningTabValue(o);
                if (!next.label || looksRough) next.label = 'Finished Opening Size';
                if (!next.measureVis) next.measureVis = 'slab';
                return next;
            }
            if (looksRough && (labelText.indexOf('rough') !== -1 || isRoughOpeningMeasureTab(valNorm))) {
                var roughNext = {};
                for (var rk in o) {
                    if (Object.prototype.hasOwnProperty.call(o, rk)) roughNext[rk] = o[rk];
                }
                roughNext.value = 'rough_opening_size';
                if (!roughNext.label || isFinishedOpeningChoiceText(o)) roughNext.label = 'Rough Opening Size';
                if (!roughNext.measureVis) roughNext.measureVis = 'jamb';
                return roughNext;
            }
            return o;
        });
    }

    function isGateCollectionAllowedMeasureTab(valueKey) {
        if (!isGateCollection()) return false;
        var v = normalizeOptionIdKey(valueKey);
        if (v === MEASURE_TAB_EXACT_GATE) return true;
        // Dp start 05-08 point #30
        if (isGardenGatesCollection()) {
            return false;
        }
        // Dp end 05-08 point #30
        if (isFinishedOpeningMeasureTab(valueKey)) return true;
        return false;
    }

    function isGateCollectionHiddenMeasureTab(valueKey) {
        if (!isGateCollection()) return false;
        if (isGateCollectionAllowedMeasureTab(valueKey)) return false;
        var v = normalizeOptionIdKey(valueKey);
        if (!v) return false;
        if (v === MEASURE_TAB_EXACT_DOOR || isFinishedOpeningMeasureTab(valueKey)) return true;
        if (v.indexOf('rough') !== -1 || v.indexOf('jamb') !== -1) return true;
        if (v === MEASURE_TAB_EXACT_SIDELIGHT || v === MEASURE_TAB_EXACT_TRANSOM) return true;
        return true;
    }

    function approxGateThicknessInches(a, b) {
        return Math.abs(parseFloat(a) - parseFloat(b)) < 0.02;
    }

    function parseGateThicknessOptionInches(opt) {
        if (!opt) return NaN;
        var vv = opt.value != null ? String(opt.value).trim() : '';
        var pv = parseFloat(vv);
        if (!isNaN(pv) && pv > 0) return pv;
        var txt = String(opt.textContent || '').trim().toLowerCase();
        if (!txt) return NaN;
        if (txt.indexOf('2 1/4') !== -1 || txt.indexOf('2-1/4') !== -1) return 2.25;
        if (txt.indexOf('1 3/4') !== -1 || txt.indexOf('1-3/4') !== -1) return 1.75;
        if (txt.indexOf('1 1/2') !== -1 || txt.indexOf('1-1/2') !== -1) return 1.5;
        return NaN;
    }

    function isAllowedGateThicknessOption(opt) {
        if (!opt || !isGateCollection()) return true;
        var inches = parseGateThicknessOptionInches(opt);
        if (isNaN(inches)) return false;
        if (isPetGatesCollection()) return approxGateThicknessInches(inches, 1.5);
        if (isGardenGatesCollection()) {
            return approxGateThicknessInches(inches, 1.75) || approxGateThicknessInches(inches, 2.25);
        }
        return true;
    }

    function isExactDoorThicknessFracSelect(sel) {
        if (!sel || String(sel.tagName || '').toLowerCase() !== 'select') return false;
        var id = String(sel.id || '').toLowerCase();
        if (id === 'exact-door-thickness-frac' || id.indexOf('exact-door-thickness-frac') === 0) return true;
        if (id === 'door-thickness') return true;
        var row = sel.closest ? sel.closest('.door-measure-dimension-row') : null;
        if (row) {
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase();
            if (title.indexOf('sidelight thickness') !== -1 || title.indexOf('transom thickness') !== -1) return false;
            if (title.indexOf('exact door thickness') !== -1 || title.indexOf('exact gate thickness') !== -1) return true;
            if (title.indexOf('door thickness') !== -1 && title.indexOf('pre-hung') === -1) return true;
            if (title.indexOf('gate thickness') !== -1) return true;
        }
        return false;
    }

    /** Gate Thickness sheet: Pet = 1 1/2 only; Garden = 1 3/4–2 1/4 (default 1 3/4). */
    var GATE_THICKNESS_FRAC_LABELS = { '1.5': '1 1/2', '1.75': '1 3/4', '2.25': '2 1/4' };

    function getGateCollectionThicknessAllowedValues() {
        if (isPetGatesCollection()) return ['1.5'];
        if (isGardenGatesCollection()) return ['1.75', '2.25'];
        return null;
    }

    function rebuildGateThicknessFracSelectOptions(sel) {
        if (!sel || !isExactDoorThicknessFracSelect(sel)) return false;
        var allowedOrder = getGateCollectionThicknessAllowedValues();
        if (!allowedOrder || !allowedOrder.length) return false;
        var def = getDefaultExactDoorThicknessFracValue();
        if (allowedOrder.indexOf(def) < 0) def = allowedOrder[0];
        var marker = 'gate-thk:' + allowedOrder.join(',') + ':' + def;
        if (sel.getAttribute('data-gate-thickness-range') === marker) return false;
        var userChanged = measurementSelectUserChanged(sel);
        var prev = String(sel.value != null ? sel.value : '').trim();
        while (sel.firstChild) sel.removeChild(sel.firstChild);
        for (var i = 0; i < allowedOrder.length; i++) {
            var v = allowedOrder[i];
            var op = document.createElement('option');
            op.value = v;
            op.textContent = GATE_THICKNESS_FRAC_LABELS[v] || v;
            sel.appendChild(op);
        }
        var next = def;
        if (userChanged && allowedOrder.indexOf(prev) >= 0) next = prev;
        else if (allowedOrder.indexOf(prev) >= 0) next = prev;
        setMeasurementSelectValue(sel, next, { dispatchChange: false });
        sel.setAttribute('data-gate-thickness-range', marker);
        try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eReb) {
            try { syncMeasurementDivSelectUi(sel); } catch (eSync) { }
        }
        return true;
    }

    function applyGateCollectionThicknessFracSelects(rootEl) {
        if (!isGateCollection()) return;
        rootEl = rootEl || document.getElementById('door-configurator-options') || document;
        try {
            collectDoorThicknessFracSelects(rootEl).forEach(function (sel) {
                rebuildGateThicknessFracSelectOptions(sel);
            });
            rootEl.querySelectorAll('select').forEach(function (sel) {
                if (!isExactDoorThicknessFracSelect(sel)) return;
                rebuildGateThicknessFracSelectOptions(sel);
            });
        } catch (eGateThk) { }
    }

    function applyGateSwingChoiceVisibility(container, scopeEl) {
        if (!scopeEl) return;
        scopeEl.querySelectorAll('input[type="radio"][data-option-id="swing_direction"]').forEach(function (inp) {
            var allowed = isAllowedGateSwingDirectionValue(inp.value);
            var card = inp.closest ? inp.closest('.common-check-option, .door-sweep-extra-option, label.door-setup-option') : null;
            if (!allowed) {
                if (inp.checked) {
                    inp.checked = false;
                    if (card) card.classList.remove('common-check-option--selected');
                }
                if (card) {
                    card.classList.add('door-hidden');
                    card.style.display = 'none';
                    card.setAttribute('data-gate-swing-hidden', '1');
                }
                return;
            }
            if (card) {
                card.classList.remove('door-hidden');
                card.style.display = '';
                card.removeAttribute('data-gate-swing-hidden');
                card.removeAttribute('data-product-tag-hidden');
            }
        });
        scopeEl.querySelectorAll('select[data-option-id="swing_direction"] option').forEach(function (op) {
            if (!op || op.value === '') return;
            var allowed = isAllowedGateSwingDirectionValue(op.value);
            op.hidden = !allowed;
            op.disabled = !allowed;
            if (!allowed) op.setAttribute('data-gate-swing-hidden', '1');
            else op.removeAttribute('data-gate-swing-hidden');
        });
        scopeEl.querySelectorAll('select[data-option-id="swing_direction"]').forEach(function (sel) {
            var cur = String(sel.value || '');
            if (cur && !isAllowedGateSwingDirectionValue(cur)) {
                // Do not auto-pick first allowed — leave empty unless metafield/defaults set it.
                sel.value = '';
            }
        });
        // No first-option auto-select. Swing stays empty until the customer picks one,
        // or configurator_defaults / saved config applies a value.
    }

    function applyGateCollectionSwingDirectionRules(container) {
        if (!container || !isGateCollection()) return;
        container.querySelectorAll('.door-option-wrap[data-option-id="swing_direction"]').forEach(function (wrap) {
            wrap.classList.remove('door-hidden');
            wrap.style.display = '';
            wrap.removeAttribute('data-empty-hidden');
            wrap.removeAttribute('hidden');
            applyGateSwingChoiceVisibility(container, wrap);
        });
        container.querySelectorAll('.door-sweep-extra-options[data-swing-from-schema="1"]').forEach(function (swingWrap) {
            var parentWrap = swingWrap.closest('.door-option-wrap');
            if (parentWrap) {
                parentWrap.classList.remove('door-hidden');
                parentWrap.style.display = '';
                parentWrap.removeAttribute('data-empty-hidden');
            }
            var title = parentWrap && parentWrap.querySelector('.fw-600.pt-24');
            if (title) title.classList.remove('d-none');
            applyGateSwingChoiceVisibility(container, swingWrap);
        });
    }

    function applyGateCollectionMeasurementTabs(container, schema) {
        if (!container || !schema || !isGateCollection()) return;
        var wrap = container.querySelector('.door-measurement-type-section.door-option-wrap');
        if (!wrap) return;
        wrap.classList.remove('door-hidden');
        wrap.style.display = '';
        var measureOpt = findMeasurementTypeOption(schema);
        var measureOptId = measureOpt && measureOpt.id ? measureOpt.id : 'measurement_type';
        var gateTabRadio = null;
        var checkedVisible = null;
        container.querySelectorAll('.door-measure-tab').forEach(function (tab) {
            var radio = tab.querySelector('input[type="radio"][data-option-id="measurement_type"], input[type="radio"][data-option-id="' + measureOptId + '"]');
            if (!radio) radio = tab.querySelector('input[type="radio"]');
            if (!radio) return;
            var valNorm = normalizeOptionIdKey(radio.value);
            var isGate = valNorm === MEASURE_TAB_EXACT_GATE;
            var shouldHide = isGateCollectionHiddenMeasureTab(radio.value);
            tab.classList.toggle('door-hidden', shouldHide);
            if (isGate) gateTabRadio = radio;
            if (!shouldHide && radio.checked) checkedVisible = radio;
            if (shouldHide && radio.checked) {
                radio.checked = false;
                tab.classList.remove('common-check-option--selected');
            }
        });
        var pick = checkedVisible || gateTabRadio;
        if (pick) {
            pick.checked = true;
            var pickTab = pick.closest('.door-measure-tab');
            if (pickTab) pickTab.classList.add('common-check-option--selected');
            try {
                applyMeasurementTypeTabSelection(pick, measureOptId, container, schema);
            } catch (eGateTab) { }
        }
    }

    function applyGardenGatesCollectionRules(container, schema) {
        container = container || document.getElementById('door-configurator-options');
        schema = schema || doorConfigSchemaRef();
        if (!container) return;
        if (!isGateCollection()) return;
        try {
            var main = document.getElementById('door-configurator');
            if (main) {
                main.classList.toggle('door-collection-garden-gates', isGardenGatesCollection());
                main.classList.toggle('door-collection-pet-gates', isPetGatesCollection());
            }
        } catch (eCls) { }
        if (isGateCollection()) applyGateCollectionSwingDirectionRules(container);
        if (isGateCollection()) applyGateCollectionMeasurementTabs(container, schema);
        if (isGateCollection()) applyGateCollectionThicknessFracSelects(container);
        applyPetGatesMeasurementDimensionCopy(container);
        var gateDimsAdjusted = false;
        try { gateDimsAdjusted = !!applyPetGatesDimensionSelectRanges(container); } catch (eGateDims) { }
        if (isPetGatesCollection()) {
            bindPetGatesMeasurementPricing();
            syncPetGatesMeasurementPrice(null, gateDimsAdjusted ? { force: true } : { uiSyncOnly: true });
        } else {
            window.__doorAddon_pet_gates_measurements = 0;
        }
    }

    function findMeasurementTypeOption(schema) {
        if (!Array.isArray(schema)) return null;
        for (var i = 0; i < schema.length; i++) {
            if (schema[i] && isMeasurementTypeOptionId(schema[i].id)) return schema[i];
        }
        return null;
    }

    function measurementTypeChoiceByValue(schema, valueKey) {
        var measureOpt = findMeasurementTypeOption(schema);
        if (!measureOpt || !Array.isArray(measureOpt.options)) return null;
        var want = normalizeOptionIdKey(valueKey);
        for (var j = 0; j < measureOpt.options.length; j++) {
            var c = measureOpt.options[j];
            if (!c) continue;
            if (normalizeOptionIdKey(c.value) === want) return c;
        }
        return null;
    }

    /** Prefer config_choice.title from measurement_type metaobject, then label. */
    function measurementTabLabelFromChoice(choice, fallback) {
        if (!choice) return fallback || '';
        var title = choice.title != null ? String(choice.title).trim() : '';
        if (title) return title;
        var label = choice.label != null ? String(choice.label).trim() : '';
        if (label) return label;
        return fallback || '';
    }

    function enrichMeasurementSidelightTransomTabEntry(tabEntry, schema) {
        if (!tabEntry || !schema) return tabEntry;
        var val = normalizeOptionIdKey(tabEntry.value);
        if (val !== MEASURE_TAB_EXACT_SIDELIGHT && val !== MEASURE_TAB_EXACT_TRANSOM) return tabEntry;
        var ch = measurementTypeChoiceByValue(schema, tabEntry.value);
        var disp = measurementTabLabelFromChoice(ch || tabEntry, tabEntry.label);
        if (disp) tabEntry.label = disp;
        if (ch && ch.title != null && String(ch.title).trim() !== '') tabEntry.title = ch.title;
        if (!tabEntry.measureVis) {
            tabEntry.measureVis = val === MEASURE_TAB_EXACT_SIDELIGHT ? 'sidelight' : 'transom';
        }
        return tabEntry;
    }

    function displayLabelForMeasurementTabChoice(o) {
        if (!o) return '';
        var valNorm = normalizeOptionIdKey(o.value);
        if (valNorm === MEASURE_TAB_EXACT_SIDELIGHT || valNorm === MEASURE_TAB_EXACT_TRANSOM) {
            return measurementTabLabelFromChoice(o, o.label || o.value || '');
        }
        if (o.title != null && String(o.title).trim() !== '') return String(o.title).trim();
        var t = String((o.label || o.value) || '').toLowerCase();
        if (t.indexOf('sidelight') !== -1 || (t.indexOf('transom') !== -1 && t.indexOf('sidelight') === -1)) {
            return measurementTabLabelFromChoice(o, o.label || o.value || '');
        }
        if (t.indexOf('gate') !== -1) return measurementTabLabelFromChoice(o, 'Exact Gate Size');
        if (t.indexOf('exact') !== -1) return 'Exact Door Size';
        if (t.indexOf('rough') !== -1 || isRoughOpeningMeasureTab(o.value)) return 'Rough Opening Size';
        if (t.indexOf('jamb') !== -1) return 'Jamb Unit Size';
        if (t.indexOf('finished') !== -1 || isFinishedOpeningMeasureTab(o.value)) return 'Finished Opening Size';
        // Do not map bare "opening" → Finished (that wrongly labeled Rough Opening Size).
        return o.label || o.value ? String(o.label || o.value) : '';
    }

    function isMeasurementSidelightTransomTabValue(valueKey) {
        var v = normalizeOptionIdKey(valueKey);
        return v === MEASURE_TAB_EXACT_SIDELIGHT || v === MEASURE_TAB_EXACT_TRANSOM;
    }

    /** Map measurement tab values to catalog JSON secondary slugs (door / sidelight / transom). */
    function measurementCatalogAliasesForTab(tabValueKey) {
        var v = normalizeOptionIdKey(tabValueKey);
        if (v === MEASURE_TAB_EXACT_DOOR) {
            return ['door', 'exact', 'exact_door_size', 'exact-door-size', 'slab', 'entrance-units', 'entrance-unit', 'entrance'];
        }
        if (v === MEASURE_TAB_EXACT_SIDELIGHT) {
            return ['sidelight', 'exterior-sidelights', 'exact_sidelight_size', 'exact-sidelight-size'];
        }
        if (v === MEASURE_TAB_EXACT_TRANSOM) {
            return ['transom', 'exterior-transoms', 'exact_transom_size', 'exact-transom-size'];
        }
        return [normProductTagSlug(tabValueKey)];
    }

    function catalogSecondaryMatchesMeasurementTab(secNorm, tabValueKey) {
        if (!secNorm) return false;
        var aliases = measurementCatalogAliasesForTab(tabValueKey);
        for (var ai = 0; ai < aliases.length; ai++) {
            var a = aliases[ai];
            if (secNorm === a) return true;
            if (a === 'sidelight' && secNorm === 'sidelights') return true;
            if (a === 'exterior-sidelights' && secNorm === 'sidelight') return true;
        }
        return false;
    }

    function isMeasurementCatalogShowWhenProductTags(raw) {
        raw = parseShowWhenProductTagsRaw(raw);
        if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return false;
        return Object.keys(raw).some(function (k) {
            return k !== 'dontShowCollection' && Array.isArray(raw[k]);
        });
    }

    function getMeasurementTabCatalogLineTagSets(raw, tabValueKey) {
        raw = parseShowWhenProductTagsRaw(raw);
        if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return [];
        var sets = [];
        Object.keys(raw).forEach(function (primaryTag) {
            if (primaryTag === 'dontShowCollection') return;
            var secondaries = raw[primaryTag];
            if (!Array.isArray(secondaries)) return;
            var primaryNorm = normProductTagSlug(primaryTag);
            if (!primaryNorm) return;
            if (!secondaries.length) {
                sets.push([primaryNorm]);
                return;
            }
            secondaries.forEach(function (secondaryTag) {
                if (catalogSecondaryMatchesMeasurementTab(normProductTagSlug(secondaryTag), tabValueKey)) {
                    sets.push([primaryNorm]);
                }
            });
        });
        return sets;
    }

    function measurementTabBlockedByDontShowCollection(raw, urlCollectionHandle) {
        if (!urlCollectionHandle) return false;
        raw = parseShowWhenProductTagsRaw(raw);
        if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return false;
        var list = raw.dontShowCollection;
        if (!Array.isArray(list)) return false;
        return list.some(function (h) { return normProductTagSlug(h) === urlCollectionHandle; });
    }

    function measurementHasTagRuleForChoice(choice) {
        var raw = choice && choice.showWhenProductTags;
        if (raw == null) return false;
        if (typeof raw === 'string') return raw.trim() !== '';
        if (Array.isArray(raw)) return raw.length > 0;
        if (typeof raw === 'object') {
            return Object.keys(raw).some(function (k) { return k !== 'dontShowCollection'; });
        }
        return false;
    }
    /** Exact sidelight / transom tabs: product must carry matching tag (e.g. sidelight, transom). */
    function productTagsIncludeMeasurementComponent(productTags, tabValueKey) {
        if (!Array.isArray(productTags) || !productTags.length) return false;
        var valNorm = normalizeOptionIdKey(tabValueKey);
        var component = valNorm === MEASURE_TAB_EXACT_SIDELIGHT
            ? 'sidelight'
            : valNorm === MEASURE_TAB_EXACT_TRANSOM
                ? 'transom'
                : '';
        if (!component) return false;
        var aliases = measurementCatalogAliasesForTab(tabValueKey);
        return productTags.some(function (tag) {
            var n = normProductTagSlug(tag);
            if (!n) return false;
            for (var i = 0; i < aliases.length; i++) {
                if (n === aliases[i] || n.indexOf(aliases[i]) !== -1) return true;
            }
            return n.indexOf(component) !== -1;
        });
    }
    /** show_when_product_tags — measurement section (exact_door_size / exact_sidelight_size / exact_transom_size). */
    function resolveMeasurementTabProductTagShouldHide(schema, tabValueKey) {
        var ch = measurementTypeChoiceByValue(schema, tabValueKey);
        var ctx = getConfiguratorProductTagContext(schema);
        var productTags = ctx.productTags || [];
        var valNorm = normalizeOptionIdKey(tabValueKey);
        if (valNorm === MEASURE_TAB_EXACT_DOOR) {
            return isSidelightOrTransomCollectionActive();
        }
        // --- Dp start ---
        var optionsContainer = document.getElementById('door-configurator-options') || document;
        var configEl = document.getElementById('door-configurator') || document.getElementById('landing-product-configurator');
        var productName = configEl ? String(configEl.getAttribute('data-product-name') || '').toLowerCase() : '';
        var colHandle = String(ctx.urlCollectionHandle || '').toLowerCase();

        // --- Dp start 14-07  ---
        var hasSidelightInCollections = false;
        var hasTransomInCollections = false;
        try {
            var handles = [];
            if (colHandle) handles.push(colHandle);
            if (configEl) {
                var routeCol = String(configEl.getAttribute('data-route-collection') || '').toLowerCase();
                if (routeCol) handles.push(routeCol);
                var rawHandles = configEl.getAttribute('data-product-collection-handles') || '[]';
                var parsedHandles = JSON.parse(rawHandles);
                if (Array.isArray(parsedHandles)) {
                    parsedHandles.forEach(function (h) {
                        if (h) handles.push(String(h).toLowerCase());
                    });
                }
            }
            handles.forEach(function (h) {
                if (h.indexOf('sidelight') !== -1) hasSidelightInCollections = true;
                if (h.indexOf('transom') !== -1) hasTransomInCollections = true;
            });
        } catch (eCol) { }
        // --- Dp end 14-07  ---

        if (valNorm === MEASURE_TAB_EXACT_SIDELIGHT) {
            var activeSidelight = hasActiveSidelightSelection(schema, optionsContainer);
            // --- Dp start 14-07  ---
            var isSidelightProduct = colHandle.indexOf('sidelight') !== -1 || hasSidelightInCollections;
            // --- Dp end 14-07  ---
            var allowedByTags = productTagsIncludeMeasurementComponent(productTags, tabValueKey);
            if (activeSidelight || isSidelightProduct || allowedByTags) {
                return false;
            }
            return true;
        }
        if (valNorm === MEASURE_TAB_EXACT_TRANSOM) {
            var activeTransom = hasActiveTransomSelection(schema, optionsContainer);
            // --- Dp start 14-07  ---
            var isTransomProduct = colHandle.indexOf('transom') !== -1 || hasTransomInCollections;
            // --- Dp end 14-07  ---
            var allowedByTags = productTagsIncludeMeasurementComponent(productTags, tabValueKey);
            if (activeTransom || isTransomProduct || allowedByTags) {
                return false;
            }
            return true;
        }
        // --- Dp end --
        var tagSets = [];
        var dontShowRaw = null;
        var hasPerChoiceRule = ch && choiceHasShowWhenProductTagsField(ch) && measurementHasTagRuleForChoice(ch);

        if (hasPerChoiceRule) {
            dontShowRaw = ch.showWhenProductTags;
            if (isMeasurementCatalogShowWhenProductTags(ch.showWhenProductTags)) {
                tagSets = getMeasurementTabCatalogLineTagSets(ch.showWhenProductTags, tabValueKey);
            } else {
                tagSets = normalizeTagSetsForChoice(ch.showWhenProductTags, tabValueKey, {
                    productTagsOnly: true
                });
            }
        }

        if (!tagSets.length && ctx.globalTagMap) {
            var globalSets = getMeasurementTabCatalogLineTagSets(ctx.globalTagMap, tabValueKey);
            if (globalSets.length) {
                tagSets = globalSets;
                dontShowRaw = dontShowRaw || ctx.globalTagMap;
            }
        }

        if (!tagSets.length) return false;

        var hide = !tagSetsMatchProductTags(tagSets, productTags);
        if (!hide && measurementTabBlockedByDontShowCollection(dontShowRaw || ctx.globalTagMap, ctx.urlCollectionHandle)) {
            hide = true;
        }
        return hide;
    }

    function measurementTabAllowedByProductTags(schema, valueKey) {
        if (isGateCollection()) return isGateCollectionAllowedMeasureTab(valueKey);
        return !resolveMeasurementTabProductTagShouldHide(schema, valueKey);
    }

    function mergeMeasurementSidelightTransomTabs(list, schema, optionsContainer) {
        list = Array.isArray(list) ? list.slice() : [];
        var seen = {};
        list.forEach(function (x) {
            if (x && x.value != null && x.value !== '') seen[String(x.value)] = true;
        });
        list = list.map(function (x) { return enrichMeasurementSidelightTransomTabEntry(x, schema); });
        list = list.filter(function (x) {
            if (!x) return false;
            if (isGateCollection()) {
                return isGateCollectionAllowedMeasureTab(x.value);
            }
            var v = normalizeOptionIdKey(x.value);
            if (v === MEASURE_TAB_EXACT_DOOR) {
                return !isSidelightOrTransomCollectionActive();
            }
            if (v === MEASURE_TAB_EXACT_SIDELIGHT || v === MEASURE_TAB_EXACT_TRANSOM || v === MEASURE_TAB_EXACT_GATE) {
                return measurementTabAllowedByProductTags(schema, x.value);
            }
            return true;
        });
        var seenAfterFilter = {};
        list.forEach(function (x) {
            if (x && x.value != null && x.value !== '') seenAfterFilter[String(x.value)] = true;
        });
        if (isGateCollection()) {
            if (!seenAfterFilter[MEASURE_TAB_EXACT_GATE]) {
                var gateCh = measurementTypeChoiceByValue(schema, MEASURE_TAB_EXACT_GATE);
                list.push({
                    value: MEASURE_TAB_EXACT_GATE,
                    label: measurementTabLabelFromChoice(gateCh, 'Exact Gate Size'),
                    title: gateCh && gateCh.title,
                    measureVis: 'always'
                });
                seenAfterFilter[MEASURE_TAB_EXACT_GATE] = true;
            }
            if (!seenAfterFilter[MEASURE_TAB_FINISHED_OPENING] && !seenAfterFilter.finished_opening) {
                var finCh = measurementTypeChoiceByValue(schema, MEASURE_TAB_FINISHED_OPENING)
                    || measurementTypeChoiceByValue(schema, 'finished_opening');
                var finVal = resolveFinishedOpeningTabValue(finCh);
                list.push({
                    value: finVal,
                    label: measurementTabLabelFromChoice(finCh, 'Finished Opening Size'),
                    title: finCh && finCh.title,
                    measureVis: 'slab'
                });
            }
            return list;
        }
        if (!seenAfterFilter[MEASURE_TAB_EXACT_SIDELIGHT] && measurementTabAllowedByProductTags(schema, MEASURE_TAB_EXACT_SIDELIGHT)) {
            var sideCh = measurementTypeChoiceByValue(schema, MEASURE_TAB_EXACT_SIDELIGHT);
            list.push({
                value: MEASURE_TAB_EXACT_SIDELIGHT,
                label: measurementTabLabelFromChoice(sideCh, 'Exact Sidelight Size'),
                title: sideCh && sideCh.title,
                measureVis: 'sidelight'
            });
        }
        if (!seenAfterFilter[MEASURE_TAB_EXACT_TRANSOM] && measurementTabAllowedByProductTags(schema, MEASURE_TAB_EXACT_TRANSOM)) {
            var transCh = measurementTypeChoiceByValue(schema, MEASURE_TAB_EXACT_TRANSOM);
            list.push({
                value: MEASURE_TAB_EXACT_TRANSOM,
                label: measurementTabLabelFromChoice(transCh, 'Exact Transom Size'),
                title: transCh && transCh.title,
                measureVis: 'transom'
            });
        }
        return list;
    }

    function syncMeasurementSidelightTransomTabVisibility(optionsContainer, schema) {
        if (!optionsContainer || !schema) return;
        optionsContainer.querySelectorAll('.door-measure-tabs .door-measure-tab').forEach(function (tab) {
            var radio = tab.querySelector('input[type="radio"][data-option-id]');
            if (!radio) return;
            var v = String(radio.value || '');
            var valNorm = normalizeOptionIdKey(v);
            var hideTab = false;
            if (valNorm === MEASURE_TAB_EXACT_DOOR) {
                hideTab = isSidelightOrTransomCollectionActive();
            } else if (valNorm === MEASURE_TAB_EXACT_SIDELIGHT || valNorm === MEASURE_TAB_EXACT_TRANSOM) {
                hideTab = !measurementTabAllowedByProductTags(schema, v);
            } else {
                return;
            }
            tab.classList.toggle('door-hidden', hideTab);
            tab.style.display = hideTab ? 'none' : '';
            if (hideTab) tab.setAttribute('data-product-tag-hidden', '1');
            else tab.removeAttribute('data-product-tag-hidden');
            if (hideTab && radio.checked) {
                radio.checked = false;
                tab.classList.remove('common-check-option--selected');
            }
        });
    }

    function wireMeasurementDimensionSelectUnits(rootEl) {
        if (!rootEl) return;
        rootEl.querySelectorAll('.door-measure-dimension-row[data-embed-dimension-id]').forEach(function (row) {
            var oid = row.getAttribute('data-embed-dimension-id');
            if (!oid) return;
            var intSel = row.querySelector('select.door-dimension-int-select');
            var fracSel = row.querySelector('select.door-dimension-frac-select');
            if (intSel) {
                intSel.setAttribute('data-option-id', oid);
                intSel.setAttribute('data-unit', 'in-int');
            }
            if (fracSel) {
                fracSel.setAttribute('data-option-id', oid);
                fracSel.setAttribute('data-unit', 'in-frac');
            }
        });
    }

    function measurementTitleTwoWordKey(title) {
        var t = String(title || '').toLowerCase();
        t = t.replace(/[^a-z0-9]+/g, ' ').trim();
        if (!t) return '';
        var stop = {
            add: true, your: true, measurements: true, measurement: true, for: true, the: true, of: true,
            existing: true, desired: true, largest: true, widest: true, tallest: true, inside: true, include: true,
            exact: true, finished: true, rough: true, opening: true, size: true
        };
        var parts = t.split(/\s+/g).filter(function (p) { return p && !stop[p]; });
        if (!parts.length) parts = t.split(/\s+/g);
        // Prefer first 2 meaningful words; if the 2nd is "unit", skip to the next.
        var w1 = parts[0] || '';
        var w2 = parts[1] || '';
        if (w2 === 'unit' && parts[2]) w2 = parts[2];
        var key = sanitizeForDomId([w1, w2].filter(Boolean).join('-'));
        return key;
    }

    function rebuildMeasurementIntSelectOptions(intSel, min, max, step, preferredDefault) {
        if (!intSel) return;
        min = parseInt(min, 10);
        max = parseInt(max, 10);
        step = parseInt(step, 10) || 1;
        if (!isFinite(min) || !isFinite(max) || max < min) return;
        var prev = parseFloat(intSel.value);
        while (intSel.firstChild) intSel.removeChild(intSel.firstChild);
        // --- Dp start 17-07 (remove Select placeholder option) ---
        /*
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = 'Select';
        intSel.appendChild(ph);
        */
        // --- Dp end 17-07 (remove Select placeholder option) ---
        for (var v = min; v <= max; v += step) {
            var op = document.createElement('option');
            op.value = String(v);
            op.textContent = String(v);
            intSel.appendChild(op);
        }
        var def = preferredDefault != null && preferredDefault !== '' ? parseInt(preferredDefault, 10) : min;
        if (isFinite(prev) && prev >= min && prev <= max) intSel.value = String(prev);
        else if (isFinite(def) && def >= min && def <= max) intSel.value = String(def);
        else intSel.value = String(min);
    }

    /** Slab transom/combo panel rows only — not main exact-door-width-int (template default 36). */
    function fixPanelDoorWidthAndTransomHeightOptionRanges(rootEl) {
        if (!rootEl) return;
        var rows = rootEl.querySelectorAll('.door-measure-dimension-row');
        for (var ri = 0; ri < rows.length; ri++) {
            var row = rows[ri];
            if (!row) continue;
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase();
            var intSel = row.querySelector('select.door-dimension-int-select');
            if (!intSel) continue;
            var inSlabTransom = !!(row.closest && row.closest('.door-measurement-slab-transom-panels'));
            var inSlabCombo = !!(row.closest && row.closest('.door-measurement-slab-combo-panels'));
            if (title.indexOf('door width') !== -1 && (inSlabTransom || inSlabCombo)) {
                rebuildMeasurementIntSelectOptions(intSel, 10, 112, 1, 82);
            } else if (
                (title.indexOf('transom height') !== -1 || (title.indexOf('transom') !== -1 && title.indexOf('height') !== -1))
                && (inSlabTransom || inSlabCombo)
            ) {
                rebuildMeasurementIntSelectOptions(intSel, 10, 144, 1, 16);
            }
        }
    }

    var DEFAULT_EXACT_DOOR_WIDTH_INT = '36';
    var DEFAULT_EXACT_DOOR_WIDTH_FRAC = '0';
    // Single Item Door Width (#exact-door-width-int): min 15, max 48, default 36
    var EXACT_DOOR_WIDTH_INT_MIN = 15;
    var EXACT_DOOR_WIDTH_INT_MAX = 48;
    var EXACT_DOOR_WIDTH_INT_RANGE_ATTR = 'data-exact-door-width-range';
    // Dutch Door Width: same 15–48 range, default 32
    var DUTCH_DOOR_WIDTH_INT_DEFAULT = '32';
    var DUTCH_DOOR_WIDTH_INT_RANGE_ATTR = 'data-dutch-door-width-range';
    // --- Dp start 15-07 ---
    var DEFAULT_EXACT_DOOR_HEIGHT_INT = '80';
    // --- Dp end 15-07 ---
    var DEFAULT_EXACT_DOOR_HEIGHT_FRAC = '0';
    // Single Item dimension sheet ranges (int selects)
    var EXACT_DOOR_HEIGHT_INT_MIN = 60;
    var EXACT_DOOR_HEIGHT_INT_MAX = 147;
    var SIDELIGHT_WIDTH_INT_MIN = 8;
    var SIDELIGHT_WIDTH_INT_MAX = 24;
    var SIDELIGHT_WIDTH_INT_DEFAULT = '12';
    var SIDELIGHT_HEIGHT_INT_MIN = 60;
    var SIDELIGHT_HEIGHT_INT_MAX = 147;
    var SIDELIGHT_HEIGHT_INT_DEFAULT = '80';
    var TRANSOM_WIDTH_INT_MIN = 15;
    var TRANSOM_WIDTH_INT_MAX = 112;
    var TRANSOM_WIDTH_INT_DEFAULT = '36';
    var TRANSOM_HEIGHT_INT_MIN = 8;
    var TRANSOM_HEIGHT_INT_MAX = 24;
    var TRANSOM_HEIGHT_INT_DEFAULT = '12';
    // Single Item row 8 — Pre-Hung Jamb Width (#exact-pre-hung-int / Pre-hung Unit Depth)
    var PRE_HUNG_JAMB_WIDTH_INT_MIN = 4;
    var PRE_HUNG_JAMB_WIDTH_INT_MAX = 16;
    var PRE_HUNG_JAMB_WIDTH_FRAC_DEFAULT = '0.5625'; // 9/16
    var PRE_HUNG_JAMB_WIDTH_RANGE_ATTR = 'data-pre-hung-jamb-width-range';
    var SINGLE_ITEM_DIM_RANGE_ATTR = 'data-single-item-dim-range';

    // Screen & Storm doors: rebuild exact door int <select>s to a fixed inch range so
    // config_id edit page and captured/admin dropdowns match the live UI.
    // --- Dp start 22-07 (screen & storm exact width 1–144 like int/ext) ---
    // Width matches interior/exterior collection (1"–144"); height 1–150 so height > 147 is selectable.
    var SCREEN_STORM_EXACT_WIDTH_MIN = 1;
    var SCREEN_STORM_EXACT_WIDTH_MAX = 144;
    // --- Dp end 22-07 (screen & storm exact width 1–144 like int/ext) ---
    // --- Dp start 15-07 ---
    var SCREEN_STORM_EXACT_HEIGHT_MIN = 1;
    // --- Dp end 15-07 ---
    // --- Dp start 22-07 (height max 150 so oversized height > 147 can fire) ---
    var SCREEN_STORM_EXACT_HEIGHT_MAX = 150;
    // --- Dp end 22-07 (height max 150 so oversized height > 147 can fire) ---

    function isScreenAndStormProduct() {
        try {
            if (
                window.PriceScreenStorm
                && typeof window.PriceScreenStorm.isScreenAndStormDoorsProductType === 'function'
                && window.PriceScreenStorm.isScreenAndStormDoorsProductType()
            ) {
                return true;
            }
        } catch (eStormType) { }
        try {
            var main = document.getElementById('door-configurator');
            if (!main) return false;
            if (String(main.getAttribute('data-use-screen-storm-glass-meta') || '') === 'true') return true;
            var tags = readConfiguratorProductTags();
            for (var i = 0; i < tags.length; i++) {
                var t = String(tags[i] || '').toLowerCase().replace(/[\s_]+/g, '-');
                if (t === 'screen-and-storm-doors' || t.indexOf('screen-and-storm') === 0) return true;
            }
            var pt = String(main.getAttribute('data-product-type') || '').toLowerCase().replace(/[\s-]+/g, '_');
            if (pt === 'screen_and_storm_doors' || pt.indexOf('screen_and_storm') !== -1) return true;
        } catch (eDomSs) { }
        return false;
    }

    function readConfiguratorProductTags() {
        var tags = [];
        try {
            var main = document.getElementById('door-configurator');
            if (!main) return tags;
            var tagsAttr = main.getAttribute('data-product-tags') || '';
            try {
                tags = Array.isArray(JSON.parse(tagsAttr)) ? JSON.parse(tagsAttr) : [];
            } catch (eJson) {
                tags = String(tagsAttr || '').split(/[|,]/);
            }
        } catch (eTags) { }
        return tags;
    }

    function isDutchDoorsProduct() {
        try {
            var tags = readConfiguratorProductTags();
            for (var i = 0; i < tags.length; i++) {
                var t = String(tags[i] || '').toLowerCase().replace(/[\s_]+/g, '-');
                if (t === 'dutch-exterior-doors' || t === 'dutch-door' || t.indexOf('dutch-door') !== -1) return true;
            }
            var main = document.getElementById('door-configurator');
            if (main) {
                var pt = String(main.getAttribute('data-product-type') || '').toLowerCase();
                if (pt.indexOf('dutch') !== -1) return true;
                var handlesRaw = main.getAttribute('data-product-collection-handles') || '[]';
                try {
                    var handles = JSON.parse(handlesRaw);
                    if (Array.isArray(handles)) {
                        for (var hi = 0; hi < handles.length; hi++) {
                            var h = String(handles[hi] || '').toLowerCase().replace(/[\s_]+/g, '-');
                            if (h === 'dutch-exterior-doors' || h.indexOf('dutch-door') !== -1) return true;
                        }
                    }
                } catch (eH) { }
            }
        } catch (eDutch) { }
        return false;
    }

    function getDefaultExactDoorWidthInt() {
        if (isDutchDoorsProduct()) return DUTCH_DOOR_WIDTH_INT_DEFAULT;
        return DEFAULT_EXACT_DOOR_WIDTH_INT;
    }

    /** Single Item row 8 — Pre-Hung Jamb Width default int: 4 Interior/SS, 6 Exterior. */
    function getDefaultPreHungJambWidthInt() {
        if (isScreenAndStormProduct()) return '4';
        try {
            var tags = readConfiguratorProductTags();
            for (var i = 0; i < tags.length; i++) {
                var t = String(tags[i] || '').toLowerCase().replace(/[\s_]+/g, '-');
                if (t === 'interior-doors' || t === 'interior-door') return '4';
            }
            var main = document.getElementById('door-configurator');
            if (main) {
                if (String(main.getAttribute('data-use-interior-glass-meta') || '') === 'true') return '4';
                var pt = String(main.getAttribute('data-product-type') || '').toLowerCase();
                if (pt.indexOf('interior') !== -1 && pt.indexOf('exterior') === -1) return '4';
            }
        } catch (eIntPh) { }
        return '6';
    }

    function isPreHungJambWidthIntSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '').toLowerCase();
        if (id === 'exact-pre-hung-int' || id.indexOf('exact-pre-hung-int') === 0) return true;
        if (id.indexOf('frac') !== -1 || id.indexOf('fraction') !== -1) return false;
        var row = sel.closest && sel.closest('.door-measure-dimension-row');
        if (!row) return false;
        var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
        var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
        return title === 'pre-hung unit depth'
            || title === 'pre hung unit depth'
            || title === 'pre-hung jamb width'
            // Dp start VDN-390 23-10
            || title === 'pre hung jamb width'
            || title === 'pre-hung jamb depth'
            || title === 'pre hung jamb depth';
            // Dp end VDN-390 23-10
    }

    function isPreHungJambWidthFracSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '').toLowerCase();
        if (id === 'exact-pre-hung-frac' || id.indexOf('exact-pre-hung-frac') === 0) return true;
        if (id.indexOf('int') !== -1 && id.indexOf('frac') === -1) return false;
        var row = sel.closest && sel.closest('.door-measure-dimension-row');
        if (!row) return false;
        var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
        var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (
            title !== 'pre-hung unit depth'
            && title !== 'pre hung unit depth'
            && title !== 'pre-hung jamb width'
            && title !== 'pre hung jamb width'
            // Dp start VDN-390 23-10
            && title !== 'pre-hung jamb depth'
            && title !== 'pre hung jamb depth'
            // Dp end VDN-390 23-10
        ) return false;
        return !!(sel.classList && sel.classList.contains('door-dimension-frac-select'));
    }

    /**
     * Single Item row 8 — Pre-Hung Jamb Width (#exact-pre-hung-int):
     * min 4, max 16; default 4 9/16 Interior or Screen & Storm, 6 9/16 Exterior.
     */
    function applyPreHungJambWidthRange(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        var defInt = getDefaultPreHungJambWidthInt();
        var marker = PRE_HUNG_JAMB_WIDTH_INT_MIN + '-' + PRE_HUNG_JAMB_WIDTH_INT_MAX + ':' + defInt + ':' + PRE_HUNG_JAMB_WIDTH_FRAC_DEFAULT;

        function applyInt(sel) {
            if (!sel || !isPreHungJambWidthIntSelect(sel)) return;
            if (sel.removeAttribute) {
                sel.removeAttribute('data-door-ss-range');
                sel.removeAttribute('data-opening-layout-range');
            }
            var opts = sel.options || [];
            var firstOpt = opts.length ? parseInt(opts[0].value, 10) : NaN;
            var lastOpt = opts.length ? parseInt(opts[opts.length - 1].value, 10) : NaN;
            var rangeOk = firstOpt === PRE_HUNG_JAMB_WIDTH_INT_MIN && lastOpt === PRE_HUNG_JAMB_WIDTH_INT_MAX;
            // Dp start 26-08 — once range is applied, do NOT force default int on every
            // price/measurement sync (that snapped Pre-hung Unit Depth back after user change).
            if (sel.getAttribute(PRE_HUNG_JAMB_WIDTH_RANGE_ATTR) === marker && rangeOk) {
                return;
            }
            // Dp end 26-08
            // Dp merge code 10-09 start — keep the live int when already in 4–16 (frac already did this)
            var userChanged = measurementSelectUserChanged(sel);
            var curBefore = String(sel.value != null ? sel.value : '').trim();
            var curBeforeNum = parseInt(curBefore, 10);
            // First load: use 4 (Interior / Screen & Storm) or 6 (Exterior).
            // A later user pick inside 4–16 is kept.
            var keepCur =
                userChanged &&
                isFinite(curBeforeNum) &&
                curBeforeNum >= PRE_HUNG_JAMB_WIDTH_INT_MIN &&
                curBeforeNum <= PRE_HUNG_JAMB_WIDTH_INT_MAX;
            rebuildMeasurementIntSelectOptions(
                sel,
                PRE_HUNG_JAMB_WIDTH_INT_MIN,
                PRE_HUNG_JAMB_WIDTH_INT_MAX,
                1,
                keepCur ? curBefore : defInt
            );
            var curAfter = String(sel.value != null ? sel.value : '').trim();
            var curAfterNum = parseInt(curAfter, 10);
            var afterOk =
                isFinite(curAfterNum) &&
                curAfterNum >= PRE_HUNG_JAMB_WIDTH_INT_MIN &&
                curAfterNum <= PRE_HUNG_JAMB_WIDTH_INT_MAX;
            // Seed default only when empty / out of range — never snap a valid pick back to 4/6.
            if (!afterOk) {
                setMeasurementSelectValue(sel, defInt, { dispatchChange: false });
            } else if (keepCur && String(sel.value) !== String(curBeforeNum)) {
                setMeasurementSelectValue(sel, String(curBeforeNum), { dispatchChange: false });
            }
            // Dp merge code 10-09 end
            sel.setAttribute(PRE_HUNG_JAMB_WIDTH_RANGE_ATTR, marker);
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eRebPh) {
                try { syncMeasurementDivSelectUi(sel); } catch (eSyncPh) { }
            }
        }

        function applyFrac(sel) {
            if (!sel || !isPreHungJambWidthFracSelect(sel)) return;
            // Dp start 26-08 — respect user frac changes; only seed default once via marker on int sibling
            if (measurementSelectUserChanged(sel)) return;
            var cur = String(sel.value != null ? sel.value : '').trim();
            // "0" is the first option when nothing is selected — seed 9/16.
            // Any other fraction is a real pick; do not overwrite it.
            if (cur !== '' && cur !== '0' && cur !== PRE_HUNG_JAMB_WIDTH_FRAC_DEFAULT) {
                return;
            }
            // Dp end 26-08
            setMeasurementSelectValue(sel, PRE_HUNG_JAMB_WIDTH_FRAC_DEFAULT, { dispatchChange: false });
            try { syncMeasurementDivSelectUi(sel); } catch (eSyncPhf) { }
        }

        rootEl.querySelectorAll(
            'select#exact-pre-hung-int, select[id^="exact-pre-hung-int"]'
        ).forEach(applyInt);
        rootEl.querySelectorAll(
            'select#exact-pre-hung-frac, select[id^="exact-pre-hung-frac"]'
        ).forEach(applyFrac);

        rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
            if (!row) return;
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
            if (
                title !== 'pre-hung unit depth'
                && title !== 'pre hung unit depth'
                && title !== 'pre-hung jamb width'
                && title !== 'pre hung jamb width'
                // Dp start VDN-390 23-10
                && title !== 'pre-hung jamb depth'
                && title !== 'pre hung jamb depth'
                // Dp end VDN-390 23-10
            ) return;
            var intSel = row.querySelector('select.door-dimension-int-select');
            var fracSel = row.querySelector('select.door-dimension-frac-select');
            if (intSel) applyInt(intSel);
            if (fracSel) applyFrac(fracSel);
        });
    }

    function rebuildScreenStormIntSelectRange(sel, min, max, def) {
        if (!sel) return;
        var marker = min + '-' + max;
        // Skip if this exact range is already applied (rebuild preserves current value).
        if (sel.getAttribute('data-door-ss-range') === marker) {
            return;
        }
        // Drop single-item / exact-door markers so 15–48 liquid cannot stick on SS products.
        if (sel.removeAttribute) {
            sel.removeAttribute('data-exact-door-width-range');
            sel.removeAttribute('data-dutch-door-width-range');
            sel.removeAttribute('data-opening-layout-range');
            try {
                var attrs = sel.attributes;
                for (var ai = attrs.length - 1; ai >= 0; ai--) {
                    var an = attrs[ai] && attrs[ai].name;
                    if (an && an.indexOf('data-single-item-dim-range') === 0) sel.removeAttribute(an);
                }
            } catch (eAttr) { }
        }
        rebuildMeasurementIntSelectOptions(sel, min, max, 1, def);
        sel.setAttribute('data-door-ss-range', marker);
        try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eRebSs) {
            try { syncMeasurementDivSelectUi(sel); } catch (eSyncRange) { }
        }
    }

    // Match the EXACT door width/height rows by their visible title (the live storm-door
    // template gives the int <select> ids like "panel-door-width-int__37_0", so id-based
    // targeting is unreliable — title matching mirrors applyStaticMeasurementDimensionDefaults).
    function applyScreenStormExactDimensionRanges(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        if (!isScreenAndStormProduct()) return;
        var rows = rootEl.querySelectorAll('.door-measure-dimension-row');
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            if (!row) continue;
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase();
            // Only the door / opening dimensions — never sidelight / transom / combo panel rows.
            if (title.indexOf('sidelight') !== -1 || title.indexOf('transom') !== -1) continue;
            if (title.indexOf('panel door') !== -1 || title.indexOf('panel transom') !== -1) continue;
            var intSel = row.querySelector('select.door-dimension-int-select') || row.querySelector('select.door-measure-dimension-dd');
            if (!intSel) continue;
            // --- Dp start 22-07 (Exact / Finished / Rough / Jamb width+height  ranges) ---
            // Exact Door Width / Height use Single Item sheet — not SS 1–144 / 1–150.
            var isExactDoorWidthTitle = (
                title.indexOf('exact door width') !== -1
                || title.indexOf('exact gate width') !== -1
                || title === 'door width'
                || title === 'gate width'
            );
            var isExactDoorHeightTitle = (
                title.indexOf('exact door height') !== -1
                || title.indexOf('exact gate height') !== -1
                || title === 'door height'
                || title === 'gate height'
            );
            if (isExactDoorWidthTitle || isExactDoorHeightTitle) {
                continue;
            }
            if (
                title.indexOf('finished opening width') !== -1
                || title.indexOf('rough opening width') !== -1
                || title.indexOf('jamb unit width') !== -1
                || title.indexOf('opening width') !== -1
            ) {
                rebuildScreenStormIntSelectRange(intSel, SCREEN_STORM_EXACT_WIDTH_MIN, SCREEN_STORM_EXACT_WIDTH_MAX, DEFAULT_EXACT_DOOR_WIDTH_INT);
            } else if (
                title.indexOf('finished opening height') !== -1
                || title.indexOf('rough opening height') !== -1
                || title.indexOf('jamb unit height') !== -1
                || title.indexOf('opening height') !== -1
            ) {
                rebuildScreenStormIntSelectRange(intSel, SCREEN_STORM_EXACT_HEIGHT_MIN, SCREEN_STORM_EXACT_HEIGHT_MAX, DEFAULT_EXACT_DOOR_HEIGHT_INT);
            }
            // --- Dp end 22-07 (Exact / Finished / Rough / Jamb width+height  ranges) ---
        }
        // Exact Door Width/Height stay on Single Item sheet (applyExactDoorWidthIntRange / applySingleItemDimensionRanges).
        // --- Dp start 22-07 (finished / rough / jamb width+height by id) ---
        rootEl.querySelectorAll(
            'select#finished-width-int, select[id^="finished-width-int"],' +
            'select#rough-width-int, select[id^="rough-width-int"],' +
            'select#panel-width-int, select[id^="panel-width-int"]'
        ).forEach(function (sel) {
            if (sel.id && /frac/i.test(sel.id)) return;
            rebuildScreenStormIntSelectRange(sel, SCREEN_STORM_EXACT_WIDTH_MIN, SCREEN_STORM_EXACT_WIDTH_MAX, DEFAULT_EXACT_DOOR_WIDTH_INT);
        });
        rootEl.querySelectorAll(
            'select[id^="panel-height-int__"],' +
            'select#finished-height-int, select[id^="finished-height-int"],' +
            'select#rough-height-int, select[id^="rough-height-int"]'
        ).forEach(function (sel) {
            if (sel.id && /frac/i.test(sel.id)) return;
            // Bare #panel-height-int is slab Exact Door Width (15–48) — never SS height 1–150.
            if (sel.id === 'panel-height-int') return;
            rebuildScreenStormIntSelectRange(sel, SCREEN_STORM_EXACT_HEIGHT_MIN, SCREEN_STORM_EXACT_HEIGHT_MAX, DEFAULT_EXACT_DOOR_HEIGHT_INT);
        });
        // --- Dp end 22-07 (finished / rough / jamb width+height by id) ---
    }

    // Exact Gate Size / Finished Opening (garden-gates + pet-gates):
    // Gate Width 24–48 def 36, Gate Height 15–60 def 24
    var PET_GATES_DOOR_WIDTH_MIN = 24;
    var PET_GATES_DOOR_WIDTH_MAX = 48;
    var PET_GATES_DOOR_WIDTH_DEFAULT = '36';
    var PET_GATES_DOOR_WIDTH_RANGE_ATTR = 'data-gate-width-range';
    var PET_GATES_DOOR_HEIGHT_MIN = 15;
    var PET_GATES_DOOR_HEIGHT_MAX = 60;
    var PET_GATES_DOOR_HEIGHT_DEFAULT = '24';
    var PET_GATES_DOOR_HEIGHT_RANGE_ATTR = 'data-gate-height-range';

    function getDefaultExactDoorHeightInt() {
        if (isGateCollection()) return PET_GATES_DOOR_HEIGHT_DEFAULT;
        return DEFAULT_EXACT_DOOR_HEIGHT_INT;
    }

    function isPetGatesExactDoorHeightIntSelect(sel) {
        if (!sel || String(sel.tagName || '').toUpperCase() !== 'SELECT') return false;
        var id = String(sel.id || '');
        if (id.indexOf('fraction') !== -1 || id.indexOf('frac') !== -1) return false;
        if (id === 'door_height' || (id.indexOf('door_height') === 0 && id.indexOf('fraction') === -1)) return true;
        // Finished Opening Size panel uses a separate height int select that, like the
        // Exact Gate Size panel, must carry the Gate Height range.
        if (id === 'finished-height-int' || id.indexOf('finished-height-int') === 0) return true;
        return false;
    }

    function isPetGatesExactDoorWidthIntSelect(sel) {
        if (!sel || String(sel.tagName || '').toUpperCase() !== 'SELECT') return false;
        var id = String(sel.id || '');
        if (id.indexOf('fraction') !== -1 || id.indexOf('frac') !== -1) return false;
        if (id === 'exact-door-width-int' || id.indexOf('exact-door-width-int') === 0) return true;
        if (id === 'finished-width-int' || id.indexOf('finished-width-int') === 0) return true;
        return false;
    }

    function rebuildExactDoorHeightIntSelectOptions(intSel, min, max, preferredDefault) {
        if (!intSel) return false;
        min = parseInt(min, 10);
        max = parseInt(max, 10);
        if (!isFinite(min) || !isFinite(max) || max < min) return false;
        var prev = parseFloat(intSel.value);
        var userChanged = measurementSelectUserChanged(intSel);
        var def = parseInt(preferredDefault, 10);
        if (!isFinite(def)) def = min;
        if (def < min || def > max) def = min;
        while (intSel.firstChild) intSel.removeChild(intSel.firstChild);
        for (var v = min; v <= max; v++) {
            var op = document.createElement('option');
            op.value = String(v);
            op.textContent = String(v);
            intSel.appendChild(op);
        }
        var nextVal;
        if (userChanged && isFinite(prev) && prev >= min && prev <= max) nextVal = String(prev);
        else if (!userChanged) nextVal = String(def);
        else if (isFinite(prev) && prev >= min && prev <= max) nextVal = String(prev);
        else if (isFinite(prev) && prev > max) nextVal = String(max);
        else nextVal = String(min);
        var before = String(intSel.value != null ? intSel.value : '');
        setMeasurementSelectValue(intSel, nextVal);
        rebuildDoorDivSelectFromNativeOptions(intSel);
        return before !== String(intSel.value != null ? intSel.value : '');
    }

    // After the native <option> list of an enhanced select is rebuilt, the custom
    // .door-div-select dropdown still holds the old <button> items (it only re-syncs
    // labels, not the item list). Drop the stale wrapper and re-enhance so the
    // visible dropdown matches the new option range.
    function rebuildDoorDivSelectFromNativeOptions(sel) {
        if (!sel || sel.getAttribute('data-door-div-select') !== '1') return;
        var wrap = sel.nextElementSibling;
        if (wrap && wrap.classList && wrap.classList.contains('door-div-select')) {
            // Don't destroy an open list (thickness blink).
            if (wrap.classList.contains('door-div-select--open')) return;
            try { wrap.parentNode.removeChild(wrap); } catch (eRm) { }
        }
        sel.removeAttribute('data-door-div-select');
        if (sel.classList) sel.classList.remove('door-native-select--enhanced');
        enhanceDoorSelectWithDivDropdown(sel);
    }

    function applyPetGatesDoorHeightSelectRange(rootEl) {
        if (!isGateCollection()) return false;
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        var rangeKey = PET_GATES_DOOR_HEIGHT_MIN + '-' + PET_GATES_DOOR_HEIGHT_MAX + ':' + PET_GATES_DOOR_HEIGHT_DEFAULT;
        var changed = false;
        rootEl.querySelectorAll('select#door_height, select[id^="door_height"], select#finished-height-int, select[id^="finished-height-int"]').forEach(function (sel) {
            if (!isPetGatesExactDoorHeightIntSelect(sel)) return;
            if (sel.getAttribute(PET_GATES_DOOR_HEIGHT_RANGE_ATTR) === rangeKey) return;
            if (rebuildExactDoorHeightIntSelectOptions(
                sel,
                PET_GATES_DOOR_HEIGHT_MIN,
                PET_GATES_DOOR_HEIGHT_MAX,
                PET_GATES_DOOR_HEIGHT_DEFAULT
            )) {
                changed = true;
            }
            sel.setAttribute(PET_GATES_DOOR_HEIGHT_RANGE_ATTR, rangeKey);
        });
        return changed;
    }

    /** Gate Width (garden-gates + pet-gates): 24–48, default 36. */
    function applyPetGatesDoorWidthSelectRange(rootEl) {
        if (!isGateCollection()) return false;
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        var rangeKey = PET_GATES_DOOR_WIDTH_MIN + '-' + PET_GATES_DOOR_WIDTH_MAX + ':' + PET_GATES_DOOR_WIDTH_DEFAULT;
        var changed = false;
        rootEl.querySelectorAll(
            'select#exact-door-width-int, select[id^="exact-door-width-int"],' +
            'select#finished-width-int, select[id^="finished-width-int"]'
        ).forEach(function (sel) {
            if (!isPetGatesExactDoorWidthIntSelect(sel)) return;
            if (sel.getAttribute(PET_GATES_DOOR_WIDTH_RANGE_ATTR) === rangeKey) return;
            var before = String(sel.value != null ? sel.value : '');
            rebuildMeasurementIntSelectOptions(
                sel,
                PET_GATES_DOOR_WIDTH_MIN,
                PET_GATES_DOOR_WIDTH_MAX,
                1,
                PET_GATES_DOOR_WIDTH_DEFAULT
            );
            sel.setAttribute(PET_GATES_DOOR_WIDTH_RANGE_ATTR, rangeKey);
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eReb) {
                try { syncMeasurementDivSelectUi(sel); } catch (eSync) { }
            }
            if (before !== String(sel.value != null ? sel.value : '')) changed = true;
        });
        return changed;
    }

    function applyPetGatesDimensionSelectRanges(rootEl) {
        var w = false;
        var h = false;
        try { w = !!applyPetGatesDoorWidthSelectRange(rootEl); } catch (eW) { }
        try { h = !!applyPetGatesDoorHeightSelectRange(rootEl); } catch (eH) { }
        return w || h;
    }

    function getDefaultExactDoorThicknessFracValue() {
        if (isPetGatesCollection()) return '1.5';
        if (isGardenGatesCollection()) return '1.75';
        try {
            if (
                window.PriceScreenStorm
                && typeof window.PriceScreenStorm.isScreenAndStormDoorsProductType === 'function'
                && window.PriceScreenStorm.isScreenAndStormDoorsProductType()
            ) {
                return '1.125';
            }
        } catch (eSs) { }
        try {
            var container = document.getElementById('door-configurator');
            if (container) {
                var tagsAttr = container.getAttribute('data-product-tags') || '';
                var tags = [];
                try {
                    tags = Array.isArray(JSON.parse(tagsAttr)) ? JSON.parse(tagsAttr) : [];
                } catch (eTags) {
                    tags = String(tagsAttr || '').split('|');
                }
                for (var ti = 0; ti < tags.length; ti++) {
                    var t = String(tags[ti] || '').toLowerCase().replace(/[\s-]+/g, '_');
                    if (t === 'interior_doors' || t === 'interior-doors') return '1.5';
                }
                var pt = String(container.getAttribute('data-product-type') || '').toLowerCase().replace(/[\s-]+/g, '_');
                if (pt.indexOf('interior') !== -1 && pt.indexOf('exterior') === -1) return '1.5';
            }
        } catch (eDom) { }
        try {
            if (
                window.DoorIntExtPricingRule
                && typeof window.DoorIntExtPricingRule.getDoorSurfaceFromTags === 'function'
                && window.DoorIntExtPricingRule.getDoorSurfaceFromTags() === 'interior'
            ) {
                return '1.5';
            }
        } catch (eSurf) { }
        return '1.75';
    }

    function collectDoorThicknessFracSelects(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        var list = [];
        var seen = [];
        function push(sel) {
            if (!sel || seen.indexOf(sel) !== -1) return;
            if (!isExactDoorThicknessFracSelect(sel)) return;
            seen.push(sel);
            list.push(sel);
        }
        try {
            rootEl.querySelectorAll(
                'select#exact-door-thickness-frac, select[id^="exact-door-thickness-frac"], select#door-thickness, select#panel-door-thickness-frac'
            ).forEach(push);
            rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
                var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                var title = String((titleEl && titleEl.textContent) || '').toLowerCase();
                if (title.indexOf('sidelight thickness') !== -1 || title.indexOf('transom thickness') !== -1) return;
                if (title.indexOf('exact door thickness') === -1 && title.indexOf('door thickness') === -1 && title.indexOf('gate thickness') === -1) return;
                row.querySelectorAll('select.door-dimension-frac-select, select.door-dimension-select').forEach(push);
            });
        } catch (eList) { }
        return list;
    }

    function pickLiveDoorThicknessSelect(rootEl) {
        var sels = collectDoorThicknessFracSelects(rootEl);
        var i;
        for (i = 0; i < sels.length; i++) {
            if (measurementSelectUserChanged(sels[i]) && String(sels[i].value || '').trim() !== '') return sels[i];
        }
        for (i = 0; i < sels.length; i++) {
            var id = String(sels[i].id || '').toLowerCase();
            if (id.indexOf('exact-door-thickness-frac') === 0 && String(sels[i].value || '').trim() !== '') {
                var vis = !!(sels[i].offsetParent || (sels[i].getClientRects && sels[i].getClientRects().length));
                if (vis) return sels[i];
            }
        }
        for (i = 0; i < sels.length; i++) {
            if (String(sels[i].value || '').trim() !== '') return sels[i];
        }
        return sels[0] || null;
    }

    function syncAllDoorThicknessSelects(value, exceptSel) {
        var want = String(value == null ? '' : value).trim();
        if (!want) return;
        collectDoorThicknessFracSelects(document.getElementById('door-configurator-options') || document).forEach(function (sel) {
            if (!sel || sel === exceptSel) return;
            var cur = String(sel.value != null ? sel.value : '').trim();
            if (cur === want) return;
            setMeasurementSelectValue(sel, want, { dispatchChange: false });
        });
        var num = parseFloat(want);
        if (!isNaN(num) && num > 0) {
            try { window.__lastDoorThicknessInches = num; } catch (eThkSync) { }
        }
    }

    function applyDefaultExactDoorThicknessFracSelects(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        var def = getDefaultExactDoorThicknessFracValue();
        var liveSel = pickLiveDoorThicknessSelect(rootEl);
        var liveVal = liveSel ? String(liveSel.value || '').trim() : '';
        var userLocked = !!(liveSel && measurementSelectUserChanged(liveSel));
        function applyToSelect(sel) {
            if (!sel) return;
            if (userLocked || measurementSelectUserChanged(sel)) return;
            var cur = String(sel.value != null ? sel.value : '').trim();
            if (cur !== '') return;
            setMeasurementSelectValue(sel, def, { dispatchChange: false });
        }
        try {
            collectDoorThicknessFracSelects(rootEl).forEach(applyToSelect);
            if (userLocked && liveVal) syncAllDoorThicknessSelects(liveVal, liveSel);
            var cacheSel = pickLiveDoorThicknessSelect(rootEl);
            var liveNum = cacheSel ? parseFloat(cacheSel.value) : NaN;
            if (isNaN(liveNum) || liveNum <= 0) liveNum = parseFloat(def);
            if (!isNaN(liveNum) && liveNum > 0) {
                try { window.__lastDoorThicknessInches = liveNum; } catch (eThk) { }
            }
        } catch (eApply) { }
    }
    var MEASUREMENT_WIDTH_DEFAULT_DEBUG_IDS = {
        'finished-width-int': true,
        'rough-width-int': true,
        'panel-width-int': true
    };
    var _measurementProgrammaticSelectChange = false;

    function setMeasurementProgrammaticSelectChangeFlag(on) {
        _measurementProgrammaticSelectChange = !!on;
        try { window.__doorMeasurementProgrammaticSelectChange = !!on; } catch (eFlag) { }
    }

    function isMeasurementWidthDefaultDebugOn() {
        try {
            if (window.__DOOR_MEASUREMENT_WIDTH_DEFAULT_DEBUG === true) return true;
            if (typeof location !== 'undefined' && location.search && /(?:\?|&)door_meas_debug=1(?:&|$)/.test(location.search)) {
                return true;
            }
        } catch (eDbg) { }
        return false;
    }

    function shouldDebugMeasurementWidthSelect(sel) {
        if (!sel || !isMeasurementWidthDefaultDebugOn()) return false;
        var id = String(sel.id || '');
        return !!(
            MEASUREMENT_WIDTH_DEFAULT_DEBUG_IDS[id]
            || id.indexOf('finished-width-int') === 0
            || id.indexOf('rough-width-int') === 0
            || id.indexOf('panel-width-int') === 0
        );
    }

    function debugMeasurementWidthDefault(sel, phase, detail) {
        if (!shouldDebugMeasurementWidthSelect(sel)) return;
        try {
            console.log('[door-meas-width-default]', String(sel.id || ''), phase, Object.assign({
                value: sel.value,
                selectedIndex: sel.selectedIndex,
                userChanged: measurementSelectUserChanged(sel),
                visible: !!(sel.offsetParent || (sel.getClientRects && sel.getClientRects().length))
            }, detail || {}));
        } catch (eLog) { }
    }

    function isExactDoorWidthIntSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '');
        return id === 'exact-door-width-int' || id.indexOf('exact-door-width-int') === 0;
    }

    /** #exact-door-width-int — Door Width 15–48 def 36 (all products incl. Screen & Storm); Dutch default 32. */
    function applyExactDoorWidthIntRange(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        // Gate collections (garden/pet) use Gate Width 24–48 (applyPetGatesDoorWidthSelectRange).
        if (isGateCollection()) return;
        var def = getDefaultExactDoorWidthInt();
        var isDutch = isDutchDoorsProduct();
        var marker = EXACT_DOOR_WIDTH_INT_MIN + '-' + EXACT_DOOR_WIDTH_INT_MAX + ':' + def;
        var rangeAttr = isDutch ? DUTCH_DOOR_WIDTH_INT_RANGE_ATTR : EXACT_DOOR_WIDTH_INT_RANGE_ATTR;

        function applyToSelect(sel) {
            if (!sel || (sel.id && /frac/i.test(sel.id))) return;
            // Clear markers from opening matrix / old SS 1–144 so Single Item 15–48 wins.
            if (sel.removeAttribute) {
                sel.removeAttribute('data-opening-layout-range');
                sel.removeAttribute('data-door-ss-range');
            }
            var opts = sel.options || [];
            var firstOpt = opts.length ? parseInt(opts[0].value, 10) : NaN;
            var lastOpt = opts.length ? parseInt(opts[opts.length - 1].value, 10) : NaN;
            var rangeOk = firstOpt === EXACT_DOOR_WIDTH_INT_MIN && lastOpt === EXACT_DOOR_WIDTH_INT_MAX;
            if (sel.getAttribute(rangeAttr) === marker && rangeOk) {
                if (isDutch && !measurementSelectUserChanged(sel)) {
                    setMeasurementSelectValue(sel, DUTCH_DOOR_WIDTH_INT_DEFAULT, { dispatchChange: false });
                }
                return;
            }
            rebuildMeasurementIntSelectOptions(
                sel,
                EXACT_DOOR_WIDTH_INT_MIN,
                EXACT_DOOR_WIDTH_INT_MAX,
                1,
                def
            );
            // Liquid defaults to 36; Dutch sheet default is 32 — apply when user has not changed.
            if (isDutch && !measurementSelectUserChanged(sel)) {
                setMeasurementSelectValue(sel, DUTCH_DOOR_WIDTH_INT_DEFAULT, { dispatchChange: false });
            } else if (!measurementSelectUserChanged(sel)) {
                var cur = String(sel.value != null ? sel.value : '').trim();
                if (cur === '' || !rangeOk) {
                    setMeasurementSelectValue(sel, def, { dispatchChange: false });
                }
            }
            sel.setAttribute(rangeAttr, marker);
            if (isDutch) sel.setAttribute(EXACT_DOOR_WIDTH_INT_RANGE_ATTR, marker);
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eReb) {
                try { syncMeasurementDivSelectUi(sel); } catch (eSync) { }
            }
        }

        // Bare main Exact Door Width + generated clones (exact-door-width-int__row_col).
        rootEl.querySelectorAll(
            'select#exact-door-width-int, select[id^="exact-door-width-int__"]'
        ).forEach(function (sel) {
            if (sel.id && /frac/i.test(sel.id)) return;
            applyToSelect(sel);
        });
        // Legacy slab+sidelight Exact Door Width uses id="panel-height-int" (width field, not height).
        var legacySlabWidth = rootEl.querySelector('select#panel-height-int');
        if (legacySlabWidth) {
            var legacyRow = legacySlabWidth.closest && legacySlabWidth.closest('.door-measure-dimension-row');
            var legacyTitleEl = legacyRow
                ? (legacyRow.querySelector('.door-measure-dimension-title') || legacyRow.querySelector('h4'))
                : null;
            var legacyTitle = String((legacyTitleEl && legacyTitleEl.textContent) || '').toLowerCase();
            if (legacyTitle.indexOf('door width') !== -1 || legacyTitle.indexOf('gate width') !== -1) {
                applyToSelect(legacySlabWidth);
            }
        }

        // Also Exact Door Width rows inside Exact Door Size + slab sidelight panels.
        rootEl.querySelectorAll(
            '.door-measurement-static-panel--exact .door-measure-dimension-row,' +
            '.door-measurement-slab-sidelight-panels .door-measure-dimension-row'
        ).forEach(function (row) {
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
            if (title.indexOf('door width') === -1 && title.indexOf('gate width') === -1) return;
            if (title.indexOf('sidelight') !== -1 || title.indexOf('transom') !== -1) return;
            var intSel = row.querySelector('select.door-dimension-int-select');
            if (intSel) applyToSelect(intSel);
        });
    }

    function applyIntSelectRangeIfNeeded(sel, min, max, def, markerKey) {
        if (!sel || (sel.id && /frac|fraction/i.test(sel.id))) return false;
        var marker = String(min) + '-' + String(max) + ':' + String(def);
        var attr = SINGLE_ITEM_DIM_RANGE_ATTR + (markerKey ? '-' + markerKey : '');
        if (sel.removeAttribute) {
            sel.removeAttribute('data-door-ss-range');
            sel.removeAttribute('data-opening-layout-range');
        }
        var opts = sel.options || [];
        var firstOpt = opts.length ? parseInt(opts[0].value, 10) : NaN;
        var lastOpt = opts.length ? parseInt(opts[opts.length - 1].value, 10) : NaN;
        var rangeOk = firstOpt === min && lastOpt === max;
        if (sel.getAttribute(attr) === marker && rangeOk) return false;
        rebuildMeasurementIntSelectOptions(sel, min, max, 1, def);
        sel.setAttribute(attr, marker);
        try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eReb) {
            try { syncMeasurementDivSelectUi(sel); } catch (eSync) { }
        }
        return true;
    }

    /**
     * Single Item sheet ranges (after Door Width):
     * Door Height 60–147 def 80 (incl. Screen & Storm #door_height)
     * Sidelight Width 8–24 def 12 | Sidelight Height 60–147 def 80
     * Transom Width 15–112 def 36 | Transom Height 8–24 def 12
     * Pre-Hung Jamb Width (#exact-pre-hung-int) 4–16; 4 9/16 Interior/SS, 6 9/16 Exterior
     */
    function applySingleItemDimensionRanges(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        // Gates keep Gate Height 15–60 via applyPetGatesDoorHeightSelectRange.
        var skipDoorHeightForGates = isGateCollection();

        // Door Height (#door_height / Exact Door Height) — sheet 60–147 def 80
        if (!skipDoorHeightForGates) {
            rootEl.querySelectorAll(
                'select#door_height, select[id^="door_height"], select#exact-door-height-int, select[id^="exact-door-height-int"]'
            ).forEach(function (sel) {
                if (!sel || /frac|fraction/i.test(String(sel.id || ''))) return;
                applyIntSelectRangeIfNeeded(
                    sel,
                    EXACT_DOOR_HEIGHT_INT_MIN,
                    EXACT_DOOR_HEIGHT_INT_MAX,
                    DEFAULT_EXACT_DOOR_HEIGHT_INT,
                    'door-height'
                );
            });
        }

        rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
            if (!row) return;
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
            var intSel = row.querySelector('select.door-dimension-int-select')
                || row.querySelector('select.door-measure-dimension-dd:not([id*="frac"]):not([id*="fraction"])');
            if (!intSel) return;

            // Skip slab combo/transom panel special ranges (handled elsewhere).
            if (row.closest && (
                row.closest('.door-measurement-slab-transom-panels')
                || row.closest('.door-measurement-slab-combo-panels')
            )) return;

            if (title === 'sidelight width' || title === 'exact sidelight width') {
                applyIntSelectRangeIfNeeded(
                    intSel,
                    SIDELIGHT_WIDTH_INT_MIN,
                    SIDELIGHT_WIDTH_INT_MAX,
                    SIDELIGHT_WIDTH_INT_DEFAULT,
                    'sidelight-width'
                );
            } else if (title === 'sidelight height' || title === 'exact sidelight height') {
                applyIntSelectRangeIfNeeded(
                    intSel,
                    SIDELIGHT_HEIGHT_INT_MIN,
                    SIDELIGHT_HEIGHT_INT_MAX,
                    SIDELIGHT_HEIGHT_INT_DEFAULT,
                    'sidelight-height'
                );
            } else if (title === 'transom width' || title === 'exact transom width') {
                applyIntSelectRangeIfNeeded(
                    intSel,
                    TRANSOM_WIDTH_INT_MIN,
                    TRANSOM_WIDTH_INT_MAX,
                    TRANSOM_WIDTH_INT_DEFAULT,
                    'transom-width'
                );
            } else if (title === 'transom height' || title === 'exact transom height') {
                applyIntSelectRangeIfNeeded(
                    intSel,
                    TRANSOM_HEIGHT_INT_MIN,
                    TRANSOM_HEIGHT_INT_MAX,
                    TRANSOM_HEIGHT_INT_DEFAULT,
                    'transom-height'
                );
            } else if (
                !skipDoorHeightForGates
                && (title === 'exact door height' || title === 'door height' || title === 'exact gate height' || title === 'gate height')
            ) {
                applyIntSelectRangeIfNeeded(
                    intSel,
                    EXACT_DOOR_HEIGHT_INT_MIN,
                    EXACT_DOOR_HEIGHT_INT_MAX,
                    DEFAULT_EXACT_DOOR_HEIGHT_INT,
                    'door-height'
                );
            }
        });

        try { applyPreHungJambWidthRange(rootEl); } catch (ePhJamb) { }
    }

    function isFinishedWidthIntSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '');
        return id === 'finished-width-int' || id.indexOf('finished-width-int') === 0;
    }

    function isRoughWidthIntSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '');
        return id === 'rough-width-int' || id.indexOf('rough-width-int') === 0;
    }

    function isPanelWidthIntSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '');
        return id === 'panel-width-int' || id.indexOf('panel-width-int') === 0;
    }

    function isStandardMeasurementWidthIntSelect(sel) {
        return isExactDoorWidthIntSelect(sel)
            || isFinishedWidthIntSelect(sel)
            || isRoughWidthIntSelect(sel)
            || isPanelWidthIntSelect(sel);
    }

    function canonicalStaticMeasurementSelectId(panelKey, title, unitKey) {
        var panel = String(panelKey || '').toLowerCase();
        var t = String(title || '').toLowerCase();
        var isInt = unitKey === 'int';
        var isFrac = unitKey === 'frac';
        var isWidth = t.indexOf('width') !== -1;
        var isHeight = t.indexOf('height') !== -1;
        // Dp merge code 10-09 start — Pre-hung Jamb Width / Unit Depth must keep exact-pre-hung ids
        // (never remap to finished/rough/panel width — that snapped the int dropdown).
        if (
            // Dp start VDN-390 23-10
            t.indexOf('pre-hung jamb depth') !== -1
            || t.indexOf('pre hung jamb depth') !== -1
            || t.indexOf('pre-hung jamb width') !== -1
            // Dp end VDN-390 23-10
            || t.indexOf('pre hung jamb width') !== -1
            || t.indexOf('pre-hung unit depth') !== -1
            || t.indexOf('pre hung unit depth') !== -1
        ) {
            return isInt ? 'exact-pre-hung-int' : (isFrac ? 'exact-pre-hung-frac' : '');
        }
        // Dp merge code 10-09 end
        // Exact Door / Gate Width must win before rough/finished panel heuristics
        // (jamb+sidelight stack sits under rough panel but still labels "Exact Door Width").
        if (
            t.indexOf('exact door width') !== -1
            || t.indexOf('exact gate width') !== -1
            || ((t === 'door width' || t === 'gate width') && panel === 'exact')
            || (panel === 'exact' && (t.indexOf('door width') !== -1 || t.indexOf('gate width') !== -1) && t.indexOf('pre-hung') === -1 && t.indexOf('pre hung') === -1)
        ) {
            return isInt ? 'exact-door-width-int' : (isFrac ? 'exact-door-width-frac' : '');
        }
        // --- Dp start 17-07  ---
        if ((panel === 'rough' || t.indexOf('rough') !== -1) && isHeight && t.indexOf('exact') === -1) {
            return isInt ? 'rough-height-int' : (isFrac ? 'rough-height-frac' : '');
        }
        if ((panel === 'finished' || t.indexOf('finished') !== -1) && isHeight && t.indexOf('exact') === -1) {
            return isInt ? 'finished-height-int' : (isFrac ? 'finished-height-frac' : '');
        }
        if ((panel === 'rough' || t.indexOf('rough') !== -1) && isWidth && t.indexOf('exact') === -1 && t.indexOf('opening') !== -1) {
            return isInt ? 'rough-width-int' : (isFrac ? 'rough-width-frac' : '');
        }
        if ((panel === 'finished' || t.indexOf('finished') !== -1) && isWidth && t.indexOf('exact') === -1 && t.indexOf('opening') !== -1) {
            return isInt ? 'finished-width-int' : (isFrac ? 'finished-width-frac' : '');
        }
        if (panel === 'exact' && t.indexOf('thickness') !== -1) {
            return 'door-thickness';
        }
        if (panel === 'finished' && t.indexOf('thickness') !== -1) {
            return 'finished-door-thickness';
        }
        if (panel === 'rough' && t.indexOf('thickness') !== -1) {
            return 'rough-door-thickness';
        }
        if (panel === 'exact' && isHeight) {
            return isInt ? 'exact-door-height-int' : (isFrac ? 'exact-door-height-frac' : '');
        }
        // --- Dp end 17-07  ---
        // Dp merge code 10-09 start — never treat Pre-hung Jamb Width as Finished/Rough/Jamb Unit Width
        if (
            // Dp start VDN-390 23-10
            t.indexOf('pre-hung jamb depth') !== -1
            || t.indexOf('pre hung jamb depth') !== -1
            || t.indexOf('pre-hung jamb width') !== -1
            // Dp end VDN-390 23-10
            || t.indexOf('pre hung jamb width') !== -1
            || t.indexOf('pre-hung unit depth') !== -1
            || t.indexOf('pre hung unit depth') !== -1
        ) {
            return isInt ? 'exact-pre-hung-int' : (isFrac ? 'exact-pre-hung-frac' : '');
        }
        // Dp merge code 10-09 end
        if (panel === 'finished' && isWidth && t.indexOf('exact') === -1) return isInt ? 'finished-width-int' : (isFrac ? 'finished-width-frac' : '');
        if (panel === 'rough' && isWidth && t.indexOf('exact') === -1) return isInt ? 'rough-width-int' : (isFrac ? 'rough-width-frac' : '');
        if (panel === 'jamb' && isWidth) return isInt ? 'panel-width-int' : (isFrac ? 'panel-width-frac' : '');
        if (panel === 'jamb' && isHeight) return isInt ? 'panel-height-int' : (isFrac ? 'panel-height-frac' : '');
        return '';
    }

    function measurementSelectUserChanged(sel) {
        return !!(sel && sel.getAttribute && sel.getAttribute('data-door-user-changed') === '1');
    }

    function setMeasurementSelectValue(sel, val, opts) {
        if (!sel) return false;
        opts = opts || {};
        var want = String(val);
        var before = String(sel.value != null ? sel.value : '');
        try {
            var options = sel.options || [];
            var matchedIndex = -1;
            for (var oi = 0; oi < options.length; oi++) {
                var ov = options[oi];
                if (!ov) continue;
                if (String(ov.value) === want) {
                    matchedIndex = oi;
                    break;
                }
                if (ov.value !== '' && !isNaN(parseFloat(ov.value)) && !isNaN(parseFloat(want))) {
                    if (Math.abs(parseFloat(ov.value) - parseFloat(want)) < 0.000001) {
                        matchedIndex = oi;
                        want = String(ov.value);
                        break;
                    }
                }
            }
            if (matchedIndex < 0) return false;
            sel.selectedIndex = matchedIndex;
            sel.value = want;
            try {
                for (var sj = 0; sj < options.length; sj++) {
                    options[sj].selected = sj === matchedIndex;
                }
            } catch (eSel) { }
            syncMeasurementDivSelectUi(sel);
            if (opts.dispatchChange !== false && before !== want) {
                setMeasurementProgrammaticSelectChangeFlag(true);
                try {
                    sel.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (eCh) { }
                setMeasurementProgrammaticSelectChangeFlag(false);
                syncMeasurementDivSelectUi(sel);
            }
            return true;
        } catch (eSet) { }
        return false;
    }

    function syncMeasurementDivSelectUi(sel) {
        if (!sel || sel.getAttribute('data-door-div-select') !== '1') return;
        var divWrap = sel.nextElementSibling;
        if (!divWrap || !divWrap.classList || !divWrap.classList.contains('door-div-select')) return;
        if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.syncDoorDivSelectFromNative === 'function') {
            window.DoorConf2Hardware.syncDoorDivSelectFromNative(sel, divWrap);
        }
    }

    function setExactDoorWidthIntDefault(sel, force) {
        if (!sel || !isExactDoorWidthIntSelect(sel)) return false;
        return setStandardMeasurementWidthIntDefault(sel, force);
    }

    function setStandardMeasurementWidthIntDefault(sel, force) {
        if (!sel || !isStandardMeasurementWidthIntSelect(sel)) return false;
        debugMeasurementWidthDefault(sel, 'attempt', { force: !!force });
        if (!force && measurementSelectUserChanged(sel)) {
            debugMeasurementWidthDefault(sel, 'skip-user-changed');
            return false;
        }
        var cur = String(sel.value != null ? sel.value : '').trim();
        // --- Dp start 17-07 (do not overwrite existing width selection) ---
        if (!force && cur !== '') {
            debugMeasurementWidthDefault(sel, 'skip-has-value');
            return false;
        }
        // --- Dp end 17-07 (do not overwrite existing width selection) ---
        var def = isExactDoorWidthIntSelect(sel) ? getDefaultExactDoorWidthInt() : DEFAULT_EXACT_DOOR_WIDTH_INT;
        if (!force && cur === def) {
            debugMeasurementWidthDefault(sel, 'skip-already-default', { def: def });
            return false;
        }
        var applied = setMeasurementSelectValue(sel, def);
        debugMeasurementWidthDefault(sel, applied ? 'applied-default' : 'apply-failed', { previous: cur, def: def });
        return applied;
    }

    function applyFinishedRoughWidthIntDefaults(rootEl, force) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        var selectors = [
            'select#exact-door-width-int',
            'select[id^="exact-door-width-int"]',
            'select#finished-width-int',
            'select[id^="finished-width-int"]',
            'select#rough-width-int',
            'select[id^="rough-width-int"]',
            'select#panel-width-int',
            'select[id^="panel-width-int"]'
        ].join(', ');
        var seen = Object.create(null);
        rootEl.querySelectorAll(selectors).forEach(function (sel) {
            if (!sel || !sel.id || seen[sel.id]) return;
            seen[sel.id] = true;
            setStandardMeasurementWidthIntDefault(sel, !!force);
        });
    }

    function bindMeasurementUserChangedTracking(rootEl) {
        if (!rootEl || rootEl.getAttribute('data-door-meas-user-track') === '1') return;
        rootEl.setAttribute('data-door-meas-user-track', '1');
        rootEl.addEventListener('change', function (e) {
            var t = e && e.target;
            if (!t || String(t.tagName || '').toUpperCase() !== 'SELECT') return;
            if (_measurementProgrammaticSelectChange) return;
            if (isStandardMeasurementWidthIntSelect(t)) t.setAttribute('data-door-user-changed', '1');
            var tid = String(t.id || '');
            if (tid.indexOf('exact-door-width') === 0) t.setAttribute('data-door-user-changed', '1');
            if (
                tid.indexOf('panel-door-width') === 0
                || tid.indexOf('door_height') === 0
                || tid === 'door_height' || tid === 'door_height_fraction'
                // --- Dp start 17-07 (track user changes on all height/width selects) ---
                || tid.indexOf('exact-door-height') === 0
                || tid.indexOf('finished-height') === 0
                || tid.indexOf('rough-height') === 0
                || tid.indexOf('panel-height') === 0
                || tid.indexOf('exact-door-width') === 0
                || tid.indexOf('finished-width') === 0
                || tid.indexOf('rough-width') === 0
                || tid.indexOf('panel-width') === 0
                // --- Dp end 17-07 (track user changes on all height/width selects) ---
                || tid === 'sidelight_width' || tid === 'sidelight_width_fraction'
                || tid.indexOf('panel-transom-height') === 0
                || tid.indexOf('exact-door-thickness') === 0
                || tid === 'door-thickness'
                || tid.indexOf('finished-door-thickness') === 0
                || tid.indexOf('panel-door-thickness') === 0
                // Dp start 26-08 — Pre-hung Unit Depth int/frac must stick after user change
                || tid.indexOf('exact-pre-hung') === 0
                || tid.indexOf('jamb-pre-hung') === 0
                || tid.indexOf('panel-pre-hung') === 0
                || tid.indexOf('rough-pre-hung') === 0
                || (typeof isPreHungJambWidthIntSelect === 'function' && isPreHungJambWidthIntSelect(t))
                || (typeof isPreHungJambWidthFracSelect === 'function' && isPreHungJambWidthFracSelect(t))
                // Dp end 26-08
            ) {
                t.setAttribute('data-door-user-changed', '1');
                if (isExactDoorThicknessFracSelect(t) && String(t.value || '').trim() !== '') {
                    syncAllDoorThicknessSelects(t.value, t);
                }
            }
        }, true);
    }

    // --- Dp start 15-07 ---
    function applyAllTabsHeightSelectRangeAndDefault(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        // Screen & Storm uses applyScreenStormExactDimensionRanges (height 1–150).
        if (isScreenAndStormProduct()) return;

        function isTargetHeightSelectTitle(title) {
            var t = String(title || '').toLowerCase();
            if (t.indexOf('height') === -1) return false;

            // Exact Door Height or Door Height (excluding sidelight/transom/combo panel)
            if (t.indexOf('door height') !== -1 || (t.indexOf('exact') !== -1 && t.indexOf('door') !== -1)) {
                if (t.indexOf('sidelight') === -1 && t.indexOf('transom') === -1 && t.indexOf('combo') === -1) {
                    return true;
                }
            }
            // Finished Opening Height
            if (t.indexOf('finished') !== -1) {
                return true;
            }
            // Jamb Unit Height / Unit Height
            if (t.indexOf('jamb') !== -1) {
                return true;
            }
            return false;
        }

        rootEl.querySelectorAll('select').forEach(function (sel) {
            var id = String(sel.id || '').toLowerCase();
            var row = sel.closest('.door-measure-dimension-row');
            var title = '';
            if (row) {
                var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                title = String((titleEl && titleEl.textContent) || '').toLowerCase();
            }

            var isIntSelect = id.indexOf('frac') === -1 && id.indexOf('fraction') === -1;
            var matchesTitle = isIntSelect && title && isTargetHeightSelectTitle(title);
            var matchesId = isIntSelect && (
                id === 'door_height' || id.indexOf('door_height') === 0
                || id === 'exact-door-height-int'
                || id === 'finished-height-int'
                || id.indexOf('finished-height-int__') === 0
                || id.indexOf('panel-height-int__') === 0
                || id === 'finished-door-height-int'
                || id === 'panel-door-height-int'
            );
            // Bare #panel-height-int is slab Exact Door Width — not a height field.

            if (matchesTitle || matchesId) {
                var isExactDoorHeight = (
                    id === 'door_height' || id.indexOf('door_height') === 0 || id === 'exact-door-height-int'
                    || (
                        (title.indexOf('door height') !== -1 || (title.indexOf('exact') !== -1 && title.indexOf('door') !== -1))
                        && title.indexOf('sidelight') === -1
                        && title.indexOf('transom') === -1
                        && title.indexOf('combo') === -1
                        && title.indexOf('finished') === -1
                        && title.indexOf('jamb') === -1
                    )
                );
                // Single Item Door Height: 60–147 (finished/jamb keep broader 1–max).
                var minVal = isExactDoorHeight ? EXACT_DOOR_HEIGHT_INT_MIN : 1;
                var rangeKey = isExactDoorHeight
                    ? ('height-' + EXACT_DOOR_HEIGHT_INT_MIN + '-' + EXACT_DOOR_HEIGHT_INT_MAX + '-default-80')
                    : 'height-1-to-max-default-80';
                var firstInit = !sel.getAttribute('data-door-height-start1')
                    || sel.getAttribute('data-door-height-start1') !== rangeKey;

                var maxVal = isExactDoorHeight ? EXACT_DOOR_HEIGHT_INT_MAX : 147;
                if (!isExactDoorHeight && sel.options && sel.options.length) {
                    for (var i = 0; i < sel.options.length; i++) {
                        var v = parseInt(sel.options[i].value, 10);
                        if (isFinite(v) && v > maxVal) {
                            maxVal = v;
                        }
                    }
                }

                var userChanged = measurementSelectUserChanged(sel);
                var prevVal = sel.value;

                if (firstInit) {
                    sel.innerHTML = '';
                    for (var val = minVal; val <= maxVal; val++) {
                        var opt = document.createElement('option');
                        opt.value = String(val);
                        opt.textContent = String(val);
                        sel.appendChild(opt);
                    }
                    sel.setAttribute('data-door-height-start1', rangeKey);
                }

                var targetValue = DEFAULT_EXACT_DOOR_HEIGHT_INT;
                if (userChanged && prevVal && parseInt(prevVal, 10) >= minVal && parseInt(prevVal, 10) <= maxVal) {
                    targetValue = String(prevVal);
                } else if (prevVal && parseInt(prevVal, 10) >= minVal && parseInt(prevVal, 10) <= maxVal) {
                    targetValue = String(prevVal);
                }

                setMeasurementSelectValue(sel, targetValue);
                try { syncMeasurementDivSelectUi(sel); } catch (eSync) { }
            }
        });
    }
    // --- Opening size matrix (Finished / Rough / Pre-Hung Unit Width+Height) ---
    // Sheet rows 21–32. Key = doors|sidelights|transoms
    var OPENING_DIMENSION_RANGE_BY_LAYOUT = {
        // Row 21 — Single Door, no Sidelight, no Transom
        '1|0|0': {
            width: { min: 15, max: 48, def: '36' },
            height: { min: 60, max: 147, def: '80' }
        },
        // Row 22 — Single Door + 1 Sidelight, no Transom
        '1|1|0': {
            width: { min: 23, max: 72, def: '48' },
            height: { min: 60, max: 147, def: '80' }
        },
        // Row 23 — Single Door + 2 Sidelights (Left & Right), no Transom
        '1|2|0': {
            width: { min: 31, max: 96, def: '60' },
            height: { min: 60, max: 147, def: '80' }
        },
        // Row 24 — Single Door + Transom
        '1|0|1': {
            width: { min: 15, max: 48, def: '36' },
            height: { min: 68, max: 171, def: '92' }
        },
        // Row 25 — Single Door + 1 Sidelight + Transom
        '1|1|1': {
            width: { min: 23, max: 72, def: '48' },
            height: { min: 68, max: 171, def: '92' }
        },
        // Row 26 — Single Door + 2 Sidelights + Transom
        '1|2|1': {
            width: { min: 31, max: 96, def: '60' },
            height: { min: 68, max: 171, def: '92' }
        },
        // Row 27 — Double Door
        '2|0|0': {
            width: { min: 30, max: 96, def: '72' },
            height: { min: 60, max: 147, def: '80' }
        },
        // Row 28 — Double Door + 1 Sidelight (Left or Right)
        '2|1|0': {
            width: { min: 38, max: 120, def: '84' },
            height: { min: 60, max: 147, def: '80' }
        },
        // Row 29 — Double Door + 2 Sidelights (Left & Right)
        '2|2|0': {
            width: { min: 46, max: 144, def: '96' },
            height: { min: 60, max: 147, def: '80' }
        },
        // Row 30 — Double Door + Transom
        '2|0|1': {
            width: { min: 30, max: 96, def: '72' },
            height: { min: 68, max: 171, def: '92' }
        },
        // Row 31 — Double Door + 1 Sidelight + Transom
        '2|1|1': {
            width: { min: 38, max: 120, def: '84' },
            height: { min: 68, max: 171, def: '92' }
        },
        // Row 32 — Double Door + 2 Sidelights + Transom
        '2|2|1': {
            width: { min: 46, max: 144, def: '96' },
            height: { min: 68, max: 171, def: '92' }
        }
    };
    var OPENING_LAYOUT_RANGE_ATTR = 'data-opening-layout-range';
    var _prevOpeningLayoutKey = '';
    var _prevEntranceUnitRoughKey = '';

    function isRoughOpeningWidthIntSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '');
        if (id === 'rough-width-int' || id.indexOf('rough-width-int') === 0) return true;
        var row = sel.closest ? sel.closest('.door-measure-dimension-row') : null;
        if (!row) return false;
        var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
        var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
        return title === 'rough opening width' || title.indexOf('rough opening width') !== -1;
    }

    function isRoughOpeningHeightIntSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '');
        if (id === 'rough-height-int' || id.indexOf('rough-height-int') === 0) return true;
        var row = sel.closest ? sel.closest('.door-measure-dimension-row') : null;
        if (!row) return false;
        var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
        var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
        return title === 'rough opening height' || title.indexOf('rough opening height') !== -1;
    }

    /**
     * Entrance-units flag override for Rough Opening W/H (config_option driven).
     * - sidelight + transoms: W 31–96 def 60, H 68–171 def 92
     * - sidelight only:       W 31–96 def 60, H 60–147 def 80
     */
    function getEntranceUnitRoughOpeningRangeOverride() {
        try {
            if (!hasEntranceUnitsTag()) return null;
            var hasSl = hasEntranceUnitSidelightConfigOption();
            var hasTr = hasEntranceUnitTransomConfigOption();
            if (!hasSl && !hasTr) return null;
            if (hasSl && hasTr) {
                return {
                    key: 'entrance|sidelight+transom',
                    width: { min: 31, max: 96, def: '60' },
                    height: { min: 68, max: 171, def: '92' }
                };
            }
            if (hasSl) {
                return {
                    key: 'entrance|sidelight',
                    width: { min: 31, max: 96, def: '60' },
                    height: { min: 60, max: 147, def: '80' }
                };
            }
        } catch (eEuRough) { }
        return null;
    }
    // --- Dp start 13-10 ---
    /** Product tag double-doors / double-door uses the same opening matrix as Door Unit Design = double door. */
    function hasDoubleDoorsProductTag() {
        try {
            var tags = [];
            var ctx = getConfiguratorProductTagContext(doorConfigSchemaRef());
            if (ctx && Array.isArray(ctx.productTags)) tags = tags.concat(ctx.productTags);
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (main) {
                var raw = main.getAttribute('data-product-tags') || '[]';
                var parsed;
                try { parsed = JSON.parse(raw); } catch (eParse) { parsed = String(raw).split(','); }
                if (Array.isArray(parsed)) tags = tags.concat(parsed);
            }
            for (var i = 0; i < tags.length; i++) {
                var t = String(tags[i] || '').toLowerCase().replace(/_/g, '-').replace(/\s+/g, '-').trim();
                if (t === 'double-doors' || t === 'double-door') return true;
            }
        } catch (eDblTag) { }
        return false;
    }
    // --- Dp end 13-10 ---
    function getUnitLayoutDoorCount(schema, optionsContainer) {
        // --- Dp start 13-10 ---
        if (hasDoubleDoorsProductTag()) return 2;
        // --- Dp end 13-10 ---
        var opt = findSchemaOptionByIdNorm(schema, 'door_unit_design');
        if (!opt || !optionsContainer) return 1;
        var val = normalizeOptionIdKey(getSelectedValueForOption(opt, optionsContainer) || '');
        if (val === 'double_door' || val.indexOf('double') === 0) return 2;
        return 1;
    }

    function getUnitLayoutSidelightCount(schema, optionsContainer) {
        if (!schema || !optionsContainer) return 0;
        var locOpt = findSchemaOptionByIdNorm(schema, 'sidelight_location');
        if (locOpt) {
            var raw = getSelectedValueForOption(locOpt, optionsContainer);
            if (!isSidelightChoiceExcluded(raw, locOpt)) {
                var loc = normalizeOptionIdKey(raw || '');
                if (
                    loc === 'both_sides'
                    || loc.indexOf('both') !== -1
                    || loc.indexOf('left_and_right') !== -1
                    || loc.indexOf('left_right') !== -1
                ) {
                    return 2;
                }
                if (
                    loc === 'left_only'
                    || loc === 'right_only'
                    || loc.indexOf('left') !== -1
                    || loc.indexOf('right') !== -1
                ) {
                    return 1;
                }
                if (loc) return 1;
            }
        }
        // Style selected without a clear location → treat as one sidelight.
        if (hasActiveSidelightSelection(schema, optionsContainer)) return 1;
        return 0;
    }

    function getUnitLayoutTransomCount(schema, optionsContainer) {
        return hasActiveTransomSelection(schema, optionsContainer) ? 1 : 0;
    }

    function getUnitLayoutCounts(schema, optionsContainer) {
        return {
            doors: getUnitLayoutDoorCount(schema, optionsContainer),
            sidelights: getUnitLayoutSidelightCount(schema, optionsContainer),
            transoms: getUnitLayoutTransomCount(schema, optionsContainer)
        };
    }

    function getOpeningDimensionRangeForLayout(counts) {
        if (!counts) return null;
        var key = String(counts.doors) + '|' + String(counts.sidelights) + '|' + String(counts.transoms);
        return OPENING_DIMENSION_RANGE_BY_LAYOUT[key] || null;
    }

    function applyOpeningIntSelectRange(sel, min, max, def, marker) {
        if (!sel || (sel.id && /frac|fraction/i.test(sel.id))) return false;
        var curBefore = String(sel.value != null ? sel.value : '').trim();
        var userChanged = measurementSelectUserChanged(sel);
        var opts = sel.options || [];
        var firstOpt = opts.length ? parseInt(opts[0].value, 10) : NaN;
        var lastOpt = opts.length ? parseInt(opts[opts.length - 1].value, 10) : NaN;
        var rangeOk = firstOpt === min && lastOpt === max;
        // Re-run when marker matches but options were overwritten (e.g. finished 1–144) or default snapped back.
        if (sel.getAttribute(OPENING_LAYOUT_RANGE_ATTR) === marker && rangeOk) {
            if (userChanged || curBefore === String(def)) return false;
            setMeasurementSelectValue(sel, def, { dispatchChange: false });
            try { syncMeasurementDivSelectUi(sel); } catch (eSyncKeep) { }
            return true;
        }
        rebuildMeasurementIntSelectOptions(sel, min, max, 1, def);
        if (!userChanged) {
            // Always snap to layout default (do not keep prior value just because it is in-range).
            setMeasurementSelectValue(sel, def, { dispatchChange: false });
        } else {
            var cur = parseInt(sel.value, 10);
            if (!isFinite(cur) || cur < min || cur > max) {
                setMeasurementSelectValue(sel, def, { dispatchChange: false });
            }
        }
        sel.setAttribute(OPENING_LAYOUT_RANGE_ATTR, marker);
        try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eReb) {
            try { syncMeasurementDivSelectUi(sel); } catch (eSync) { }
        }
        return true;
    }

    function isOpeningLayoutAddonPanelContext(el) {
        if (!el || !el.closest) return false;
        // Default rough / Exact Door panels use bare ids — never matrix targets.
        if (el.closest('.door-rough-panel-default')) return false;
        if (el.closest('.door-measurement-static-panel--exact')) return false;
        return !!(
            el.closest('.door-rough-panel-jamb-sidelight')
            || el.closest('.door-measurement-static-panel--finished')
            || el.closest('.door-measurement-static-panel--jamb')
            || el.closest('.door-jamb-sidelight-addon')
            || el.closest('.door-measurement-slab-sidelight-panels')
        );
    }

    function isOpeningLayoutMatrixTargetSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '');
        // Never touch Exact Door Width/Height.
        if (id === 'door_height' || (id.indexOf('door_height') === 0 && id.indexOf('__') === -1)) return false;
        if (id === 'exact-door-width-int' || id.indexOf('exact-door-width-int') === 0) return false;
        if (id === 'exact-door-height-int' || id.indexOf('exact-door-height-int') === 0) return false;
        // Legacy slab Exact Door Width id — leave to applyExactDoorWidthIntRange (15–48).
        if (id === 'panel-height-int') return false;
        // Bare Finished / Rough / Pre-Hung opening selects — apply opening matrix.
        if (
            id === 'finished-width-int' || id === 'finished-height-int'
            || id === 'rough-width-int' || id === 'rough-height-int'
            || id === 'panel-width-int'
        ) {
            return true;
        }
        // Generated clones: base__row_col
        if (/^(finished|rough|panel)-(width|height)-int__/.test(id)) return true;
        // No id yet: only inside jamb/finished/addon stacks (not default rough).
        if (!id) return isOpeningLayoutAddonPanelContext(sel);
        return false;
    }

    function collectOpeningDimensionIntSelects(rootEl, kind) {
        var list = [];
        var seen = [];
        function push(sel) {
            if (!sel || seen.indexOf(sel) !== -1) return;
            if (sel.id && /frac|fraction/i.test(sel.id)) return;
            if (!isOpeningLayoutMatrixTargetSelect(sel)) return;
            seen.push(sel);
            list.push(sel);
        }
        var idSelectors = kind === 'width'
            ? [
                'select#finished-width-int, select[id^="finished-width-int"]',
                'select#rough-width-int, select[id^="rough-width-int"]',
                'select#panel-width-int, select[id^="panel-width-int"]'
            ].join(',')
            : [
                'select#finished-height-int, select[id^="finished-height-int"]',
                'select#rough-height-int, select[id^="rough-height-int"]',
                'select[id^="panel-height-int__"]'
            ].join(',');
        rootEl.querySelectorAll(idSelectors).forEach(push);

        // Title match only in jamb/finished/addon stacks (selects may lack id until assign runs).
        rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
            if (!isOpeningLayoutAddonPanelContext(row)) return;
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
            var intSel = row.querySelector('select.door-dimension-int-select')
                || row.querySelector('select.door-measure-dimension-dd:not([id*="frac"]):not([id*="fraction"])');
            if (!intSel) return;
            if (kind === 'width') {
                if (title.indexOf('exact door') !== -1 || title === 'door width' || title === 'gate width') return;
                if (
                    title === 'rough opening width'
                    || title === 'finished opening width'
                    || title === 'jamb unit width'
                    || (title.indexOf('unit width') !== -1 && title.indexOf('jamb') !== -1)
                ) {
                    push(intSel);
                }
            } else if (
                title.indexOf('exact door') === -1
                && title !== 'door height'
                && title !== 'gate height'
                && (
                    title === 'rough opening height'
                    || title === 'finished opening height'
                    || title === 'jamb unit height'
                    || (title.indexOf('unit height') !== -1 && title.indexOf('jamb') !== -1)
                )
            ) {
                push(intSel);
            }
        });
        return list;
    }

    /**
     * Finished / Rough / Pre-Hung (Jamb) opening width+height from unit layout matrix.
     * Sheet rows 21–32 (single + double door × sidelights × transom).
     */
    function applyOpeningDimensionRangesFromUnitLayout(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        if (isGateCollection() || productIsPorchPanelProduct()) return false;
        var schema = doorConfigSchemaRef();
        if (!schema) return false;
        var counts = getUnitLayoutCounts(schema, rootEl);
        var key = String(counts.doors) + '|' + String(counts.sidelights) + '|' + String(counts.transoms);
        var range = getOpeningDimensionRangeForLayout(counts);
        if (!range) {
            _prevOpeningLayoutKey = key;
            return false;
        }
        var w = range.width;
        var h = range.height;
        var wMarker = key + ':w' + w.min + '-' + w.max + '-' + w.def;
        var hMarker = key + ':h' + h.min + '-' + h.max + '-' + h.def;
        var layoutChanged = _prevOpeningLayoutKey && _prevOpeningLayoutKey !== key;
        _prevOpeningLayoutKey = key;

        if (layoutChanged) {
            collectOpeningDimensionIntSelects(rootEl, 'width')
                .concat(collectOpeningDimensionIntSelects(rootEl, 'height'))
                .forEach(function (sel) {
                    if (sel && sel.removeAttribute) sel.removeAttribute(OPENING_LAYOUT_RANGE_ATTR);
                });
        }

        collectOpeningDimensionIntSelects(rootEl, 'width').forEach(function (sel) {
            applyOpeningIntSelectRange(sel, w.min, w.max, w.def, wMarker);
        });
        collectOpeningDimensionIntSelects(rootEl, 'height').forEach(function (sel) {
            applyOpeningIntSelectRange(sel, h.min, h.max, h.def, hMarker);
        });

        // Entrance units: force Rough Opening ranges from config_option flags
        // (flags do not bump layout sidelight/transom counts, so matrix alone stays 1|0|0).
        var euRough = getEntranceUnitRoughOpeningRangeOverride();
        var euKey = euRough ? euRough.key : '';
        if (_prevEntranceUnitRoughKey && _prevEntranceUnitRoughKey !== euKey) {
            collectOpeningDimensionIntSelects(rootEl, 'width')
                .concat(collectOpeningDimensionIntSelects(rootEl, 'height'))
                .forEach(function (sel) {
                    if (!sel || !sel.removeAttribute) return;
                    if (isRoughOpeningWidthIntSelect(sel) || isRoughOpeningHeightIntSelect(sel)) {
                        sel.removeAttribute(OPENING_LAYOUT_RANGE_ATTR);
                    }
                });
        }
        _prevEntranceUnitRoughKey = euKey;
        if (euRough) {
            var euW = euRough.width;
            var euH = euRough.height;
            var euWMarker = euKey + ':w' + euW.min + '-' + euW.max + '-' + euW.def;
            var euHMarker = euKey + ':h' + euH.min + '-' + euH.max + '-' + euH.def;
            collectOpeningDimensionIntSelects(rootEl, 'width').forEach(function (sel) {
                if (!isRoughOpeningWidthIntSelect(sel)) return;
                applyOpeningIntSelectRange(sel, euW.min, euW.max, euW.def, euWMarker);
            });
            collectOpeningDimensionIntSelects(rootEl, 'height').forEach(function (sel) {
                if (!isRoughOpeningHeightIntSelect(sel)) return;
                applyOpeningIntSelectRange(sel, euH.min, euH.max, euH.def, euHMarker);
            });
        }
        return true;
    }

    // --- Dp end 15-07 ---

    /** Restore liquid/template defaults when measurement selects were cleared on boot. */
    function applyStaticMeasurementDimensionDefaults(rootEl) {
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        bindMeasurementUserChangedTracking(rootEl);
        // Constrain Screen & Storm exact width/height option ranges before applying defaults.
        try { applyScreenStormExactDimensionRanges(rootEl); } catch (eSsRangeDefaults) { }
        // Single Item Exact Door Width (#exact-door-width-int): 15–48, default 36
        try { applyExactDoorWidthIntRange(rootEl); } catch (eExactWRange) { }
        // --- Dp start 22-07 (Finished Opening Width — skip when opening matrix owns the range) ---
        try {
            if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
            // Gate collections use Gate Width 24–48 instead of Finished Opening Width 1–144.
            // When unit-layout matrix has a row (e.g. 1|0|0), applyOpeningDimensionRangesFromUnitLayout owns finished width.
            var skipFinWBlanket = false;
            try {
                if (!isGateCollection() && !productIsPorchPanelProduct()) {
                    var schemaFin = doorConfigSchemaRef();
                    if (schemaFin && getOpeningDimensionRangeForLayout(getUnitLayoutCounts(schemaFin, rootEl))) {
                        skipFinWBlanket = true;
                    }
                }
            } catch (eSkipFin) { }
            if (!isGateCollection() && !skipFinWBlanket) {
                rootEl.querySelectorAll('select#finished-width-int, select[id^="finished-width-int"]').forEach(function (sel) {
                    if (!sel || (sel.id && /frac/i.test(sel.id))) return;
                    rebuildMeasurementIntSelectOptions(sel, 1, 144, 1, DEFAULT_EXACT_DOOR_WIDTH_INT);
                    try { syncMeasurementDivSelectUi(sel); } catch (eSyncFinW) { }
                });
            }
        } catch (eFinWRange) { }
        // --- Dp end 22-07 (Finished Opening Width) ---
        // --- Dp start 15-07 ---
        try { applyAllTabsHeightSelectRangeAndDefault(rootEl); } catch (eHRange) { }
        // Single Item sheet: Door Height / Sidelight / Transom ranges (after height boot helper)
        try { applySingleItemDimensionRanges(rootEl); } catch (eSingleItemDims) { }
        // Pet-gates Gate Width / Gate Height (must run after generic door ranges)
        try { applyPetGatesDimensionSelectRanges(rootEl); } catch (ePetGateDims) { }
        // Opening matrix (Finished / Rough / Jamb) — validation: row 22 only for now
        try { applyOpeningDimensionRangesFromUnitLayout(rootEl); } catch (eOpenLayout) { }
        // Exact Door Width must win after opening matrix (never inherit 23–72 / def 48).
        try { applyExactDoorWidthIntRange(rootEl); } catch (eExactWAfterOpen) { }
        try { applySingleItemDimensionRanges(rootEl); } catch (eSingleAfterOpen) { }
        // Screen & Storm opening ranges; Exact Door Width/Height re-applied after (Single Item sheet).
        try { applyScreenStormExactDimensionRanges(rootEl); } catch (eSsAfterOpen) { }
        try { applyExactDoorWidthIntRange(rootEl); } catch (eExactWSsLast) { }
        try { applySingleItemDimensionRanges(rootEl); } catch (eSingleSsLast) { }
        // --- Dp end 15-07 ---
        function setSelectValueIfEmpty(sel, val) {
            if (!sel || measurementSelectUserChanged(sel)) return;
            var cur = String(sel.value != null ? sel.value : '').trim();
            if (cur !== '') return;
            setMeasurementSelectValue(sel, val);
        }
        // --- Dp start 14-07  ---
        function setRoughOpeningHeightIntDefault(sel, force) {
            if (!sel) return false;
            if (!force && measurementSelectUserChanged(sel)) return false;
            var cur = String(sel.value != null ? sel.value : '').trim();
            // --- Dp start 17-07  ---
            if (cur !== '') return false;
            // --- Dp end 17-07  ---
            if (!force && cur === '80') return false;
            return setMeasurementSelectValue(sel, '80');
        }
        // --- Dp end 14-07  ---
        rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').toLowerCase();
            var intSel = row.querySelector('select.door-dimension-int-select');
            var fracSel = row.querySelector('select.door-dimension-frac-select');
            if (title.indexOf('door width') !== -1 || title.indexOf('gate width') !== -1) {
                setStandardMeasurementWidthIntDefault(intSel, false);
                setSelectValueIfEmpty(fracSel, DEFAULT_EXACT_DOOR_WIDTH_FRAC);
            } else if (title.indexOf('opening width') !== -1) {
                setStandardMeasurementWidthIntDefault(intSel, false);
                setSelectValueIfEmpty(fracSel, DEFAULT_EXACT_DOOR_WIDTH_FRAC);
            } else if (title.indexOf('jamb unit width') !== -1 || (title.indexOf('unit width') !== -1 && title.indexOf('jamb') !== -1)) {
                setStandardMeasurementWidthIntDefault(intSel, false);
                setSelectValueIfEmpty(fracSel, DEFAULT_EXACT_DOOR_WIDTH_FRAC);
            } else if (title.indexOf('door height') !== -1 || title.indexOf('gate height') !== -1) {
                setSelectValueIfEmpty(intSel, getDefaultExactDoorHeightInt());
                setSelectValueIfEmpty(fracSel, DEFAULT_EXACT_DOOR_HEIGHT_FRAC);
            } else if (title.indexOf('sidelight width') !== -1) {
                setSelectValueIfEmpty(intSel, SIDELIGHT_WIDTH_INT_DEFAULT);
                setSelectValueIfEmpty(fracSel, '0');
            } else if (title.indexOf('sidelight height') !== -1) {
                setSelectValueIfEmpty(intSel, SIDELIGHT_HEIGHT_INT_DEFAULT);
                setSelectValueIfEmpty(fracSel, '0');
            } else if (title.indexOf('transom width') !== -1) {
                setSelectValueIfEmpty(intSel, TRANSOM_WIDTH_INT_DEFAULT);
                setSelectValueIfEmpty(fracSel, '0');
            } else if (title.indexOf('transom height') !== -1) {
                setSelectValueIfEmpty(intSel, TRANSOM_HEIGHT_INT_DEFAULT);
                setSelectValueIfEmpty(fracSel, '0');
                // --- Dp start 14-07  ---
            } else if (title.indexOf('rough opening height') !== -1 || title.indexOf('rough height') !== -1) {
                setRoughOpeningHeightIntDefault(intSel, false);
                setSelectValueIfEmpty(fracSel, '0');
                // --- Dp end 14-07  ---
            }
        });
        try {
            rootEl.querySelectorAll('select#exact-door-width-int, select[id^="exact-door-width-int"]').forEach(function (sel) {
                setStandardMeasurementWidthIntDefault(sel, false);
            });
            rootEl.querySelectorAll('select#finished-width-int, select[id^="finished-width-int"]').forEach(function (sel) {
                setStandardMeasurementWidthIntDefault(sel, false);
            });
            rootEl.querySelectorAll('select#rough-width-int, select[id^="rough-width-int"]').forEach(function (sel) {
                setStandardMeasurementWidthIntDefault(sel, false);
            });
            rootEl.querySelectorAll('select#panel-width-int, select[id^="panel-width-int"]').forEach(function (sel) {
                setStandardMeasurementWidthIntDefault(sel, false);
            });
            rootEl.querySelectorAll('select#exact-door-width-frac, select[id^="exact-door-width-frac"]').forEach(function (sel) {
                setSelectValueIfEmpty(sel, DEFAULT_EXACT_DOOR_WIDTH_FRAC);
            });
            rootEl.querySelectorAll('select#finished-width-frac, select[id^="finished-width-frac"]').forEach(function (sel) {
                setSelectValueIfEmpty(sel, DEFAULT_EXACT_DOOR_WIDTH_FRAC);
            });
            rootEl.querySelectorAll('select#rough-width-frac, select[id^="rough-width-frac"]').forEach(function (sel) {
                setSelectValueIfEmpty(sel, DEFAULT_EXACT_DOOR_WIDTH_FRAC);
            });
            rootEl.querySelectorAll('select#panel-width-frac, select[id^="panel-width-frac"]').forEach(function (sel) {
                setSelectValueIfEmpty(sel, DEFAULT_EXACT_DOOR_WIDTH_FRAC);
            });
            applyFinishedRoughWidthIntDefaults(rootEl, false);
            rootEl.querySelectorAll('select#door_height, select[id^="door_height"]').forEach(function (sel) {
                if (sel.id && sel.id.indexOf('fraction') !== -1) return;
                setSelectValueIfEmpty(sel, getDefaultExactDoorHeightInt());
            });
            rootEl.querySelectorAll('select#door_height_fraction, select[id^="door_height_fraction"]').forEach(function (sel) {
                setSelectValueIfEmpty(sel, DEFAULT_EXACT_DOOR_HEIGHT_FRAC);
            });
            // --- Dp start 14-07  ---
            rootEl.querySelectorAll('select#rough_height_int, select[id^="rough_height_int"], select#rough-height-int, select[id^="rough-height-int"], select[data-option-id="rough_height_int"]').forEach(function (sel) {
                setRoughOpeningHeightIntDefault(sel, false);
            });
            rootEl.querySelectorAll('select#rough_height_frac, select[id^="rough_height_frac"], select#rough-height-frac, select[id^="rough-height-frac"], select[data-option-id="rough_height_frac"]').forEach(function (sel) {
                setSelectValueIfEmpty(sel, '0');
            });
            // --- Dp end 14-07  ---
            applyDefaultExactDoorThicknessFracSelects(rootEl);
            applyGateCollectionThicknessFracSelects(rootEl);
            try {
                rootEl.querySelectorAll(
                    'select#transom-transom-thickness-frac, select[id^="transom-transom-thickness-frac"],' +
                    'select#sidelight-sidelight-thickness-frac, select[id^="sidelight-sidelight-thickness-frac"]'
                ).forEach(function (sel) {
                    restrictSidelightTransomThicknessFracSelectOptions(sel);
                });
                rootEl.querySelectorAll('.door-measure-dimension-row').forEach(function (row) {
                    var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                    var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
                    if (title !== 'transom thickness' && title !== 'sidelight thickness') return;
                    row.querySelectorAll('select.door-dimension-frac-select, select.door-measure-dimension-dd').forEach(function (sel) {
                        restrictSidelightTransomThicknessFracSelectOptions(sel);
                    });
                });
            } catch (eTrThkDef) { }
            applyPetGatesMeasurementDimensionCopy(rootEl);
            // Must run after pet-gates copy (which used to restore "Door Thickness").
            applySidelightTransomMeasurementDimensionCopy(rootEl);
            // Re-apply opening matrix last so Rough/Finished/Jamb defaults (e.g. 48) win over generic 36.
            try { applyOpeningDimensionRangesFromUnitLayout(rootEl); } catch (eOpenLayoutEnd) { }
            // Then restore Exact Door Width 15–48 def 36 (must not stay on opening matrix range).
            try { applyExactDoorWidthIntRange(rootEl); } catch (eExactWEnd) { }
            try { applySingleItemDimensionRanges(rootEl); } catch (eSingleEnd) { }
            // Screen & Storm opening ranges; Exact Door Width/Height stay on Single Item sheet.
            try { applyScreenStormExactDimensionRanges(rootEl); } catch (eSsEnd) { }
            try { applyExactDoorWidthIntRange(rootEl); } catch (eExactWSsEnd) { }
            try { applySingleItemDimensionRanges(rootEl); } catch (eSingleSsEnd) { }
        } catch (eId) { }
    }

    function assignStaticMeasurementRowSelectIds(rootEl) {
        if (!rootEl) return;
        var rows = rootEl.querySelectorAll('.door-measure-dimension-row');
        var used = Object.create(null);
        // Seed with liquid/existing ids so clones always get base__row_col (never steal bare #rough-height-int).
        try {
            rootEl.querySelectorAll('select[id]').forEach(function (existing) {
                if (existing && existing.id) used[existing.id] = true;
            });
        } catch (eUsedSeed) { }
        for (var ri = 0; ri < rows.length; ri++) {
            var row = rows[ri];
            if (!row) continue;
            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
            var title = String((titleEl && titleEl.textContent) || '').trim();
            var panelKey = inferStaticMeasurementPanelKey(row);
            var panelShort = staticMeasurementPanelShortKey(panelKey);
            var rowKey = measurementTitleTwoWordKey(title) || ('row_' + ri);
            var baseKey = panelShort + '-' + rowKey;

            var selects = row.querySelectorAll('select');
            for (var si = 0; si < selects.length; si++) {
                var sel = selects[si];
                if (!sel) continue;
                var unitKey = 'sel-' + si;
                if (sel.classList && sel.classList.contains('door-dimension-int-select')) unitKey = 'int';
                else if (sel.classList && sel.classList.contains('door-dimension-frac-select')) unitKey = 'frac';

                if (!sel.id) {
                    var canonicalId = canonicalStaticMeasurementSelectId(panelKey, title, unitKey);
                    var id = canonicalId || (sanitizeForDomId(baseKey + '-' + unitKey));
                    if (used[id] || (typeof document !== 'undefined' && document.getElementById(id))) {
                        id = id + '__' + ri + '_' + si;
                    }
                    used[id] = true;
                    sel.id = id;
                }
                if (isStandardMeasurementWidthIntSelect(sel)) {
                    // --- Dp start 17-07 (do not force reset width default when assigning IDs) ---
                    setStandardMeasurementWidthIntDefault(sel, false);
                    // --- Dp end 17-07 (do not force reset width default when assigning IDs) ---
                }
                try { restrictSidelightTransomThicknessFracSelectOptions(sel); } catch (eTrThk) { }
            }
        }
    }

    /** Sidelight / Transom thickness — sheet ranges by product family. */
    var SIDELIGHT_TRANSOM_THICKNESS_FRAC_LABELS = {
        '1.125': '1 1/8',
        '1.25': '1 1/4',
        '1.375': '1 3/8',
        '1.5': '1 1/2',
        '1.75': '1 3/4',
        '2.25': '2 1/4'
    };
    // Screen & Storm: min 1 1/8, max 2 1/4 (full list). Others: 1 1/2–2 1/4.
    var SIDELIGHT_TRANSOM_THICKNESS_FRAC_ALLOWED = {
        '1.5': '1 1/2',
        '1.75': '1 3/4',
        '2.25': '2 1/4'
    };
    var SIDELIGHT_TRANSOM_THICKNESS_SS_ORDER = ['1.125', '1.25', '1.375', '1.5', '1.75', '2.25'];
    var SIDELIGHT_TRANSOM_THICKNESS_STD_ORDER = ['1.5', '1.75', '2.25'];
    var SIDELIGHT_TRANSOM_THICKNESS_RANGE_ATTR = 'data-sidelight-transom-thk-range';

    function isInteriorDoorsProductForThickness() {
        try {
            if (
                window.DoorIntExtPricingRule
                && typeof window.DoorIntExtPricingRule.getDoorSurfaceFromTags === 'function'
                && window.DoorIntExtPricingRule.getDoorSurfaceFromTags() === 'interior'
            ) {
                return true;
            }
        } catch (eSurf) { }
        try {
            var main = document.getElementById('door-configurator');
            if (!main) return false;
            if (String(main.getAttribute('data-use-interior-glass-meta') || '') === 'true') return true;
            var tagsAttr = main.getAttribute('data-product-tags') || '';
            var tags = [];
            try {
                tags = Array.isArray(JSON.parse(tagsAttr)) ? JSON.parse(tagsAttr) : [];
            } catch (eTags) {
                tags = String(tagsAttr || '').split(/[|,]/);
            }
            for (var i = 0; i < tags.length; i++) {
                var t = String(tags[i] || '').toLowerCase().replace(/[\s_]+/g, '-');
                if (t === 'interior-doors' || t === 'interior-door') return true;
            }
            var pt = String(main.getAttribute('data-product-type') || '').toLowerCase();
            if (pt.indexOf('interior') !== -1 && pt.indexOf('exterior') === -1) return true;
        } catch (eDom) { }
        return false;
    }

    /** Defaults from sheet: SS 1 1/8, Interior 1 1/2, Exterior 1 3/4. */
    function getSidelightTransomThicknessDefault() {
        if (isScreenAndStormProduct()) return '1.125';
        if (isInteriorDoorsProductForThickness()) return '1.5';
        return '1.75';
    }

    function getSidelightTransomThicknessAllowedOrder() {
        if (isScreenAndStormProduct()) return SIDELIGHT_TRANSOM_THICKNESS_SS_ORDER.slice();
        return SIDELIGHT_TRANSOM_THICKNESS_STD_ORDER.slice();
    }

    function isSidelightOrTransomThicknessFracSelect(sel) {
        if (!sel) return false;
        var id = String(sel.id || '').toLowerCase();
        if (id === 'transom-transom-thickness-frac' || id.indexOf('transom-transom-thickness-frac') === 0) return true;
        if (id === 'sidelight-sidelight-thickness-frac' || id.indexOf('sidelight-sidelight-thickness-frac') === 0) return true;
        var row = sel.closest && sel.closest('.door-measure-dimension-row');
        if (!row) return false;
        var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
        var title = String((titleEl && titleEl.textContent) || '').toLowerCase().replace(/\s+/g, ' ').trim();
        return title === 'transom thickness' || title === 'sidelight thickness';
    }

    function restrictSidelightTransomThicknessFracSelectOptions(sel) {
        if (!isSidelightOrTransomThicknessFracSelect(sel)) return false;
        var allowedOrder = getSidelightTransomThicknessAllowedOrder();
        var def = getSidelightTransomThicknessDefault();
        if (allowedOrder.indexOf(def) < 0) def = allowedOrder[0];
        var marker = allowedOrder.join(',') + ':' + def;
        if (sel.getAttribute(SIDELIGHT_TRANSOM_THICKNESS_RANGE_ATTR) === marker) {
            // Still ensure selected value is allowed.
            var curFast = String(sel.value != null ? sel.value : '').trim();
            if (allowedOrder.indexOf(curFast) >= 0) return false;
        }
        var userChanged = measurementSelectUserChanged(sel);
        var cur = String(sel.value != null ? sel.value : '').trim();
        var keep = {};
        var i;
        for (i = 0; i < allowedOrder.length; i++) keep[allowedOrder[i]] = true;
        var changed = false;
        while (sel.firstChild) {
            sel.removeChild(sel.firstChild);
            changed = true;
        }
        for (i = 0; i < allowedOrder.length; i++) {
            var v = allowedOrder[i];
            var op = document.createElement('option');
            op.value = v;
            op.textContent = SIDELIGHT_TRANSOM_THICKNESS_FRAC_LABELS[v]
                || SIDELIGHT_TRANSOM_THICKNESS_FRAC_ALLOWED[v]
                || v;
            sel.appendChild(op);
        }
        var next = def;
        if (userChanged && keep[cur]) next = cur;
        else if (keep[cur]) next = cur;
        if (String(sel.value) !== next) {
            sel.value = next;
            changed = true;
        }
        for (i = 0; i < (sel.options || []).length; i++) {
            sel.options[i].selected = String(sel.options[i].value) === next;
        }
        sel.setAttribute(SIDELIGHT_TRANSOM_THICKNESS_RANGE_ATTR, marker);
        if (changed || !userChanged) {
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eReb) {
                try { enhanceDoorSelectWithDivDropdown(sel); } catch (eEnh) { }
            }
        }
        return changed;
    }
    /** @deprecated use restrictSidelightTransomThicknessFracSelectOptions */
    function restrictTransomThicknessFracSelectOptions(sel) {
        return restrictSidelightTransomThicknessFracSelectOptions(sel);
    }

    function assignUniqueOptionIds(rootEl, selectIdPrefix) {
        if (!rootEl) return;
        var selects = rootEl.querySelectorAll('select');
        for (var si = 0; si < selects.length; si++) {
            var sel = selects[si];
            var selId = ensureSelectHasId(sel, selectIdPrefix || 'door-select');
            var used = Object.create(null);
            var options = sel.options || [];
            for (var oi = 0; oi < options.length; oi++) {
                var opt = options[oi];
                if (!opt) continue;
                if (!opt.id) {
                    opt.id = buildOptionDomId(selId, opt.value != null && opt.value !== '' ? opt.value : (opt.textContent || ''), oi);
                }
                if (used[opt.id]) {
                    opt.id = opt.id + '__' + oi;
                }
                used[opt.id] = true;
            }
        }
    }

    // Selection meta capture (useful for future pricing keyed by select+option)
    var doorSelectionMetaBySelectId = Object.create(null);
    var doorLastSelectionMeta = null;

    function getSelectSelectionMeta(selectEl, fallbackSelectIdPrefix) {
        if (!selectEl || String(selectEl.tagName || '').toUpperCase() !== 'SELECT') return null;
        var selectId = ensureSelectHasId(selectEl, fallbackSelectIdPrefix || 'door-select');
        var opt = null;
        try {
            opt = (selectEl.selectedOptions && selectEl.selectedOptions[0]) || selectEl.options[selectEl.selectedIndex];
        } catch (eSel) {
            opt = null;
        }
        var value = String(selectEl.value != null ? selectEl.value : '');
        var optionId = opt && opt.id ? String(opt.id) : '';
        if (!optionId && opt) {
            // In case some options were inserted without ids, synthesize one deterministically.
            optionId = buildOptionDomId(selectId, value || (opt.textContent || ''), selectEl.selectedIndex);
            try { opt.id = optionId; } catch (eSet) { }
        }
        return { selectId: selectId, optionId: optionId, value: value };
    }

    function recordDoorSelectMeta(selectEl, fallbackSelectIdPrefix) {
        var meta = getSelectSelectionMeta(selectEl, fallbackSelectIdPrefix);
        if (!meta) return null;
        doorSelectionMetaBySelectId[meta.selectId] = meta;
        doorLastSelectionMeta = meta;
        return meta;
    }
    function isMeasurementTypeOptionId(id) {
        return normalizeOptionIdKey(id) === 'measurement_type';
    }

    function optionHasJsonVisibilityRules(opt) {
        if (!opt) return false;
        if (opt.hideWhen && typeof opt.hideWhen === 'object') return true;
        if (opt.showWhen && typeof opt.showWhen === 'object') return true;
        return false;
    }

    function choiceHasJsonVisibilityRules(choice) {
        if (!choice) return false;
        if (choice.showWhen && typeof choice.showWhen === 'object') return true;
        if (choice.hideWhen && (typeof choice.hideWhen === 'object' || Array.isArray(choice.hideWhen))) return true;
        return false;
    }

    /** True when measurement_type and/or measurement dimensions use metaobject hide_when / show_when. */
    function measurementSchemaUsesJsonVisibility(schema) {
        if (!Array.isArray(schema)) return false;
        for (var i = 0; i < schema.length; i++) {
            var o = schema[i];
            if (!o) continue;
            if (isMeasurementTypeOptionId(o.id)) {
                if (optionHasJsonVisibilityRules(o)) return true;
                var choices = o.options || [];
                for (var j = 0; j < choices.length; j++) {
                    if (choiceHasJsonVisibilityRules(choices[j])) return true;
                }
            }
            if (String(o.type || '').toLowerCase() === 'dimension' && optionHasJsonVisibilityRules(o)) return true;
        }
        return false;
    }

    /** Match static liquid measurement rows to schema dimension options for applyHideWhen. */
    function linkStaticMeasurementRowsToSchema(schema, rootEl) {
        if (!schema || !rootEl) return;
        schema.forEach(function (opt) {
            if (!opt || String(opt.type || '').toLowerCase() !== 'dimension') return;
            var optId = String(opt.id || '');
            if (!optId) return;
            var lab = String(opt.label || '').toLowerCase().trim();
            var optKey = measurementTitleTwoWordKey(opt.label);
            var rows = rootEl.querySelectorAll('.door-measure-dimension-row');
            for (var ri = 0; ri < rows.length; ri++) {
                var row = rows[ri];
                if (!row || row.getAttribute('data-embed-dimension-id')) continue;
                var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                var title = String((titleEl && titleEl.textContent) || '').trim();
                var titleLower = title.toLowerCase();
                var rowKey = measurementTitleTwoWordKey(title);
                var match = false;
                if (lab && titleLower.indexOf(lab) !== -1) match = true;
                if (!match && optKey && rowKey && optKey === rowKey) match = true;
                if (!match && optId) {
                    var idPhrase = normalizeOptionIdKey(optId).replace(/_/g, ' ');
                    if (idPhrase && titleLower.indexOf(idPhrase) !== -1) match = true;
                }
                if (!match) continue;
                row.setAttribute('data-embed-dimension-id', optId);
                wireMeasurementDimensionSelectUnits(row.parentNode || rootEl);
            }
        });
        wireMeasurementDimensionSelectUnits(rootEl);
    }

    function applyMeasurementSectionJsonVisibility(schema, container) {
        if (!schema || !container) return;
        applyHideWhen(schema, container);
        applyChoiceVisibility(schema, container);
        syncMeasurementPanelsFromSchemaRows(container);
    }

    /** Show static panel / panel group when it has at least one schema-linked row not hidden by JSON rules. */
    function syncMeasurementPanelsFromSchemaRows(container) {
        if (!container) return;
        var emb = container.querySelector('.door-measurement-embedded-dimensions');
        if (!emb) return;
        function groupHasVisibleLinkedRow(groupEl) {
            var linked = groupEl.querySelectorAll('.door-measure-dimension-row[data-embed-dimension-id]');
            if (!linked.length) return null;
            for (var i = 0; i < linked.length; i++) {
                var row = linked[i];
                if (row.classList && row.classList.contains('door-hidden')) continue;
                if (row.style && row.style.display === 'none') continue;
                return true;
            }
            return false;
        }
        emb.querySelectorAll('.door-measurement-static-panel').forEach(function (panel) {
            var vis = groupHasVisibleLinkedRow(panel);
            if (vis === null) return;
            panel.classList.toggle('door-hidden', !vis);
        });
        var groupSelectors = [
            '.door-measurement-default-panels',
            '.door-measurement-slab-sidelight-panels',
            '.door-measurement-slab-transom-panels',
            '.door-measurement-slab-combo-panels'
        ];
        groupSelectors.forEach(function (sel) {
            var group = emb.querySelector(sel);
            if (!group) return;
            var vis = groupHasVisibleLinkedRow(group);
            if (vis === null) return;
            group.classList.toggle('door-hidden', !vis);
        });
    }

    function isPreHungOnDoorJambTrigger(preOpt, val) {
        if (val == null || val === '') return false;
        var n = normPreHungSelectionValue(val);
        if (n === 'pre_hung_on_jamb') return true;
        if (n.indexOf('door') !== -1 && n.indexOf('jamb') !== -1) return true;
        var ch = choiceMatchingValue(preOpt, val);
        if (ch) {
            var lbl = String(ch.label || '').toLowerCase();
            if (lbl.indexOf('brick') !== -1) return false;
            if (lbl.indexOf('slab') !== -1 && lbl.indexOf('only') !== -1) return false;
            if ((lbl.indexOf('pre-hung') !== -1 || lbl.indexOf('pre hung') !== -1) && lbl.indexOf('jamb') !== -1) return true;
            if (lbl.indexOf('door jamb') !== -1) return true;
        }
        return false;
    }

    function isPreHungOnDoorJambSelected(schema, optionsContainer) {
        var preOpt = findPreHungStyleOption(schema || doorConfigSchemaRef());
        if (!preOpt || !optionsContainer) return false;
        return isPreHungOnDoorJambTrigger(preOpt, getSelectedValueForOption(preOpt, optionsContainer));
    }

    function filterMeasurementTypeTabChoices(options) {
        if (!Array.isArray(options)) return [];
        var exact = null;
        var finished = null;
        options.forEach(function (o) {
            var t = String((o && (o.label || o.value)) || '').toLowerCase();
            if (t.indexOf('exact') !== -1 && !exact) exact = o;
            // Never treat Rough Opening as Finished — "opening" alone used to match rough_opening_size.
            else if (isFinishedOpeningChoiceText(o) && !finished) finished = o;
        });
        if (exact && finished) return [exact, finished];
        if (options.length === 2) return options.slice();
        return options.filter(function (o) {
            var t = String((o && (o.label || o.value)) || '').toLowerCase();
            if (t.indexOf('exact') !== -1) return true;
            if (isFinishedOpeningChoiceText(o)) return true;
            return false;
        }).slice(0, 2);
    }

    /** Measurement tabs: use metaobject choices when JSON visibility is configured; else legacy 4-tab list. */
    function buildMeasurementTypeTabOptionList(measureOpt, schema, optionsContainer) {
        var opts = (measureOpt && measureOpt.options) ? measureOpt.options : [];
        var hideExactDoorTab = isSidelightOrTransomCollectionActive();
        if (measurementSchemaUsesJsonVisibility(schema)) {
            var jsonTabs = normalizeFinishedVsRoughMeasurementTabValues(
                mergeMeasurementSidelightTransomTabs(opts.slice(), schema, optionsContainer)
            );
            if (!hideExactDoorTab) return jsonTabs;
            return jsonTabs.filter(function (o) {
                return normalizeOptionIdKey(o && o.value) !== MEASURE_TAB_EXACT_DOOR;
            });
        }
        var filtered = filterMeasurementTypeTabChoices(opts);
        var exactChoice = null;
        var finishedChoice = null;
        filtered.forEach(function (c) {
            var t = String((c && (c.label || c.value)) || '').toLowerCase();
            if (t.indexOf('exact') !== -1 && !exactChoice) exactChoice = c;
            if (isFinishedOpeningChoiceText(c) && !finishedChoice) finishedChoice = c;
        });
        if (!exactChoice && filtered[0]) exactChoice = filtered[0];
        if (!finishedChoice && filtered[1] && isFinishedOpeningChoiceText(filtered[1])) finishedChoice = filtered[1];
        var ev = function (v) { return v != null && v !== '' ? String(v) : ''; };
        var list = [
            { value: ev(exactChoice && exactChoice.value) || 'exact_door_size', label: 'Exact Door Size', measureVis: 'always' },
            {
                value: resolveFinishedOpeningTabValue(finishedChoice),
                label: 'Finished Opening Size',
                measureVis: 'slab'
            },
            { value: 'rough_opening_size', label: 'Rough Opening Size', measureVis: 'jamb' },
            { value: 'jamb_unit_size', label: 'Jamb Unit Size', measureVis: 'jamb' }
        ];
        var merged = normalizeFinishedVsRoughMeasurementTabValues(
            mergeMeasurementSidelightTransomTabs(list, schema, optionsContainer)
        );
        if (!hideExactDoorTab) return merged;
        return merged.filter(function (o) {
            return normalizeOptionIdKey(o && o.value) !== MEASURE_TAB_EXACT_DOOR;
        });
    }

    function syncMeasurementTabCardVisibility(optionsContainer, schema) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        if (isGateCollection()) {
            applyGateCollectionMeasurementTabs(optionsContainer, schema);
            return;
        }
        if (measurementSchemaUsesJsonVisibility(schema)) {
            applyMeasurementSectionJsonVisibility(schema, optionsContainer);
            syncMeasurementSidelightTransomTabVisibility(optionsContainer, schema);
            var wrapJson = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
            if (wrapJson && !wrapJson.querySelector('.door-measure-tab input[type="radio"]:checked')) {
                wrapJson.querySelectorAll('.door-measurement-static-panel').forEach(function (p) {
                    p.classList.add('door-hidden');
                });
                var introJ = wrapJson.querySelector('.door-measurement-panel-intro');
                var embJ = wrapJson.querySelector('.door-measurement-embedded-dimensions');
                if (introJ) introJ.classList.add('door-hidden');
                if (embJ) embJ.classList.add('door-hidden');
            }
            return;
        }
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        var jamb = isPreHungOnDoorJambSelected(schema, optionsContainer);
        var jambTwoTab = isJambTwoTabMeasureMode(schema, optionsContainer);
        var hasSide = wantsSidelightMeasureFields(schema, optionsContainer);
        var hasTrans = wantsTransomMeasureFields(schema, optionsContainer);
        var lostCheckedTab = false;
        optionsContainer.querySelectorAll('.door-measure-tab[data-measure-vis]').forEach(function (tab) {
            var v = tab.getAttribute('data-measure-vis');
            var tabRadio = tab.querySelector('input[type="radio"]');
            var tabVal = tabRadio ? String(tabRadio.value || '') : '';
            var show;
            if (isMeasurementSidelightTransomTabValue(tabVal)) {
                show = measurementTabAllowedByProductTags(schema, tabVal);
            } else if (v === 'sidelight') show = hasSide;
            else if (v === 'transom') show = hasTrans;
            else if (jambTwoTab) show = (v === 'always' || v === 'slab');
            else show = (v === 'always' || (jamb && v === 'jamb') || (!jamb && v === 'slab'));
            if (show && normalizeOptionIdKey(tabVal) === MEASURE_TAB_EXACT_DOOR && isSidelightOrTransomCollectionActive()) {
                show = false;
            }
            tab.classList.toggle('door-hidden', !show);
            if (!show) {
                var ir = tab.querySelector('input[type="radio"]');
                if (ir && ir.checked) {
                    ir.checked = false;
                    tab.classList.remove('common-check-option--selected');
                    // Dp start 26-08 — Slab / Brick Molding hide Rough/Jamb tabs; remember to
                    // re-select a visible Finished/Exact tab so W/H/T panels stay capturable.
                    lostCheckedTab = true;
                    // Dp end 26-08
                }
            }
        });
        syncJambSidelightMeasurementTabValues(optionsContainer, schema);
        var slabSideEarly = isSlabSpecialMeasurementMode(schema, optionsContainer);
        // Entrance-units: do not auto-pick a measurement tab on load — user must choose.
        // Other products: keep prior auto-pick when nothing is checked.
        // Always re-select when a checked tab was hidden by setup change (Jamb → Slab/Brick).
        var skipMeasureTabDefault = false;
        try { skipMeasureTabDefault = hasEntranceUnitsTag(); } catch (eEntMt) { }
        if (
            wrap
            && !slabSideEarly
            && (
                lostCheckedTab
                || (!skipMeasureTabDefault && !wrap.querySelector('.door-measure-tab:not(.door-hidden) input[type="radio"]:checked'))
            )
        ) {
            var pickTab = wrap.querySelector('.door-measure-tab:not(.door-hidden)[data-measure-vis="slab"]')
                || wrap.querySelector('.door-measure-tab:not(.door-hidden)[data-measure-vis="always"]')
                || wrap.querySelector('.door-measure-tab:not(.door-hidden)');
            var pickRadio = pickTab ? pickTab.querySelector('input[type="radio"]') : null;
            if (pickRadio) {
                pickRadio.checked = true;
                pickTab.classList.add('common-check-option--selected');
                var measureOptId = wrap.getAttribute('data-option-id') || 'measurement_type';
                var modePick = measurementModeFromCheckedTab(pickRadio, optionsContainer, schema);
                syncMeasurementTabVisibilityCore(modePick, measureOptId, optionsContainer, schema);
                try {
                    pickRadio.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (ePickCh) { }
            }
        }
        // Dp end 26-08
        if (wrap && !slabSideEarly && !wrap.querySelector('.door-measure-tab input[type="radio"]:checked')) {
            wrap.querySelectorAll('.door-measurement-static-panel').forEach(function (p) {
                p.classList.add('door-hidden');
            });
            var intro0 = wrap.querySelector('.door-measurement-panel-intro');
            var emb0 = wrap.querySelector('.door-measurement-embedded-dimensions');
            if (intro0) intro0.classList.add('door-hidden');
            if (emb0) emb0.classList.add('door-hidden');
        }
        syncJambSidelightTabLabels(optionsContainer, schema);
        syncMeasurementSidelightTransomTabVisibility(optionsContainer, schema);
        syncMeasurementPromptAndEyebrow(optionsContainer, schema);
    }

    /** Normalizes tab label / value to exact | rough | jamb | finished | sidelight | transom */
    function measurementModeFromTabText(tabLower) {
        var t = String(tabLower || '').toLowerCase();
        if (t.indexOf('sidelight') !== -1) return 'sidelight';
        if (t.indexOf('transom') !== -1) return 'transom';
        if (t.indexOf('gate') !== -1) return 'exact';
        if (t.indexOf('exact') !== -1) return 'exact';
        if (t.indexOf('rough') !== -1) return 'rough';
        if (t.indexOf('jamb') !== -1) return 'jamb';
        if (t.indexOf('finished') !== -1 || t.indexOf('opening') !== -1) return 'finished';
        return 'finished';
    }

    /** Resolves panel mode from the checked measurement tab (handles jamb+sidelight labels without "exact"/"rough" text). */
    function measurementModeFromCheckedTab(chk, optionsContainer, schema) {
        if (!chk) return 'finished';
        var valNorm = normalizeOptionIdKey(chk.value);
        if (valNorm === MEASURE_TAB_EXACT_GATE) return 'exact';
        if (valNorm === MEASURE_TAB_EXACT_SIDELIGHT || valNorm === 'exact_sidelight_size') return 'sidelight';
        if (valNorm === MEASURE_TAB_EXACT_TRANSOM || valNorm === 'exact_transom_size') return 'transom';
        // Token wins over label text so Finished Opening Size never runs as rough mode.
        if (isRoughOpeningMeasureTab(valNorm)) return 'rough';
        if (isFinishedOpeningMeasureTab(valNorm)) return 'finished';
        if (valNorm === 'jamb_unit_size' || valNorm.indexOf('jamb') === 0) return 'jamb';
        if (valNorm === MEASURE_TAB_EXACT_DOOR || (valNorm.indexOf('exact') === 0 && valNorm.indexOf('door') !== -1)) return 'exact';
        var tabEl = chk.closest('.door-measure-tab');
        if (!tabEl) return measurementModeFromTabText('');
        var tabVis = tabEl.getAttribute('data-measure-vis');
        if (tabVis === 'sidelight') return 'sidelight';
        if (tabVis === 'transom') return 'transom';
        if (optionsContainer && schema && isJambTwoTabMeasureMode(schema, optionsContainer)) {
            var vis = tabEl.getAttribute('data-measure-vis');
            if (vis === 'always') return 'exact';
            if (vis === 'slab') return 'rough';
        }
        return measurementModeFromTabText(String(tabEl.textContent || '').toLowerCase());
    }

    function syncMeasurementPromptAndEyebrow(optionsContainer, schema) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer || !schema) return;
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        if (!wrap) return;
        var strong = wrap.querySelector('.door-measurement-type-question strong');
        var preOpt = findPreHungStyleOption(schema);
        if (strong) {
            if (preOpt && isPreHungOnDoorJambTrigger(preOpt, getSelectedValueForOption(preOpt, optionsContainer))) {
                strong.textContent = 'How will you measure for the door and pre-hung jamb dimensions?';
            } else {
                strong.textContent = 'How will you measure?';
            }
        }
        var chk = wrap.querySelector('.door-measure-tabs .door-measure-tab input[type="radio"]:checked');
        var eyebrow = wrap.querySelector('.door-measurement-type-eyebrow');
        if (eyebrow && chk) {
            var mode = measurementModeFromCheckedTab(chk, optionsContainer, schema);
            var roughJamb = isPreHungOnDoorJambSelected(schema, optionsContainer);
            var jambSidePick = wantsSidelightMeasureFields(schema, optionsContainer);
            var jambTransPick = wantsTransomMeasureFields(schema, optionsContainer);
            var jambTwoTab = isJambTwoTabMeasureMode(schema, optionsContainer);
            if (roughJamb) {
                if (jambTwoTab && mode === 'exact') {
                    if (jambSidePick && jambTransPick) eyebrow.textContent = 'Pre-Hung + Transom + Sidelight Exact Component Size';
                    else if (jambSidePick) eyebrow.textContent = 'Pre-Hung + Sidelight Exact Component Size';
                    else if (jambTransPick) eyebrow.textContent = 'Pre-Hung + Transom Exact Component Size';
                    else eyebrow.textContent = 'Pre-Hung Exact Component Size';
                } else if (jambTwoTab && mode === 'rough') {
                    if (jambSidePick && jambTransPick) eyebrow.textContent = 'Pre-Hung + Transom + Sidelight Exact Door Size and Rough Opening';
                    else if (jambSidePick) eyebrow.textContent = 'Pre-Hung + Sidelight Exact Door Size and Rough Opening';
                    else if (jambTransPick) eyebrow.textContent = 'Pre-Hung + Transom Exact Door Size and Rough Opening';
                    else eyebrow.textContent = 'Pre-Hung Exact Door Size and Rough Opening';
                } else if (mode === 'exact') eyebrow.textContent = isGateCollection()
                    ? 'Exact Gate Size Measurements'
                    : 'Exact Door Size Measurements';
                else if (mode === 'rough') eyebrow.textContent = 'Rough Opening Measurements';
                else if (mode === 'jamb') eyebrow.textContent = 'Jamb Opening Measurements';
                else eyebrow.textContent = '';
            } else {
                eyebrow.textContent = mode === 'exact'
                    ? (isGateCollection() ? 'Exact Gate Size Measurements' : 'Exact Door Size Measurements')
                    : 'Finished Opening Measurements';
            }
        } else if (eyebrow && !chk && !isSlabSpecialMeasurementMode(schema, optionsContainer)) {
            eyebrow.textContent = '';
        }
    }

    /** Exact / finished / rough / jamb static panels + schema dimension row visibility */
    function syncMeasurementTabVisibilityCore(method, measureOptionId, optionsContainer, schema) {
        if (!optionsContainer) return;
        schema = schema || doorConfigSchemaRef();
        var m = String(method || '').toLowerCase();
        var threeJamb = isPreHungOnDoorJambSelected(schema, optionsContainer);

        if (measurementSchemaUsesJsonVisibility(schema)) {
            applyMeasurementSectionJsonVisibility(schema, optionsContainer);
            var measureWrapJson = measureOptionId
                ? optionsContainer.querySelector('.door-option-wrap[data-option-id="' + measureOptionId + '"]')
                : optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
            var modeActiveJson = m.indexOf('exact') !== -1 || m.indexOf('finished') !== -1 ||
                m.indexOf('rough') !== -1 || m.indexOf('jamb') !== -1 ||
                m.indexOf('sidelight') !== -1 || m.indexOf('transom') !== -1;
            if (measureWrapJson && modeActiveJson) {
                var embJson = measureWrapJson.querySelector('.door-measurement-embedded-dimensions');
                if (embJson) embJson.classList.remove('door-hidden');
                var sidePanelJ = measureWrapJson.querySelector('.door-measurement-static-panel--sidelight');
                var transPanelJ = measureWrapJson.querySelector('.door-measurement-static-panel--transom');
                if (sidePanelJ) sidePanelJ.classList.toggle('door-hidden', m.indexOf('sidelight') === -1);
                if (transPanelJ) transPanelJ.classList.toggle('door-hidden', m.indexOf('transom') === -1);
                measureWrapJson.querySelectorAll('.door-measurement-static-panel--exact, .door-measurement-static-panel--finished, .door-measurement-static-panel--rough, .door-measurement-static-panel--jamb').forEach(function (p) {
                    if (m.indexOf('sidelight') !== -1 || m.indexOf('transom') !== -1) p.classList.add('door-hidden');
                });
                // MERGE: Pre-hung Jamb Width on Exact Sidelight / Exact Transom when Pre-Hung selected
                var showPhSideTransJson = threeJamb && (m.indexOf('sidelight') !== -1 || m.indexOf('transom') !== -1);
                measureWrapJson.querySelectorAll('.door-measure-row--prehung-depth-side-trans').forEach(function (row) {
                    row.classList.toggle('door-hidden', !showPhSideTransJson);
                });
            }
            syncMeasurementSidelightTransomTabVisibility(optionsContainer, schema);
            syncMeasurementPromptAndEyebrow(optionsContainer, schema);
            return;
        }

        if (schema) {
            schema.forEach(function (sectionOpt) {
                if (!sectionOpt || String(sectionOpt.type || '').toLowerCase() !== 'dimension') return;
                if (optionHasJsonVisibilityRules(sectionOpt)) return;
                var lab = String(sectionOpt.label || sectionOpt.id || '').toLowerCase();
                var wrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="' + sectionOpt.id + '"]') ||
                    optionsContainer.querySelector('.door-measure-dimension-row[data-embed-dimension-id="' + sectionOpt.id + '"]');
                if (!wrap) return;
                var isExactField = lab.indexOf('exact') !== -1;
                var isFinishedField = lab.indexOf('finished') !== -1 || (lab.indexOf('opening') !== -1 && lab.indexOf('rough') === -1);
                if (threeJamb) {
                    if (isExactField) wrap.classList.toggle('door-hidden', m.indexOf('exact') === -1);
                    else if (isFinishedField) wrap.classList.toggle('door-hidden', m.indexOf('finished') === -1);
                } else {
                    var exactMode = m.indexOf('exact') !== -1;
                    var finishedMode = !exactMode;
                    if (isExactField) wrap.classList.toggle('door-hidden', !exactMode);
                    else if (isFinishedField) wrap.classList.toggle('door-hidden', !finishedMode);
                }
            });
        }

        var measureWrap = measureOptionId
            ? optionsContainer.querySelector('.door-option-wrap[data-option-id="' + measureOptionId + '"]')
            : null;
        if (!measureWrap) {
            measureWrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        }
        if (!measureWrap) return;

        if (measureOptionId) {
            var intro = optionsContainer.querySelector('.door-measurement-panel-intro[data-option-id="' + measureOptionId + '"]');
            if (intro) {
                if (threeJamb) {
                    if (m.indexOf('exact') !== -1) {
                        intro.textContent = petGatesExistingMeasureIntroCopy(
                            isJambTwoTabMeasureMode(schema, optionsContainer)
                                ? 'Add the measurements for your Door'
                                : 'Add your measurements for your Existing Door'
                        );
                        intro.classList.remove('door-hidden');
                        intro.setAttribute('aria-hidden', 'false');
                    } else if (m.indexOf('rough') !== -1) {
                        if (isJambTwoTabMeasureMode(schema, optionsContainer)) {
                            intro.textContent = 'Add the measurements for your Door';
                            intro.classList.remove('door-hidden');
                            intro.setAttribute('aria-hidden', 'false');
                        } else {
                            intro.textContent = 'Add your measurements for your Rough Opening';
                            intro.classList.remove('door-hidden');
                            intro.setAttribute('aria-hidden', 'false');
                        }
                    } else if (m.indexOf('jamb') !== -1) {
                        intro.textContent = 'Add your measurements for the Jamb Unit Size';
                        intro.classList.remove('door-hidden');
                        intro.setAttribute('aria-hidden', 'false');
                    } else {
                        intro.textContent = 'Add your measurements';
                        intro.classList.remove('door-hidden');
                        intro.setAttribute('aria-hidden', 'false');
                    }
                } else {
                    intro.textContent = petGatesExistingMeasureIntroCopy(
                        m.indexOf('exact') !== -1
                            ? 'Add your measurements for your Existing Door'
                            : 'Add the measurements for the Finished Opening'
                    );
                    intro.classList.remove('door-hidden');
                    intro.setAttribute('aria-hidden', 'false');
                }
            }
        }

        var modeActive = m.indexOf('exact') !== -1 || m.indexOf('finished') !== -1 ||
            m.indexOf('rough') !== -1 || m.indexOf('jamb') !== -1 ||
            m.indexOf('sidelight') !== -1 || m.indexOf('transom') !== -1;
        if (measureWrap && modeActive) {
            var embReveal = measureWrap.querySelector('.door-measurement-embedded-dimensions');
            if (embReveal) embReveal.classList.remove('door-hidden');
        }

        var exactPanel = measureWrap.querySelector('.door-measurement-static-panel--exact');
        var finishedPanel = measureWrap.querySelector('.door-measurement-static-panel--finished');
        var roughPanel = measureWrap.querySelector('.door-measurement-static-panel--rough');
        var jambPanel = measureWrap.querySelector('.door-measurement-static-panel--jamb');
        var sidelightPanel = measureWrap.querySelector('.door-measurement-static-panel--sidelight');
        var transomPanel = measureWrap.querySelector('.door-measurement-static-panel--transom');
        var depthExact = measureWrap.querySelectorAll('.door-measure-row--prehung-depth-exact');
        var sideOnlyMode = m.indexOf('sidelight') !== -1;
        var transOnlyMode = m.indexOf('transom') !== -1;

        if (sidelightPanel) sidelightPanel.classList.toggle('door-hidden', !sideOnlyMode);
        if (transomPanel) transomPanel.classList.toggle('door-hidden', !transOnlyMode);

        if (sideOnlyMode || transOnlyMode) {
            if (exactPanel) exactPanel.classList.add('door-hidden');
            if (finishedPanel) finishedPanel.classList.add('door-hidden');
            if (roughPanel) roughPanel.classList.add('door-hidden');
            if (jambPanel) jambPanel.classList.add('door-hidden');
            // Exact-door Pre-hung Jamb Width stays in exact panel (hidden with it)
            depthExact.forEach(function (row) { row.classList.add('door-hidden'); });
            // MERGE: show Pre-hung Jamb Width on Exact Sidelight / Exact Transom when Pre-Hung selected
            measureWrap.querySelectorAll('.door-measure-row--prehung-depth-side-trans').forEach(function (row) {
                row.classList.toggle('door-hidden', !threeJamb);
            });
            if (measureOptionId) {
                var introSide = optionsContainer.querySelector('.door-measurement-panel-intro[data-option-id="' + measureOptionId + '"]');
                if (introSide) {
                    introSide.textContent = sideOnlyMode
                        ? 'Add your exact sidelight measurements'
                        : 'Add your exact transom measurements';
                    introSide.classList.remove('door-hidden');
                    introSide.setAttribute('aria-hidden', 'false');
                }
            }
            syncMeasurementPromptAndEyebrow(optionsContainer, schema);
            return;
        }

        // Hide sidelight/transom-only Pre-hung Jamb Width when not on those tabs
        measureWrap.querySelectorAll('.door-measure-row--prehung-depth-side-trans').forEach(function (row) {
            row.classList.add('door-hidden');
        });

        if (threeJamb) {
            if (exactPanel) exactPanel.classList.toggle('door-hidden', m.indexOf('exact') === -1);
            if (roughPanel) roughPanel.classList.toggle('door-hidden', m.indexOf('rough') === -1);
            if (jambPanel) jambPanel.classList.toggle('door-hidden', m.indexOf('jamb') === -1);
            if (finishedPanel) finishedPanel.classList.add('door-hidden');
            depthExact.forEach(function (row) {
                row.classList.toggle('door-hidden', m.indexOf('exact') === -1);
            });
        } else {
            var exactMode2 = m.indexOf('exact') !== -1;
            var finishedMode2 = !exactMode2;
            if (exactPanel) exactPanel.classList.toggle('door-hidden', !exactMode2);
            if (finishedPanel) finishedPanel.classList.toggle('door-hidden', !finishedMode2);
            if (roughPanel) roughPanel.classList.add('door-hidden');
            if (jambPanel) jambPanel.classList.add('door-hidden');
            depthExact.forEach(function (row) {
                row.classList.add('door-hidden');
            });
        }

        var roughJambSideInner = measureWrap.querySelector('.door-rough-panel-jamb-sidelight');
        var roughDefaultInner = measureWrap.querySelector('.door-rough-panel-default');
        if (roughJambSideInner && roughDefaultInner) {
            if (threeJamb) {
                var jambRoughStack = isJambTwoTabMeasureMode(schema, optionsContainer);
                var roughModeOn = m.indexOf('rough') !== -1;
                roughJambSideInner.classList.toggle('door-hidden', !jambRoughStack || !roughModeOn);
                roughDefaultInner.classList.toggle('door-hidden', jambRoughStack || !roughModeOn);
            } else {
                roughJambSideInner.classList.add('door-hidden');
                roughDefaultInner.classList.remove('door-hidden');
            }
        }

        var addon = measureWrap.querySelector('.door-jamb-sidelight-addon');
        if (addon) {
            var showJambSideAddon = threeJamb
                && wantsSidelightMeasureFields(schema, optionsContainer)
                && m.indexOf('exact') !== -1;
            addon.classList.toggle('door-hidden', !showJambSideAddon);
        }
        var transomAddon = measureWrap.querySelector('.door-jamb-transom-addon');
        if (transomAddon) {
            var showJambTransomAddon = threeJamb
                && wantsTransomMeasureFields(schema, optionsContainer)
                && m.indexOf('exact') !== -1;
            transomAddon.classList.toggle('door-hidden', !showJambTransomAddon);
        }

        syncMeasurementPromptAndEyebrow(optionsContainer, schema);
    }

    function findPreHungStyleOption(schema) {
        if (!Array.isArray(schema)) return null;
        for (var i = 0; i < schema.length; i++) {
            var opt = schema[i];
            if (!opt || !opt.id) continue;
            var t = (opt.type || '').toLowerCase();
            if (t !== 'radio' && t !== 'select') continue;
            var id = normalizeOptionIdKey(opt.id);
            var lab = String(opt.label || '').toLowerCase();
            if (id.indexOf('pre_hung') !== -1 || id.indexOf('prehung') !== -1) return opt;
            if (lab.indexOf('pre-hung') !== -1) return opt;
            if (lab.indexOf('pre') !== -1 && lab.indexOf('hung') !== -1) return opt;
        }
        return null;
    }

    function isDoorSetupChoiceValue(v) {
        var n = String(v == null ? '' : v).toLowerCase().replace(/-/g, '_');
        return n === 'slab_only'
            || n === 'pre_hung_on_jamb'
            || n === 'pre_hung_on_brick_molding';
    }

    function getPreHungDoorSetupChoices(schema) {
        var preOpt = findPreHungStyleOption(schema);
        if (!preOpt || !Array.isArray(preOpt.options)) return [];
        var hideSlab = false;
        try { hideSlab = hasNoSlabConfigOption(); } catch (eNoSlabChoices) { }
        var out = [];
        preOpt.options.forEach(function (choice) {
            if (!choice) return;
            if (!isDoorSetupChoiceValue(choice.value)) return;
            var n = String(choice.value || '').toLowerCase().replace(/-/g, '_');
            if (hideSlab && n === 'slab_only') return;
            var cloned = Object.assign({}, choice);
            cloned._renderOptionId = preOpt.id;
            cloned._renderOptionLabel = preOpt.label || preOpt.id;
            out.push(cloned);
        });
        return out;
    }
    function optionIsPanelUnitDesign(opt) {
        if (!opt) return false;
        var id = normalizeOptionIdKey(opt.id);
        if (id === 'panel_unit_design' || id === 'porch_panel_project' || id === 'porch_panel_order' || id === 'porch_panel_order_type') return true;
        var lab = String(opt.label || '').toLowerCase();
        return lab.indexOf('panel unit design') !== -1 || lab.indexOf('order your porch panels') !== -1;
    }

    function panelUnitDesignSectionExists(root) {
        if (!root) return false;
        if (root.querySelector('[data-static-panel-unit-design]')) return true;
        return !!root.querySelector('.door-option-wrap[data-option-id="panel_unit_design"], .door-option-wrap[data-option-id="porch_panel_project"]');
    }

    function schemaIncludesPanelUnitDesignOption(schema) {
        return Array.isArray(schema) && schema.some(function (opt) { return optionIsPanelUnitDesign(opt); });
    }

    function productIsPorchPanelProduct() {
        var root = document.getElementById('door-configurator');
        if (!root) return false;
        var type = String(root.getAttribute('data-product-type') || '').toLowerCase();
        if (type.indexOf('porch') !== -1) return true;
        try {
            var tags = JSON.parse(root.getAttribute('data-product-tags') || '[]');
            return Array.isArray(tags) && tags.some(function (tag) {
                var normalized = String(tag || '').toLowerCase().replace(/[\s_]+/g, '-');
                return normalized === 'porch-panel' || normalized === 'porch-panels';
            });
        } catch (eTags) {
            return false;
        }
    }

    function isPanelUnitDesignSectionEl(el) {
        if (!el || !el.closest) return false;
        return !!el.closest('[data-static-panel-unit-design], .door-panel-unit-design-static, .door-option-wrap[data-option-id="panel_unit_design"], .door-option-wrap[data-option-id="porch_panel_project"]');
    }

    function enhancePanelUnitMeasurementSelects(scopeEl) {
        if (!scopeEl || !scopeEl.querySelectorAll) return;
        try { applyPorchPanelUnitDimensionRanges(scopeEl); } catch (ePorchRange) { }
        all('select.door-measure-dimension-dd, select.door-input-select', scopeEl).forEach(function (sel) {
            enhanceDoorSelectWithDivDropdown(sel);
        });
    }

    // Porch Panel Set measurements (data-panel-dimension) — not Exact Door Width/Height.
    var PORCH_PANEL_WIDTH_MIN = 15;
    var PORCH_PANEL_WIDTH_MAX = 48;
    var PORCH_PANEL_WIDTH_DEFAULT = '36';
    var PORCH_PANEL_HEIGHT_MIN = 60;
    var PORCH_PANEL_HEIGHT_MAX = 147;
    var PORCH_PANEL_HEIGHT_DEFAULT = '80';
    var PORCH_PANEL_THICKNESS_DEFAULT = '1.125';
    var PORCH_PANEL_THICKNESS_LABELS = {
        '1.125': '1 1/8',
        '1.25': '1 1/4',
        '1.375': '1 3/8',
        '1.5': '1 1/2',
        '1.75': '1 3/4',
        '2.25': '2 1/4'
    };
    var PORCH_PANEL_THICKNESS_ORDER = ['1.125', '1.25', '1.375', '1.5', '1.75', '2.25'];
    var PORCH_PANEL_DIM_RANGE_ATTR = 'data-porch-panel-dim-range';

    function applyPorchPanelUnitDimensionRanges(rootEl) {
        if (!rootEl || !rootEl.querySelectorAll) {
            rootEl = document.getElementById('door-configurator-options') || document;
        }
        var widthMarker = PORCH_PANEL_WIDTH_MIN + '-' + PORCH_PANEL_WIDTH_MAX + ':' + PORCH_PANEL_WIDTH_DEFAULT;
        var heightMarker = PORCH_PANEL_HEIGHT_MIN + '-' + PORCH_PANEL_HEIGHT_MAX + ':' + PORCH_PANEL_HEIGHT_DEFAULT;
        var thickMarker = 'thk:' + PORCH_PANEL_THICKNESS_ORDER.join(',') + ':' + PORCH_PANEL_THICKNESS_DEFAULT;

        rootEl.querySelectorAll('select[data-panel-dimension="width-int"]').forEach(function (sel) {
            if (!sel || sel.getAttribute(PORCH_PANEL_DIM_RANGE_ATTR) === widthMarker) return;
            rebuildMeasurementIntSelectOptions(
                sel,
                PORCH_PANEL_WIDTH_MIN,
                PORCH_PANEL_WIDTH_MAX,
                1,
                PORCH_PANEL_WIDTH_DEFAULT
            );
            if (!measurementSelectUserChanged(sel)) {
                setMeasurementSelectValue(sel, PORCH_PANEL_WIDTH_DEFAULT, { dispatchChange: false });
            }
            sel.setAttribute(PORCH_PANEL_DIM_RANGE_ATTR, widthMarker);
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eW) {
                try { syncMeasurementDivSelectUi(sel); } catch (eWs) { }
            }
        });

        rootEl.querySelectorAll('select[data-panel-dimension="height-int"]').forEach(function (sel) {
            if (!sel || sel.getAttribute(PORCH_PANEL_DIM_RANGE_ATTR) === heightMarker) return;
            rebuildMeasurementIntSelectOptions(
                sel,
                PORCH_PANEL_HEIGHT_MIN,
                PORCH_PANEL_HEIGHT_MAX,
                1,
                PORCH_PANEL_HEIGHT_DEFAULT
            );
            if (!measurementSelectUserChanged(sel)) {
                setMeasurementSelectValue(sel, PORCH_PANEL_HEIGHT_DEFAULT, { dispatchChange: false });
            }
            sel.setAttribute(PORCH_PANEL_DIM_RANGE_ATTR, heightMarker);
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eH) {
                try { syncMeasurementDivSelectUi(sel); } catch (eHs) { }
            }
        });

        // Porch opening rows: Finished Opening Height only (data-porch-dimension="height-int") → 60–147 def 80.
        rootEl.querySelectorAll('select[data-porch-dimension="height-int"]').forEach(function (sel) {
            if (!sel || sel.getAttribute(PORCH_PANEL_DIM_RANGE_ATTR) === heightMarker) return;
            rebuildMeasurementIntSelectOptions(
                sel,
                PORCH_PANEL_HEIGHT_MIN,
                PORCH_PANEL_HEIGHT_MAX,
                1,
                PORCH_PANEL_HEIGHT_DEFAULT
            );
            if (!measurementSelectUserChanged(sel)) {
                setMeasurementSelectValue(sel, PORCH_PANEL_HEIGHT_DEFAULT, { dispatchChange: false });
            }
            sel.setAttribute(PORCH_PANEL_DIM_RANGE_ATTR, heightMarker);
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (ePorchH) {
                try { syncMeasurementDivSelectUi(sel); } catch (ePorchHs) { }
            }
        });

        // Porch opening width: 15×panels / 48×panels / 36×panels (per opening entry).
        try {
            rootEl.querySelectorAll('.door-porch-opening-entry').forEach(function (entry) {
                applyPorchOpeningWidthIntRange(entry);
            });
            // Standalone width select (not yet in entry) — treat panels as 1.
            rootEl.querySelectorAll('select[data-porch-dimension="width-int"]').forEach(function (sel) {
                if (sel.closest && sel.closest('.door-porch-opening-entry')) return;
                applyPorchOpeningWidthIntRangeForSelect(sel, 1);
            });
        } catch (ePorchW) { }

        // Porch Panel Thickness: never allow a "0" option; default 1 1/8.
        rootEl.querySelectorAll('select[data-porch-dimension="thickness"]').forEach(function (sel) {
            if (!sel || !sel.options) return;
            var changedUi = false;
            for (var oi = sel.options.length - 1; oi >= 0; oi--) {
                if (String(sel.options[oi].value) === '0') {
                    sel.remove(oi);
                    changedUi = true;
                }
            }
            var porchThkDef = '1.125';
            if (!measurementSelectUserChanged(sel)) {
                var curThk = String(sel.value != null ? sel.value : '').trim();
                if (curThk !== porchThkDef) {
                    setMeasurementSelectValue(sel, porchThkDef, { dispatchChange: false });
                    changedUi = true;
                }
            }
            if (changedUi) {
                try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eTh0) {
                    try { syncMeasurementDivSelectUi(sel); } catch (eTh0s) { }
                }
            }
        });

        rootEl.querySelectorAll('select[data-panel-dimension="thickness"]').forEach(function (sel) {
            if (!sel || sel.getAttribute(PORCH_PANEL_DIM_RANGE_ATTR) === thickMarker) return;
            var userChanged = measurementSelectUserChanged(sel);
            var prev = String(sel.value != null ? sel.value : '').trim();
            while (sel.firstChild) sel.removeChild(sel.firstChild);
            for (var i = 0; i < PORCH_PANEL_THICKNESS_ORDER.length; i++) {
                var v = PORCH_PANEL_THICKNESS_ORDER[i];
                var op = document.createElement('option');
                op.value = v;
                op.textContent = PORCH_PANEL_THICKNESS_LABELS[v] || v;
                sel.appendChild(op);
            }
            var next = PORCH_PANEL_THICKNESS_DEFAULT;
            if (userChanged && PORCH_PANEL_THICKNESS_LABELS[prev]) next = prev;
            else if (PORCH_PANEL_THICKNESS_LABELS[prev]) next = prev;
            setMeasurementSelectValue(sel, next, { dispatchChange: false });
            sel.setAttribute(PORCH_PANEL_DIM_RANGE_ATTR, thickMarker);
            try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eT) {
                try { syncMeasurementDivSelectUi(sel); } catch (eTs) { }
            }
        });

        // Frac defaults to 0 when empty / not user-changed (sheet only specifies int defaults).
        rootEl.querySelectorAll(
            'select[data-panel-dimension="width-frac"], select[data-panel-dimension="height-frac"]'
        ).forEach(function (sel) {
            if (!sel || measurementSelectUserChanged(sel)) return;
            var cur = String(sel.value != null ? sel.value : '').trim();
            if (cur === '') setMeasurementSelectValue(sel, '0', { dispatchChange: false });
        });
    }

    function panelUnitOrderChoiceLabel(radioEl) {
        if (!radioEl) return '';
        var card = radioEl.closest && radioEl.closest('.common-check-option');
        if (!card) return '';
        var labelEl = card.querySelector('.common-check-option-label');
        return labelEl ? String(labelEl.textContent || '').trim() : '';
    }

    function isPanelUnitIndividualOrderChoice(val, label) {
        var v = normPreHungSelectionValue(val);
        var l = String(label || '').toLowerCase();
        if (v.indexOf('individual') !== -1 || v.indexOf('fixed_qty') !== -1 || v.indexOf('order_fixed') !== -1) return true;
        if (l.indexOf('individual panel') !== -1 || l.indexOf('order individual') !== -1 || l.indexOf('order fixed') !== -1) return true;
        return false;
    }

    function panelUnitIndividualOrderSelected(root, optionId) {
        if (!root) return false;
        var radios = all('input[type="radio"][data-option-id="' + optionId + '"]', root);
        if (radios.length) {
            var checked = radios.filter(function (el) { return el.checked; })[0];
            if (!checked) return false;
            if (isPanelUnitIndividualOrderChoice(checked.value, panelUnitOrderChoiceLabel(checked))) return true;
            if (radios.length >= 2 && radios.indexOf(checked) === 1) return true;
            return false;
        }
        var sel = root.querySelector('select[data-option-id="' + optionId + '"]');
        if (!sel || !sel.value) return false;
        var selectedOption = sel.options[sel.selectedIndex];
        var selectedLabel = selectedOption ? selectedOption.textContent : '';
        if (isPanelUnitIndividualOrderChoice(sel.value, selectedLabel)) return true;
        if (sel.options.length >= 2 && sel.selectedIndex === 1) return true;
        return false;
    }

    function isPanelUnitEnclosureOrderChoice(val, label) {
        if (isPanelUnitIndividualOrderChoice(val, label)) return false;
        var v = normPreHungSelectionValue(val);
        var l = String(label || '').toLowerCase();
        if (v.indexOf('enclosure') !== -1 || v.indexOf('design_porch') !== -1 || v.indexOf('porch_enclosure') !== -1) return true;
        if (l.indexOf('design a porch') !== -1 || l.indexOf('enclosure system') !== -1) return true;
        return false;
    }

    function panelUnitEnclosureOrderSelected(root, optionId) {
        if (!root) return false;
        var radios = all('input[type="radio"][data-option-id="' + optionId + '"]', root);
        if (radios.length) {
            var checked = radios.filter(function (el) { return el.checked; })[0];
            if (!checked) return false;
            if (isPanelUnitEnclosureOrderChoice(checked.value, panelUnitOrderChoiceLabel(checked))) return true;
            if (radios.length >= 2 && radios.indexOf(checked) === 0) return true;
            return false;
        }
        var sel = root.querySelector('select[data-option-id="' + optionId + '"]');
        if (!sel || !sel.value) return false;
        var selectedOption = sel.options[sel.selectedIndex];
        var selectedLabel = selectedOption ? selectedOption.textContent : '';
        if (isPanelUnitEnclosureOrderChoice(sel.value, selectedLabel)) return true;
        if (sel.options.length >= 2 && sel.selectedIndex === 0) return true;
        return false;
    }

    function porchOpeningDimensionSelect(openingEl, key) {
        if (!openingEl || !key) return null;
        return openingEl.querySelector('select[data-porch-dimension="' + key + '"]');
    }

    var PORCH_OPENING_TRIM_STOP_ALLOWANCE = 56.25;
    var PORCH_OPENING_FRACTION_DISPLAY = [
        { value: 0, label: '00' },
        { value: 0.0625, label: '1/16' },
        { value: 0.125, label: '1/8' },
        { value: 0.1875, label: '3/16' },
        { value: 0.25, label: '1/4' },
        { value: 0.3125, label: '5/16' },
        { value: 0.375, label: '3/8' },
        { value: 0.4375, label: '7/16' },
        { value: 0.5, label: '1/2' },
        { value: 0.5625, label: '9/16' },
        { value: 0.625, label: '5/8' },
        { value: 0.6875, label: '11/16' },
        { value: 0.75, label: '3/4' },
        { value: 0.8125, label: '13/16' },
        { value: 0.875, label: '7/8' },
        { value: 0.9375, label: '15/16' }
    ];

    function porchOpeningDimensionInches(openingEl, key) {
        var intSel = porchOpeningDimensionSelect(openingEl, key + '-int');
        var fracSel = porchOpeningDimensionSelect(openingEl, key + '-frac');
        if (!intSel) return 0;
        return (parseInt(intSel.value, 10) || 0) + (parseFloat(fracSel && fracSel.value) || 0);
    }

    function formatPorchInchesFromNumber(inches) {
        if (isNaN(inches)) return '';
        var rounded = Math.round(inches * 16) / 16;
        if (rounded < 0) rounded = 0;
        var intPart = Math.floor(rounded + 1e-9);
        var fracPart = Math.round((rounded - intPart) * 1000) / 1000;
        var fracLabel = '';
        var bestDiff = 1;
        PORCH_OPENING_FRACTION_DISPLAY.forEach(function (entry) {
            var diff = Math.abs(entry.value - fracPart);
            if (diff < bestDiff) {
                bestDiff = diff;
                fracLabel = entry.label;
            }
        });
        if (bestDiff > 1e-4) fracLabel = '';
        if (!fracLabel || fracLabel === '0' || fracLabel === '00') return String(intPart);
        return intPart + ' ' + fracLabel;
    }

    function porchOpeningPanelsCount(openingEl) {
        if (!openingEl) return 1;
        var qtyInput = openingEl.querySelector('[data-porch-dimension="panels"]');
        return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    }

    /** Finished Opening Width for a porch opening: min/max/def = 15/48/36 × panel count. */
    function applyPorchOpeningWidthIntRangeForSelect(sel, panelCount) {
        if (!sel || (sel.id && /frac/i.test(sel.id))) return false;
        var n = Math.max(1, parseInt(panelCount, 10) || 1);
        var min = PORCH_PANEL_WIDTH_MIN * n;
        var max = PORCH_PANEL_WIDTH_MAX * n;
        var def = String((parseInt(PORCH_PANEL_WIDTH_DEFAULT, 10) || 36) * n);
        var marker = 'porch-w:' + n + ':' + min + '-' + max + ':' + def;
        if (sel.getAttribute(PORCH_PANEL_DIM_RANGE_ATTR) === marker) {
            if (!measurementSelectUserChanged(sel)) {
                var cur = String(sel.value != null ? sel.value : '').trim();
                if (cur !== def) setMeasurementSelectValue(sel, def, { dispatchChange: false });
            }
            return false;
        }
        rebuildMeasurementIntSelectOptions(sel, min, max, 1, def);
        if (!measurementSelectUserChanged(sel)) {
            setMeasurementSelectValue(sel, def, { dispatchChange: false });
        } else {
            var curNum = parseInt(sel.value, 10);
            if (!isFinite(curNum) || curNum < min || curNum > max) {
                setMeasurementSelectValue(sel, def, { dispatchChange: false });
            }
        }
        sel.setAttribute(PORCH_PANEL_DIM_RANGE_ATTR, marker);
        try { rebuildDoorDivSelectFromNativeOptions(sel); } catch (eReb) {
            try { syncMeasurementDivSelectUi(sel); } catch (eSync) { }
        }
        return true;
    }

    function applyPorchOpeningWidthIntRange(openingEl) {
        if (!openingEl) return false;
        var sel = openingEl.querySelector('select[data-porch-dimension="width-int"]');
        if (!sel) return false;
        return applyPorchOpeningWidthIntRangeForSelect(sel, porchOpeningPanelsCount(openingEl));
    }

    var PORCH_TRIM_INFO_COPY = {
        sill: {
            title: 'Sill',
            body: 'A Sill is a solid piece of milled wood that sits beneath your Porch Enclosure Panels, tapered to shed water away from your panels and serving as a flat base for installation.',
            imageAttr: 'data-porch-trim-info-image-sill'
        },
        stops: {
            title: 'Stops',
            body: 'Stops are trim pieces that extend the length and height of your porch panels within each porch opening, securing the panels in place on the top, bottom and sides of the opening.',
            imageAttr: 'data-porch-trim-info-image-stops'
        },
        astragal: {
            title: 'Astragal',
            body: 'An Astragal is a two-piece trim unit that connects two adjacent porch panels and fills the space between them.',
            imageAttr: 'data-porch-trim-info-image-astragal'
        }
    };

    function porchTrimInfoModalImageUrl(kind) {
        var configRoot = document.getElementById('door-configurator');
        if (!configRoot) return '';
        var copy = PORCH_TRIM_INFO_COPY[kind];
        if (!copy || !copy.imageAttr) return '';
        return String(configRoot.getAttribute(copy.imageAttr) || '').trim();
    }

    function porchTrimInfoModalSyncDiagramImages(modal, root) {
        if (!modal || !root) return;
        all('.door-porch-trim-info-modal__screen', modal).forEach(function (screen) {
            var kind = screen.getAttribute('data-porch-trim-info');
            var img = screen.querySelector('.door-porch-trim-info-modal__image');
            if (!img || !kind) return;
            var configured = porchTrimInfoModalImageUrl(kind);
            if (configured) img.setAttribute('src', configured);
        });
    }

    function porchTrimInfoModalAttachToBody(modal) {
        if (!modal || !document.body) return;
        if (modal.parentNode === document.body) return;
        document.body.appendChild(modal);
    }

    function porchTrimInfoModalElement(root) {
        var modal = document.querySelector('.door-porch-trim-info-modal');
        if (modal) return modal;
        if (!root) root = document.getElementById('door-configurator');
        if (!root) return null;
        return root.querySelector('.door-porch-trim-info-modal');
    }

    function ensurePorchTrimInfoModal(root) {
        if (!root) root = document.getElementById('door-configurator');
        var modal = porchTrimInfoModalElement(root);
        if (!modal) {
            modal = document.createElement('div');
            modal.className = 'door-porch-trim-info-modal door-hidden';
            modal.setAttribute('role', 'dialog');
            modal.setAttribute('aria-modal', 'true');
            modal.setAttribute('aria-hidden', 'true');
            modal.innerHTML =
                '<div class="door-porch-trim-info-modal__backdrop" data-porch-info-close></div>' +
                '<div class="door-porch-trim-info-modal__panel">' +
                '<button type="button" class="door-porch-trim-info-modal__close" data-porch-info-close aria-label="Close">&times;</button>' +
                '<h3 class="door-porch-trim-info-modal__title p-medium fw-600 primaryFont"></h3>' +
                '<div class="door-porch-trim-info-modal__body p-small"></div>' +
                '</div>';
            (document.body || root).appendChild(modal);
        }
        porchTrimInfoModalAttachToBody(modal);
        if (!modal.getAttribute('data-porch-trim-info-bound')) {
            modal.setAttribute('data-porch-trim-info-bound', '1');
            modal.addEventListener('click', function (ev) {
                var target = ev.target;
                if (!target) return;
                var closer = target.closest ? target.closest('[data-porch-info-close]') : null;
                if (!closer && target.getAttribute && target.getAttribute('data-porch-info-close') != null) {
                    closer = target;
                }
                if (closer && modal.contains(closer)) {
                    porchOpeningCloseInfoModal(root);
                }
            });
            document.addEventListener('keydown', function (ev) {
                if (!modal || modal.classList.contains('door-hidden')) return;
                if (ev.key === 'Escape' || ev.key === 'Esc') porchOpeningCloseInfoModal(root);
            });
        }
        porchTrimInfoModalSyncDiagramImages(modal, root);
        return modal;
    }

    function porchOpeningCloseInfoModal(root) {
        var configRoot = root || document.getElementById('door-configurator');
        var modal = porchTrimInfoModalElement(configRoot);
        if (!modal) return;
        modal.classList.add('door-hidden');
        modal.setAttribute('aria-hidden', 'true');
        all('.door-porch-trim-info-modal__screen', modal).forEach(function (screen) {
            screen.classList.add('door-hidden');
        });
    }

    function porchOpeningOpenInfoModal(kind) {
        var configRoot = document.getElementById('door-configurator');
        if (!configRoot) return;
        var copy = PORCH_TRIM_INFO_COPY[kind];
        if (!copy) return;
        var modal = ensurePorchTrimInfoModal(configRoot);
        if (!modal) return;
        var activeScreen = modal.querySelector('.door-porch-trim-info-modal__screen[data-porch-trim-info="' + kind + '"]');
        if (activeScreen) {
            all('.door-porch-trim-info-modal__screen', modal).forEach(function (screen) {
                screen.classList.toggle('door-hidden', screen !== activeScreen);
            });
            var activeTitle = activeScreen.querySelector('.door-porch-trim-info-modal__title');
            if (activeTitle) modal.setAttribute('aria-labelledby', activeTitle.id || 'door-porch-trim-info-title');
        } else {
            var titleEl = modal.querySelector('.door-porch-trim-info-modal__title');
            var bodyEl = modal.querySelector('.door-porch-trim-info-modal__body');
            if (titleEl) titleEl.textContent = copy.title;
            if (bodyEl) bodyEl.textContent = copy.body;
        }
        modal.classList.remove('door-hidden');
        modal.setAttribute('aria-hidden', 'false');
        var closeBtn = modal.querySelector('.door-porch-trim-info-modal__close');
        if (closeBtn) closeBtn.focus();
    }

    function porchOpeningHideSillEditor(openingEl) {
        if (!openingEl) return;
        openingEl.removeAttribute('data-porch-sill-editor-open');
        var editor = openingEl.querySelector('.door-porch-opening-sill-editor');
        if (editor) editor.classList.add('door-hidden');
    }

    function porchOpeningShowSillEditor(openingEl) {
        if (!openingEl) return;
        var editor = openingEl.querySelector('.door-porch-opening-sill-editor');
        if (!editor) return;
        var depthSel = openingEl.querySelector('.door-porch-sill-depth-select');
        var fracSel = openingEl.querySelector('.door-porch-sill-frac-select');
        if (depthSel) openingEl.setAttribute('data-porch-sill-depth-saved', depthSel.value || '5');
        if (fracSel) openingEl.setAttribute('data-porch-sill-frac-saved', fracSel.value || '0');
        openingEl.setAttribute('data-porch-sill-editor-open', '1');
        editor.classList.remove('door-hidden');
        // Dp start 17-08 — re-bind hidden inch dropdown so the custom UI matches the native value
        try { enhancePanelUnitMeasurementSelects(editor); } catch (eSillEnh) { }
        if (depthSel) {
            var depthOk = setMeasurementSelectValue(depthSel, depthSel.value || '5', { dispatchChange: false });
            if (!depthOk) {
                try { depthSel.value = String(depthSel.value || '5'); } catch (eDepth) { }
                syncMeasurementDivSelectUi(depthSel);
            }
        }
        if (fracSel) {
            var fracOk = setMeasurementSelectValue(fracSel, fracSel.value || '0', { dispatchChange: false });
            if (!fracOk) {
                try { fracSel.value = String(fracSel.value || '0'); } catch (eFrac) { }
                syncMeasurementDivSelectUi(fracSel);
            }
        }
        // Dp end 17-08
        updatePorchOpeningDerivedUi(openingEl);
    }

    function bindPorchOpeningInfoControls(scopeEl) {
        if (!scopeEl) return;
        all('[data-porch-info]', scopeEl).forEach(function (btn) {
            if (btn.getAttribute('data-porch-info-bound')) return;
            btn.setAttribute('data-porch-info-bound', '1');
            btn.addEventListener('click', function (ev) {
                ev.preventDefault();
                porchOpeningOpenInfoModal(btn.getAttribute('data-porch-info'));
            });
        });
    }

    // Dp start 19-08 — porch Door #N options come from config_choice JSON (#door-config-choices-json)
    function porchChoiceString(v) {
        if (v == null || v === '') return '';
        if (typeof v === 'string' || typeof v === 'number') return String(v);
        if (typeof v === 'object') {
            if (v.value != null && (typeof v.value === 'string' || typeof v.value === 'number')) return String(v.value);
            if (v.handle) return String(v.handle);
        }
        return '';
    }
    function porchConfigChoiceNorm(v) {
        return porchChoiceString(v).trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_').replace(/_finish$/, '');
    }
    function porchConfigChoiceImage(ch) {
        if (!ch) return '';
        var candidates = [ch.image_url, ch.image, ch.imag_url];
        for (var i = 0; i < candidates.length; i++) {
            var img = candidates[i];
            if (!img) continue;
            var src = '';
            if (typeof img === 'string') src = String(img).trim();
            else if (img.url) src = String(img.url).trim();
            else if (img.src) src = String(img.src).trim();
            else if (typeof img.value === 'string') src = String(img.value).trim();
            else if (img.value && img.value.url) src = String(img.value.url).trim();
            if (src && src !== '#' && /^(https?:)?\/\//i.test(src)) return src;
        }
        return '';
    }
    function porchConfigChoiceRow(ch) {
        var handle = porchChoiceString(ch && ch.handle);
        var value = porchChoiceString(ch && (ch.value || ch.handle));
        var label = porchChoiceString(ch && (ch.label || ch.value || ch.handle));
        var image = porchConfigChoiceImage(ch);
        var row = { value: value, label: label, handle: handle };
        if (image) {
            row.image = image;
            row.image_url = image;
        }
        if (ch && ch.description) row.description = String(ch.description);
        return row;
    }
    function porchConfigChoiceInGroup(ch, keys) {
        var parts = [ch && ch.group, ch && ch.value, ch && ch.handle, ch && ch.label];
        var norms = [];
        for (var p = 0; p < parts.length; p++) {
            var n = porchConfigChoiceNorm(parts[p]);
            if (n) norms.push(n);
        }
        for (var i = 0; i < keys.length; i++) {
            var k = porchConfigChoiceNorm(keys[i]);
            if (!k) continue;
            for (var ni = 0; ni < norms.length; ni++) {
                var n = norms[ni];
                if (n === k) return true;
                if (k.length >= 6 && (n.indexOf(k) === 0 || n.indexOf('_' + k) !== -1)) return true;
            }
        }
        return false;
    }
    var PORCH_OPENING_DOOR_SWING_OPTIONS = [];
    var PORCH_HINGE_FINISH_IMAGE_URLS = {};
    var PORCH_OPENING_DOOR_HINGE_OPTIONS = [];
    var PORCH_OPENING_DOOR_LOCKSET_OPTIONS = [];
    var _porchSeenSwing = {};
    var _porchSeenHinge = {};
    var _porchSeenLockset = {};
    function porchPushChoiceToGroup(ch) {
        if (!ch) return;
        var group = porchConfigChoiceNorm(ch.group);
        var row = porchConfigChoiceRow(ch);
        var dedupe = porchConfigChoiceNorm(row.value || row.handle);
        if (!dedupe) return;
        var swingKeys = ['swing_direction', 'out_right', 'out_left', 'in_right', 'in_left', 'barn_door', 'pocket_door', 'double_door', 'out_right_swing', 'out_left_swing', 'in_right_swing', 'in_left_swing', 'out_right_door_handling', 'out_left_door_handling', 'in_right_door_handling', 'in_left_door_handling'];
        var hingeKeys = ['hinge_finish', 'oil_rubbed_bronze', 'polished_brass', 'unlacquered_brass', 'unlacqured_brass', 'black', 'satin_nickel', 'french_antique', 'pewter'];
        var locksetKeys = ['lockset_prep', 'none', 'no_lock_prep', 'no_lockset_prep', 'lockset_none', 'mortise_lock_prep', 'mortise-lock-prep', 'mortise_pocket'];
        var isLockset = group === 'lockset_prep'
            || dedupe === 'none'
            || dedupe.indexOf('lock_prep') !== -1
            || dedupe.indexOf('mortise') !== -1
            || porchConfigChoiceInGroup(ch, locksetKeys);
        if (isLockset) {
            if (_porchSeenLockset[dedupe]) return;
            _porchSeenLockset[dedupe] = true;
            PORCH_OPENING_DOOR_LOCKSET_OPTIONS.push(row);
            return;
        }
        if (group === 'swing_direction' || porchConfigChoiceInGroup(ch, swingKeys)) {
            if (_porchSeenSwing[dedupe]) return;
            _porchSeenSwing[dedupe] = true;
            PORCH_OPENING_DOOR_SWING_OPTIONS.push(row);
            return;
        }
        if (group === 'hinge_finish' || porchConfigChoiceInGroup(ch, hingeKeys)) {
            if (_porchSeenHinge[dedupe]) return;
            _porchSeenHinge[dedupe] = true;
            PORCH_OPENING_DOOR_HINGE_OPTIONS.push(row);
            if (row.image) {
                PORCH_HINGE_FINISH_IMAGE_URLS[dedupe] = row.image;
                if (row.handle) PORCH_HINGE_FINISH_IMAGE_URLS[porchConfigChoiceNorm(row.handle)] = row.image;
            }
        }
    }
    function parseDoorConfigChoicesJson(raw) {
        var text = String(raw == null ? '' : raw).replace(/^\uFEFF/, '').trim();
        if (!text) return [];
        text = text.replace(/^\[\s*,+/, '[').replace(/,+\s*\]\s*$/, ']').replace(/,\s*,+/g, ',');
        try {
            var parsed = JSON.parse(text);
            if (Array.isArray(parsed)) return parsed.filter(function (row) { return !!row; });
            if (parsed && typeof parsed === 'object') return [parsed];
        } catch (eParse) { }
        var rows = [];
        var start = -1;
        var depth = 0;
        for (var i = 0; i < text.length; i++) {
            var ch = text.charAt(i);
            if (ch === '{') {
                if (depth === 0) start = i;
                depth += 1;
            } else if (ch === '}') {
                depth -= 1;
                if (depth === 0 && start >= 0) {
                    try { rows.push(JSON.parse(text.slice(start, i + 1))); } catch (eObj) { }
                    start = -1;
                }
            }
        }
        return rows;
    }
    function fillPorchOptionsFromConfigChoiceJson() {
        var catalog = [];
        try {
            var el = document.getElementById('door-config-choices-json');
            if (el && (el.textContent || el.innerText)) {
                catalog = parseDoorConfigChoicesJson(el.textContent || el.innerText);
            }
        } catch (eJson) { }
        catalog.forEach(porchPushChoiceToGroup);
        try {
            var schemaEl = document.getElementById('door-configurator-schema');
            if (schemaEl && schemaEl.textContent) {
                var schema = JSON.parse(schemaEl.textContent);
                if (Array.isArray(schema)) {
                    schema.forEach(function (opt) {
                        var id = porchConfigChoiceNorm(opt && opt.id);
                        if (id !== 'swing_direction' && id !== 'lockset_prep' && id !== 'hinge_finish') return;
                        var opts = opt && Array.isArray(opt.options) ? opt.options : [];
                        opts.forEach(function (ch) {
                            if (!ch) return;
                            ch.group = id;
                            porchPushChoiceToGroup(ch);
                        });
                    });
                }
            }
        } catch (eSchema) { }
        try {
            var liveSchema = doorConfigSchemaRef();
            if (Array.isArray(liveSchema)) {
                liveSchema.forEach(function (opt) {
                    var id = porchConfigChoiceNorm(opt && opt.id);
                    if (id !== 'swing_direction' && id !== 'lockset_prep' && id !== 'hinge_finish') return;
                    var opts = opt && Array.isArray(opt.options) ? opt.options : [];
                    opts.forEach(function (ch) {
                        if (!ch) return;
                        ch.group = id;
                        porchPushChoiceToGroup(ch);
                    });
                });
            }
        } catch (eLive) { }
        // Dp: porch-19-08 debug console.log removed (quieter console)
    }
    fillPorchOptionsFromConfigChoiceJson();
    // Dp end 19-08

    function resolvePorchChoiceImageSrc(choice) {
        if (!choice) return '';
        // Dp start 13-08
        if (typeof deps.resolveChoiceImageSrc === 'function') {
            try {
                var fromDeps = deps.resolveChoiceImageSrc(choice);
                if (fromDeps) return String(fromDeps);
            } catch (eDepImg) { }
        }
        // Dp end 13-08
        var candidates = [choice.image, choice.image_url, choice.imag_url];
        for (var ci = 0; ci < candidates.length; ci++) {
            var img = candidates[ci];
            if (!img) continue;
            var src = '';
            if (typeof img === 'string') src = String(img).trim();
            else if (img.url) src = String(img.url).trim();
            else if (img.src) src = String(img.src).trim();
            else if (img.value && img.value.url) src = String(img.value.url).trim();
            else if (img.preview_image && typeof img.preview_image === 'string') src = String(img.preview_image).trim();
            else if (img.preview_image && img.preview_image.url) src = String(img.preview_image.url).trim();
            if (src && src !== '#' && /^(https?:)?\/\//i.test(src)) return src;
        }
        return '';
    }

    function getPorchHingeFinishImageFromStaticMap(value) {
        var key = normalizePorchChoiceKey(value);
        if (!key) return '';
        if (PORCH_HINGE_FINISH_IMAGE_URLS[key]) return PORCH_HINGE_FINISH_IMAGE_URLS[key];
        var stripped = key.replace(/_finish$/, '');
        if (stripped && PORCH_HINGE_FINISH_IMAGE_URLS[stripped]) return PORCH_HINGE_FINISH_IMAGE_URLS[stripped];
        return '';
    }

    function normalizePorchChoiceKey(v) {
        return String(v == null ? '' : v).trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
    }

    function findSchemaHingeFinishOption(schema) {
        if (!Array.isArray(schema)) return null;
        for (var i = 0; i < schema.length; i++) {
            var opt = schema[i];
            if (!opt) continue;
            var id = normalizeOptionIdKey(opt.id);
            if (id === 'hinge_finish') return opt;
        }
        return null;
    }

    function findSchemaChoiceForPorchValue(byKey, value) {
        var k = normalizePorchChoiceKey(value);
        if (!k) return null;
        if (byKey[k]) return byKey[k];
        if (byKey[k + '_finish']) return byKey[k + '_finish'];
        var stripped = k.replace(/_finish$/, '');
        if (stripped && byKey[stripped]) return byKey[stripped];
        return null;
    }

    /** Enrich hardcoded porch hinge finishes with image/image_url from schema hinge_finish choices. */
    function getPorchOpeningHingeFinishOptions() {
        var base = PORCH_OPENING_DOOR_HINGE_OPTIONS.map(function (o) {
            var row = { value: o.value, label: o.label };
            var hardcodedSrc = resolvePorchChoiceImageSrc(o);
            if (hardcodedSrc) row.image = hardcodedSrc;
            return row;
        });
        var schema = doorConfigSchemaRef();
        var hingeOpt = findSchemaHingeFinishOption(schema);
        if (!hingeOpt || !Array.isArray(hingeOpt.options) || !hingeOpt.options.length) return base;
        var byKey = {};
        hingeOpt.options.forEach(function (ch) {
            var key = normalizePorchChoiceKey(ch && ch.value);
            if (key) byKey[key] = ch;
        });
        return base.map(function (o) {
            var ch = findSchemaChoiceForPorchValue(byKey, o.value);
            var src = resolvePorchChoiceImageSrc(ch) || resolvePorchChoiceImageSrc(o) || getPorchHingeFinishImageFromStaticMap(o.value);
            var out = {
                value: o.value,
                label: (ch && (ch.label || ch.value)) ? String(ch.label || ch.value) : o.label
            };
            if (src) out.image = src;
            return out;
        });
    }

    function porchOpeningDoorChoiceCards(groupEl) {
        if (!groupEl) return [];
        return all('.common-check-option', groupEl);
    }

    function porchOpeningDoorChoiceSelectedValue(groupEl) {
        if (!groupEl) return '';
        var selected = groupEl.querySelector('input:checked');
        return selected ? String(selected.value || '') : '';
    }

    function porchOpeningDoorChoiceSetSelected(groupEl, value) {
        if (!groupEl) return;
        var nextValue = value != null ? String(value) : '';
        porchOpeningDoorChoiceCards(groupEl).forEach(function (card) {
            var input = card.querySelector('input');
            var cardValue = card.getAttribute('data-choice-value') || (input && input.value) || '';
            var isSelected = nextValue && cardValue === nextValue;
            if (input) input.checked = isSelected;
            card.classList.toggle('common-check-option--selected', isSelected);
        });
    }

    function bindPorchOpeningDoorChoiceGroup(groupEl) {
        if (!groupEl || groupEl.getAttribute('data-porch-door-choice-bound')) return;
        groupEl.setAttribute('data-porch-door-choice-bound', '1');
        porchOpeningDoorChoiceCards(groupEl).forEach(function (card) {
            var input = card.querySelector('input');
            if (!input) return;
            input.addEventListener('change', function () {
                porchOpeningDoorChoiceSetSelected(groupEl, input.value);
                updateEstimatedPrice();
            });
        });
        porchOpeningDoorChoiceSetSelected(groupEl, porchOpeningDoorChoiceSelectedValue(groupEl));
    }

    // Dp start image alt tag updated
    function buildOptionChoiceImageAlt(sectionTitle, choiceLabel) {
        var sec = String(sectionTitle || '').trim();
        var choice = String(choiceLabel || '').trim();
        if (!choice) return sec;
        if (!sec) return choice;
        var secLower = sec.toLowerCase();
        var choiceLower = choice.toLowerCase();
        if (choiceLower.indexOf(secLower) !== -1) {
            return choice;
        }
        return sec + ' - ' + choice;
    }
    // Dp end image alt

    function porchOpeningDoorChoiceGroup(fieldName, choices, options) {
        options = options || {};
        var group = document.createElement('div');
        group.className = 'common-check-options door-porch-opening-door-choice-group' + (options.gridClass ? ' ' + options.gridClass : '');
        choices.forEach(function (choice, idx) {
            var card = document.createElement('label');
            card.className = 'common-check-option door-porch-opening-door-choice';
            card.setAttribute('data-choice-value', choice.value);
            var input = document.createElement('input');
            input.type = 'radio';
            input.name = fieldName;
            input.value = choice.value;
            input.style.position = 'absolute';
            input.style.opacity = '0';
            input.style.pointerEvents = 'none';
            // No default select — customer must pick swing / hinge / lockset.
            if (options.defaultValue != null && choice.value === options.defaultValue) {
                input.checked = true;
            }
            card.appendChild(input);
            if (options.imageClass) {
                var image = document.createElement('div');
                image.className = options.imageClass;
                var imgSrc = resolvePorchChoiceImageSrc(choice);
                // Dp start 13-08
                if (!imgSrc) {
                    try {
                        if (options.imageClass.indexOf('door-porch-opening-door-hinge-swatch') !== -1) {
                            imgSrc = getHingeSwatchImageFromSchema(choice.value);
                        } else if (options.imageClass.indexOf('door-porch-opening-door-swing-image') !== -1) {
                            imgSrc = getSwingDirectionImageFromSchema(choice.value);
                        }
                    } catch (eDp1308Thumb) { }
                }
                // Dp end 13-08
                // Dp start 19-08
                if (!imgSrc && options.imageClass.indexOf('door-porch-opening-door-lockset-image') !== -1) {
                    imgSrc = resolvePorchChoiceImageSrc(choice) || porchConfigChoiceImage(choice);
                }
                // Dp end 19-08
                if (imgSrc) {
                    var img = document.createElement('img');
                    img.src = imgSrc;
                    // Dp start image alt tag updated
                    var secTitle = fieldName ? String(fieldName).replace(/^attributes\[/, '').replace(/\]$/, '') : '';
                    img.alt = buildOptionChoiceImageAlt(secTitle, choice.label || choice.value);
                    // Dp end image alt
                    img.className = 'door-porch-opening-door-choice-img';
                    image.appendChild(img);
                    image.classList.add('door-porch-opening-door-hinge-swatch--has-image');
                }
                card.appendChild(image);
            }
            var textWrap = document.createElement('div');
            textWrap.className = 'common-check-option-text';
            var text = document.createElement('span');
            text.className = 'common-check-option-label';
            text.textContent = choice.label;
            textWrap.appendChild(text);
            if (choice.description) {
                var desc = document.createElement('span');
                desc.className = 'common-check-option-desc';
                desc.textContent = choice.description;
                textWrap.appendChild(desc);
            }
            card.appendChild(textWrap);
            group.appendChild(card);
        });
        bindPorchOpeningDoorChoiceGroup(group);
        return group;
    }

    /** Unique radio name per Opening + Door so Opening #1 and #2 Door #1 don't share one group. */
    function porchOpeningDoorRadioName(openingNumber, doorNumber, fieldLabel) {
        var op = Math.max(1, parseInt(openingNumber, 10) || 1);
        var dn = Math.max(1, parseInt(doorNumber, 10) || 1);
        return 'attributes[Panel Opening ' + op + ' Door ' + dn + ' ' + fieldLabel + ']';
    }

    function porchOpeningNumberFromEl(openingEl) {
        if (!openingEl) return 1;
        var listEl = openingEl.closest ? openingEl.closest('.door-porch-opening-list') : null;
        if (!listEl) listEl = document.querySelector('.door-porch-opening-list');
        if (!listEl) return 1;
        var entries = all('.door-porch-opening-entry', listEl);
        for (var i = 0; i < entries.length; i++) {
            if (entries[i] === openingEl) return i + 1;
        }
        return 1;
    }

    function syncPorchOpeningDoorRadioNames(openingEl) {
        if (!openingEl) return;
        var openingNumber = porchOpeningNumberFromEl(openingEl);
        all('.door-porch-opening-door-config', openingEl).forEach(function (block) {
            if (!block) return;
            var doorNumber = parseInt(block.getAttribute('data-porch-door-config'), 10) || 1;
            all('.door-porch-opening-door-swing-section input[type="radio"]', block).forEach(function (inp) {
                inp.name = porchOpeningDoorRadioName(openingNumber, doorNumber, 'Swing Direction');
            });
            all('.door-porch-opening-door-hinge-section input[type="radio"]', block).forEach(function (inp) {
                inp.name = porchOpeningDoorRadioName(openingNumber, doorNumber, 'Hinge Finish');
            });
            all('.door-porch-opening-door-lockset-section input[type="radio"]', block).forEach(function (inp) {
                inp.name = porchOpeningDoorRadioName(openingNumber, doorNumber, 'Lockset Preparation');
            });
        });
    }

    function createPorchOpeningDoorConfigBlock(doorNumber, openingNumber) {
        // Dp start 19-08
        try { fillPorchOptionsFromConfigChoiceJson(); } catch (eFillPorch) { }
        // Dp end 19-08
        openingNumber = Math.max(1, parseInt(openingNumber, 10) || 1);
        var block = document.createElement('div');
        block.className = 'door-porch-opening-door-config door-hidden';
        block.setAttribute('data-porch-door-config', String(doorNumber));
        var swingSection = document.createElement('div');
        swingSection.className = 'door-porch-opening-door-config-section door-porch-opening-door-swing-section';
        var swingTitle = document.createElement('p');
        swingTitle.className = 'door-porch-opening-door-config-title fw-600';
        swingTitle.textContent = 'Door #' + doorNumber + ' Swing Direction';
        swingSection.appendChild(swingTitle);
        swingSection.appendChild(porchOpeningDoorChoiceGroup(
            porchOpeningDoorRadioName(openingNumber, doorNumber, 'Swing Direction'),
            PORCH_OPENING_DOOR_SWING_OPTIONS,
            { gridClass: 'grid-4', imageClass: 'common-check-option-image door-porch-opening-door-swing-image' }
        ));
        block.appendChild(swingSection);
        var hingeSection = document.createElement('div');
        hingeSection.className = 'door-porch-opening-door-config-section door-porch-opening-door-hinge-section';
        var hingeTitle = document.createElement('p');
        hingeTitle.className = 'door-porch-opening-door-config-title fw-600';
        hingeTitle.textContent = 'Door #' + doorNumber + ' Hinge Finish';
        hingeSection.appendChild(hingeTitle);
        hingeSection.appendChild(porchOpeningDoorChoiceGroup(
            porchOpeningDoorRadioName(openingNumber, doorNumber, 'Hinge Finish'),
            getPorchOpeningHingeFinishOptions(),
            { gridClass: 'grid-3', imageClass: 'common-check-option-image door-porch-opening-door-hinge-swatch' }
        ));
        block.appendChild(hingeSection);
        var locksetSection = document.createElement('div');
        locksetSection.className = 'door-porch-opening-door-config-section door-porch-opening-door-lockset-section';
        var locksetHeader = document.createElement('div');
        locksetHeader.className = 'door-porch-opening-door-config-header';
        var locksetTitle = document.createElement('p');
        locksetTitle.className = 'door-porch-opening-door-config-title fw-600';
        locksetTitle.textContent = 'Door #' + doorNumber + ' Lockset Preparation';
        locksetHeader.appendChild(locksetTitle);
        var locksetBtn = document.createElement('button');
        locksetBtn.type = 'button';
        locksetBtn.className = 'wood-species-open-btn common-btn btn-secondary btn-small door-lockset-prep-btn';
        locksetBtn.setAttribute('data-lockset-prep-open', '');
        locksetBtn.setAttribute('aria-haspopup', 'dialog');
        locksetBtn.textContent = 'About Lockset Prep';
        locksetBtn.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (typeof openLocksetPrepDrawer === 'function') openLocksetPrepDrawer();
        });
        locksetHeader.appendChild(locksetBtn);
        locksetSection.appendChild(locksetHeader);
        var locksetDefault = 'none';
        var locksetImageClass = '';
        if (PORCH_OPENING_DOOR_LOCKSET_OPTIONS.length) {
            locksetDefault = PORCH_OPENING_DOOR_LOCKSET_OPTIONS[0].value;
            for (var ldi = 0; ldi < PORCH_OPENING_DOOR_LOCKSET_OPTIONS.length; ldi++) {
                var lockOpt = PORCH_OPENING_DOOR_LOCKSET_OPTIONS[ldi];
                var lk = porchConfigChoiceNorm(lockOpt.value);
                if (lk === 'none' || lk === 'no_lock_prep' || lk === 'no_lockset_prep') {
                    locksetDefault = lockOpt.value;
                }
                if (resolvePorchChoiceImageSrc(lockOpt) || porchConfigChoiceImage(lockOpt)) {
                    locksetImageClass = 'common-check-option-image door-porch-opening-door-lockset-image';
                }
            }
        }
        locksetSection.appendChild(porchOpeningDoorChoiceGroup(
            porchOpeningDoorRadioName(openingNumber, doorNumber, 'Lockset Preparation'),
            PORCH_OPENING_DOOR_LOCKSET_OPTIONS,
            { gridClass: 'grid-3', defaultValue: locksetDefault, imageClass: locksetImageClass || undefined }
        ));
        block.appendChild(locksetSection);
        return block;
    }

    function porchOpeningDoorConfigList(openingEl) {
        return openingEl ? openingEl.querySelector('.door-porch-opening-door-config-list') : null;
    }

    function porchOpeningDoorConfigBlock(openingEl, doorNumber) {
        var listEl = porchOpeningDoorConfigList(openingEl);
        if (!listEl) return null;
        return listEl.querySelector('.door-porch-opening-door-config[data-porch-door-config="' + doorNumber + '"]');
    }

    // Dp start 13-08
    function hingeFinishNormKey(value) {
        var s = String(value || '').toLowerCase().replace(/[-_\s]/g, '');
        if (s.slice(-6) === 'finish') s = s.slice(0, -6);
        return s;
    }

    function getHingeSwatchImageFromSchema(value) {
        var fromStatic = getPorchHingeFinishImageFromStaticMap(value);
        var normValue = hingeFinishNormKey(value);
        if (!normValue) return fromStatic || '';

        var schemasToSearch = [];
        try {
            var refSchema = doorConfigSchemaRef();
            if (refSchema) schemasToSearch.push(refSchema);
        } catch (e) { }

        try {
            if (window.__doorConfigSchema) schemasToSearch.push(window.__doorConfigSchema);
        } catch (e) { }

        try {
            if (window.doorConfigSchema) schemasToSearch.push(window.doorConfigSchema);
        } catch (e) { }

        try {
            var hwEl = document.getElementById('door-recommended-hardware-products');
            if (hwEl && hwEl.textContent) {
                var products = JSON.parse(hwEl.textContent);
                if (Array.isArray(products)) {
                    for (var p = 0; p < products.length; p++) {
                        var prod = products[p];
                        if (prod && prod.finishOption) {
                            schemasToSearch.push(prod.finishOption);
                        }
                    }
                }
            }
        } catch (e) { }

        try {
            var rootEl = document.getElementById('door-configurator');
            if (rootEl) {
                var raw = rootEl.getAttribute('data-recommended-hardware-products');
                if (raw) {
                    var products2 = JSON.parse(raw);
                    if (Array.isArray(products2)) {
                        for (var p2 = 0; p2 < products2.length; p2++) {
                            var prod2 = products2[p2];
                            if (prod2 && prod2.finishOption) {
                                schemasToSearch.push(prod2.finishOption);
                            }
                        }
                    }
                }
            }
        } catch (e) { }

        try {
            var choicesEl = document.getElementById('door-config-choices-json');
            if (choicesEl && choicesEl.textContent) {
                var choices = JSON.parse(choicesEl.textContent);
                if (Array.isArray(choices)) {
                    for (var c = 0; c < choices.length; c++) {
                        var choiceObj = choices[c];
                        if (choiceObj) {
                            var oVal = hingeFinishNormKey(choiceObj.value);
                            var oLbl = hingeFinishNormKey(choiceObj.label);
                            var oHandle = hingeFinishNormKey(choiceObj.handle);
                            if (oVal === normValue || oLbl === normValue || oHandle === normValue) {
                                var src = getSrc(choiceObj.image) || getSrc(choiceObj.image_url) || getSrc(choiceObj.imag_url);
                                if (src) return src;
                            }
                        }
                    }
                }
            }
        } catch (e) { }

        function getSrc(img) {
            if (!img) return '';
            if (typeof img === 'string') return img;
            if (img.url) return img.url;
            if (img.src) return img.src;
            if (img.value && img.value.url) return img.value.url;
            if (img.preview_image && typeof img.preview_image === 'string') return img.preview_image;
            if (img.preview_image && img.preview_image.url) return img.preview_image.url;
            return '';
        }

        for (var s = 0; s < schemasToSearch.length; s++) {
            var schema = schemasToSearch[s];
            if (!schema) continue;

            if (Array.isArray(schema)) {
                for (var i = 0; i < schema.length; i++) {
                    var opt = schema[i];
                    if (opt && Array.isArray(opt.options)) {
                        for (var j = 0; j < opt.options.length; j++) {
                            var o = opt.options[j];
                            if (o) {
                                var oValArr = hingeFinishNormKey(o.value);
                                var oLblArr = hingeFinishNormKey(o.label);
                                if (oValArr === normValue || oLblArr === normValue) {
                                    var srcArr = getSrc(o.image) || getSrc(o.image_url) || getSrc(o.imag_url);
                                    if (srcArr) return srcArr;
                                }
                            }
                        }
                    }
                }
            }

            if (schema && !Array.isArray(schema) && Array.isArray(schema.options)) {
                var firstOpt = schema.options[0];
                var isChoicesArray = firstOpt && !Array.isArray(firstOpt.options);
                if (isChoicesArray || !firstOpt) {
                    for (var k = 0; k < schema.options.length; k++) {
                        var o2 = schema.options[k];
                        if (o2) {
                            var oVal2 = hingeFinishNormKey(o2.value);
                            var oLbl2 = hingeFinishNormKey(o2.label);
                            if (oVal2 === normValue || oLbl2 === normValue) {
                                var src2 = getSrc(o2.image) || getSrc(o2.image_url) || getSrc(o2.imag_url);
                                if (src2) return src2;
                            }
                        }
                    }
                }
            }

            if (schema && !Array.isArray(schema) && Array.isArray(schema.options)) {
                for (var x = 0; x < schema.options.length; x++) {
                    var optx = schema.options[x];
                    if (optx && Array.isArray(optx.options)) {
                        for (var y = 0; y < optx.options.length; y++) {
                            var o3 = optx.options[y];
                            if (o3) {
                                var oVal3 = hingeFinishNormKey(o3.value);
                                var oLbl3 = hingeFinishNormKey(o3.label);
                                if (oVal3 === normValue || oLbl3 === normValue) {
                                    var src3 = getSrc(o3.image) || getSrc(o3.image_url) || getSrc(o3.imag_url);
                                    if (src3) return src3;
                                }
                            }
                        }
                    }
                }
            }
        }
        return fromStatic || '';
    }

    function updateHingeSwatchImages(openingEl) {
        if (!openingEl) return;
        var swatches = all('.door-porch-opening-door-hinge-swatch', openingEl);
        swatches.forEach(function (sw) {
            var card = sw.closest ? sw.closest('.door-porch-opening-door-choice') : null;
            var choiceVal = card ? card.getAttribute('data-choice-value') : '';
            if (!choiceVal) return;
            var imgUrl = getHingeSwatchImageFromSchema(choiceVal);
            if (!imgUrl) return;
            var altText = choiceVal;
            try {
                var labelEl = card ? card.querySelector('.common-check-option-label') : null;
                if (labelEl) altText = String(labelEl.textContent || '').trim() || choiceVal;
            } catch (eAltHinge) { }
            applyPorchSwingImageToEl(sw, imgUrl, altText);
        });
    }

    var PORCH_SWING_DIRECTION_IMAGE_URLS = {
        in_left: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/In_Left.png?v=1780553697',
        out_left: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Out_Left.png?v=1780553697',
        in_right: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/In_Right.png?v=1780553697',
        out_right: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Out_Right.png?v=1780553696',
        barn_door: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Barn_Door.png?v=1780553696',
        pocket_door: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Pocket_Door.png?v=1780553696',
        no_swing_barn_style_sliding_door: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Barn_Door.png?v=1780553696',
        no_swing_pocket_door: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Pocket_Door.png?v=1780553696'
    };

    function porchSwingImageLookupValues(value) {
        var raw = String(value || '').trim();
        if (!raw) return [];
        var key = raw.toLowerCase().replace(/-/g, '_');
        var out = [raw, key];
        if (key === 'barn_door') {
            out.push('no_swing_barn_style_sliding_door', 'barn-door');
        } else if (key === 'pocket_door') {
            out.push('no_swing_pocket_door', 'pocket-door');
        } else if (key === 'no_swing_barn_style_sliding_door') {
            out.push('barn_door', 'barn-door');
        } else if (key === 'no_swing_pocket_door') {
            out.push('pocket_door', 'pocket-door');
        }
        return out;
    }

    function normalizeSwingChoiceKey(value) {
        var s = String(value || '').toLowerCase().trim().replace(/[-_\s]+/g, '');
        if (!s) return '';
        if (s.length > 5 && s.slice(-5) === 'swing') s = s.slice(0, -5);
        if (s === 'noswingbarnstyleslidingdoor' || s === 'barndoorswing' || s === 'barnstyleslidingdoor') s = 'barndoor';
        if (s === 'noswingpocketdoor' || s === 'pocketdoorswing') s = 'pocketdoor';
        return s;
    }

    function swingChoiceKeysMatch(a, b) {
        var na = normalizeSwingChoiceKey(a);
        var nb = normalizeSwingChoiceKey(b);
        return !!(na && nb && na === nb);
    }

    function findSwingDirectionOptionFromSchemas(schemas) {
        if (!Array.isArray(schemas)) return null;
        for (var si = 0; si < schemas.length; si++) {
            var schema = schemas[si];
            if (!Array.isArray(schema)) continue;
            for (var i = 0; i < schema.length; i++) {
                var sopt = schema[i];
                if (!sopt || !sopt.id) continue;
                var st = String(sopt.type || '').toLowerCase();
                if (st && st !== 'radio' && st !== 'select') continue;
                var sid = normalizeOptionIdKey(sopt.id);
                if (sid === 'swing_direction' || sid === 'swingdirection') return sopt;
                var slab = String(sopt.label || '').toLowerCase();
                if (slab.indexOf('swing') !== -1 && slab.indexOf('direction') !== -1) return sopt;
            }
        }
        return null;
    }

    function findSwingImageInChoiceList(choices, value) {
        if (!Array.isArray(choices) || !choices.length) return '';
        var lookupVals = porchSwingImageLookupValues(value);
        for (var li = 0; li < lookupVals.length; li++) {
            var want = lookupVals[li];
            for (var i = 0; i < choices.length; i++) {
                var o = choices[i];
                if (!o) continue;
                if (
                    swingChoiceKeysMatch(o.value, want)
                    || swingChoiceKeysMatch(o.label, want)
                    || swingChoiceKeysMatch(o.handle, want)
                    || swingChoiceKeysMatch(o.id, want)
                ) {
                    var src = resolvePorchChoiceImageSrc(o);
                    if (src) return src;
                }
            }
        }
        return '';
    }

    function getSwingImageFromDomCards(value) {
        var lookupVals = porchSwingImageLookupValues(value);
        try {
            var cards = document.querySelectorAll(
                '.door-option-wrap[data-option-id="swing_direction"] .common-check-option, ' +
                '.door-sweep-extra-options[data-swing-from-schema="1"] .common-check-option'
            );
            for (var li = 0; li < lookupVals.length; li++) {
                var want = lookupVals[li];
                for (var ci = 0; ci < cards.length; ci++) {
                    var card = cards[ci];
                    if (!card) continue;
                    var cardVal = card.getAttribute('data-choice-value') || '';
                    if (!swingChoiceKeysMatch(cardVal, want)) continue;
                    var imgEl = card.querySelector('img.common-check-option-image');
                    if (imgEl && imgEl.getAttribute('src')) return String(imgEl.getAttribute('src'));
                }
            }
        } catch (eDom) { }
        return '';
    }

    function getSwingImageFromStaticMap(value) {
        var lookupVals = porchSwingImageLookupValues(value);
        for (var i = 0; i < lookupVals.length; i++) {
            var k = String(lookupVals[i] || '').toLowerCase().replace(/-/g, '_');
            if (PORCH_SWING_DIRECTION_IMAGE_URLS[k]) return PORCH_SWING_DIRECTION_IMAGE_URLS[k];
        }
        var norm = normalizeSwingChoiceKey(value);
        var byNorm = {
            inleft: PORCH_SWING_DIRECTION_IMAGE_URLS.in_left,
            outleft: PORCH_SWING_DIRECTION_IMAGE_URLS.out_left,
            inright: PORCH_SWING_DIRECTION_IMAGE_URLS.in_right,
            outright: PORCH_SWING_DIRECTION_IMAGE_URLS.out_right,
            barndoor: PORCH_SWING_DIRECTION_IMAGE_URLS.barn_door,
            pocketdoor: PORCH_SWING_DIRECTION_IMAGE_URLS.pocket_door
        };
        return byNorm[norm] || '';
    }

    function getSwingDirectionImageFromSchema(value) {
        var rawValue = String(value || '').trim();
        if (!rawValue) return '';

        var fromDom = getSwingImageFromDomCards(rawValue);
        if (fromDom) return fromDom;

        var schemasToSearch = [];
        try {
            var refSchema = doorConfigSchemaRef();
            if (refSchema) schemasToSearch.push(refSchema);
        } catch (e) { }
        try {
            if (window.__doorConfigSchema) schemasToSearch.push(window.__doorConfigSchema);
        } catch (e) { }
        try {
            if (window.doorConfigSchema) schemasToSearch.push(window.doorConfigSchema);
        } catch (e) { }

        try {
            var swingOpt = findSwingDirectionOptionFromSchemas(schemasToSearch);
            if (swingOpt && Array.isArray(swingOpt.options)) {
                var fromSwingOpt = findSwingImageInChoiceList(swingOpt.options, rawValue);
                if (fromSwingOpt) return fromSwingOpt;
            }
        } catch (eSwingOpt) { }

        try {
            var choicesEl = document.getElementById('door-config-choices-json');
            if (choicesEl && choicesEl.textContent) {
                var choices = JSON.parse(choicesEl.textContent);
                var fromCatalog = findSwingImageInChoiceList(choices, rawValue);
                if (fromCatalog) return fromCatalog;
            }
        } catch (e) { }

        try {
            for (var s = 0; s < schemasToSearch.length; s++) {
                var schema = schemasToSearch[s];
                if (!Array.isArray(schema)) continue;
                for (var i = 0; i < schema.length; i++) {
                    var opt = schema[i];
                    if (!opt || !Array.isArray(opt.options)) continue;
                    var fromOpt = findSwingImageInChoiceList(opt.options, rawValue);
                    if (fromOpt) return fromOpt;
                }
            }
        } catch (eScan) { }

        return getSwingImageFromStaticMap(rawValue);
    }

    function applyPorchSwingImageToEl(sw, imgUrl, altText) {
        if (!sw || !imgUrl) return;
        if (sw.tagName && sw.tagName.toLowerCase() === 'img') {
            if (sw.getAttribute('src') !== imgUrl) sw.src = imgUrl;
            if (altText && !sw.alt) sw.alt = altText;
            return;
        }
        var nestedImg = sw.querySelector('img');
        if (nestedImg) {
            if (nestedImg.getAttribute('src') !== imgUrl) nestedImg.src = imgUrl;
            if (altText && !nestedImg.alt) nestedImg.alt = altText;
            sw.classList.add('door-porch-opening-door-hinge-swatch--has-image');
            return;
        }
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = altText || '';
        img.className = 'door-porch-opening-door-choice-img';
        img.loading = 'lazy';
        sw.appendChild(img);
        sw.classList.add('door-porch-opening-door-hinge-swatch--has-image');
    }

    function updateSwingDirectionImages(openingEl) {
        var roots = [];
        if (openingEl) {
            roots.push(openingEl);
        } else {
            all('.door-porch-opening-entry, .door-porch-opening-door-config').forEach(function (el) {
                roots.push(el);
            });
        }
        roots.forEach(function (root) {
            if (!root) return;
            var swatches = all('.door-porch-opening-door-swing-image', root);
            swatches.forEach(function (sw) {
                var card = sw.closest ? sw.closest('.door-porch-opening-door-choice') : null;
                var choiceVal = card ? card.getAttribute('data-choice-value') : '';
                if (!choiceVal) return;
                var imgUrl = getSwingDirectionImageFromSchema(choiceVal);
                if (!imgUrl) return;
                var altText = '';
                try {
                    var labelEl = card.querySelector('.common-check-option-label');
                    altText = labelEl ? String(labelEl.textContent || '').trim() : choiceVal;
                } catch (eAlt) {
                    altText = choiceVal;
                }
                applyPorchSwingImageToEl(sw, imgUrl, altText);
            });
        });
    }
    // Dp end 13-08

    function porchOpeningDefaultHingeFinish(openingEl) {
        var firstBlock = porchOpeningDoorConfigBlock(openingEl, 1);
        if (!firstBlock) return '';
        var hingeGroup = firstBlock.querySelector('.door-porch-opening-door-hinge-section .door-porch-opening-door-choice-group');
        return porchOpeningDoorChoiceSelectedValue(hingeGroup) || '';
    }

    function syncPorchOpeningDoorConfigVisibility(openingEl) {
        if (!openingEl) return;
        var panels = all('.door-porch-opening-preview-panel', openingEl);
        panels.forEach(function (panel, idx) {
            var doorNumber = idx + 1;
            var input = panel.querySelector('.door-porch-opening-door-input');
            var label = panel.querySelector('.common-check-option-label');
            if (label) label.textContent = 'Door #' + doorNumber;
            if (input) input.value = 'Door #' + doorNumber;
            var configBlock = porchOpeningDoorConfigBlock(openingEl, doorNumber);
            if (!configBlock) return;
            var isDoor = !!(input && input.checked);
            configBlock.classList.toggle('door-hidden', !isDoor);
            if (!isDoor) {
                // Unchecked Door #N must not keep swing / hinge / lockset for submit.
                try {
                    configBlock.querySelectorAll('.door-porch-opening-door-choice-group').forEach(function (group) {
                        if (!group) return;
                        group.querySelectorAll('input[type="radio"]').forEach(function (inp) {
                            inp.checked = false;
                        });
                        group.querySelectorAll('.common-check-option--selected, .door-porch-opening-door-choice--selected').forEach(function (card) {
                            card.classList.remove('common-check-option--selected');
                            card.classList.remove('door-porch-opening-door-choice--selected');
                        });
                    });
                } catch (eClrPorchDoor) { }
            }
            if (isDoor && doorNumber > 1) {
                var hingeGroup = configBlock.querySelector('.door-porch-opening-door-hinge-section .door-porch-opening-door-choice-group');
                var hingeFromDoor1 = porchOpeningDefaultHingeFinish(openingEl);
                if (hingeGroup && hingeFromDoor1 && !porchOpeningDoorChoiceSelectedValue(hingeGroup)) {
                    porchOpeningDoorChoiceSetSelected(hingeGroup, hingeFromDoor1);
                }
            }
        });
        // Dp start 13-08
        try {
            updateHingeSwatchImages(openingEl);
        } catch (eHingeSw) { }
        try {
            updateSwingDirectionImages(openingEl);
        } catch (eSwingSw) { }
        // Dp end 13-08
    }

    function syncPorchOpeningDoorConfigs(openingEl) {
        if (!openingEl) return;
        var listEl = porchOpeningDoorConfigList(openingEl);
        if (!listEl) return;
        var panelCount = porchOpeningPanelsCount(openingEl);
        var openingNumber = porchOpeningNumberFromEl(openingEl);
        var existingBlocks = all('.door-porch-opening-door-config', listEl);
        for (var i = existingBlocks.length; i < panelCount; i++) {
            listEl.appendChild(createPorchOpeningDoorConfigBlock(i + 1, openingNumber));
        }
        for (var j = existingBlocks.length - 1; j >= panelCount; j--) {
            if (existingBlocks[j]) existingBlocks[j].remove();
        }
        syncPorchOpeningDoorRadioNames(openingEl);
        syncPorchOpeningDoorConfigVisibility(openingEl);
        // Dp start 13-08
        try { updateSwingDirectionImages(openingEl); } catch (eSwingCfg) { }
        // Dp end 13-08
    }

    function porchOpeningPreviewPanelImageUrl() {
        var root = document.getElementById('door-configurator');
        if (root) {
            var configured = String(root.getAttribute('data-porch-opening-preview-image') || '').trim();
            if (configured) return configured;
        }
        var rowTpl = document.getElementById('door-static-porch-opening-row');
        if (rowTpl && rowTpl.content) {
            var tplImg = rowTpl.content.querySelector('.door-porch-opening-preview-panel-image');
            if (tplImg && tplImg.getAttribute('src')) return tplImg.getAttribute('src');
        }
        return 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/image_109.webp?v=1778579784';
    }

    function appendPorchOpeningPreviewPanel(panelsWrap, options) {
        if (!panelsWrap) return null;
        options = options || {};
        var panel = document.createElement('div');
        panel.className = 'door-porch-opening-preview-panel';
        var img = document.createElement('img');
        img.className = 'door-porch-opening-preview-panel-image';
        img.src = porchOpeningPreviewPanelImageUrl();
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.loading = 'lazy';
        panel.appendChild(img);
        var label = document.createElement('label');
        label.className = 'common-check-option door-porch-opening-door-label';
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'door-porch-opening-door-input custom-checkbox';
        input.name = 'attributes[Convert to Door][]';
        input.value = 'Door #' + (options.index != null ? options.index + 1 : panelsWrap.querySelectorAll('.door-porch-opening-preview-panel').length + 1);
        if (options.checked) input.checked = true;
        var textWrap = document.createElement('div');
        textWrap.className = 'common-check-option-text';
        var text = document.createElement('span');
        text.className = 'common-check-option-label';
        text.textContent = 'Door #' + (options.index != null ? options.index + 1 : panelsWrap.querySelectorAll('.door-porch-opening-preview-panel').length + 1);
        textWrap.appendChild(text);
        label.appendChild(input);
        label.appendChild(textWrap);
        panel.appendChild(label);
        panelsWrap.appendChild(panel);
        return panel;
    }

    function updatePorchOpeningPanelLayout(openingEl) {
        if (!openingEl) return;
        var panelCount = porchOpeningPanelsCount(openingEl);
        var panelsWrap = openingEl.querySelector('.door-porch-opening-preview-panels');
        if (!panelsWrap) return;
        var existingPanels = all('.door-porch-opening-preview-panel', panelsWrap);
        if (existingPanels.length === panelCount && existingPanels.every(function (panel) {
            return panel.querySelector('.door-porch-opening-door-input');
        })) return;
        var doorStates = existingPanels.map(function (panel) {
            var input = panel.querySelector('.door-porch-opening-door-input');
            return !!(input && input.checked);
        });
        panelsWrap.innerHTML = '';
        for (var i = 0; i < panelCount; i++) {
            appendPorchOpeningPreviewPanel(panelsWrap, { checked: doorStates[i], index: i });
        }
        syncPorchOpeningDoorConfigs(openingEl);
    }

    function syncPorchOpeningTrimSystemVisibility(openingEl) {
        if (!openingEl) return;
        var trimInput = openingEl.querySelector('.door-porch-opening-trim-input');
        var trimOn = !!(trimInput && trimInput.checked);
        var trimDetails = openingEl.querySelector('.door-porch-opening-trim-system-details');
        if (trimDetails) trimDetails.classList.toggle('door-hidden', !trimOn);
        if (!trimOn) porchOpeningHideSillEditor(openingEl);
    }

    function porchOpeningDimensionLabel(selectEl) {
        if (!selectEl) return '';
        var opt = selectEl.options[selectEl.selectedIndex];
        return opt ? String(opt.textContent || '').trim() : '';
    }

    function porchOpeningWidthLabel(openingEl) {
        var intSel = porchOpeningDimensionSelect(openingEl, 'width-int');
        var fracSel = porchOpeningDimensionSelect(openingEl, 'width-frac');
        var intLabel = porchOpeningDimensionLabel(intSel);
        var fracLabel = porchOpeningDimensionLabel(fracSel);
        if (!intLabel) return '';
        if (!fracLabel || fracLabel === '0') return intLabel;
        return intLabel + ' ' + fracLabel;
    }

    function porchOpeningHeightLabel(openingEl) {
        var intSel = porchOpeningDimensionSelect(openingEl, 'height-int');
        var fracSel = porchOpeningDimensionSelect(openingEl, 'height-frac');
        var intLabel = porchOpeningDimensionLabel(intSel);
        var fracLabel = porchOpeningDimensionLabel(fracSel);
        if (!intLabel) return '';
        if (!fracLabel || fracLabel === '0') return intLabel;
        return intLabel + ' ' + fracLabel;
    }

    function porchOpeningSillDepthLabel(openingEl) {
        if (!openingEl) return '5';
        var depthSel = openingEl.querySelector('.door-porch-sill-depth-select');
        var fracSel = openingEl.querySelector('.door-porch-sill-frac-select');
        var depthLabel = porchOpeningDimensionLabel(depthSel) || '5';
        var fracLabel = porchOpeningDimensionLabel(fracSel);
        if (!fracLabel || fracLabel === '0' || fracLabel === '00') return depthLabel;
        return depthLabel + ' ' + fracLabel;
    }

    function updatePorchOpeningDerivedUi(openingEl) {
        if (!openingEl) return;
        var widthLabel = porchOpeningWidthLabel(openingEl);
        var heightLabel = porchOpeningHeightLabel(openingEl);
        var heightInches = porchOpeningDimensionInches(openingEl, 'height');
        var trimInput = openingEl.querySelector('.door-porch-opening-trim-input');
        var trimOn = !!(trimInput && trimInput.checked);
        syncPorchOpeningTrimSystemVisibility(openingEl);
        var depthSel = openingEl.querySelector('.door-porch-sill-depth-select');
        if (depthSel && !openingEl.getAttribute('data-porch-sill-depth-custom')) {
            depthSel.value = '5';
        }
        var sillSizeEl = openingEl.querySelector('.door-porch-opening-sill-size');
        if (sillSizeEl) sillSizeEl.textContent = porchOpeningSillDepthLabel(openingEl) + '" x ' + widthLabel + '"';
        var sillWidthLabel = openingEl.querySelector('.door-porch-opening-sill-width-label');
        if (sillWidthLabel) sillWidthLabel.textContent = widthLabel + '"';
        var stopsTop = openingEl.querySelector('.door-porch-opening-stops-top-bottom');
        var stopsSide = openingEl.querySelector('.door-porch-opening-stops-left-right');
        if (trimOn) {
            var topBottomLabel = formatPorchInchesFromNumber(Math.max(0, heightInches - PORCH_OPENING_TRIM_STOP_ALLOWANCE));
            if (stopsTop) stopsTop.textContent = '(4) ' + topBottomLabel + '" top and bottom';
            if (stopsSide) {
                stopsSide.textContent = '(4) ' + heightLabel + '" left and right';
                stopsSide.classList.remove('door-hidden');
            }
        } else {
            if (stopsTop) stopsTop.textContent = '(4) ' + widthLabel + '" top and bottom';
            if (stopsSide) {
                stopsSide.textContent = '(4) ' + widthLabel + '" left and right';
                stopsSide.classList.remove('door-hidden');
            }
        }
        var panelCount = porchOpeningPanelsCount(openingEl);
        var astragalsWrap = openingEl.querySelector('.door-porch-opening-astragals');
        var astragalsCopy = openingEl.querySelector('.door-porch-opening-astragals-copy');
        var astragalsApplicable = panelCount >= 1;
        if (astragalsWrap) astragalsWrap.classList.toggle('door-hidden', !trimOn || !astragalsApplicable);
        if (astragalsCopy) {
            if (astragalsApplicable && heightLabel) {
                astragalsCopy.textContent = '(' + panelCount + ') ' + heightLabel + '"';
            } else {
                astragalsCopy.textContent = '';
            }
        }
        updatePorchOpeningPanelLayout(openingEl);
        syncPorchOpeningDoorConfigs(openingEl);
        if (openingEl.getAttribute('data-porch-sill-editor-open') === '1') {
            var sillEditor = openingEl.querySelector('.door-porch-opening-sill-editor');
            if (sillEditor) sillEditor.classList.remove('door-hidden');
        }
    }

    function bindPorchOpeningRow(openingEl) {
        if (!openingEl || openingEl.getAttribute('data-porch-opening-bound')) return;
        openingEl.setAttribute('data-porch-opening-bound', '1');
        var depthSel = openingEl.querySelector('.door-porch-sill-depth-select');
        var fracSel = openingEl.querySelector('.door-porch-sill-frac-select');
        var saveBtn = openingEl.querySelector('.door-porch-opening-sill-save-btn');
        var cancelBtn = openingEl.querySelector('.door-porch-opening-sill-cancel-btn');
        if (saveBtn) {
            saveBtn.addEventListener('click', function (ev) {
                ev.preventDefault();
                openingEl.setAttribute('data-porch-sill-depth-custom', '1');
                // Dp start 17-08
                if (depthSel) syncMeasurementDivSelectUi(depthSel);
                if (fracSel) syncMeasurementDivSelectUi(fracSel);
                // Dp end 17-08
                porchOpeningHideSillEditor(openingEl);
                updatePorchOpeningDerivedUi(openingEl);
                updateEstimatedPrice();
            });
        }
        if (cancelBtn) {
            cancelBtn.addEventListener('click', function (ev) {
                ev.preventDefault();
                if (depthSel) depthSel.value = openingEl.getAttribute('data-porch-sill-depth-saved') || depthSel.value;
                if (fracSel) fracSel.value = openingEl.getAttribute('data-porch-sill-frac-saved') || fracSel.value;
                porchOpeningHideSillEditor(openingEl);
                updatePorchOpeningDerivedUi(openingEl);
            });
        }
        bindPorchOpeningInfoControls(openingEl);
        if (!openingEl.getAttribute('data-porch-opening-delegate-bound')) {
            openingEl.setAttribute('data-porch-opening-delegate-bound', '1');
            openingEl.addEventListener('change', function (ev) {
                var target = ev.target;
                if (!target || !openingEl.contains(target)) return;
                if (target.classList && target.classList.contains('door-porch-opening-trim-input')) {
                    openingEl.removeAttribute('data-porch-sill-depth-custom');
                }
                // Dp start 17-08
                if (target.classList && (target.classList.contains('door-porch-sill-depth-select') || target.classList.contains('door-porch-sill-frac-select'))) {
                    openingEl.setAttribute('data-porch-sill-depth-custom', '1');
                    syncMeasurementDivSelectUi(target);
                }
                // Dp end 17-08
                if (target.classList && target.classList.contains('door-porch-opening-door-input')) {
                    syncPorchOpeningDoorConfigVisibility(openingEl);
                }
                if (target.getAttribute && target.getAttribute('data-porch-dimension') === 'panels') {
                    try { applyPorchOpeningWidthIntRange(openingEl); } catch (ePorchWCh) { }
                }
                updatePorchOpeningDerivedUi(openingEl);
                updateEstimatedPrice();
            });
            openingEl.addEventListener('input', function (ev) {
                var target = ev.target;
                if (!target || !openingEl.contains(target)) return;
                if (target.getAttribute && target.getAttribute('data-porch-dimension') === 'panels') {
                    try { applyPorchOpeningWidthIntRange(openingEl); } catch (ePorchWIn) { }
                }
                updatePorchOpeningDerivedUi(openingEl);
                updateEstimatedPrice();
            });
        }
        updatePorchOpeningDerivedUi(openingEl);
        bindPanelUnitQtyControls(openingEl);
        enhancePanelUnitMeasurementSelects(openingEl);
    }

    function createPorchOpeningRemoveButton() {
        var removeBtn = createPanelUnitSetRemoveButton();
        removeBtn.setAttribute('aria-label', 'Remove opening');
        return removeBtn;
    }

    function syncPorchOpeningDom(listEl) {
        if (!listEl) return;
        var entries = all('.door-porch-opening-entry', listEl);
        entries.forEach(function (entry, idx) {
            var title = entry.querySelector('.door-porch-opening-entry-title');
            if (title) title.textContent = (idx === 0 ? 'Porch Opening #' : 'Panel Opening #') + (idx + 1);
            var trimInput = entry.querySelector('.door-porch-opening-trim-input');
            var trimHelp = entry.querySelector('.door-porch-opening-trim-help');
            var trimLabel = entry.querySelector('.door-porch-opening-trim-copy .door-row-label');
            if (trimInput) {
                var trimId = 'door-porch-opening-trim-input-' + (idx + 1);
                trimInput.id = trimId;
                trimInput.setAttribute('name', 'attributes[Add Trim System][]');
                trimInput.setAttribute('aria-describedby', trimId + '-help');
                if (trimLabel) trimLabel.setAttribute('for', trimId);
                if (trimHelp) trimHelp.id = trimId + '-help';
            }
            try { syncPorchOpeningDoorRadioNames(entry); } catch (eRadioNames) {}
            var header = entry.querySelector('.door-porch-opening-entry-header');
            var removeBtn = entry.querySelector('.door-panel-unit-size-remove-btn');
            var showRemove = entries.length > 1;
            if (!showRemove) {
                if (removeBtn) removeBtn.remove();
                return;
            }
            if (!removeBtn && header) header.appendChild(createPorchOpeningRemoveButton());
        });
        bindPorchOpeningRemoveControls(listEl);
    }

    function bindPorchOpeningRemoveControls(listEl) {
        if (!listEl) return;
        all('.door-panel-unit-size-remove-btn', listEl).forEach(function (btn) {
            if (btn.getAttribute('data-porch-opening-remove-bound')) return;
            btn.setAttribute('data-porch-opening-remove-bound', '1');
            btn.addEventListener('click', function (ev) {
                ev.preventDefault();
                var entry = btn.closest('.door-porch-opening-entry');
                if (!entry || !listEl) return;
                if (all('.door-porch-opening-entry', listEl).length <= 1) return;
                entry.remove();
                syncPorchOpeningDom(listEl);
                updateEstimatedPrice();
            });
        });
    }

    function appendPorchOpeningRow(listEl) {
        if (!listEl) return null;
        var rowTpl = document.getElementById('door-static-porch-opening-row');
        if (!rowTpl || !rowTpl.content) return null;
        var rowClone = rowTpl.content.cloneNode(true);
        var row = rowClone.firstElementChild;
        if (!row) return null;
        listEl.appendChild(row);
        var existingEntries = all('.door-porch-opening-entry', listEl);
        if (existingEntries.length > 1) {
            var hasTrim = existingEntries.some(function (entry) {
                if (entry === row) return false;
                var trimInput = entry.querySelector('.door-porch-opening-trim-input');
                return !!(trimInput && trimInput.checked);
            });
            var rowTrim = row.querySelector('.door-porch-opening-trim-input');
            if (rowTrim) rowTrim.checked = hasTrim;
        }
        syncPorchOpeningDom(listEl);
        bindPorchOpeningRow(row);
        enhancePanelUnitMeasurementSelects(row);
        return row;
    }

    function bindPanelUnitEnclosureMeasurements(sectionEl, measurementsWrap) {
        if (!sectionEl || !measurementsWrap || measurementsWrap.getAttribute('data-panel-unit-enclosure-bound')) return;
        measurementsWrap.setAttribute('data-panel-unit-enclosure-bound', '1');
        var listEl = measurementsWrap.querySelector('.door-porch-opening-list');
        if (listEl && !listEl.querySelector('.door-porch-opening-entry')) {
            appendPorchOpeningRow(listEl);
        } else if (listEl) {
            syncPorchOpeningDom(listEl);
            all('.door-porch-opening-entry', listEl).forEach(bindPorchOpeningRow);
        }
        if (!measurementsWrap.getAttribute('data-porch-sill-bound')) {
            measurementsWrap.setAttribute('data-porch-sill-bound', '1');
            measurementsWrap.addEventListener('click', function (ev) {
                var changeBtn = ev.target && ev.target.closest ? ev.target.closest('.door-porch-opening-sill-change-btn') : null;
                if (!changeBtn || !measurementsWrap.contains(changeBtn)) return;
                ev.preventDefault();
                var entry = changeBtn.closest('.door-porch-opening-entry');
                if (entry) porchOpeningShowSillEditor(entry);
            });
        }
        bindPorchOpeningInfoControls(measurementsWrap);
        var addBtn = measurementsWrap.querySelector('.door-panel-unit-add-opening-btn');
        if (addBtn) {
            addBtn.addEventListener('click', function (ev) {
                ev.preventDefault();
                appendPorchOpeningRow(listEl);
                updateEstimatedPrice();
            });
        }
        enhancePanelUnitMeasurementSelects(measurementsWrap);
    }

    function mountPanelUnitEnclosureMeasurements(sectionEl) {
        if (!sectionEl || sectionEl.querySelector('[data-panel-unit-enclosure-measurements]')) return;
        var tpl = document.getElementById('door-static-panel-unit-enclosure-measurements');
        if (!tpl || !tpl.content) return;
        var clone = tpl.content.cloneNode(true);
        var wrap = clone.firstElementChild;
        if (!wrap) return;
        sectionEl.appendChild(wrap);
        bindPanelUnitEnclosureMeasurements(sectionEl, wrap);
    }

    function syncPanelUnitEnclosureMeasurementsVisibility(sectionEl, optionId) {
        if (!sectionEl) return;
        var show = panelUnitEnclosureOrderSelected(sectionEl, optionId);
        if (show) mountPanelUnitEnclosureMeasurements(sectionEl);
        var wrap = sectionEl.querySelector('[data-panel-unit-enclosure-measurements]');
        if (!wrap) return;
        wrap.classList.toggle('door-hidden', !show);
    }

    function syncPanelUnitDesignMeasurements(sectionEl, optionId) {
        syncPanelUnitEnclosureMeasurementsVisibility(sectionEl, optionId);
        syncPanelUnitIndividualMeasurementsVisibility(sectionEl, optionId);
    }

    function bindPanelUnitQtyControls(scopeEl) {
        if (!scopeEl) return;
        all('.qty-btn.plus', scopeEl).forEach(function (button) {
            if (button.getAttribute('data-panel-unit-qty-bound')) return;
            button.setAttribute('data-panel-unit-qty-bound', '1');
            button.addEventListener('click', function () {
                var input = this.parentElement && this.parentElement.querySelector('.door-panel-unit-qty-input');
                if (!input) return;
                var currentVal = parseInt(input.value, 10) || 1;
                input.value = String(currentVal + 1);
                input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        });
        all('.qty-btn.minus', scopeEl).forEach(function (button) {
            if (button.getAttribute('data-panel-unit-qty-bound')) return;
            button.setAttribute('data-panel-unit-qty-bound', '1');
            button.addEventListener('click', function () {
                var input = this.parentElement && this.parentElement.querySelector('.door-panel-unit-qty-input');
                if (!input) return;
                var currentVal = parseInt(input.value, 10) || 1;
                var min = parseInt(input.getAttribute('min'), 10) || 1;
                if (currentVal > min) {
                    input.value = String(currentVal - 1);
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    }

    function createPanelUnitSetRemoveButton() {
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'door-panel-unit-size-remove-btn common-btn btn-woodDust btn-small';
        removeBtn.setAttribute('aria-label', 'Remove panel set');
        removeBtn.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
            '<path d="M10.6667 3.99967V3.46634C10.6667 2.7196 10.6667 2.34624 10.5213 2.06102C10.3935 1.81014 10.1895 1.60616 9.93865 1.47833C9.65344 1.33301 9.28007 1.33301 8.53333 1.33301H7.46667C6.71993 1.33301 6.34656 1.33301 6.06135 1.47833C5.81046 1.60616 5.60649 1.81014 5.47866 2.06102C5.33333 2.34624 5.33333 2.7196 5.33333 3.46634V3.99967M6.66667 7.66634V10.9997M9.33333 7.66634V10.9997M2 3.99967H14M12.6667 3.99967V11.4663C12.6667 12.5864 12.6667 13.1465 12.4487 13.5743C12.2569 13.9506 11.951 14.2566 11.5746 14.4484C11.1468 14.6663 10.5868 14.6663 9.46667 14.6663H6.53333C5.41323 14.6663 4.85318 14.6663 4.42535 14.4484C4.04903 14.2566 3.74307 13.9506 3.55132 13.5743C3.33333 13.1465 3.33333 12.5864 3.33333 11.4663V3.99967" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '</svg>';
        return removeBtn;
    }

    function syncPanelUnitSetDom(listEl) {
        if (!listEl) return;
        var entries = all('.door-panel-unit-size-entry', listEl);
        entries.forEach(function (entry, idx) {
            var title = entry.querySelector('.door-panel-unit-size-entry-title');
            if (title) title.textContent = 'Panel Set #' + (idx + 1);
            var header = entry.querySelector('.door-panel-unit-size-entry-header');
            var removeBtn = entry.querySelector('.door-panel-unit-size-remove-btn');
            var showRemove = entries.length > 1;
            if (!showRemove) {
                if (removeBtn) removeBtn.remove();
                return;
            }
            if (!removeBtn && header) header.appendChild(createPanelUnitSetRemoveButton());
        });
        bindPanelUnitSetRemoveControls(listEl);
    }

    function bindPanelUnitSetRemoveControls(listEl) {
        if (!listEl) return;
        all('.door-panel-unit-size-remove-btn', listEl).forEach(function (btn) {
            if (btn.getAttribute('data-panel-unit-remove-bound')) return;
            btn.setAttribute('data-panel-unit-remove-bound', '1');
            btn.addEventListener('click', function (ev) {
                ev.preventDefault();
                var entry = btn.closest('.door-panel-unit-size-entry');
                if (!entry || !listEl) return;
                if (all('.door-panel-unit-size-entry', listEl).length <= 1) return;
                entry.remove();
                syncPanelUnitSetDom(listEl);
                assignUniqueOptionIds(listEl, 'door-panel-unit-size-row-select');
                updateEstimatedPrice();
            });
        });
    }

    function appendPanelUnitSizeRow(listEl) {
        if (!listEl) return null;
        var rowTpl = document.getElementById('door-static-panel-unit-size-row');
        if (!rowTpl || !rowTpl.content) return null;
        var rowClone = rowTpl.content.cloneNode(true);
        var row = rowClone.firstElementChild;
        if (!row) return null;
        listEl.appendChild(row);
        syncPanelUnitSetDom(listEl);
        assignUniqueOptionIds(listEl, 'door-panel-unit-size-row-select');
        bindPanelUnitQtyControls(row);
        enhancePanelUnitMeasurementSelects(row);
        return row;
    }

    function bindPanelUnitIndividualMeasurements(sectionEl, measurementsWrap) {
        if (!sectionEl || !measurementsWrap || measurementsWrap.getAttribute('data-panel-unit-bound')) return;
        measurementsWrap.setAttribute('data-panel-unit-bound', '1');
        var listEl = measurementsWrap.querySelector('.door-panel-unit-size-list');
        if (listEl && !listEl.querySelector('.door-panel-unit-size-entry')) {
            appendPanelUnitSizeRow(listEl);
        } else if (listEl) {
            syncPanelUnitSetDom(listEl);
        }
        bindPanelUnitQtyControls(measurementsWrap);
        var addBtn = measurementsWrap.querySelector('.door-panel-unit-add-size-btn');
        if (addBtn) {
            addBtn.addEventListener('click', function (ev) {
                ev.preventDefault();
                appendPanelUnitSizeRow(listEl);
                updateEstimatedPrice();
            });
        }
        all('select, input', measurementsWrap).forEach(function (el) {
            el.addEventListener('change', updateEstimatedPrice);
            el.addEventListener('input', updateEstimatedPrice);
        });
        enhancePanelUnitMeasurementSelects(measurementsWrap);
    }

    function mountPanelUnitIndividualMeasurements(sectionEl) {
        if (!sectionEl || sectionEl.querySelector('[data-panel-unit-individual-measurements]')) return;
        var tpl = document.getElementById('door-static-panel-unit-individual-measurements');
        if (!tpl || !tpl.content) return;
        var clone = tpl.content.cloneNode(true);
        var wrap = clone.firstElementChild;
        if (!wrap) return;
        sectionEl.appendChild(wrap);
        bindPanelUnitIndividualMeasurements(sectionEl, wrap);
    }

    function syncPanelUnitIndividualMeasurementsVisibility(sectionEl, optionId) {
        if (!sectionEl) return;
        var show = panelUnitIndividualOrderSelected(sectionEl, optionId);
        if (show) mountPanelUnitIndividualMeasurements(sectionEl);
        var wrap = sectionEl.querySelector('[data-panel-unit-individual-measurements]');
        if (!wrap) return;
        wrap.classList.toggle('door-hidden', !show);
    }

    function bindPanelUnitDesignVisibilityControls(sectionEl, optionId) {
        if (!sectionEl || sectionEl.getAttribute('data-panel-unit-visibility-bound')) return;
        sectionEl.setAttribute('data-panel-unit-visibility-bound', '1');
        function syncPanelUnitOrderUi() {
            syncPanelUnitDesignMeasurements(sectionEl, optionId);
            updateEstimatedPrice();
        }
        function syncPanelUnitCardSelection(activeRadio) {
            if (!activeRadio || !activeRadio.closest) return;
            var cardOwnerWrap = activeRadio.closest('.common-check-options');
            if (cardOwnerWrap) {
                cardOwnerWrap.querySelectorAll('.common-check-option').forEach(function (c) { c.classList.remove('common-check-option--selected'); });
            }
            var selCard = activeRadio.closest('.common-check-option');
            if (selCard) selCard.classList.add('common-check-option--selected');
        }
        all('input[type="radio"][data-option-id="' + optionId + '"], select[data-option-id="' + optionId + '"]', sectionEl).forEach(function (el) {
            el.addEventListener('change', function () {
                if (el.type === 'radio') syncPanelUnitCardSelection(el);
                syncPanelUnitOrderUi();
            });
        });
        sectionEl.addEventListener('click', function (ev) {
            var card = ev.target && ev.target.closest ? ev.target.closest('.common-check-option') : null;
            if (!card || !sectionEl.contains(card)) return;
            if (ev.target && ev.target.closest && ev.target.closest('.door-panel-unit-design-btn, .wood-species-open-btn, button')) return;
            var radio = card.querySelector('input[type="radio"][data-option-id="' + optionId + '"]');
            if (!radio) return;
            all('input[type="radio"][data-option-id="' + optionId + '"]', sectionEl).forEach(function (r) {
                r.checked = r === radio;
            });
            syncPanelUnitCardSelection(radio);
            try { radio.dispatchEvent(new Event('change', { bubbles: true })); } catch (eRadioEvt) { }
            syncPanelUnitOrderUi();
        });
    }

    function initializePanelUnitDesignSection(sectionEl, optionId) {
        if (!sectionEl || !optionId) return;
        bindPanelUnitDesignVisibilityControls(sectionEl, optionId);
        syncPanelUnitDesignMeasurements(sectionEl, optionId);
    }

    function appendStaticPanelUnitDesignSection(container) {
        if (!container || panelUnitDesignSectionExists(document.getElementById('door-configurator') || container)) return null;
        if (!productIsPorchPanelProduct()) return null;
        var optionId = 'panel_unit_design';
        var section = document.createElement('div');
        section.className = 'door-section door-option-wrap door-panel-unit-design-static';
        section.setAttribute('data-option-id', optionId);
        section.setAttribute('data-static-panel-unit-design', '');

        var headerRow = document.createElement('div');
        headerRow.className = 'door-option-header-row';
        var leftWrap = document.createElement('div');
        leftWrap.className = 'door-option-title-wrap';
        var title = document.createElement('h3');
        title.className = 'door-section-title door-option-title';
        var titleText = document.createElement('span');
        titleText.textContent = 'Panel Unit Design';
        title.appendChild(titleText);
        leftWrap.appendChild(title);
        headerRow.appendChild(leftWrap);
        section.appendChild(headerRow);

        var prompt = document.createElement('p');
        prompt.className = 'door-panel-unit-order-prompt p-medium fw-600 primaryFont mb-16';
        prompt.textContent = 'How would you like to order your Porch Panels?';
        section.appendChild(prompt);

        var radioWrap = document.createElement('div');
        radioWrap.className = 'common-check-options';
        [
            { value: 'design_porch_enclosure_system', label: 'Design a Porch Enclosure System', selected: false },
            { value: 'order_individual_panels', label: 'Order Individual Panels', selected: false }
        ].forEach(function (choice) {
            var card = document.createElement('label');
            card.className = 'common-check-option' + (choice.selected ? ' common-check-option--selected' : '');
            var radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'attributes[Panel Unit Design]';
            radio.value = choice.value;
            radio.setAttribute('data-option-id', optionId);
            radio.style.position = 'absolute';
            radio.style.opacity = '0';
            radio.style.pointerEvents = 'none';
            if (choice.selected) radio.checked = true;
            card.appendChild(radio);
            var textWrap = document.createElement('div');
            textWrap.className = 'common-check-option-text';
            var text = document.createElement('span');
            text.className = 'common-check-option-label';
            text.textContent = choice.label;
            textWrap.appendChild(text);
            card.appendChild(textWrap);
            radioWrap.appendChild(card);
        });
        section.appendChild(radioWrap);

        if (container.firstChild) container.insertBefore(section, container.firstChild);
        else container.appendChild(section);
        initializePanelUnitDesignSection(section, optionId);
        return section;
    }

    function initializePanelUnitDesignSections(container, schema) {
        var root = document.getElementById('door-configurator') || container || document;
        all('[data-static-panel-unit-design]', root).forEach(function (sectionEl) {
            initializePanelUnitDesignSection(sectionEl, sectionEl.getAttribute('data-option-id') || 'panel_unit_design');
        });
        if (!container) return;
        (schema || []).forEach(function (opt) {
            if (!optionIsPanelUnitDesign(opt)) return;
            var sectionEl = container.querySelector('.door-option-wrap[data-option-id="' + opt.id + '"]');
            if (!sectionEl) return;
            initializePanelUnitDesignSection(sectionEl, opt.id);
        });
        // Dp start 13-08 — fill porch swing thumbs after panel-unit UI mounts
        try {
            updateSwingDirectionImages(null);
            setTimeout(function () {
                try { updateSwingDirectionImages(null); } catch (eSwingDelay) { }
            }, 0);
        } catch (eSwingInit) { }
        // Dp end 13-08
    }

    function getSelectedValueForOption(opt, optionsContainer) {
        if (!opt || !optionsContainer) return null;
        var t = (opt.type || '').toLowerCase();
        var inputs = all('select[data-option-id="' + opt.id + '"], input[data-option-id="' + opt.id + '"]', optionsContainer);
        if (t === 'radio') {
            var checked = inputs.filter(function (el) { return el.type === 'radio' && el.checked; })[0];
            return checked ? (checked.value || null) : null;
        }
        if (t === 'select' && inputs[0] && inputs[0].tagName && inputs[0].tagName.toLowerCase() === 'select') {
            var v = inputs[0].value;
            return v === '' ? null : v;
        }
        return null;
    }

    function normPreHungSelectionValue(v) {
        return String(v == null ? '' : v).trim().toLowerCase().replace(/\s+/g, '_');
    }

    function choiceMatchingValue(opt, val) {
        var choices = opt.options || [];
        var s = String(val);
        for (var i = 0; i < choices.length; i++) {
            var c = choices[i];
            if (c && String(c.value != null ? c.value : '') === s) return c;
        }
        return null;
    }

    function isSlabOnlyMeasurementTrigger(val) {
        return normPreHungSelectionValue(val) === 'slab_only';
    }

    /** Matches metaobject value slab_only and labels/values like "Pre-Hung on Brick Molding". */
    function isPreHungBrickMoldingTrigger(preOpt, val) {
        if (val == null || val === '') return false;
        var n = normPreHungSelectionValue(val);
        if (n === 'pre_hung_brick_molding' || n === 'pre_hung_on_brick_molding' || n === 'pre_hung_on_brick' || n === 'brick_molding') return true;
        if (n.indexOf('brick') !== -1 && n.indexOf('mold') !== -1) return true;
        var ch = choiceMatchingValue(preOpt, val);
        if (!ch) return false;
        var lbl = String(ch.label || '').toLowerCase();
        if (lbl.indexOf('brick') !== -1 && (lbl.indexOf('mold') !== -1 || lbl.indexOf('mould') !== -1)) return true;
        return false;
    }

    function shouldShowMeasurementTypeForPreHungSelection(schema, optionsContainer) {
        // Always show the Measurements block so Exact + Finished (first two tabs) are visible
        // before the customer chooses Pre-hung style. Panel details stay hidden until they pick a method.
        return true;
    }

    function findSchemaOptionByIdNorm(schema, idNorm) {
        if (!Array.isArray(schema)) return null;
        for (var si = 0; si < schema.length; si++) {
            var o = schema[si];
            if (o && normalizeOptionIdKey(o.id) === idNorm) return o;
        }
        return null;
    }

    function isSidelightChoiceExcluded(val, opt) {
        if (val == null || val === '') return true;
        var n = normPreHungSelectionValue(val);
        if (n === 'none' || n === 'no' || n.indexOf('no_sidelight') !== -1) return true;
        if (n.indexOf('without') !== -1 && n.indexOf('sidelight') !== -1) return true;
        var ch = choiceMatchingValue(opt, val);
        if (ch) {
            var lbl = String(ch.label || '').toLowerCase();
            if (lbl === 'none' || lbl.trim() === '—' || lbl.trim() === '-') return true;
            if (lbl.indexOf('no sidelight') !== -1) return true;
            if (lbl.indexOf('without') !== -1 && lbl.indexOf('sidelight') !== -1) return true;
        }
        return false;
    }

    function hasActiveSidelightSelection(schema, optionsContainer) {
        if (!schema || !optionsContainer) return false;
        var keys = ['sidelight_location', 'sidelight_style'];
        for (var ki = 0; ki < keys.length; ki++) {
            var opt = findSchemaOptionByIdNorm(schema, keys[ki]);
            if (!opt) continue;
            var val = getSelectedValueForOption(opt, optionsContainer);
            if (!isSidelightChoiceExcluded(val, opt)) return true;
        }
        return false;
    }

    /** True only when product tags include exact tag "entrance-units". */
    function hasEntranceUnitsTag() {
        try {
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!main) return false;
            var raw = main.getAttribute('data-product-tags') || '[]';
            var tags;
            try {
                tags = JSON.parse(raw);
            } catch (eParse) {
                tags = String(raw).split(',');
            }
            if (!Array.isArray(tags)) return false;
            for (var i = 0; i < tags.length; i++) {
                var t = String(tags[i] || '').toLowerCase().replace(/_/g, '-').replace(/\s+/g, '-').trim();
                if (t === 'entrance-units') return true;
            }
        } catch (eTag) { }
        return false;
    }

    /**
     * Product has config_option key entrance_unit_sidelight assigned (door_config_options).
     * Flag-only: enables Pre-Hung 2-tab measurement + Exact Sidelight Width addon,
     * without showing sidelight location/style UI.
     */
    function hasEntranceUnitSidelightConfigOption() {
        try {
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!main) return false;
            if (String(main.getAttribute('data-entrance-unit-sidelight') || '').toLowerCase() === 'true') {
                return true;
            }
            var raw = main.getAttribute('data-door-config-option-keys') || '[]';
            var keys = JSON.parse(raw);
            if (!Array.isArray(keys)) return false;
            for (var i = 0; i < keys.length; i++) {
                var k = String(keys[i] || '').toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_').trim();
                if (k === 'entrance_unit_sidelight') return true;
            }
        } catch (eEuSl) { }
        return false;
    }

    /**
     * Product has config_option key entrance_unit_transoms (or entrance_unit_transom).
     * Flag-only: enables Pre-Hung 2-tab measurement + Exact Transom Height addon,
     * without showing transom style/count UI.
     */
    function hasEntranceUnitTransomConfigOption() {
        try {
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!main) return false;
            if (String(main.getAttribute('data-entrance-unit-transom') || '').toLowerCase() === 'true') {
                return true;
            }
            var raw = main.getAttribute('data-door-config-option-keys') || '[]';
            var keys = JSON.parse(raw);
            if (!Array.isArray(keys)) return false;
            for (var i = 0; i < keys.length; i++) {
                var k = String(keys[i] || '').toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_').trim();
                if (k === 'entrance_unit_transoms' || k === 'entrance_unit_transom') return true;
            }
        } catch (eEuTr) { }
        return false;
    }

    /**
     * Entrance-unit sidelight/transom measure UI (2-tab + Exact Width/Height addons)
     * only when ALL are true:
     * 1) Pre-Hung on Jamb selected
     * 2) Product tag is entrance-units
     * 3) door_config_options includes entrance_unit_sidelight and/or entrance_unit_transoms
     */
    function isEntranceUnitMeasureConfigActive() {
        if (!hasEntranceUnitsTag()) return false;
        return hasEntranceUnitSidelightConfigOption() || hasEntranceUnitTransomConfigOption();
    }

    /** Treat entrance-unit sidelight flag like an active sidelight for measurement panels only. */
    function wantsSidelightMeasureFields(schema, optionsContainer) {
        if (hasEntranceUnitsTag() && hasEntranceUnitSidelightConfigOption()) return true;
        return hasActiveSidelightSelection(schema, optionsContainer);
    }

    /** Treat entrance-unit transom flag like an active transom for measurement panels only. */
    function wantsTransomMeasureFields(schema, optionsContainer) {
        if (hasEntranceUnitsTag() && hasEntranceUnitTransomConfigOption()) return true;
        return hasActiveTransomSelection(schema, optionsContainer);
    }

    /**
     * Product has config_option key no_slab assigned (door_config_options).
     * Flag-only: force-hide Slab Only from Door Setup and prefer a prehung choice.
     */
    function hasNoSlabConfigOption() {
        try {
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!main) return false;
            if (String(main.getAttribute('data-no-slab') || '').toLowerCase() === 'true') {
                return true;
            }
            var raw = main.getAttribute('data-door-config-option-keys') || '[]';
            var keys = JSON.parse(raw);
            if (!Array.isArray(keys)) return false;
            for (var i = 0; i < keys.length; i++) {
                var k = String(keys[i] || '').toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_').trim();
                if (k === 'no_slab') return true;
            }
        } catch (eNoSlab) { }
        return false;
    }

    /**
     * When no_slab is assigned: hide any Slab Only Door Setup card and ensure a
     * non-slab prehung choice is selected (prefer pre_hung_on_jamb).
     */
    function syncNoSlabDoorSetupVisibility(schema, optionsContainer) {
        if (!hasNoSlabConfigOption()) return;
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;

        var needReselect = false;
        Array.prototype.forEach.call(
            optionsContainer.querySelectorAll(
                'input[type="radio"][value="slab_only"], input[type="checkbox"][value="slab_only"]'
            ),
            function (inp) {
                if (!inp) return;
                var card = inp.closest
                    ? (inp.closest('.common-check-option') || inp.closest('label.door-setup-option'))
                    : null;
                if (card) {
                    card.style.display = 'none';
                    card.classList.add('door-hidden');
                    card.setAttribute('data-no-slab-hidden', '1');
                }
                if (inp.checked) {
                    inp.checked = false;
                    if (card) card.classList.remove('common-check-option--selected');
                    needReselect = true;
                }
            }
        );
        Array.prototype.forEach.call(
            optionsContainer.querySelectorAll('.common-check-option[data-choice-value="slab_only"]'),
            function (card) {
                if (!card) return;
                card.style.display = 'none';
                card.classList.add('door-hidden');
                card.setAttribute('data-no-slab-hidden', '1');
            }
        );

        var preOpt = findPreHungStyleOption(schema);
        var optId = preOpt && preOpt.id != null ? String(preOpt.id) : 'pre_hung';
        var anyChecked = optionsContainer.querySelector(
            'input[type="radio"][data-option-id="' + optId.replace(/"/g, '') + '"]:checked,'
            + 'input[type="radio"][data-option-id="pre_hung"]:checked'
        );
        if (anyChecked && isSlabOnlyMeasurementTrigger(anyChecked.value)) {
            anyChecked.checked = false;
            needReselect = true;
        }
        if (anyChecked && !needReselect) return;

        var pick = null;
        var radios = optionsContainer.querySelectorAll(
            'input[type="radio"][data-option-id="' + optId.replace(/"/g, '') + '"],'
            + 'input[type="radio"][data-option-id="pre_hung"]'
        );
        Array.prototype.forEach.call(radios, function (r) {
            if (!r || r.disabled) return;
            var n = String(r.value || '').toLowerCase().replace(/-/g, '_');
            if (n === 'slab_only') return;
            var card = r.closest
                ? (r.closest('.common-check-option') || r.closest('label.door-setup-option'))
                : null;
            if (card && (
                card.getAttribute('data-no-slab-hidden') === '1'
                || card.classList.contains('door-hidden')
                || card.style.display === 'none'
            )) return;
            if (n === 'pre_hung_on_jamb') pick = r;
            else if (!pick) pick = r;
        });
        if (!pick) return;
        pick.checked = true;
        var pickCard = pick.closest
            ? (pick.closest('.common-check-option') || pick.closest('label.door-setup-option'))
            : null;
        if (pickCard) pickCard.classList.add('common-check-option--selected');
        if (!isDoorRestorePendingSafe()) {
            try {
                pick.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (eNoSlabCh) { }
        }
    }

    /** Pre-Hung on jamb with sidelight/transom selection, or entrance-unit + config flags. */
    function isJambTwoTabMeasureMode(schema, optionsContainer) {
        if (!schema || !optionsContainer) return false;
        if (!isPreHungOnDoorJambSelected(schema, optionsContainer)) return false;
        if (isEntranceUnitMeasureConfigActive()) return true;
        return hasActiveSidelightSelection(schema, optionsContainer) || hasActiveTransomSelection(schema, optionsContainer);
    }

    function syncJambSidelightTabLabels(optionsContainer, schema) {
        if (!optionsContainer || !schema) return;
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        if (!wrap) return;
        var jambTwoTab = isJambTwoTabMeasureMode(schema, optionsContainer);
        wrap.querySelectorAll('.door-measure-tabs .door-measure-tab').forEach(function (tab) {
            var labelSpan = tab.querySelector('.common-check-option-label');
            if (!labelSpan) return;
            if (!labelSpan.getAttribute('data-door-tab-label-orig')) {
                labelSpan.setAttribute('data-door-tab-label-orig', labelSpan.textContent || '');
            }
            var orig = labelSpan.getAttribute('data-door-tab-label-orig') || '';
            if (jambTwoTab) {
                var vis = tab.getAttribute('data-measure-vis');
                if (vis === 'always') labelSpan.textContent = 'I know the exact size of each component';
                else if (vis === 'slab') labelSpan.textContent = 'I know my rough opening and door size — calculate the rest for me';
                else labelSpan.textContent = orig;
            } else {
                labelSpan.textContent = orig;
            }
        });
    }

    /** When Pre-Hung jamb + sidelight: second tab must submit rough-opening value, not finished-opening. */
    function syncJambSidelightMeasurementTabValues(optionsContainer, schema) {
        if (!optionsContainer || !schema) return;
        var measureOpt = null;
        for (var mi = 0; mi < schema.length; mi++) {
            if (schema[mi] && isMeasurementTypeOptionId(schema[mi].id)) {
                measureOpt = schema[mi];
                break;
            }
        }
        if (!measureOpt) return;
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        if (!wrap) return;
        var slabTab = wrap.querySelector('.door-measure-tab[data-measure-vis="slab"]');
        if (!slabTab) return;
        var radio = slabTab.querySelector('input[type="radio"]');
        if (!radio) return;
        if (!radio.getAttribute('data-door-slab-tab-value-orig')) {
            var initialVal = radio.value || '';
            // Legacy bug stored Finished Opening as rough_opening_size — keep a finished token as orig.
            if (isRoughOpeningMeasureTab(initialVal)) initialVal = 'finished_opening';
            radio.setAttribute('data-door-slab-tab-value-orig', initialVal);
            slabTab.setAttribute('data-door-slab-tab-choice-orig', initialVal || slabTab.getAttribute('data-choice-value') || '');
        }
        var origVal = radio.getAttribute('data-door-slab-tab-value-orig') || '';
        if (isRoughOpeningMeasureTab(origVal)) {
            origVal = 'finished_opening';
            radio.setAttribute('data-door-slab-tab-value-orig', origVal);
            slabTab.setAttribute('data-door-slab-tab-choice-orig', origVal);
        }
        var jambTwoTab = isJambTwoTabMeasureMode(schema, optionsContainer);
        var roughVal = 'rough_opening_size';
        var filtered = filterMeasurementTypeTabChoices(measureOpt.options || []);
        for (var ri = 0; ri < filtered.length; ri++) {
            var c = filtered[ri];
            var t = String((c && (c.label || c.value)) || '').toLowerCase();
            if (t.indexOf('rough') !== -1 && c.value != null && c.value !== '') {
                roughVal = String(c.value);
                break;
            }
        }
        // Jamb+sidelight/transom marketing tab calculates from rough opening — use rough token.
        // All other setups: slab tab is Finished Opening Size → finished_opening(_size) only.
        var targetVal = jambTwoTab ? roughVal : (isFinishedOpeningMeasureTab(origVal) ? origVal : 'finished_opening');
        if (radio.value !== targetVal) {
            radio.value = targetVal;
            slabTab.setAttribute('data-choice-value', targetVal);
        }
        var chk = wrap.querySelector('.door-measure-tabs .door-measure-tab input[type="radio"]:checked');
        if (chk) {
            var mode = measurementModeFromCheckedTab(chk, optionsContainer, schema);
            syncMeasurementTabVisibilityCore(mode, measureOpt.id, optionsContainer, schema);
        }
    }

    function isSlabSidelightMeasurementMode(schema, optionsContainer) {
        if (!schema || !optionsContainer) return false;
        var preOpt = findPreHungStyleOption(schema);
        if (!preOpt) return false;
        var v = getSelectedValueForOption(preOpt, optionsContainer);
        if (!isSlabOnlyMeasurementTrigger(v)) return false;
        return hasActiveSidelightSelection(schema, optionsContainer);
    }

    function isTransomChoiceExcluded(val, opt) {
        if (val == null || val === '') return true;
        var n = normPreHungSelectionValue(val);
        if (n === 'none' || n === 'no' || n.indexOf('no_transom') !== -1) return true;
        if (n.indexOf('without') !== -1 && n.indexOf('transom') !== -1) return true;
        var ch = choiceMatchingValue(opt, val);
        if (ch) {
            var lbl = String(ch.label || '').toLowerCase();
            if (lbl === 'none' || lbl.trim() === '—' || lbl.trim() === '-') return true;
            if (lbl.indexOf('no transom') !== -1) return true;
            if (lbl.indexOf('without') !== -1 && lbl.indexOf('transom') !== -1) return true;
        }
        return false;
    }

    function hasActiveTransomSelection(schema, optionsContainer) {
        if (!schema || !optionsContainer) return false;
        var keys = ['transom_style'];
        for (var ti = 0; ti < keys.length; ti++) {
            var opt = findSchemaOptionByIdNorm(schema, keys[ti]);
            if (!opt) continue;
            var val = getSelectedValueForOption(opt, optionsContainer);
            if (!isTransomChoiceExcluded(val, opt)) return true;
        }
        return false;
    }

    function isSlabTransomMeasurementMode(schema, optionsContainer) {
        if (!schema || !optionsContainer) return false;
        if (isSlabSidelightMeasurementMode(schema, optionsContainer)) return false;
        var preOpt = findPreHungStyleOption(schema);
        if (!preOpt) return false;
        var v = getSelectedValueForOption(preOpt, optionsContainer);
        if (!isSlabOnlyMeasurementTrigger(v)) return false;
        return hasActiveTransomSelection(schema, optionsContainer);
    }

    function isSlabSidelightTransomComboMode(schema, optionsContainer) {
        if (!schema || !optionsContainer) return false;
        var preOpt = findPreHungStyleOption(schema);
        if (!preOpt) return false;
        var v = getSelectedValueForOption(preOpt, optionsContainer);
        if (!isSlabOnlyMeasurementTrigger(v)) return false;
        return hasActiveSidelightSelection(schema, optionsContainer) && hasActiveTransomSelection(schema, optionsContainer);
    }

    function isSlabSpecialMeasurementMode(schema, optionsContainer) {
        var preOpt = findPreHungStyleOption(schema);
        if (!preOpt || !optionsContainer || !schema) return false;
        if (!isSlabOnlyMeasurementTrigger(getSelectedValueForOption(preOpt, optionsContainer))) return false;
        return hasActiveSidelightSelection(schema, optionsContainer) || hasActiveTransomSelection(schema, optionsContainer);
    }

    function syncSlabSidelightMeasurementUI(optionsContainer, schema) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer || !schema) return;
        if (measurementSchemaUsesJsonVisibility(schema)) {
            applyMeasurementSectionJsonVisibility(schema, optionsContainer);
            return;
        }
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        if (!wrap || wrap.classList.contains('door-hidden')) return;
        var emb = wrap.querySelector('.door-measurement-embedded-dimensions');
        var defaultPanels = emb && emb.querySelector('.door-measurement-default-panels');
        var slabPanels = emb && emb.querySelector('.door-measurement-slab-sidelight-panels');
        var transomPanels = emb && emb.querySelector('.door-measurement-slab-transom-panels');
        var comboPanels = emb && emb.querySelector('.door-measurement-slab-combo-panels');
        if (!defaultPanels) return;
        if (!slabPanels && !transomPanels && !comboPanels) return;

        var combo = isSlabSidelightTransomComboMode(schema, optionsContainer);
        var slabSide = isSlabSidelightMeasurementMode(schema, optionsContainer);
        var slabTrans = isSlabTransomMeasurementMode(schema, optionsContainer);
        var prompt = wrap.querySelector('.door-measurement-type-prompt');
        var tabs = wrap.querySelector('.door-measure-tabs');
        var intro = wrap.querySelector('.door-measurement-panel-intro');
        var eyebrow = wrap.querySelector('.door-measurement-type-eyebrow');
        var measureOptId = wrap.getAttribute('data-option-id');

        function hideIntro() {
            if (intro) {
                intro.classList.add('door-hidden');
                intro.textContent = '';
                intro.setAttribute('aria-hidden', 'true');
            }
        }

        if (combo) {
            if (eyebrow) eyebrow.textContent = 'Exact Door Size + Sidelight + Transom';
            if (prompt) prompt.classList.add('door-hidden');
            if (tabs) tabs.classList.add('door-hidden');
            hideIntro();
            if (emb) emb.classList.remove('door-hidden');
            defaultPanels.classList.add('door-hidden');
            if (slabPanels) slabPanels.classList.add('door-hidden');
            if (transomPanels) transomPanels.classList.add('door-hidden');
            if (comboPanels) {
                comboPanels.classList.remove('door-hidden');
                fixPanelDoorWidthAndTransomHeightOptionRanges(comboPanels);
            }
        } else if (slabSide) {
            if (eyebrow) eyebrow.textContent = 'Exact Door Size + Sidelight';
            if (prompt) prompt.classList.add('door-hidden');
            if (tabs) tabs.classList.add('door-hidden');
            hideIntro();
            if (emb) emb.classList.remove('door-hidden');
            defaultPanels.classList.add('door-hidden');
            if (transomPanels) transomPanels.classList.add('door-hidden');
            if (comboPanels) comboPanels.classList.add('door-hidden');
            if (slabPanels) slabPanels.classList.remove('door-hidden');
        } else if (slabTrans) {
            if (eyebrow) eyebrow.textContent = 'Exact Door Size + Transom';
            if (prompt) prompt.classList.add('door-hidden');
            if (tabs) tabs.classList.add('door-hidden');
            hideIntro();
            if (emb) emb.classList.remove('door-hidden');
            defaultPanels.classList.add('door-hidden');
            if (slabPanels) slabPanels.classList.add('door-hidden');
            if (comboPanels) comboPanels.classList.add('door-hidden');
            if (transomPanels) {
                transomPanels.classList.remove('door-hidden');
                fixPanelDoorWidthAndTransomHeightOptionRanges(transomPanels);
            }
        } else {
            if (slabPanels) slabPanels.classList.add('door-hidden');
            if (transomPanels) transomPanels.classList.add('door-hidden');
            if (comboPanels) comboPanels.classList.add('door-hidden');
            defaultPanels.classList.remove('door-hidden');
            if (prompt) prompt.classList.remove('door-hidden');
            if (tabs) tabs.classList.remove('door-hidden');
            var modeAfter = 'exact';
            if (tabs) {
                var chk = tabs.querySelector('.door-measure-tab input[type="radio"]:checked');
                if (chk) modeAfter = measurementModeFromCheckedTab(chk, optionsContainer, schema);
            }
            if (measureOptId) syncMeasurementTabVisibilityCore(modeAfter, measureOptId, optionsContainer, schema);
            syncMeasurementPromptAndEyebrow(optionsContainer, schema);
        }
    }

    function syncMeasurementTypeSectionPreHungGate(schema, optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer || !schema) return;
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        if (!wrap) return;
        if (isGateCollection()) {
            wrap.classList.remove('door-hidden');
            applyGateCollectionMeasurementTabs(optionsContainer, schema);
            return;
        }
        var measureOptGate = null;
        for (var mg = 0; mg < schema.length; mg++) {
            if (schema[mg] && isMeasurementTypeOptionId(schema[mg].id)) {
                measureOptGate = schema[mg];
                break;
            }
        }
        if (measureOptGate && optionHasJsonVisibilityRules(measureOptGate)) return;
        var show = shouldShowMeasurementTypeForPreHungSelection(schema, optionsContainer);
        wrap.classList.toggle('door-hidden', !show);
        if (!show) return;
        var oid = wrap.getAttribute('data-option-id');
        var radioTabs = wrap.querySelector('.door-measure-tabs');
        if (radioTabs && oid) {
            var chk = radioTabs.querySelector('.door-measure-tab input[type="radio"]:checked');
            if (chk) {
                var modeAfter = measurementModeFromCheckedTab(chk, optionsContainer, schema);
                syncMeasurementTabVisibilityCore(modeAfter, oid, optionsContainer, schema);
            }
        }
    }

    function syncHingeFinishVisibility(schema, optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer || !schema) return;
        var hingeWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="hinge_finish"]')
            || optionsContainer.querySelector('.door-option-wrap[data-option-id="Hinge_Finish"]')
            || optionsContainer.querySelector('.door-option-wrap[data-option-id="hinge-finish"]');
        if (!hingeWrap) return;
        var preOpt = findPreHungStyleOption(schema);
        if (!preOpt) return;
        var preVal = getSelectedValueForOption(preOpt, optionsContainer);
        var isSlab = isSlabOnlyMeasurementTrigger(preVal);
        var noSelection = (preVal == null || preVal === '');
        var shouldHide = isSlab || noSelection;
        hingeWrap.classList.toggle('door-hidden', shouldHide);
        // Slab / no Door Setup: clear Pre-Hung hinge so submit does not keep the hidden selection.
        if (shouldHide) {
            try {
                hingeWrap.querySelectorAll('input[type="radio"]').forEach(function (inp) {
                    inp.checked = false;
                });
                hingeWrap.querySelectorAll('.common-check-option--selected').forEach(function (card) {
                    card.classList.remove('common-check-option--selected');
                });
                var hingeSel = hingeWrap.querySelector('select');
                if (hingeSel) hingeSel.value = '';
            } catch (eClrHinge) { }
            return;
        }
        // Pre-Hung again: restore default hinge when nothing is selected.
        if (isDoorRestorePendingSafe()) return;
        try {
            if (hingeWrap.querySelector('input[type="radio"]:checked')) return;
            var defVal = getDefaultSelectionForOption('hinge_finish');
            if (defVal == null || defVal === '') return;
            var defNorm = String(defVal).trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
            var radios = hingeWrap.querySelectorAll('input[type="radio"]');
            var match = null;
            Array.prototype.forEach.call(radios, function (inp) {
                if (match || !inp) return;
                var v = String(inp.value || '').trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
                if (v && (v === defNorm || String(inp.value) === String(defVal))) match = inp;
            });
            if (!match) return;
            Array.prototype.forEach.call(radios, function (inp) {
                inp.checked = (inp === match);
                var card = inp.closest ? inp.closest('.common-check-option') : null;
                if (card) card.classList.toggle('common-check-option--selected', inp === match);
            });
            try { match.dispatchEvent(new Event('change', { bubbles: true })); } catch (eHingeCh) { }
        } catch (eHingeDef) { }
    }

    /**
     * Screen & Storm only: Lockset Prep is available for prehung on jamb or brickmold.
     * When Slab Only is selected (or no prehung yet), hide the Lockset Prep section.
     */
    function isScreenStormConfiguratorProduct() {
        try {
            var cfg = document.getElementById('door-configurator');
            if (cfg && cfg.getAttribute('data-use-screen-storm-glass-meta') === 'true') return true;
            var tagsRaw = cfg ? String(cfg.getAttribute('data-product-tags') || '') : '';
            var tagsNorm = tagsRaw.toLowerCase().replace(/&/g, 'and');
            if (tagsNorm.indexOf('screen') !== -1 && tagsNorm.indexOf('storm') !== -1) return true;
            var route = cfg ? String(cfg.getAttribute('data-route-collection') || '').toLowerCase() : '';
            if (route.indexOf('screen-and-storm') !== -1 || route.indexOf('screen_and_storm') !== -1) return true;
        } catch (eSs) { }
        return false;
    }

    function isDoorRestorePendingSafe() {
        try {
            if (window.__doorRestoreApplying) return true;
            if (typeof deps.doorRestorePending === 'function') return !!deps.doorRestorePending();
        } catch (eRestorePending) { }
        return false;
    }

    function getDefaultSelectionForOption(optId) {
        if (typeof deps.getDefaultSelectionForOption === 'function') {
            return deps.getDefaultSelectionForOption(optId);
        }
        return null;
    }

    function normalizeLocksetChoiceKey(v) {
        return String(v == null ? '' : v).trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
    }

    function isLocksetPrepChoiceVisible(locksetWrap, card, inp) {
        if (!locksetWrap || locksetWrap.classList.contains('door-hidden')) return false;
        if (!inp || inp.disabled) return false;
        if (card) {
            if (card.style.display === 'none' || card.classList.contains('door-hidden')) return false;
            if (card.getAttribute('data-product-tag-hidden') === '1') return false;
            if (card.getAttribute('data-choice-condition-hidden') === '1') return false;
        }
        return true;
    }

    function isNoLockPrepChoice(inp, card) {
        if (!inp) return false;
        var key = normalizeLocksetChoiceKey(inp.value);
        if (key === 'no_lock_prep' || key === 'no_lockset_prep') return true;
        if (card) {
            var dv = normalizeLocksetChoiceKey(card.getAttribute('data-choice-value') || '');
            if (dv === 'no_lock_prep' || dv === 'no_lockset_prep') return true;
            var lbl = card.querySelector('.common-check-option-label');
            if (lbl) {
                var lk = normalizeLocksetChoiceKey(lbl.textContent);
                if (lk === 'no_lock_prep' || lk === 'no_lockset_prep') return true;
            }
        }
        return false;
    }

    function findLocksetPrepWrap(optionsContainer) {
        if (!optionsContainer) return null;
        return optionsContainer.querySelector('.door-option-wrap[data-option-id="lockset_prep"]')
            || optionsContainer.querySelector('.door-option-wrap[data-option-id="Lockset_Prep"]')
            || optionsContainer.querySelector('.door-option-wrap[data-option-id="lockset-prep"]');
    }

    function locksetPrepRadioSelector() {
        return 'input[type="radio"][data-option-id="lockset_prep"], input[type="radio"][data-option-id="Lockset_Prep"], input[type="radio"][data-option-id="lockset-prep"]';
    }

    function locksetPrepSelectSelector() {
        return 'select[data-option-id="lockset_prep"], select[data-option-id="Lockset_Prep"], select[data-option-id="lockset-prep"]';
    }

    function applyLocksetPrepNoLockPrepDefault(optionsContainer) {
        if (typeof deps.applyLocksetPrepNoneDefault === 'function') {
            return deps.applyLocksetPrepNoneDefault(optionsContainer);
        }
        return false;
    }

    function syncLocksetPrepVisibility(schema, optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        var locksetWrap = findLocksetPrepWrap(optionsContainer);
        if (!locksetWrap) return;

        // Rule applies only to Screen & Storm Doors.
        if (!isScreenStormConfiguratorProduct()) {
            locksetWrap.classList.remove('door-hidden');
            try { applyLocksetPrepNoLockPrepDefault(optionsContainer); } catch (eLocksetDefNs) { }
            return;
        }

        schema = schema || doorConfigSchemaRef();
        var preOpt = findPreHungStyleOption(schema);
        var preVal = preOpt ? getSelectedValueForOption(preOpt, optionsContainer) : '';
        var allowLockset = !!(preOpt && (
            isPreHungOnDoorJambTrigger(preOpt, preVal)
            || isPreHungBrickMoldingTrigger(preOpt, preVal)
        ));
        var shouldHide = !allowLockset;
        locksetWrap.classList.toggle('door-hidden', shouldHide);

        if (shouldHide) {
            try {
                locksetWrap.querySelectorAll(locksetPrepRadioSelector()).forEach(function (inp) {
                    inp.checked = false;
                });
                locksetWrap.querySelectorAll('.common-check-option--selected').forEach(function (card) {
                    card.classList.remove('common-check-option--selected');
                });
                var sel = locksetWrap.querySelector(locksetPrepSelectSelector());
                if (sel) sel.value = '';
            } catch (eClrLockset) { }
        } else {
            try { applyLocksetPrepNoLockPrepDefault(optionsContainer); } catch (eLocksetDef) { }
        }
    }

    /** Apply measurement tab selection: show intro, dimension rows, and correct static panel. */
    function applyMeasurementTypeTabSelection(radioEl, measureOptionId, optionsContainer, schema) {
        if (!radioEl || !optionsContainer) return;
        schema = schema || doorConfigSchemaRef();
        var mode = measurementModeFromCheckedTab(radioEl, optionsContainer, schema);
        syncMeasurementTabVisibilityCore(mode, measureOptionId, optionsContainer, schema);
        if (measurementSchemaUsesJsonVisibility(schema)) {
            applyMeasurementSectionJsonVisibility(schema, optionsContainer);
        }
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap[data-option-id="' + measureOptionId + '"]') ||
            optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap');
        if (!wrap) return;
        var intro = wrap.querySelector('.door-measurement-panel-intro');
        var emb = wrap.querySelector('.door-measurement-embedded-dimensions');
        if (intro) {
            intro.classList.remove('door-hidden');
            intro.setAttribute('aria-hidden', 'false');
        }
        if (emb) emb.classList.remove('door-hidden');
        var tabEl = radioEl.closest ? radioEl.closest('.door-measure-tab') : null;
        if (tabEl) {
            var tabsWrap = tabEl.closest('.door-measure-tabs');
            if (tabsWrap) {
                tabsWrap.querySelectorAll('.door-measure-tab').forEach(function (c) {
                    c.classList.remove('common-check-option--selected');
                });
            }
            tabEl.classList.add('common-check-option--selected');
        }
        try { applyFinishedRoughWidthIntDefaults(optionsContainer, false); } catch (eFinRoughDef) { }
        try { applyStaticMeasurementDimensionDefaults(optionsContainer); } catch (eTabMeasDef) { }
        try {
            if (typeof window.__doorHydrateMeasurementRowThumbnails === 'function') {
                window.__doorHydrateMeasurementRowThumbnails(wrap);
            }
        } catch (eHydrateMeasSvg) { }
    }

    /**
     * Collection handle defaults for measurement_type:
     *  - sidelights / interior-doors-sidelight (and other sidelight collections) → exact_sidelight_size
     *  - transoms / interior-doors-transom (and other transom collections) → exact_transom_size
     * @param {boolean|object} [forceOrOpts] - true / { force: true } overrides another checked tab (boot defaults).
     */
    function applySidelightTransomMeasurementTypeDefault(container, schema, forceOrOpts) {
        if (!container) return false;
        var force = forceOrOpts === true
            || (forceOrOpts && typeof forceOrOpts === 'object' && forceOrOpts.force === true);
        var colType = getSidelightTransomCollectionType();
        var want = '';
        if (colType === 'sidelight') want = MEASURE_TAB_EXACT_SIDELIGHT;
        else if (colType === 'transom') want = MEASURE_TAB_EXACT_TRANSOM;
        else return false;

        schema = schema || doorConfigSchemaRef();
        try { syncMeasurementSidelightTransomTabVisibility(container, schema); } catch (eVisFirst) { }

        var measureOptId = 'measurement_type';
        if (schema && Array.isArray(schema)) {
            for (var mi = 0; mi < schema.length; mi++) {
                if (schema[mi] && isMeasurementTypeOptionId(schema[mi].id)) {
                    measureOptId = String(schema[mi].id);
                    break;
                }
            }
        }

        var wantNorm = normalizeOptionIdKey(want);
        var target = null;
        var checkedVisible = null;
        var tabsRoot = container.querySelector('.door-measure-tabs') || container;
        var radios = tabsRoot.querySelectorAll(
            'input[type="radio"][data-option-id="' + measureOptId + '"],' +
            'input[type="radio"][data-option-id="measurement_type"],' +
            '.door-measure-tab input[type="radio"]'
        );
        Array.prototype.forEach.call(radios, function (inp) {
            if (!inp) return;
            var tab = inp.closest ? inp.closest('.door-measure-tab, .common-check-option') : null;
            var hidden = false;
            if (tab) {
                if (tab.style.display === 'none' || tab.classList.contains('door-hidden')) hidden = true;
                if (tab.getAttribute('data-product-tag-hidden') === '1') hidden = true;
                if (tab.getAttribute('data-choice-condition-hidden') === '1') hidden = true;
            }
            var valNorm = normalizeOptionIdKey(inp.value);
            if (!target && valNorm === wantNorm) target = inp;
            if (!hidden && inp.checked) checkedVisible = inp;
        });
        if (!target) return false;

        // Collection tab must be selectable — unhide if product is on this collection.
        var targetTab = target.closest ? target.closest('.door-measure-tab, .common-check-option') : null;
        if (targetTab) {
            targetTab.classList.remove('door-hidden');
            targetTab.style.display = '';
            targetTab.removeAttribute('data-product-tag-hidden');
            targetTab.removeAttribute('data-choice-condition-hidden');
        }

        // Soft mode: keep another already-checked visible tab (user pick).
        if (!force && checkedVisible && checkedVisible !== target) {
            return false;
        }

        if (target.checked && targetTab && targetTab.classList.contains('common-check-option--selected')) {
            try { applyMeasurementTypeTabSelection(target, measureOptId, container, schema); } catch (eSync) { }
            return true;
        }

        Array.prototype.forEach.call(radios, function (inp) {
            inp.checked = (inp === target);
            var c = inp.closest ? inp.closest('.door-measure-tab, .common-check-option') : null;
            if (c) c.classList.toggle('common-check-option--selected', inp === target);
        });
        try { applyMeasurementTypeTabSelection(target, measureOptId, container, schema); } catch (eApply) { }
        try { target.dispatchEvent(new Event('change', { bubbles: true })); } catch (eChg) { }
        return true;
    }

    /** When measurement_type has no default selection, intro + rows stay hidden until a tab is picked; restore visibility after load/save. */
    function syncMeasurementTypeDetailsVisibility(optionsContainer, schema) {
        if (!optionsContainer || !schema) return;
        var measureOpt = null;
        for (var mi = 0; mi < schema.length; mi++) {
            if (schema[mi] && isMeasurementTypeOptionId(schema[mi].id)) {
                measureOpt = schema[mi];
                break;
            }
        }
        if (!measureOpt) return;
        var wrap = optionsContainer.querySelector('.door-measurement-type-section.door-option-wrap[data-option-id="' + measureOpt.id + '"]');
        if (!wrap) return;
        var slabSpecialDet = isSlabSpecialMeasurementMode(schema, optionsContainer);
        var chk = wrap.querySelector('.door-measure-tabs .door-measure-tab input[type="radio"]:checked');
        var intro = wrap.querySelector('.door-measurement-panel-intro');
        var emb = wrap.querySelector('.door-measurement-embedded-dimensions');
        var reveal = !!chk || slabSpecialDet;
        if (intro) {
            if (!reveal || slabSpecialDet) {
                intro.textContent = '';
                intro.setAttribute('aria-hidden', 'true');
            } else {
                intro.setAttribute('aria-hidden', 'false');
            }
            intro.classList.toggle('door-hidden', !reveal || slabSpecialDet);
        }
        if (emb) emb.classList.toggle('door-hidden', !reveal);
        if (slabSpecialDet) return;
        if (chk) {
            applyMeasurementTypeTabSelection(chk, measureOpt.id, optionsContainer, schema);
        }
    }

    function runMeasurementUiSync() {
        var optContainer = document.getElementById('door-configurator-options');
        if (!doorConfigSchemaRef() || !optContainer) return;
        try { syncNoSlabDoorSetupVisibility(doorConfigSchemaRef(), optContainer); } catch (eNoSlabSync) { }
        syncMeasurementTypeSectionPreHungGate(doorConfigSchemaRef(), optContainer);
        syncHingeFinishVisibility(doorConfigSchemaRef(), optContainer);
        syncLocksetPrepVisibility(doorConfigSchemaRef(), optContainer);
        syncMeasurementTabCardVisibility(optContainer, doorConfigSchemaRef());
        syncMeasurementTypeDetailsVisibility(optContainer, doorConfigSchemaRef());
        syncSlabSidelightMeasurementUI(optContainer, doorConfigSchemaRef());
        if (measurementSchemaUsesJsonVisibility(doorConfigSchemaRef())) {
            applyMeasurementSectionJsonVisibility(doorConfigSchemaRef(), optContainer);
        }
        syncMeasurementSidelightTransomTabVisibility(optContainer, doorConfigSchemaRef());
        applyGardenGatesCollectionRules(optContainer, doorConfigSchemaRef());
        // Collection default: sidelight → exact_sidelight_size, transom → exact_transom_size
        try { applySidelightTransomMeasurementTypeDefault(optContainer, doorConfigSchemaRef()); } catch (eSideTransDef) { }
        applySidelightTransomMeasurementDimensionCopy(optContainer);
        // Opening width/height matrix from doors × sidelights × transoms (row 22 validation for now)
        try { applyOpeningDimensionRangesFromUnitLayout(optContainer); } catch (eOpenLayoutSync) { }
        // Keep Exact Door Width on Single Item sheet (15–48 def 36) after opening sync.
        try { applyExactDoorWidthIntRange(optContainer); } catch (eExactWSync) { }
        // Screen & Storm: opening width/height 1–144/1–150; Exact Door W/H stay on Single Item sheet.
        try { applyScreenStormExactDimensionRanges(optContainer); } catch (eSsSync) { }
        try { applyExactDoorWidthIntRange(optContainer); } catch (eExactWSsSync) { }
        try { applySingleItemDimensionRanges(optContainer); } catch (eSingleSsSync) { }
        // Do not re-apply measurement defaults on every price/API sync — that
        // snapped Exact Door Thickness back to 1 1/2 after the user picked 1 3/4.

        // --- Dp start 17-07 ---
        var schema = doorConfigSchemaRef();
        var curSidelight = hasActiveSidelightSelection(schema, optContainer);
        var curTransom = hasActiveTransomSelection(schema, optContainer);
        var preOpt = findPreHungStyleOption(schema);
        var curPrehung = preOpt ? getSelectedValueForOption(preOpt, optContainer) : '';

        if (!_hasInitializedPrevValues) {
            _prevSidelightActive = curSidelight;
            _prevTransomActive = curTransom;
            _prevPrehungStyle = curPrehung;
            _hasInitializedPrevValues = true;
        } else {
            var optionChanged = (_prevSidelightActive !== curSidelight) ||
                (_prevTransomActive !== curTransom) ||
                (_prevPrehungStyle !== curPrehung);

            if (optionChanged) {
                _prevSidelightActive = curSidelight;
                _prevTransomActive = curTransom;
                _prevPrehungStyle = curPrehung;

                var tabsWrap = optContainer.querySelector('.door-measure-tabs');
                if (tabsWrap) {
                    // Dp start 04-08
                    var firstVisibleTab = tabsWrap.querySelector('.door-measure-tab:not(.door-hidden) input[value="exact_sidelight_size"]')
                        ? tabsWrap.querySelector('.door-measure-tab:not(.door-hidden) input[value="exact_sidelight_size"]').closest('.door-measure-tab')
                        : (tabsWrap.querySelector('.door-measure-tab:not(.door-hidden) input[value="exact_transom_size"]')
                            ? tabsWrap.querySelector('.door-measure-tab:not(.door-hidden) input[value="exact_transom_size"]').closest('.door-measure-tab')
                            : tabsWrap.querySelector('.door-measure-tab:not(.door-hidden)'));
                    // Dp end 04-08
                    if (firstVisibleTab) {
                        var radio = firstVisibleTab.querySelector('input[type="radio"]');
                        if (radio) {
                            var measureOpt = null;
                            for (var mi = 0; mi < schema.length; mi++) {
                                if (schema[mi] && isMeasurementTypeOptionId(schema[mi].id)) {
                                    measureOpt = schema[mi];
                                    break;
                                }
                            }
                            var measureOptionId = measureOpt ? measureOpt.id : 'measurement_type';

                            radio.checked = true;

                            try {
                                applyMeasurementTypeTabSelection(radio, measureOptionId, optContainer, schema);
                            } catch (eSelectFirst) { }
                        }
                    }
                }
            }
        }
        // --- Dp end 17-07 ---
    }
    var MEASUREMENT_ADDON_BREAKDOWN_CATALOG = {
        door_oversized: ['int_ext_oversized', 'screen_storm_oversized'],
        door_thickness: [
            'interior_door_thickness',
            'screen_storm_thickness',
            'screen_storm_thickness_frac',
            'screen_storm_panel_door_thickness_extra',
            'sidelight_panel_thickness'
        ],
        sidelight_transom: [
            'sidelight_transom_oversized',
            'sidelight_transom_oversized_pair1',
            'sidelight_transom_oversized_pair2',
            'screen_storm_sidelight_transom',
            'screen_storm_transom_combo'
        ]
    };

    var MEASUREMENT_ADDON_WINDOW_MAP = {
        int_ext_oversized: '__doorAddon_intExtOversizedApi',
        interior_door_thickness: '__doorAddon_interiorDoorThickness',
        sidelight_panel_thickness: '__doorAddon_sidelightPanelThickness',
        sidelight_transom_oversized: '__doorAddon_sidelightTransomOversized',
        sidelight_transom_oversized_pair1: '__doorAddon_sidelightTransomOversizedPair1',
        sidelight_transom_oversized_pair2: '__doorAddon_sidelightTransomOversizedPair2',
        screen_storm_oversized: '__doorScreenStormAddon_oversized',
        screen_storm_thickness: '__doorScreenStormAddon_thickness',
        screen_storm_thickness_frac: '__doorScreenStormAddon_thickness_frac',
        screen_storm_sidelight_transom: '__doorScreenStormAddon_sidelight_transom',
        screen_storm_transom_combo: '__doorScreenStormAddon_transom_combo',
        screen_storm_panel_door_thickness_extra: '__doorScreenStormAddon_panel_door_thickness_extra'
    };

    function allMeasurementAddonBreakdownKeys() {
        var keys = [];
        Object.keys(MEASUREMENT_ADDON_BREAKDOWN_CATALOG).forEach(function (g) {
            (MEASUREMENT_ADDON_BREAKDOWN_CATALOG[g] || []).forEach(function (k) {
                if (keys.indexOf(k) === -1) keys.push(k);
            });
        });
        return keys;
    }

    function sumMeasurementBreakdownKeys(bd, keys) {
        if (!bd || !keys || !keys.length) return 0;
        var sum = 0;
        keys.forEach(function (k) {
            if (bd[k] == null || bd[k] === '') return;
            var n = parseFloat(bd[k]);
            if (!isNaN(n)) sum += n;
        });
        return Math.round(sum * 100) / 100;
    }

    function liveAmountForMeasurementBreakdownKey(key) {
        var winKey = MEASUREMENT_ADDON_WINDOW_MAP[key];
        if (!winKey) return 0;
        return parseFloat(window[winKey] || 0) || 0;
    }

    function sumLiveMeasurementKeys(keys) {
        var sum = 0;
        (keys || []).forEach(function (k) { sum += liveAmountForMeasurementBreakdownKey(k); });
        return Math.round(sum * 100) / 100;
    }

    function measurementStyleOptionHasValue(optionKey) {
        var root = document.getElementById('door-configurator-options');
        if (!root) return false;
        var checked = root.querySelector('input[type="radio"][data-option-id="' + optionKey + '"]:checked');
        if (checked && String(checked.value || '').trim() !== '') return true;
        var sel = root.querySelector('select[data-option-id="' + optionKey + '"]');
        return !!(sel && String(sel.value || '').trim() !== '');
    }

    function breakdownSidelightTransomSplitMode(bd) {
        if (!bd) return false;
        var pair1 = parseFloat(bd.sidelight_transom_oversized_pair1 || 0) || 0;
        var pair2 = parseFloat(bd.sidelight_transom_oversized_pair2 || 0) || 0;
        return Math.abs(pair1) > 0.005 || Math.abs(pair2) > 0.005;
    }

    function liveSidelightTransomSplitMode() {
        var pair1 = liveAmountForMeasurementBreakdownKey('sidelight_transom_oversized_pair1');
        var pair2 = liveAmountForMeasurementBreakdownKey('sidelight_transom_oversized_pair2');
        return Math.abs(pair1) > 0.005 || Math.abs(pair2) > 0.005;
    }

    function isSidelightMeasurementOptionId(optionId) {
        return /(sidelight.*width|sidelight_width)/.test(normalizeOptionIdKey(optionId));
    }

    function isTransomMeasurementOptionId(optionId) {
        return /(transom.*height|panel_transom|panel_door_width)/.test(normalizeOptionIdKey(optionId));
    }

    function sumSidelightTransomRowAddon(optionId, bd, opts) {
        var id = normalizeOptionIdKey(optionId);
        var split;
        var pair1;
        var pair2;
        var legacy;
        var ssSl;
        var ssTc;
        if (bd) {
            split = breakdownSidelightTransomSplitMode(bd);
            pair1 = parseFloat(bd.sidelight_transom_oversized_pair1 || 0) || 0;
            pair2 = parseFloat(bd.sidelight_transom_oversized_pair2 || 0) || 0;
            legacy = parseFloat(bd.sidelight_transom_oversized || 0) || 0;
            ssSl = parseFloat(bd.screen_storm_sidelight_transom || 0) || 0;
            ssTc = parseFloat(bd.screen_storm_transom_combo || 0) || 0;
        } else {
            split = liveSidelightTransomSplitMode();
            pair1 = liveAmountForMeasurementBreakdownKey('sidelight_transom_oversized_pair1');
            pair2 = liveAmountForMeasurementBreakdownKey('sidelight_transom_oversized_pair2');
            legacy = liveAmountForMeasurementBreakdownKey('sidelight_transom_oversized');
            ssSl = liveAmountForMeasurementBreakdownKey('screen_storm_sidelight_transom');
            ssTc = liveAmountForMeasurementBreakdownKey('screen_storm_transom_combo');
        }
        var hasSl = opts && opts.sidelight_style != null && String(opts.sidelight_style || '') !== ''
            ? true
            : measurementStyleOptionHasValue('sidelight_style');
        var hasTr = opts && opts.transom_style != null && String(opts.transom_style || '') !== ''
            ? true
            : measurementStyleOptionHasValue('transom_style');
        if (isSidelightMeasurementOptionId(id)) {
            if (!split && Math.abs(legacy) > 0.005 && hasTr && !hasSl) return 0;
            var slAmt = split ? pair2 : legacy;
            return Math.round((slAmt + ssSl) * 100) / 100;
        }
        if (isTransomMeasurementOptionId(id)) {
            if (!split && Math.abs(legacy) > 0.005 && hasSl && !hasTr) return 0;
            var trAmt = split ? pair1 : legacy;
            return Math.round((trAmt + ssSl + ssTc) * 100) / 100;
        }
        return null;
    }

    function measurementOptionAddonGroup(optionId) {
        var id = normalizeOptionIdKey(optionId);
        if (id === 'measurement_type') return 'all';
        if (/(sidelight.*width|sidelight_width|transom.*height|panel_transom|panel_door_width)/.test(id)) {
            return 'sidelight_transom';
        }
        if (/thick/.test(id)) return 'door_thickness';
        if (/(width|height|pre_hung|jamb)/.test(id)) return 'door_oversized';
        return null;
    }

    function formatMeasurementAddonPriceLabel(amount) {
        var n = parseFloat(amount) || 0;
        if (Math.abs(n) < 0.005) return '';
        var abs = Math.abs(n);
        var s = abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return (n >= 0 ? '+$' : '-$') + s;
    }

    function getMeasurementAddonAmountForOption(optionId, opts) {
        var group = measurementOptionAddonGroup(optionId);
        if (!group) return 0;
        var bd = opts && opts._addon_breakdown && typeof opts._addon_breakdown === 'object'
            ? opts._addon_breakdown : null;
        if (group === 'all') {
            if (bd) return sumMeasurementBreakdownKeys(bd, allMeasurementAddonBreakdownKeys());
            return sumLiveMeasurementKeys(allMeasurementAddonBreakdownKeys());
        }
        if (group === 'sidelight_transom') {
            var rowAmt = sumSidelightTransomRowAddon(optionId, bd, opts);
            if (rowAmt !== null) return rowAmt;
        }
        var keys = MEASUREMENT_ADDON_BREAKDOWN_CATALOG[group] || [];
        if (bd) return sumMeasurementBreakdownKeys(bd, keys);
        return sumLiveMeasurementKeys(keys);
    }

    // function ensureMeasurementSelectedPriceEl(hostEl, optionId) {
    //     if (!hostEl) return null;
    //     var oid = String(optionId || hostEl.getAttribute('data-option-id') || '');
    //     var priceEl = hostEl.querySelector('.door-measurement-selected-price[data-option-id="' + oid + '"]');
    //     if (!priceEl) {
    //         priceEl = document.createElement('span');
    //         priceEl.className = 'door-measurement-selected-price door-measurement-selected-price--empty';
    //         priceEl.setAttribute('data-option-id', oid);
    //         hostEl.appendChild(priceEl);
    //     }
    //     return priceEl;
    // }

    function measurementDimensionRowHasValue(row) {
        if (!row) return false;
        var selects = row.querySelectorAll('select, input[type="hidden"]');
        for (var i = 0; i < selects.length; i++) {
            var el = selects[i];
            if (!el || el.disabled) continue;
            var v = String(el.value || '').trim();
            if (v !== '') return true;
        }
        return false;
    }

    function syncMeasurementSelectedPriceLabels(opts) {
        var container = document.getElementById('door-configurator-options');
        if (!container) return;

        var measWrap = container.querySelector('.door-measurement-type-section.door-option-wrap[data-option-id]');

        container.querySelectorAll('.door-measurement-selected-price').forEach(function (priceEl) {
            priceEl.textContent = '';
            priceEl.classList.add('door-measurement-selected-price--empty');
        });

        container.querySelectorAll('.admin-option-row[data-option-id] .admin-option-selected-price').forEach(function (priceEl) {
            var row = priceEl.closest('.admin-option-row[data-option-id]');
            var oid = row ? row.getAttribute('data-option-id') || '' : '';
            if (oid && measurementOptionAddonGroup(oid) && normalizeOptionIdKey(oid) !== 'measurement_type') {
                priceEl.textContent = '';
                priceEl.classList.add('admin-option-selected-price--empty');
            }
        });

        if (measWrap) {
            var measOid = measWrap.getAttribute('data-option-id') || 'measurement_type';
            var heading = measWrap.querySelector('.door-measurement-type-heading');
            if (heading) {
                var typeRadio = measWrap.querySelector('.door-measure-tabs .door-measure-tab input[type="radio"]:checked');
                var priceOnType = ensureMeasurementSelectedPriceEl(heading, measOid);
                if (priceOnType) {
                    var typeAmt = typeRadio ? getMeasurementAddonAmountForOption(measOid, opts) : 0;
                    var typeText = formatMeasurementAddonPriceLabel(typeAmt);
                    priceOnType.textContent = typeText;
                    priceOnType.classList.toggle('door-measurement-selected-price--empty', typeText === '');
                }
            }
        }
    }

    function isSavedMeasurementRestoreDebugOn() {
        try {
            if (window.__DOOR_SAVED_MEASUREMENT_RESTORE_DEBUG === true) return true;
            if (typeof window.__doorSavedRestoreDebug === 'function') return true;
            if (typeof location !== 'undefined' && location.search && /door_saved_restore_debug/i.test(location.search)) {
                return true;
            }
        } catch (eDbg) { }
        return isMeasurementWidthDefaultDebugOn();
    }

    function debugSavedMeasurementRestore(phase, detail) {
        if (!isSavedMeasurementRestoreDebugOn()) return;
        try {
            if (typeof window.__doorSavedRestoreDebug === 'function') {
                window.__doorSavedRestoreDebug(phase, detail || {});
                return;
            }
            console.log('[door-saved-meas-restore]', phase, detail || {});
        } catch (eLog) { }
    }

    var SAVED_MEAS_RESTORE_KEY_SELECT_IDS = {
        measurement_type: true,
        exact_door_width_int: true,
        exact_door_width_frac: true,
        door_height: true,
        door_height_fraction: true,
        door_height_frac: true
    };
    var lastSavedMeasApplyCompleteLogAt = 0;

    function savedMeasRestoreSelectBaseId(sel) {
        return String(sel && sel.id ? sel.id : '').split('__')[0].replace(/-/g, '_');
    }

    function trackSavedMeasurementSelectRestore(stats, sel, val, ok) {
        if (!stats || !sel) return;
        if (ok) stats.applied += 1;
        else stats.failed += 1;
        var baseId = savedMeasRestoreSelectBaseId(sel);
        if (!SAVED_MEAS_RESTORE_KEY_SELECT_IDS[baseId] || stats.keys[baseId]) return;
        stats.keys[baseId] = {
            want: String(val),
            got: String(sel.value || ''),
            ok: ok
        };
    }

    function markMeasurementSelectRestoredFromSaved(sel) {
        if (!sel || !sel.setAttribute) return;
        sel.setAttribute('data-door-user-changed', '1');
    }

    function isMeasurementDimensionSelect(sel) {
        if (!sel) return false;
        if (isStandardMeasurementWidthIntSelect(sel)) return true;
        var id = String(sel.id || '').toLowerCase();
        if (id === 'door_height' || id.indexOf('door_height') === 0) return true;
        if (id.indexOf('door-height') === 0) return true;
        if (id.indexOf('height') !== -1 && sel.classList && sel.classList.contains('door-dimension-int-select')) return true;
        if (id.indexOf('height') !== -1 && sel.classList && sel.classList.contains('door-dimension-frac-select')) return true;
        if (id.indexOf('frac') !== -1 || id.indexOf('fraction') !== -1) return true;
        return false;
    }

    function applySavedValueToMeasurementSelect(sel, val, setSelectValueFromSaved, stats) {
        if (!sel || val == null || val === '') return false;
        var ok = setMeasurementSelectValue(sel, val, { dispatchChange: true });
        if (!ok && typeof setSelectValueFromSaved === 'function') {
            ok = setSelectValueFromSaved(sel, val);
            if (ok) {
                syncMeasurementDivSelectUi(sel);
                try {
                    sel.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (eCh) { }
                syncMeasurementDivSelectUi(sel);
            }
        }
        if (ok) markMeasurementSelectRestoredFromSaved(sel);
        trackSavedMeasurementSelectRestore(stats, sel, val, ok);
        return ok;
    }

    function normSummaryLabel(label) {
        return String(label == null ? '' : label).trim().toLowerCase().replace(/\s+/g, ' ');
    }

    function parseFractionToken(token) {
        var t = String(token == null ? '' : token).trim();
        var map = { '0': '0', '1/4': '0.25', '1/2': '0.5', '3/4': '0.75' };
        if (Object.prototype.hasOwnProperty.call(map, t)) return map[t];
        if (t !== '' && !isNaN(parseFloat(t))) return String(parseFloat(t));
        return t;
    }

    function parseCombinedMeasurementDisplayValue(value) {
        var parts = String(value == null ? '' : value).trim().split(/\s+/).filter(Boolean);
        if (!parts.length) return [];
        if (parts.length === 2 && /\d+\/\d+/.test(parts[1])) {
            return [String(parseFloat(parts[0]) + parseFloat(parseFractionToken(parts[1])))];
        }
        return parts;
    }

    function measurementSummaryTitleFieldMap() {
        return {
            'exact door width': ['exact_door_width_int', 'exact_door_width_frac'],
            'exact door height': ['door_height', 'door_height_fraction'],
            'exact door thickness': ['exact_door_thickness_frac'],
            'finished opening width': ['finished_width_int', 'finished_width_frac'],
            'finished opening height': ['finished_height_int', 'finished_height_frac'],
            'rough opening width': ['rough_width_int', 'rough_width_frac'],
            'rough opening height': ['rough_height_int', 'rough_height_frac'],
            'door thickness': ['door_thickness'],
            'pre-hung unit depth': ['exact_pre_hung_int', 'exact_pre_hung_frac'],
            'pre hung unit depth': ['exact_pre_hung_int', 'exact_pre_hung_frac'],
            // Dp merge code 10-09 start — include int so saved restore does not drop the whole-inch pick
            'pre-hung jamb width': ['exact_pre_hung_int', 'exact_pre_hung_frac'],
            'pre hung jamb width': ['exact_pre_hung_int', 'exact_pre_hung_frac'],
            // Dp merge code 10-09 end
            // Dp start VDN-390 23-10
            'pre-hung jamb depth': ['exact_pre_hung_int', 'exact_pre_hung_frac'],
            'pre hung jamb depth': ['exact_pre_hung_int', 'exact_pre_hung_frac'],
            // Dp end VDN-390 23-10
            'exact sidelight width': ['sidelight_width', 'sidelight_width_fraction'],
            'exact transom height': ['panel_transom_height_int', 'panel_transom_height_frac'],
            'jamb unit width': ['panel_width_int', 'panel_width_frac', 'panel-width-int', 'panel-width-frac'],
            'jamb unit height': ['panel_height_int', 'panel_height_frac', 'panel-height-int', 'panel-height-frac'],
            'sidelight width': ['sidelight_width', 'sidelight_width_fraction'],
            'transom height': ['panel_transom_height_int', 'panel_transom_height_frac'],
            'panel door width': ['panel_width_int'],
            'panel transom height': ['panel_transom_height_int', 'panel_transom_height_frac']
        };
    }

    function measurementOptionKeysPopulated(opts, id) {
        var getSaved = deps.getSavedOptionValue;
        if (typeof getSaved === 'function') {
            var val = getSaved(opts, id);
            return val != null && val !== '';
        }
        var norm = normalizeOptionIdKey(id);
        var keys = [String(id), norm, norm.replace(/_/g, '-')];
        for (var ki = 0; ki < keys.length; ki++) {
            if (keys[ki] && opts[keys[ki]] != null && opts[keys[ki]] !== '') return true;
        }
        return false;
    }

    function setSavedOptionValue(opts, id, val) {
        if (!opts || id == null || val == null || val === '') return;
        var keysFn = deps.savedOptionKeysForId;
        if (typeof keysFn === 'function') {
            keysFn(id).forEach(function (k) {
                if (k) opts[k] = val;
            });
            return;
        }
        var norm = normalizeOptionIdKey(id);
        [String(id), norm, norm.replace(/_/g, '-')].forEach(function (k) {
            if (k) opts[k] = val;
        });
    }

    function inferMeasurementTypeFromSummary(opts) {
        var summary = opts && opts._selected_summary;
        if (!Array.isArray(summary)) return '';
        var labels = summary.map(function (item) {
            return item ? normSummaryLabel(item.label) : '';
        }).filter(Boolean);
        function has(needle) {
            return labels.some(function (l) { return l.indexOf(needle) !== -1; });
        }
        // Explicit Measurements / How will you measure row value wins.
        for (var i = 0; i < summary.length; i++) {
            var it = summary[i];
            if (!it) continue;
            var lab = normSummaryLabel(it.label);
            var val = String(it.value == null ? '' : it.value).trim().toLowerCase();
            if (
                (lab === 'measurements' || lab === 'measurement type' || lab === 'how will you measure') &&
                val
            ) {
                if (val.indexOf('jamb') !== -1) return 'jamb_unit_size';
                if (val.indexOf('rough') !== -1) return 'rough_opening_size';
                if (val.indexOf('finished') !== -1) return 'finished_opening_size';
                if (val.indexOf('exact') !== -1 && val.indexOf('door') !== -1) return 'exact_door_size';
            }
        }
        // Dp merge code 10-09 start — prefer opening Size method labels over companion Pre-hung depth
        if (has('jamb unit size') || (has('jamb unit') && !has('rough opening') && !has('finished opening'))) {
            return 'jamb_unit_size';
        }
        if (has('rough opening')) return 'rough_opening_size';
        if (has('finished opening')) return 'finished_opening_size';
        if (has('exact sidelight')) return 'exact_sidelight_size';
        if (has('exact transom')) return 'exact_transom_size';
        if (
            has('exact door') ||
            has('pre-hung unit depth') ||
            has('pre hung unit depth') ||
            has('pre-hung jamb width') ||
            // Dp start VDN-390 23-10
            has('pre hung jamb width') ||
            has('pre-hung jamb depth') ||
            has('pre hung jamb depth')
            // Dp end VDN-390 23-10
        ) {
            return 'exact_door_size';
        }
        // Dp merge code 10-09 end
        return '';
    }

    function hydrateMeasurementOptionsFromSummary(opts, ctx) {
        if (!opts || !Array.isArray(opts._selected_summary) || !opts._selected_summary.length) return;
        ctx = ctx || {};
        var getSavedFn = ctx.getSavedOptionValue || deps.getSavedOptionValue;
        var keysFn = ctx.savedOptionKeysForId || deps.savedOptionKeysForId;
        function populated(id) {
            if (typeof getSavedFn === 'function') {
                var v = getSavedFn(opts, id);
                return v != null && v !== '';
            }
            return measurementOptionKeysPopulated(opts, id);
        }
        function setVal(id, val) {
            if (typeof keysFn === 'function' && typeof getSavedFn === 'function') {
                keysFn(id).forEach(function (k) { if (k) opts[k] = val; });
                return;
            }
            setSavedOptionValue(opts, id, val);
        }
        // Dp merge code 10-09 start — split combined Size lines (Finished / Rough / Jamb Unit Size: Ww x Hh)
        function hydrateFromSizeLine(title, value) {
            var t = String(title || '');
            var sizeMap = null;
            if (t === 'finished opening size') {
                sizeMap = {
                    wInt: ['exact_door_width_int', 'door_width', 'finished_width_int'],
                    wFrac: ['exact_door_width_frac', 'door_width_fraction', 'finished_width_frac'],
                    hInt: ['door_height', 'finished_height_int'],
                    hFrac: ['door_height_fraction', 'finished_height_frac']
                };
            } else if (t === 'rough opening size') {
                sizeMap = {
                    wInt: ['rough_width_int'],
                    wFrac: ['rough_width_frac'],
                    hInt: ['rough_height_int'],
                    hFrac: ['rough_height_frac']
                };
            } else if (t === 'jamb unit size' || t === 'pre hung unit size' || t === 'pre-hung unit size') {
                sizeMap = {
                    wInt: ['exact_door_width_int', 'door_width', 'panel_width_int'],
                    wFrac: ['exact_door_width_frac', 'door_width_fraction', 'panel_width_frac'],
                    hInt: ['door_height', 'panel_height_int'],
                    hFrac: ['door_height_fraction', 'panel_height_frac']
                };
            } else if (t === 'exact door size') {
                sizeMap = {
                    wInt: ['exact_door_width_int', 'door_width'],
                    wFrac: ['exact_door_width_frac', 'door_width_fraction'],
                    hInt: ['door_height'],
                    hFrac: ['door_height_fraction']
                };
            }
            if (!sizeMap) return;
            var bits = String(value || '').split(/\s*[x×]\s*/i);
            if (bits.length < 2) return;
            var wPart = String(bits[0] || '').replace(/[wht]\s*$/i, '').trim();
            var hPart = String(bits[1] || '').replace(/[wht]\s*$/i, '').trim();
            function writeDim(intIds, fracIds, raw) {
                if (!raw) return;
                var parts = typeof parseCombinedMeasurementDisplayValue === 'function'
                    ? parseCombinedMeasurementDisplayValue(raw)
                    : String(raw).trim().split(/\s+/);
                var intVal = parts[0] != null ? parts[0] : '';
                var fracVal = parts[1] != null ? parts[1] : '';
                if (fracVal && typeof parseFractionToken === 'function') {
                    fracVal = parseFractionToken(fracVal);
                }
                (intIds || []).forEach(function (id) {
                    if (id && intVal !== '' && !populated(id)) setVal(id, intVal);
                });
                (fracIds || []).forEach(function (id) {
                    if (id && fracVal !== '' && !populated(id)) setVal(id, fracVal);
                });
            }
            writeDim(sizeMap.wInt, sizeMap.wFrac, wPart);
            writeDim(sizeMap.hInt, sizeMap.hFrac, hPart);
        }
        // Dp merge code 10-09 end
        var titleMap = measurementSummaryTitleFieldMap();
        var schema = Array.isArray(opts._pricing_schema) ? opts._pricing_schema : [];
        opts._selected_summary.forEach(function (item) {
            if (!item) return;
            var title = normSummaryLabel(item.label);
            var value = String(item.value == null ? '' : item.value).trim();
            if (!title || !value) return;
            // Dp merge code 10-09 start
            if (
                title === 'finished opening size' ||
                title === 'rough opening size' ||
                title === 'jamb unit size' ||
                title === 'pre hung unit size' ||
                title === 'pre-hung unit size' ||
                title === 'exact door size'
            ) {
                hydrateFromSizeLine(title, value);
                return;
            }
            // Dp merge code 10-09 end
            var fields = titleMap[title];
            if (!fields && schema.length) {
                fields = [];
                schema.forEach(function (o) {
                    if (!o || !o.id) return;
                    if (o._adminGroup !== 'measurement' && !/(width|height|thick|pre_hung|jamb|sidelight|transom)/i.test(String(o.id))) return;
                    var ol = normSummaryLabel(o.label);
                    if (ol === title || (ol && ol.indexOf(title) === 0)) fields.push(String(o.id));
                });
                fields.sort(function (a, b) {
                    return (/frac/i.test(a) ? 1 : 0) - (/frac/i.test(b) ? 1 : 0);
                });
            }
            if (!fields || !fields.length) return;
            var parts = parseCombinedMeasurementDisplayValue(value);
            if (fields.length === 1) {
                if (!populated(fields[0])) {
                    var single = parts.length === 1 ? parts[0] : parts.join(' ');
                    if (/frac|thick/i.test(fields[0])) single = parseFractionToken(single);
                    setVal(fields[0], single);
                }
                return;
            }
            fields.forEach(function (fieldId, idx) {
                if (populated(fieldId)) return;
                if (parts[idx] == null) return;
                var partVal = /frac/i.test(fieldId) ? parseFractionToken(parts[idx]) : parts[idx];
                setVal(fieldId, partVal);
            });
        });
        if (!populated('measurement_type')) {
            var inferred = inferMeasurementTypeFromSummary(opts);
            if (inferred) setVal('measurement_type', inferred);
        }
    }

    function applyMeasurementSelectsFromSavedOptions(opts, ctx) {
        if (!opts) return;
        ctx = ctx || {};
        var optionsContainer = ctx.optionsContainer;
        var getSavedOptionValue = ctx.getSavedOptionValue || deps.getSavedOptionValue;
        var setSelectValueFromSaved = ctx.setSelectValueFromSaved || deps.setSelectValueFromSaved;
        if (typeof getSavedOptionValue !== 'function' || typeof setSelectValueFromSaved !== 'function') return;
        hydrateMeasurementOptionsFromSummary(opts, ctx);
        // Apply the Screen & Storm width/height ranges first so the saved value maps to a
        // valid option on the config_id edit page before we restore selections.
        try { applyScreenStormExactDimensionRanges(optionsContainer || document); } catch (eSsRangeRestore) { }
        var restoreStats = { applied: 0, failed: 0, keys: {} };
        var selectors = '.door-measurement-static-panels select, .door-measurement-static-panel select, .door-measurement-embedded-dimensions select, .door-measurement-static-rows select, .door-measure-dimension-row select, .door-measure-dimension-inputs-row select';
        all(selectors, document).forEach(function (sel) {
            var id = sel.id || (sel.getAttribute && sel.getAttribute('data-option-id')) || '';
            if (!id) return;
            var val = getSavedOptionValue(opts, id);
            if (val == null || val === '') return;
            applySavedValueToMeasurementSelect(sel, val, setSelectValueFromSaved, restoreStats);
        });
        if (Array.isArray(opts._pricing_schema)) {
            opts._pricing_schema.forEach(function (opt) {
                if (!opt || !opt.id) return;
                if (opt._adminGroup !== 'measurement' && !/(width|height|thick|pre_hung|jamb|sidelight|transom)/i.test(String(opt.id))) return;
                var val2 = getSavedOptionValue(opts, opt.id);
                if (val2 == null || val2 === '') return;
                var selList = [];
                var byId = document.getElementById(opt.id);
                if (byId) selList.push(byId);
                if (optionsContainer) {
                    all('select[data-option-id="' + opt.id + '"]', optionsContainer).forEach(function (s) {
                        if (selList.indexOf(s) === -1) selList.push(s);
                    });
                }
                all('select#' + opt.id + ', select[id^="' + opt.id + '"]', document).forEach(function (s) {
                    if (selList.indexOf(s) === -1) selList.push(s);
                });
                selList.forEach(function (sel2) {
                    applySavedValueToMeasurementSelect(sel2, val2, setSelectValueFromSaved, restoreStats);
                });
            });
        }
        applySavedDoorHeightFromOptions(opts, ctx, setSelectValueFromSaved, restoreStats);
        var now = Date.now();
        if (now - lastSavedMeasApplyCompleteLogAt < 1200) return;
        lastSavedMeasApplyCompleteLogAt = now;
        debugSavedMeasurementRestore('apply-complete', {
            applied: restoreStats.applied,
            failed: restoreStats.failed,
            keys: restoreStats.keys
        });
    }

    function applySavedDoorHeightFromOptions(opts, ctx, setSelectValueFromSaved, stats) {
        if (!opts) return;
        ctx = ctx || {};
        var getSavedOptionValue = ctx.getSavedOptionValue || deps.getSavedOptionValue;
        if (typeof getSavedOptionValue !== 'function') return;
        var h = getSavedOptionValue(opts, 'door_height');
        var hf = getSavedOptionValue(opts, 'door_height_fraction');
        if (h == null || h === '') return;
        if (isGateCollection()) {
            var hn = parseInt(h, 10);
            if (isFinite(hn)) {
                if (hn < PET_GATES_DOOR_HEIGHT_MIN) h = String(PET_GATES_DOOR_HEIGHT_MIN);
                else if (hn > PET_GATES_DOOR_HEIGHT_MAX) h = String(PET_GATES_DOOR_HEIGHT_MAX);
            }
        }
        all('select#door_height', document).forEach(function (sel) {
            applySavedValueToMeasurementSelect(sel, h, setSelectValueFromSaved, stats);
        });
        if (hf != null && hf !== '') {
            all('select#door_height_fraction, select#door_height_frac', document).forEach(function (sel) {
                applySavedValueToMeasurementSelect(sel, hf, setSelectValueFromSaved, stats);
            });
        }
    }

    function syncMeasurementUiAfterSavedRestore(opts, ctx) {
        ctx = ctx || {};
        var normSavedOptionKey = ctx.normSavedOptionKey || deps.normSavedOptionKey;
        var container = document.getElementById('door-configurator-options');
        var schema = doorConfigSchemaRef();
        if (!container || !schema || !opts) return;
        var getSavedOptionValue = ctx.getSavedOptionValue || deps.getSavedOptionValue;
        if (typeof getSavedOptionValue !== 'function') return;
        hydrateMeasurementOptionsFromSummary(opts, ctx);
        var mt = getSavedOptionValue(opts, 'measurement_type');
        if (!mt) {
            mt = inferMeasurementTypeFromSummary(opts);
            if (mt) setSavedOptionValue(opts, 'measurement_type', mt);
        }
        if (!mt) return;
        var radio = null;
        function matchMtRadio(r, want) {
            if (!r || want == null || want === '') return false;
            if (String(r.value) === String(want)) return true;
            if (typeof normSavedOptionKey === 'function' && normSavedOptionKey(r.value) === normSavedOptionKey(want)) return true;
            return normalizeOptionIdKey(r.value) === normalizeOptionIdKey(want);
        }
        all('input[type="radio"][data-option-id="measurement_type"]', container).forEach(function (r) {
            if (radio) return;
            if (matchMtRadio(r, mt)) radio = r;
        });
        // finished_opening <-> finished_opening_size aliases
        if (!radio && isFinishedOpeningMeasureTab(mt)) {
            all('input[type="radio"][data-option-id="measurement_type"]', container).forEach(function (r) {
                if (radio) return;
                if (isFinishedOpeningMeasureTab(r.value)) radio = r;
            });
        }
        // Legacy slab/brick: Finished Opening Size was stored as rough_opening_size
        if (!radio && isRoughOpeningMeasureTab(mt) && !isPreHungOnDoorJambSelected(schema, container)) {
            all('input[type="radio"][data-option-id="measurement_type"]', container).forEach(function (r) {
                if (radio) return;
                if (isFinishedOpeningMeasureTab(r.value)) radio = r;
            });
        }
        if (radio) {
            radio.checked = true;
            try {
                applyMeasurementTypeTabSelection(radio, 'measurement_type', container, schema);
            } catch (eMeasTab) { }
        }
        try { runMeasurementUiSync(); } catch (eMeasSync) { }
        try { syncMeasurementTypeDetailsVisibility(container, schema); } catch (eMeasVis) { }
        if (typeof ctx.setSelectValueFromSaved === 'function' || typeof deps.setSelectValueFromSaved === 'function') {
            applyMeasurementSelectsFromSavedOptions(opts, ctx);
        }
    }

    // Reconstruct the panel sets from the flat editable keys the admin writes
    // (panel_unit_set_{n}_{dim}) so a config edited/saved in the admin app still restores
    // even if the panel_unit_individual_measurements array is missing/stale.
    function reconstructPanelSetsFromFlatKeys(opts) {
        if (!opts || typeof opts !== 'object') return [];
        var sets = {};
        var re = /^panel_unit_set_(\d+)_(width_int|width_frac|height_int|height_frac|thickness|quantity)$/;
        Object.keys(opts).forEach(function (k) {
            var m = String(k).toLowerCase().replace(/-/g, '_').match(re);
            if (!m) return;
            var setNo = parseInt(m[1], 10);
            var dim = m[2];
            var v = opts[k];
            if (Array.isArray(v)) v = v.length ? v[0] : '';
            if (!sets[setNo]) sets[setNo] = {};
            sets[setNo][dim] = v == null ? '' : String(v);
        });
        return Object.keys(sets).map(function (n) { return parseInt(n, 10); })
            .sort(function (a, b) { return a - b; })
            .map(function (n) {
                var s = sets[n];
                return {
                    width_int: s.width_int || '',
                    width_frac: s.width_frac || '',
                    height_int: s.height_int || '',
                    height_frac: s.height_frac || '',
                    thickness: s.thickness || '',
                    quantity: (s.quantity != null && s.quantity !== '') ? s.quantity : '1'
                };
            });
    }

    function applyPanelUnitIndividualMeasurementsFromSavedOptions(opts, attempt) {
        if (!opts) return;
        var panels = opts.panel_unit_individual_measurements || opts._panel_unit_individual_measurements;
        if (!Array.isArray(panels) || !panels.length) {
            panels = reconstructPanelSetsFromFlatKeys(opts);
        }
        if (!Array.isArray(panels) || !panels.length) return;
        var listEl = document.querySelector('.door-panel-unit-size-list');
        if (!listEl) {
            // The individual-panels measurements block isn't mounted yet (the order radio
            // may still be restoring). Retry a few times so the saved sets still land.
            attempt = attempt || 0;
            if (attempt < 20) {
                setTimeout(function () {
                    applyPanelUnitIndividualMeasurementsFromSavedOptions(opts, attempt + 1);
                }, 150);
            }
            return;
        }
        listEl.innerHTML = '';
        panels.forEach(function (panel) {
            var row = appendPanelUnitSizeRow(listEl);
            if (!row) return;
            [
                ['width-int', panel.width_int],
                ['width-frac', panel.width_frac],
                ['height-int', panel.height_int],
                ['height-frac', panel.height_frac],
                ['thickness', panel.thickness]
            ].forEach(function (pair) {
                var el = row.querySelector('[data-panel-dimension="' + pair[0] + '"]');
                if (!el || pair[1] == null || pair[1] === '') return;
                var ok = setMeasurementSelectValue(el, pair[1], { dispatchChange: true });
                if (!ok) { try { el.value = String(pair[1]); } catch (eSet) { } }
                // Keep the custom div-dropdown UI in sync with the restored native value.
                syncMeasurementDivSelectUi(el);
            });
            var qty = row.querySelector('[data-panel-dimension="quantity"]');
            if (qty && panel.quantity != null && panel.quantity !== '') {
                qty.value = String(panel.quantity);
                try { qty.dispatchEvent(new Event('change', { bubbles: true })); } catch (eQty) { }
            }
        });
        updateEstimatedPrice();
    }

    function reconstructEnclosureOpeningsFromFlatKeys(opts) {
        if (!opts || typeof opts !== 'object') return [];
        var openingsMap = {};
        var reField = /^panel_unit_enclosure_(\d+)_(width_int|width_frac|height_int|height_frac|thickness|panels|trim_system|sill_depth|sill_frac)$/;
        var reDoor = /^panel_unit_enclosure_(\d+)_door_(\d+)_(active|swing_direction|hinge_finish|lockset_preparation)$/;
        Object.keys(opts).forEach(function (k) {
            var normKey = String(k).toLowerCase().replace(/-/g, '_');
            var mField = normKey.match(reField);
            if (mField) {
                var opNo = parseInt(mField[1], 10);
                var field = mField[2];
                var v = opts[k];
                if (Array.isArray(v)) v = v.length ? v[0] : '';
                if (!openingsMap[opNo]) openingsMap[opNo] = { doors: {} };
                openingsMap[opNo][field] = v == null ? '' : String(v);
                return;
            }
            var mDoor = normKey.match(reDoor);
            if (mDoor) {
                var opNo = parseInt(mDoor[1], 10);
                var doorNo = parseInt(mDoor[2], 10);
                var field = mDoor[3];
                var v = opts[k];
                if (Array.isArray(v)) v = v.length ? v[0] : '';
                if (!openingsMap[opNo]) openingsMap[opNo] = { doors: {} };
                if (!openingsMap[opNo].doors[doorNo]) openingsMap[opNo].doors[doorNo] = { door_number: doorNo };
                openingsMap[opNo].doors[doorNo][field] = v == null ? '' : String(v);
            }
        });
        return Object.keys(openingsMap).map(function (n) { return parseInt(n, 10); })
            .sort(function (a, b) { return a - b; })
            .map(function (n) {
                var op = openingsMap[n];
                var doorsArr = Object.keys(op.doors).map(function (d) { return parseInt(d, 10); })
                    .sort(function (a, b) { return a - b; })
                    .map(function (d) {
                        return op.doors[d];
                    })
                    .filter(function (d) {
                        // Dp start 17-08
                        if (d && (d.active === 'true' || d.active === true || d.active === '1' || d.active === 1)) return true;
                        if (d && (d.swing_direction || d.swingDirection || d.hinge_finish || d.hingeFinish || d.lockset_preparation || d.locksetPreparation)) return true;
                        // Dp end 17-08
                        return d.active === 'true';
                    });
                return {
                    width_int: op.width_int || '',
                    width_frac: op.width_frac || '',
                    height_int: op.height_int || '',
                    height_frac: op.height_frac || '',
                    thickness: op.thickness || '',
                    panels: op.panels || '1',
                    trim_system: op.trim_system || 'false',
                    sill_depth: op.sill_depth || '5',
                    sill_frac: op.sill_frac || '0',
                    doors: doorsArr
                };
            });
    }


    // Dp start 17-08
    function panelUnitEnclosureOrderIsPorchSystem(cfg) {
        var val = '';
        try {
            if (cfg && cfg.panel_unit_design) val = String(cfg.panel_unit_design);
        } catch (eCfg) { }
        if (!val) {
            try {
                var checked = document.querySelector('input[type="radio"][data-option-id="panel_unit_design"]:checked');
                if (checked) val = String(checked.value || '');
            } catch (eRadio) { }
        }
        val = String(val || '').toLowerCase().replace(/-/g, '_');
        return val === 'design_porch_enclosure_system' || val.indexOf('enclosure') !== -1;
    }

    function collectPanelUnitEnclosureOpeningsFromDom() {
        var listEl = document.querySelector('.door-porch-opening-list');
        if (!listEl) return [];
        var openings = [];
        all('.door-porch-opening-entry', listEl).forEach(function (entry, idx) {
            if (!entry) return;
            var wInt = entry.querySelector('[data-porch-dimension="width-int"]');
            var wFrac = entry.querySelector('[data-porch-dimension="width-frac"]');
            var hInt = entry.querySelector('[data-porch-dimension="height-int"]');
            var hFrac = entry.querySelector('[data-porch-dimension="height-frac"]');
            var thick = entry.querySelector('[data-porch-dimension="thickness"]');
            var panels = entry.querySelector('[data-porch-dimension="panels"]');
            var trimInput = entry.querySelector('.door-porch-opening-trim-input');
            var sillDepth = entry.querySelector('[data-porch-sill="depth"]');
            var sillFrac = entry.querySelector('[data-porch-sill="depth-frac"]');
            var doors = [];
            all('.door-porch-opening-preview-panel', entry).forEach(function (panel, pIdx) {
                var chk = panel.querySelector('.door-porch-opening-door-input');
                var doorNo = pIdx + 1;
                var active = !!(chk && chk.checked);
                var configBlock = porchOpeningDoorConfigBlock(entry, doorNo);
                var swingGroup = configBlock ? configBlock.querySelector('.door-porch-opening-door-swing-section .door-porch-opening-door-choice-group') : null;
                var hingeGroup = configBlock ? configBlock.querySelector('.door-porch-opening-door-hinge-section .door-porch-opening-door-choice-group') : null;
                var locksetGroup = configBlock ? configBlock.querySelector('.door-porch-opening-door-lockset-section .door-porch-opening-door-choice-group') : null;
                var swing = porchOpeningDoorChoiceSelectedValue(swingGroup);
                var hinge = porchOpeningDoorChoiceSelectedValue(hingeGroup);
                var lockset = porchOpeningDoorChoiceSelectedValue(locksetGroup);
                if (!active) return;
                doors.push({
                    door_number: doorNo,
                    active: 'true',
                    swing_direction: swing || '',
                    hinge_finish: hinge || '',
                    lockset_preparation: lockset || ''
                });
            });
            openings.push({
                opening_number: idx + 1,
                width_int: wInt ? String(wInt.value || '') : '',
                width_frac: wFrac ? String(wFrac.value || '0') : '0',
                height_int: hInt ? String(hInt.value || '') : '',
                height_frac: hFrac ? String(hFrac.value || '0') : '0',
                thickness: (function () {
                    var thickVal = thick ? String(thick.value || '').trim() : '';
                    return thickVal || '1.125';
                })(),
                panels: panels ? String(panels.value || '1') : '1',
                trim_system: (trimInput && trimInput.checked) ? 'true' : 'false',
                sill_depth: sillDepth ? String(sillDepth.value || '5') : '5',
                sill_frac: sillFrac ? String(sillFrac.value || '0') : '0',
                // Dp start 17-08 — persist live Stops & Astragals copy from trim UI
                stops: (function () {
                    var topEl = entry.querySelector('.door-porch-opening-stops-top-bottom');
                    var sideEl = entry.querySelector('.door-porch-opening-stops-left-right');
                    var topTxt = topEl ? String(topEl.textContent || '').trim() : '';
                    var sideTxt = sideEl ? String(sideEl.textContent || '').trim() : '';
                    return [topTxt, sideTxt].filter(Boolean).join('; ');
                })(),
                astragals: (function () {
                    var aEl = entry.querySelector('.door-porch-opening-astragals-copy');
                    return aEl ? String(aEl.textContent || '').trim() : '';
                })(),
                // Dp end 17-08
                doors: doors
            });
        });
        return openings;
    }

    function applyPanelUnitEnclosureOpeningsToConfig(cfg) {
        cfg = cfg || {};
        var wrap = document.querySelector('[data-panel-unit-enclosure-measurements]');
        var wrapVisible = !!(wrap && (!wrap.classList || !wrap.classList.contains('door-hidden')));
        if (!wrapVisible && !panelUnitEnclosureOrderIsPorchSystem(cfg)) {
            return cfg;
        }
        var openings = collectPanelUnitEnclosureOpeningsFromDom();
        if (!Array.isArray(openings) || !openings.length) {
            return cfg;
        }
        cfg.panel_unit_enclosure_openings = openings;
        cfg._panel_unit_enclosure_openings = openings;
        openings.forEach(function (op, idx) {
            var i = idx + 1;
            cfg['panel_unit_enclosure_' + i + '_width_int'] = op.width_int;
            cfg['panel_unit_enclosure_' + i + '_width_frac'] = op.width_frac;
            cfg['panel_unit_enclosure_' + i + '_height_int'] = op.height_int;
            cfg['panel_unit_enclosure_' + i + '_height_frac'] = op.height_frac;
            cfg['panel_unit_enclosure_' + i + '_thickness'] = op.thickness;
            cfg['panel_unit_enclosure_' + i + '_panels'] = op.panels;
            cfg['panel_unit_enclosure_' + i + '_trim_system'] = op.trim_system;
            cfg['panel_unit_enclosure_' + i + '_sill_depth'] = op.sill_depth;
            cfg['panel_unit_enclosure_' + i + '_sill_frac'] = op.sill_frac;
            // Dp start 17-08
            cfg['panel_unit_enclosure_' + i + '_stops'] = op.stops || '';
            cfg['panel_unit_enclosure_' + i + '_astragals'] = op.astragals || '';
            // Dp end 17-08
            (op.doors || []).forEach(function (door) {
                var d = parseInt(door.door_number, 10);
                if (!d) return;
                cfg['panel_unit_enclosure_' + i + '_door_' + d + '_active'] = 'true';
                cfg['panel_unit_enclosure_' + i + '_door_' + d + '_swing_direction'] = door.swing_direction || '';
                cfg['panel_unit_enclosure_' + i + '_door_' + d + '_hinge_finish'] = door.hinge_finish || '';
                cfg['panel_unit_enclosure_' + i + '_door_' + d + '_lockset_preparation'] = door.lockset_preparation || '';
            });
        });
        return cfg;
    }
    // Dp end 17-08

    function applyPanelUnitEnclosureOpeningsFromSavedOptions(opts, attempt) {
        if (!opts) return;
        var openings = opts.panel_unit_enclosure_openings || opts._panel_unit_enclosure_openings;
        if (!Array.isArray(openings) || !openings.length) {
            openings = reconstructEnclosureOpeningsFromFlatKeys(opts);
        }
        if (!Array.isArray(openings) || !openings.length) return;
        var listEl = document.querySelector('.door-porch-opening-list');
        if (!listEl) {
            attempt = attempt || 0;
            if (attempt < 20) {
                setTimeout(function () {
                    applyPanelUnitEnclosureOpeningsFromSavedOptions(opts, attempt + 1);
                }, 150);
            }
            return;
        }
        listEl.innerHTML = '';
        openings.forEach(function (opening) {
            var row = appendPorchOpeningRow(listEl);
            if (!row) return;
            // Dp start 17-08
            opening = opening || {};
            opening.width_int = opening.width_int || opening.widthInt || '';
            opening.width_frac = opening.width_frac || opening.widthFrac || '0';
            opening.height_int = opening.height_int || opening.heightInt || '';
            opening.height_frac = opening.height_frac || opening.heightFrac || '0';
            opening.trim_system = opening.trim_system != null ? opening.trim_system : opening.trimSystem;
            opening.sill_depth = opening.sill_depth || opening.sillDepth || '';
            opening.sill_frac = opening.sill_frac || opening.sillFrac || '';
            // Dp end 17-08
            [
                ['width-int', opening.width_int],
                ['width-frac', opening.width_frac],
                ['height-int', opening.height_int],
                ['height-frac', opening.height_frac],
                ['thickness', opening.thickness]
            ].forEach(function (pair) {
                var el = row.querySelector('[data-porch-dimension="' + pair[0] + '"]');
                if (!el || pair[1] == null || pair[1] === '') return;
                var ok = setMeasurementSelectValue(el, pair[1], { dispatchChange: true });
                if (!ok) { try { el.value = String(pair[1]); } catch (eSet) { } }
                syncMeasurementDivSelectUi(el);
            });

            var panelsInput = row.querySelector('[data-porch-dimension="panels"]');
            if (panelsInput && opening.panels != null && opening.panels !== '') {
                panelsInput.value = String(opening.panels);
                try { panelsInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (ePanels) { }
            }

            var trimInput = row.querySelector('.door-porch-opening-trim-input');
            if (trimInput) {
                trimInput.checked = (opening.trim_system === 'true' || opening.trim_system === true);
                try { trimInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (eTrim) { }
            }

            var sillDepthSel = row.querySelector('[data-porch-sill="depth"]');
            var sillFracSel = row.querySelector('[data-porch-sill="depth-frac"]');
            if (opening.sill_depth != null && opening.sill_depth !== '') {
                if (sillDepthSel) sillDepthSel.value = String(opening.sill_depth);
                row.setAttribute('data-porch-sill-depth-custom', '1');
            }
            if (opening.sill_frac != null && opening.sill_frac !== '') {
                if (sillFracSel) sillFracSel.value = String(opening.sill_frac);
                row.setAttribute('data-porch-sill-depth-custom', '1');
            }

            // Dp start 17-08 — set native + custom inch dropdown (00 / 1/8 / 1/4 / 1/2)
            if (opening.sill_depth != null && opening.sill_depth !== '') {
                var depthSet = sillDepthSel && setMeasurementSelectValue(sillDepthSel, opening.sill_depth, { dispatchChange: false });
                if (!depthSet && sillDepthSel) {
                    try { sillDepthSel.value = String(opening.sill_depth); } catch (eSillD) { }
                    syncMeasurementDivSelectUi(sillDepthSel);
                }
                row.setAttribute('data-porch-sill-depth-custom', '1');
            }
            if (opening.sill_frac != null && opening.sill_frac !== '') {
                var fracSet = sillFracSel && setMeasurementSelectValue(sillFracSel, opening.sill_frac, { dispatchChange: false });
                if (!fracSet && sillFracSel) {
                    try { sillFracSel.value = String(opening.sill_frac); } catch (eSillF) { }
                    syncMeasurementDivSelectUi(sillFracSel);
                }
                row.setAttribute('data-porch-sill-depth-custom', '1');
            }
            // Dp end 17-08

            updatePorchOpeningDerivedUi(row);

            var doors = opening.doors || [];
            var previewPanels = all('.door-porch-opening-preview-panel', row);
            doors.forEach(function (door) {
                // Dp start 17-08
                if (!door || typeof door !== 'object') return;
                door.door_number = door.door_number || door.doorNumber;
                door.swing_direction = door.swing_direction || door.swingDirection || '';
                door.hinge_finish = door.hinge_finish || door.hingeFinish || '';
                door.lockset_preparation = door.lockset_preparation || door.locksetPreparation || '';
                // Dp end 17-08
                var doorIdx = door.door_number - 1;
                var panelEl = previewPanels[doorIdx];
                if (panelEl) {
                    var chk = panelEl.querySelector('.door-porch-opening-door-input');
                    if (chk) {
                        chk.checked = true;
                        try { chk.dispatchEvent(new Event('change', { bubbles: true })); } catch (eChk) { }
                    }
                    var configBlock = porchOpeningDoorConfigBlock(row, door.door_number);
                    if (configBlock) {
                        var swingGroup = configBlock.querySelector('.door-porch-opening-door-swing-section .door-porch-opening-door-choice-group');
                        var hingeGroup = configBlock.querySelector('.door-porch-opening-door-hinge-section .door-porch-opening-door-choice-group');
                        var locksetGroup = configBlock.querySelector('.door-porch-opening-door-lockset-section .door-porch-opening-door-choice-group');

                        if (swingGroup && door.swing_direction) {
                            porchOpeningDoorChoiceSetSelected(swingGroup, door.swing_direction);
                        }
                        if (hingeGroup && door.hinge_finish) {
                            porchOpeningDoorChoiceSetSelected(hingeGroup, door.hinge_finish);
                        }
                        if (locksetGroup && door.lockset_preparation) {
                            porchOpeningDoorChoiceSetSelected(locksetGroup, door.lockset_preparation);
                        }
                    }
                }
            });
            updatePorchOpeningDerivedUi(row);
        });
        updateEstimatedPrice();
    }

    window.DoorConf2Measurements = window.DoorConf2Measurements || {};
    window.DoorConf2Measurements.init = function (d) { deps = d || {}; };
    window.DoorConf2Measurements.applyPanelUnitIndividualMeasurementsFromSavedOptions = applyPanelUnitIndividualMeasurementsFromSavedOptions;
    window.DoorConf2Measurements.applyPanelUnitEnclosureOpeningsFromSavedOptions = applyPanelUnitEnclosureOpeningsFromSavedOptions;
    // Dp start 17-08
    window.DoorConf2Measurements.collectPanelUnitEnclosureOpeningsFromDom = collectPanelUnitEnclosureOpeningsFromDom;
    window.DoorConf2Measurements.applyPanelUnitEnclosureOpeningsToConfig = applyPanelUnitEnclosureOpeningsToConfig;
    // Dp end 17-08
    window.DoorConf2Measurements.runMeasurementUiSync = runMeasurementUiSync;
    window.DoorConf2Measurements.applyMeasurementTypeTabSelection = applyMeasurementTypeTabSelection;
    window.DoorConf2Measurements.applySidelightTransomMeasurementTypeDefault = applySidelightTransomMeasurementTypeDefault;
    window.DoorConf2Measurements.syncMeasurementTypeDetailsVisibility = syncMeasurementTypeDetailsVisibility;
    window.DoorConf2Measurements.syncSlabSidelightMeasurementUI = syncSlabSidelightMeasurementUI;
    window.DoorConf2Measurements.syncMeasurementTabCardVisibility = syncMeasurementTabCardVisibility;
    window.DoorConf2Measurements.syncMeasurementTypeSectionPreHungGate = syncMeasurementTypeSectionPreHungGate;
    window.DoorConf2Measurements.syncHingeFinishVisibility = syncHingeFinishVisibility;
    window.DoorConf2Measurements.syncLocksetPrepVisibility = syncLocksetPrepVisibility;
    window.DoorConf2Measurements.applyLocksetPrepNoLockPrepDefault = applyLocksetPrepNoLockPrepDefault;
    window.DoorConf2Measurements.syncMeasurementTabVisibilityCore = syncMeasurementTabVisibilityCore;
    window.DoorConf2Measurements.linkStaticMeasurementRowsToSchema = linkStaticMeasurementRowsToSchema;
    window.DoorConf2Measurements.assignStaticMeasurementRowSelectIds = assignStaticMeasurementRowSelectIds;
    window.DoorConf2Measurements.fixPanelDoorWidthAndTransomHeightOptionRanges = fixPanelDoorWidthAndTransomHeightOptionRanges;
    window.DoorConf2Measurements.applyExactDoorWidthIntRange = applyExactDoorWidthIntRange;
    window.DoorConf2Measurements.applySingleItemDimensionRanges = applySingleItemDimensionRanges;
    window.DoorConf2Measurements.applyPreHungJambWidthRange = applyPreHungJambWidthRange;
    window.DoorConf2Measurements.getDefaultPreHungJambWidthInt = getDefaultPreHungJambWidthInt;
    window.DoorConf2Measurements.getDefaultExactDoorWidthInt = getDefaultExactDoorWidthInt;
    window.DoorConf2Measurements.isDutchDoorsProduct = isDutchDoorsProduct;
    window.DoorConf2Measurements.applyFinishedRoughWidthIntDefaults = applyFinishedRoughWidthIntDefaults;
    window.DoorConf2Measurements.applyStaticMeasurementDimensionDefaults = applyStaticMeasurementDimensionDefaults;
    window.DoorConf2Measurements.applyOpeningDimensionRangesFromUnitLayout = applyOpeningDimensionRangesFromUnitLayout;
    window.DoorConf2Measurements.getUnitLayoutCounts = getUnitLayoutCounts;
    window.DoorConf2Measurements.applyScreenStormExactDimensionRanges = applyScreenStormExactDimensionRanges;
    window.DoorConf2Measurements.getDefaultExactDoorThicknessFracValue = getDefaultExactDoorThicknessFracValue;
    window.DoorConf2Measurements.getDefaultExactDoorHeightInt = getDefaultExactDoorHeightInt;
    window.DoorConf2Measurements.resetPetGatesMeasurementOnTabChange = resetPetGatesMeasurementOnTabChange;
    window.DoorConf2Measurements.logPetGatesPricing = logPetGatesPricing;
    window.DoorConf2Measurements.findPetGatesExactMeasureSelect = findPetGatesExactMeasureSelect;
    window.DoorConf2Measurements.syncPetGatesMeasurementPrice = syncPetGatesMeasurementPrice;
    window.DoorConf2Measurements.readPetGatesExactMeasureInchesFromDom = readPetGatesExactMeasureInchesFromDom;
    window.DoorConf2Measurements.findPetGatesCatalogPrice = findPetGatesCatalogPrice;
    window.DoorConf2Measurements.isPetGatesExactMeasureSelectEl = isPetGatesExactMeasureSelectEl;
    window.DoorConf2Measurements.applyDefaultExactDoorThicknessFracSelects = applyDefaultExactDoorThicknessFracSelects;
    window.DoorConf2Measurements.restrictTransomThicknessFracSelectOptions = restrictTransomThicknessFracSelectOptions;
    window.DoorConf2Measurements.restrictSidelightTransomThicknessFracSelectOptions = restrictSidelightTransomThicknessFracSelectOptions;
    window.DoorConf2Measurements.getSidelightTransomThicknessDefault = getSidelightTransomThicknessDefault;
    window.DoorConf2Measurements.assignUniqueOptionIds = assignUniqueOptionIds;
    window.DoorConf2Measurements.applyPorchPanelUnitDimensionRanges = applyPorchPanelUnitDimensionRanges;
    window.DoorConf2Measurements.applyPorchOpeningWidthIntRange = applyPorchOpeningWidthIntRange;
    window.DoorConf2Measurements.recordDoorSelectMeta = recordDoorSelectMeta;
    window.DoorConf2Measurements.getDoorSelectionMetaBySelectId = function () { return doorSelectionMetaBySelectId; };
    window.DoorConf2Measurements.getDoorLastSelectionMeta = function () { return doorLastSelectionMeta; };
    window.DoorConf2Measurements.buildMeasurementTypeTabOptionList = buildMeasurementTypeTabOptionList;
    window.DoorConf2Measurements.findPreHungStyleOption = findPreHungStyleOption;
    window.DoorConf2Measurements.getPreHungDoorSetupChoices = getPreHungDoorSetupChoices;
    window.DoorConf2Measurements.initializePanelUnitDesignSections = initializePanelUnitDesignSections;
    window.DoorConf2Measurements.appendStaticPanelUnitDesignSection = appendStaticPanelUnitDesignSection;
    window.DoorConf2Measurements.schemaIncludesPanelUnitDesignOption = schemaIncludesPanelUnitDesignOption;
    window.DoorConf2Measurements.productIsPorchPanelProduct = productIsPorchPanelProduct;
    // Dp start 13-08
    window.DoorConf2Measurements.updateSwingDirectionImages = updateSwingDirectionImages;
    window.DoorConf2Measurements.getSwingDirectionImageFromSchema = getSwingDirectionImageFromSchema;
    // Dp end 13-08
    window.DoorConf2Measurements.panelUnitDesignSectionExists = panelUnitDesignSectionExists;
    window.DoorConf2Measurements.optionIsPanelUnitDesign = optionIsPanelUnitDesign;
    window.DoorConf2Measurements.isGateCollectionAllowedMeasureTab = isGateCollectionAllowedMeasureTab;
    window.DoorConf2Measurements.applyGateCollectionThicknessFracSelects = applyGateCollectionThicknessFracSelects;
    window.DoorConf2Measurements.isGardenGatesCollection = isGardenGatesCollection;
    window.DoorConf2Measurements.isGateCollection = isGateCollection;
    window.DoorConf2Measurements.isPetGatesCollection = isPetGatesCollection;
    window.DoorConf2Measurements.applyPetGatesDoorHeightSelectRange = applyPetGatesDoorHeightSelectRange;
    window.DoorConf2Measurements.applyPetGatesDoorWidthSelectRange = applyPetGatesDoorWidthSelectRange;
    window.DoorConf2Measurements.applyPetGatesDimensionSelectRanges = applyPetGatesDimensionSelectRanges;
    window.DoorConf2Measurements.applyPetGatesMeasurementDimensionCopy = applyPetGatesMeasurementDimensionCopy;
    window.DoorConf2Measurements.petGatesExactMeasureTitleCopy = petGatesExactMeasureTitleCopy;
    window.DoorConf2Measurements.petGatesExactMeasureHintCopy = petGatesExactMeasureHintCopy;
    window.DoorConf2Measurements.normalizeGateMeasureOriginalTitle = normalizeGateMeasureOriginalTitle;
    window.DoorConf2Measurements.normalizeGateMeasureOriginalHint = normalizeGateMeasureOriginalHint;
    window.DoorConf2Measurements.applyGardenGatesCollectionRules = applyGardenGatesCollectionRules;
    window.DoorConf2Measurements.measurementSchemaUsesJsonVisibility = measurementSchemaUsesJsonVisibility;
    window.DoorConf2Measurements.isMeasurementTypeOptionId = isMeasurementTypeOptionId;
    window.DoorConf2Measurements.measurementModeFromCheckedTab = measurementModeFromCheckedTab;
    window.DoorConf2Measurements.syncMeasurementSelectedPriceLabels = syncMeasurementSelectedPriceLabels;
    window.DoorConf2Measurements.hydrateMeasurementOptionsFromSummary = hydrateMeasurementOptionsFromSummary;
    window.DoorConf2Measurements.applyMeasurementSelectsFromSavedOptions = applyMeasurementSelectsFromSavedOptions;
    window.DoorConf2Measurements.syncMeasurementUiAfterSavedRestore = syncMeasurementUiAfterSavedRestore;
    window.DoorConf2Measurements.displayLabelForMeasurementTabChoice = displayLabelForMeasurementTabChoice;
    window.DoorConf2Measurements.isFinishedOpeningMeasureTab = isFinishedOpeningMeasureTab;
    window.DoorConf2Measurements.isRoughOpeningMeasureTab = isRoughOpeningMeasureTab;
    window.DoorConf2Measurements.resolveFinishedOpeningTabValue = resolveFinishedOpeningTabValue;
    window.DoorConf2Measurements.normalizeFinishedVsRoughMeasurementTabValues = normalizeFinishedVsRoughMeasurementTabValues;
    window.DoorConf2Measurements.hasEntranceUnitSidelightConfigOption = hasEntranceUnitSidelightConfigOption;
    window.DoorConf2Measurements.hasEntranceUnitTransomConfigOption = hasEntranceUnitTransomConfigOption;
    window.DoorConf2Measurements.hasEntranceUnitsTag = hasEntranceUnitsTag;
    window.DoorConf2Measurements.hasNoSlabConfigOption = hasNoSlabConfigOption;
    window.DoorConf2Measurements.isEntranceUnitMeasureConfigActive = isEntranceUnitMeasureConfigActive;
    window.DoorConf2Measurements.syncNoSlabDoorSetupVisibility = syncNoSlabDoorSetupVisibility;
    window.DoorConf2Measurements.getEntranceUnitRoughOpeningRangeOverride = getEntranceUnitRoughOpeningRangeOverride;
    window.DoorConf2Measurements.isMeasurementSidelightTransomTabValue = isMeasurementSidelightTransomTabValue;
    window.DoorConf2Measurements.resolveMeasurementTabProductTagShouldHide = resolveMeasurementTabProductTagShouldHide;
    window.DoorConf2Measurements.isPanelUnitDesignSectionEl = isPanelUnitDesignSectionEl;

    try {
        if (typeof location !== 'undefined' && /door_saved_restore_debug/i.test(String(location.search || ''))) {
            if (typeof window.__doorSavedRestoreDebug === 'function') {
                window.__doorSavedRestoreDebug('measurements.js loaded', { build: '20260604b' });
            }
        }
    } catch (eMeasBoot) { }
    bindPetGatesMeasurementPricing();
})();